webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_kit__ = __webpack_require__(146);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}
















var HUNG_PUBLICATION_TIMEOUT = 5; // in minutes
var HUNG_PUBLICATION_INTERVAL = 5; // in seconds

function _mostRecentPublication(publications) {
  var value = null;

  if (publications.size > 0) {
    value = publications.sortBy(function (publication) {
      return publication.startedAt.unix();
    }).reverse().first();
  }

  return value;
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests,
    kitMutations: state.kitMutations
  };
};

var PublishButton = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'PublishButton',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    kitMutations: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired,
    kit: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.record.isRequired,
    onPublishing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onPublished: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFirstTimePublished: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      onPublished: function onPublished() {},
      onPublishing: function onPublishing() {},
      onFirstTimePublished: function onFirstTimePublished() {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      buttonDisabled: true,
      lastStatus: null,
      lastPublishFailed: false,
      hasNeverBeenPublished: false,
      hungPublicationWatcher: __WEBPACK_IMPORTED_MODULE_6_moment___default()()
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kit.token]
      })
    });

    this.setRequest({
      publications: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kit.token, 'publications']
      })
    });

    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kit.token, 'working-set-icons']
      })
    });

    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kit.token, 'working-set-typefaces']
      })
    });

    this.setRequest({
      workingSetImages: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kit.token, 'working-set-images']
      })
    });

    this.scheduleHungWatcher();
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.state.hungPublicationWatcher);
  },
  scheduleHungWatcher: function scheduleHungWatcher() {
    var _this = this;

    this.setState({
      hungPublicationWatcher: setTimeout(function () {
        _this.scheduleHungWatcher();
      }, HUNG_PUBLICATION_INTERVAL * 1000)
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _state = this.state,
        lastStatus = _state.lastStatus,
        hasNeverBeenPublished = _state.hasNeverBeenPublished;

    var publication = this.mostRecentPublication(nextProps);
    var rm = this.resourceManager(nextProps);
    var publicationsLoaded = rm.requests.isDone(this.requests.publications);
    var finishedPublications = rm.type(this.requests.publications, 'publications').all().filter(function (p) {
      return p.status === 'finished';
    });

    if (publication) {
      if (lastStatus === 'processing' && publication.status === 'finished') {
        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_actions__["i" /* published */])(this.props.kit.token));

        this.props.onPublished();

        this.setState({ buttonDisabled: false });

        if (this.state.hasNeverBeenPublished) {
          this.props.onFirstTimePublished();

          hasNeverBeenPublished = false;
        }
      }

      if (lastStatus === 'processing' && publication.status === 'errored') {
        this.setState({ lastPublishFailed: true });
      }

      lastStatus = publication.status;
    }

    hasNeverBeenPublished = publicationsLoaded && finishedPublications.isEmpty();

    this.setState({
      lastStatus: lastStatus,
      hasNeverBeenPublished: hasNeverBeenPublished
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.publications,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var publications = rm.type(this.requests.publications, 'publications').all();
        var publication = _mostRecentPublication(publications);

        if (publication) {
          this.setState({
            buttonDisabled: publication.status === 'processing',
            lastPublishFailed: publication.status === 'errored'
          });
        } else {
          this.setState({
            buttonDisabled: false
          });
        }
      }
    });

    register({
      request: this.requests.publishKit,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.props.onPublishing();
      }
    });

    register({
      request: this.requests.publishKit,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.setState({
          lastPublishFailed: true
        });
      }
    });

    register({
      request: this.requests.deletePublication,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.handleClick();
      }
    });
  },
  resources: function resources() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var _requests = this.requests,
        kitRequest = _requests.kit,
        publicationsRequest = _requests.publications,
        workingSetIconsRequest = _requests.workingSetIcons,
        workingSetTypefacesRequest = _requests.workingSetTypefaces,
        workingSetImagesRequest = _requests.workingSetImages;

    var rm = this.resourceManager(props || this.props);
    var workingSet = rm.type(kitRequest, 'working-sets').get();
    var publications = rm.type(publicationsRequest, 'publications').all();
    var workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    var workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    var workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();

    return { publications: publications, workingSet: workingSet, workingSetIcons: workingSetIcons, workingSetTypefaces: workingSetTypefaces, workingSetImages: workingSetImages };
  },
  handleClick: function handleClick(event) {
    var _this2 = this;

    if (event) {
      event.preventDefault();
    }

    this.setState({
      buttonDisabled: true
    }, function () {
      _this2.publish();
    });
  },
  handleTryPublishingAgain: function handleTryPublishingAgain(event) {
    this.setState({
      lastPublishFailed: false
    });

    this.handleClick(event);
  },
  handleTryPublishingAfterHung: function handleTryPublishingAfterHung(event) {
    var publication = this.mostRecentPublication();

    this.setRequest({
      deletePublication: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kit.token, 'publications', publication.id],
        record: publication
      })
    });
  },
  handleGetSupport: function handleGetSupport(event) {
    this.setState({
      lastPublishFailed: false,
      buttonDisabled: false
    });
  },
  mostRecentPublication: function mostRecentPublication() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _resources = this.resources(props),
        publications = _resources.publications;

    return _mostRecentPublication(publications);
  },
  getButtonAndTiming: function getButtonAndTiming() {
    var buttonDisabled = this.state.buttonDisabled;

    var publication = this.mostRecentPublication();
    var button = 'Publish';
    var timing = '';

    if (publication) {
      if (publication.status !== 'finished') {
        button = this.getButtonSpinning();
      }

      if (publication.startedAt.isValid()) {
        timing = 'Started publishing ' + publication.startedAt.fromNow();
      }

      if (publication.erroredAt.isValid()) {
        timing = 'Failed to publish ' + publication.erroredAt.fromNow();
      }

      if (publication.finishedAt.isValid()) {
        timing = 'Published ' + publication.finishedAt.fromNow();
      }
    }

    if (buttonDisabled) {
      button = this.getButtonSpinning();
    }

    return [button, timing];
  },
  getButtonSpinning: function getButtonSpinning() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin m-xs-r-xs' }), " Publishing\u2026");
  },
  publish: function publish() {
    var kit = this.props.kit;

    var _resources2 = this.resources(),
        workingSet = _resources2.workingSet;

    this.setRequest({
      publishKit: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        url: ['api', 'kits', kit.token, 'publications'],
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["c" /* POST */],
        record: workingSet
      })
    });
  },
  workingSetEmpty: function workingSetEmpty() {
    var _requests2 = this.requests,
        workingSetIconsRequest = _requests2.workingSetIcons,
        workingSetTypefacesRequest = _requests2.workingSetTypefaces,
        workingSetImagesRequest = _requests2.workingSetImages;

    var rm = this.resourceManager();
    var workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    var workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    var workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();

    return workingSetIcons.size === 0 && workingSetTypefaces.size === 0 && workingSetImages.size === 0;
  },
  updatesArePending: function updatesArePending() {
    var _resources3 = this.resources(),
        workingSetIcons = _resources3.workingSetIcons,
        workingSetTypefaces = _resources3.workingSetTypefaces,
        workingSetImages = _resources3.workingSetImages;

    var all = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["List"])().concat(workingSetIcons).concat(workingSetTypefaces).concat(workingSetImages);

    var publication = this.mostRecentPublication();
    var lastWorkingSetChange = Math.max.apply(Math, _toConsumableArray(all.map(function (i) {
      return i.updatedAt.unix();
    })));

    var value = false;

    if (publication) {
      value = publication.finishedAt.unix() < lastWorkingSetChange;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_13__utils_kit__["c" /* needsPublishing */])(this.props.kitMutations, this.props.kit.token) || value;
  },
  appearsHung: function appearsHung() {
    var publication = this.mostRecentPublication();
    var value = false;

    if (publication && publication.status === 'processing') {
      var publicationStartedAt = publication.startedAt;
      var now = __WEBPACK_IMPORTED_MODULE_6_moment___default()();

      value = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration(now.diff(publicationStartedAt)).asMinutes() > HUNG_PUBLICATION_TIMEOUT;
    }

    return value;
  },
  renderPublishButton: function renderPublishButton() {
    var buttonDisabled = this.state.buttonDisabled;

    var workingSetEmpty = this.workingSetEmpty();
    var hasNoPublications = !this.mostRecentPublication();
    var buttonType = (this.updatesArePending() || hasNoPublications) && !buttonDisabled ? 'btn-primary' : 'btn-secondary';
    var buttonClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('btn', 'btn-lg', 'm-xs-l-md', buttonType);

    var _getButtonAndTiming = this.getButtonAndTiming(),
        _getButtonAndTiming2 = _slicedToArray(_getButtonAndTiming, 2),
        button = _getButtonAndTiming2[0],
        timing = _getButtonAndTiming2[1];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, timing, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClick, className: buttonClassName, disabled: buttonDisabled || workingSetEmpty }, button));
  },
  renderPublishFailed: function renderPublishFailed() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-exclamation-circle' }), ' We failed to publish your kit. You can ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', onClick: this.handleTryPublishingAgain }, 'publish again'), ' or', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleGetSupport, className: 'btn btn-lg m-xs-l-md btn-secondary' }, 'Get support'));
  },
  renderPublishHung: function renderPublishHung() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-exclamation-circle' }), ' This is taking too long, let\'s start over. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', onClick: this.handleTryPublishingAfterHung }, 'Publish again'), ' or', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleGetSupport, className: 'btn btn-lg m-xs-l-md btn-secondary' }, 'Get support'));
  },
  renderMain: function renderMain() {
    var value = this.state.lastPublishFailed ? this.renderPublishFailed() : this.renderPublishButton();

    if (this.appearsHung()) {
      value = this.renderPublishHung();
    }

    return value;
  },
  render: function render() {
    var requests = [this.requests.kit, this.requests.publications];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(PublishButton));

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conditionalComponent__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__conditionalComponent__["a" /* default */])('NotFound', {
  all: 'allNotFound',
  any: 'anyNotFound'
}));

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conditionalComponent__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__conditionalComponent__["a" /* default */])('Failed', {
  all: 'allFailed',
  any: 'anyFailed'
}));

/***/ }),

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components_Done__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_MainNavMixin__ = __webpack_require__(214);













var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var NotFoundController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'NotFoundController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_MainNavMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    var kitToken = this.props.kitToken;

    return {
      embedCodeUrl: 'https://' + "use.fortawesome.com" + '/' + kitToken + '.js',
      embedCodeScriptTag: '<script src="https://' + "use.fortawesome.com" + '/' + kitToken + '.js"></script>'
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_6_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_6_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_6_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_6_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });
  },
  renderMessage: function renderMessage(kit) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-body p-xs-a-2x text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-md block' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block m-xs-b-sm' }, 'Found nothing we have.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block text-xl' }, 'Consumed by the Dark Side this page has become.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lead font-weight-normal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Hmmm, you may have hit a bad link or typed in a URL incorrectly. Double-check that this address is correct or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kit.token }, 'go back to your kit'), '.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'If you keep running into trouble,  ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com' }, 'Let us know'), '.')));
  },
  renderKit: function renderKit() {
    var kitToken = this.props.kitToken;
    var _requests = this.requests,
        kitRequest = _requests.kit,
        subscriptionRequest = _requests.subscription;

    var rm = this.resourceManager();
    var kit = rm.type(kitRequest, 'kits').find({ token: kitToken });
    var subscription = rm.type(subscriptionRequest, 'subscriptions').get();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-summary gg gg-middle m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'text-3x gg-col kit-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { className: 'link-dashed-none', to: '/kits/' + kit.token }, kit.name)))), this.renderNav(kit, subscription), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-components' }, this.renderMessage(kit)));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_requests_components_ResourcesMatching__["a" /* default */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components_Requesting__["a" /* default */], { any: true }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_10_components_Spinner__["b" /* SIZE_LARGE */] }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components_Done__["a" /* default */], { all: true, render: this.renderKit }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(NotFoundController));

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Feature__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconsSummary__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TypefacesSummary__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImagesSummary__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__KitMessages__ = __webpack_require__(1010);












var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var SummaryController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SummaryController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      kitMessages: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'messages']
      })
    });
  },
  renderKitMessages: function renderKitMessages(kitMessages) {
    var kitMessageElement = null;

    if (!kitMessages.isEmpty()) {
      kitMessageElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__KitMessages__["a" /* default */], { kitToken: this.props.kitToken, messages: kitMessages }));
    }

    return kitMessageElement;
  },
  render: function render() {
    var kitToken = this.props.kitToken;
    var kitMessagesRequest = this.requests.kitMessages;

    var rm = this.resourceManager();
    var kitMessages = rm.type(kitMessagesRequest, 'kit-messages').all();
    var hasKitMessages = !kitMessages.isEmpty();
    var summaryProps = { kitToken: kitToken };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: hasKitMessages ? 'col-xs-9' : 'col-xs-12' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IconsSummary__["a" /* default */], summaryProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TypefacesSummary__["a" /* default */], summaryProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Feature__["a" /* default */], { name: 'images' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ImagesSummary__["a" /* default */], summaryProps))), this.renderKitMessages(kitMessages));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(SummaryController));

/***/ }),

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_requests_components_Done__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IconCard__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IconCardPlaceholder__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IconSettings__ = __webpack_require__(461);

















var NUMBER_OF_ICONS_NEEDED = 22;
var ICON_MULTIPLES = 11;

var mapStateToProps = function mapStateToProps(state, props) {
  var kitToken = props.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var IconsSummary = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconsSummary',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      usingFocused: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });
  },
  handleUsingFocused: function handleUsingFocused() {
    this.setState({ usingFocused: !this.state.usingFocused });
  },
  handleRemovedIcon: function handleRemovedIcon(workingSetIcon) {
    this.setRequest({
      removeWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', workingSetIcon.id],
        record: workingSetIcon
      })
    });
  },
  renderUsingLabel: function renderUsingLabel() {
    var _requests = this.requests,
        workingSetIconsRequest = _requests.workingSetIcons,
        subscriptionRequest = _requests.subscription;

    var rm = this.resourceManager();
    var workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    var subscription = rm.type(subscriptionRequest, 'subscriptions').get();
    var iconsPerKitAllowed = subscription.iconsPerKitAllowed;
    var iconsAllowed = iconsPerKitAllowed === Infinity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u221E') : iconsPerKitAllowed;
    var popover = null;

    if (this.state.usingFocused) {
      popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], {
        noIcon: true,
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Using ', workingSetIcons.size, ' of ', iconsAllowed, ' icons per kit', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'available in your plan')
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'use-count', onMouseOver: this.handleUsingFocused, onMouseOut: this.handleUsingFocused }, popover, 'Using ', workingSetIcons.size, ' of ', iconsAllowed, ' available');
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-icons-summary m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderIcons: function renderIcons() {
    var _this = this;

    var kitToken = this.props.kitToken;
    var workingSetIconsRequest = this.requests.workingSetIcons;

    var rm = this.resourceManager();
    var workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();
    var sortedWorkingSetIcons = workingSetIcons.filter(function (record) {
      return !record.logo;
    }).sortBy(function (record) {
      return record.createdAt.unix();
    }).reverse();
    var cardElements = sortedWorkingSetIcons.take(NUMBER_OF_ICONS_NEEDED).map(function (workingSetIcon, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__IconCard__["a" /* default */], {
        key: workingSetIcon.id,
        kitToken: kitToken,
        workingSetIcon: workingSetIcon,
        onRemoveIcon: _this.handleRemovedIcon
      });
    });

    var elements = Object(__WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__["a" /* default */])(cardElements, {
      placeholder: __WEBPACK_IMPORTED_MODULE_14__IconCardPlaceholder__["a" /* default */],
      multipleOf: ICON_MULTIPLES,
      minimum: NUMBER_OF_ICONS_NEEDED,
      props: { kitToken: kitToken }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'grid-assets grid-assets-sm grid-assets-xs-11 kit-assets kit-assets-grid kit-assets-icons' }, elements);
  },
  render: function render() {
    var kitToken = this.props.kitToken;
    var _requests2 = this.requests,
        workingSetIconsRequest = _requests2.workingSetIcons,
        subscriptionRequest = _requests2.subscription;

    var mainRequests = [workingSetIconsRequest, subscriptionRequest];
    var rm = this.resourceManager();
    var workingSetIcons = rm.type(workingSetIconsRequest, 'working-set-icons').all();

    var addLabel = workingSetIcons.size > 0 ? 'Add' : 'Add your first ICON';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components_ResourcesMatching__["a" /* default */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons', className: 'link-dashed-none' }, 'Icons'), '\xA0\u2009', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__IconSettings__["a" /* default */], { kitToken: kitToken })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/new', className: 'link-dashed-none m-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle m-xs-r-xs' }), addLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/upload', className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components_Requesting__["a" /* default */], { any: mainRequests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components_Done__["a" /* default */], { all: mainRequests, render: this.renderIcons }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components_Done__["a" /* default */], { request: subscriptionRequest, render: this.renderUsingLabel }), '\xA0\xB7 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'Get More'))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(IconsSummary));

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TypefaceCard__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TypefaceCardPlaceholder__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TypefacesSettings__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_requests_components_Done__ = __webpack_require__(57);



















var NUMBER_OF_TYPEFACES_NEEDED = 4;
var TYPEFACE_MULTIPLES = 2;

var mapStateToProps = function mapStateToProps(state, props) {
  var kitToken = props.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var TypefacesSummary = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefacesSummary',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showSettings: false,
      settingsFocused: false,
      usingFocused: false,
      focusedOn: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      typefaceSettings: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings']
      })
    });

    this.setRequest({
      characterSets: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["b" /* GET */],
        url: ['api', 'character-sets']
      })
    });
  },
  handleUsingFocused: function handleUsingFocused() {
    this.setState({ usingFocused: !this.state.usingFocused });
  },
  handleSettingsFocused: function handleSettingsFocused() {
    this.setState({ settingsFocused: !this.state.settingsFocused });
  },
  handleSettingsClicked: function handleSettingsClicked(event) {
    event.preventDefault();

    this.setState({
      showSettings: true,
      settingsFocused: false
    });
  },
  handleSettingsClosed: function handleSettingsClosed() {
    this.setState({
      showSettings: false
    });
  },
  handleSettingsSaved: function handleSettingsSaved(typefaceSettings) {
    this.setRequest({
      updateTypefaceSettings: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["d" /* PUT */],
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
        record: typefaceSettings
      })
    });

    this.setState({
      showSettings: false
    });
  },
  handleRemoveWorkingSetTypeface: function handleRemoveWorkingSetTypeface(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new __WEBPACK_IMPORTED_MODULE_12_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_12_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        record: workingSetTypeface
      })
    });
  },
  renderUsingLabel: function renderUsingLabel() {
    var _requests = this.requests,
        workingSetTypefacesRequest = _requests.workingSetTypefaces,
        subscriptionRequest = _requests.subscription;

    var rm = this.resourceManager();
    var workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    var subscription = rm.type(subscriptionRequest, 'subscriptions').get();

    var typefacesPerKitAllowed = subscription.workingSetTypefacesAllowed;
    var typefacesAllowed = typefacesPerKitAllowed === Infinity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u221E') : typefacesPerKitAllowed;
    var popover = null;

    if (this.state.usingFocused) {
      popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], {
        noIcon: true,
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Using ', workingSetTypefaces.size, ' of ', typefacesAllowed, ' typefaces per kit', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'available in your plan')
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'use-count', onMouseOver: this.handleUsingFocused, onMouseOut: this.handleUsingFocused }, popover, 'Using ', workingSetTypefaces.size, ' of ', typefacesAllowed, ' available');
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-typefaces-summary m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderTypefaces: function renderTypefaces() {
    var _this = this;

    var kitToken = this.props.kitToken;
    var workingSetTypefacesRequest = this.requests.workingSetTypefaces;

    var rm = this.resourceManager();
    var workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();

    var sortedWorkingSetTypefaces = workingSetTypefaces.sortBy(function (record) {
      return record.createdAt.unix();
    }).reverse();
    var cardElements = sortedWorkingSetTypefaces.take(NUMBER_OF_TYPEFACES_NEEDED).map(function (workingSetTypeface, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TypefaceCard__["a" /* default */], {
        key: workingSetTypeface.id,
        kitToken: kitToken,
        workingSetTypeface: workingSetTypeface,
        onRemoveTypeface: _this.handleRemoveWorkingSetTypeface
      });
    });

    var elements = Object(__WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__["a" /* default */])(cardElements, {
      placeholder: __WEBPACK_IMPORTED_MODULE_10__TypefaceCardPlaceholder__["a" /* default */],
      multipleOf: TYPEFACE_MULTIPLES,
      minimum: NUMBER_OF_TYPEFACES_NEEDED,
      props: { kitToken: kitToken }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'grid-assets grid-assets-sm grid-assets-xs-2 kit-assets kit-assets-typefaces-sm' }, elements);
  },
  render: function render() {
    var kitToken = this.props.kitToken;
    var _requests2 = this.requests,
        workingSetTypefacesRequest = _requests2.workingSetTypefaces,
        subscriptionRequest = _requests2.subscription,
        typefaceSettingsRequest = _requests2.typefaceSettings,
        characterSetsRequest = _requests2.characterSets;

    var rm = this.resourceManager();
    var workingSetTypefaces = rm.type(workingSetTypefacesRequest, 'working-set-typefaces').all();
    var typefaceSettings = rm.type(typefaceSettingsRequest, 'typeface-settings').get();
    var characterSets = rm.type(characterSetsRequest, 'character-sets').all();

    var settingsFocused = this.state.settingsFocused;

    var addLabel = workingSetTypefaces && workingSetTypefaces.size > 0 ? 'Add' : 'Add your first TYPEFACE';
    var popover = settingsFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Typeface Settings', position: __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["a" /* TOOLTIP_POSITION_RIGHT */] }) : null;
    var settingsDataLoaded = rm.requests.isDone(typefaceSettingsRequest) && rm.requests.isDone(characterSetsRequest);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_requests_components_ResourcesMatching__["a" /* default */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces', className: 'link-dashed-none' }, 'Typefaces'), '\xA0\u2009', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
      href: '#',
      className: 'text-muted text-lg has-tooltip link-dashed-none',
      onClick: this.handleSettingsClicked,
      onMouseOver: this.handleSettingsFocused,
      onMouseOut: this.handleSettingsFocused
    }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components_Done__["a" /* default */], { all: [typefaceSettingsRequest, characterSetsRequest] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear' })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/new', className: 'link-dashed-none m-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle m-xs-r-xs' }), addLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/upload', className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_requests_components_Requesting__["a" /* default */], { request: workingSetTypefacesRequest, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components_Done__["a" /* default */], { request: workingSetTypefacesRequest, render: this.renderTypefaces }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components_Done__["a" /* default */], { request: subscriptionRequest, render: this.renderUsingLabel }), '\xA0\xB7 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'Get More')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TypefacesSettings__["a" /* default */], {
      show: this.state.showSettings && settingsDataLoaded,
      typefaceSettings: typefaceSettings,
      characterSets: characterSets,
      onClosed: this.handleSettingsClosed,
      onSaved: this.handleSettingsSaved
    })));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(TypefacesSummary));

/***/ }),

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedText__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RemoveTypefaceModal__ = __webpack_require__(217);










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefaceCard',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetTypeface: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired,
    onRemoveTypeface: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      isFocused: false,
      isRemoving: false,
      showConfirmRemoveModal: false,
      preparingToDelete: false
    };
  },
  removeWorkingSetTypeface: function removeWorkingSetTypeface() {
    this.setState({ isRemoving: true });

    this.props.onRemoveTypeface(this.props.workingSetTypeface);
  },
  handleFocused: function handleFocused() {
    this.setState({ isFocused: !this.state.isFocused });
  },
  handleRemoveClicked: function handleRemoveClicked(event) {
    event.preventDefault();
    event.stopPropagation();

    this.removeWorkingSetTypeface();
  },
  handleConfirmRemoveTypeface: function handleConfirmRemoveTypeface(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      showConfirmRemoveModal: true
    });
  },
  handleRemoveTypefaceConfirmed: function handleRemoveTypefaceConfirmed() {
    this.removeWorkingSetTypeface();

    this.setState({ showConfirmRemoveModal: false });
  },
  handleRemoveTypefaceClosed: function handleRemoveTypefaceClosed() {
    this.setState({ showConfirmRemoveModal: false });
  },
  handlePreparingToDelete: function handlePreparingToDelete() {
    this.setState({ preparingToDelete: true });
  },
  handleNotPreparingToDelete: function handleNotPreparingToDelete() {
    this.setState({ preparingToDelete: null });
  },
  renderFinished: function renderFinished() {
    var _props = this.props,
        kitToken = _props.kitToken,
        workingSetTypeface = _props.workingSetTypeface;
    var _state = this.state,
        isFocused = _state.isFocused,
        preparingToDelete = _state.preparingToDelete;
    var fontFamily = workingSetTypeface.family,
        fontWeight = workingSetTypeface.weight,
        fontStyle = workingSetTypeface.style;

    var typefaceName = fontFamily + ' ' + fontWeight + ' ' + (fontStyle !== 'normal' ? fontStyle : '');
    var popover = isFocused && !preparingToDelete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { icon: 'ficon-pencil', content: 'Edit ' + typefaceName }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], {
      to: '/kits/' + kitToken + '/typefaces/' + workingSetTypeface.id,
      className: 'kit-typeface asset asset-typeface link-dashed-none',
      onMouseOver: this.handleFocused,
      onMouseOut: this.handleFocused
    }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedText__["a" /* default */], { woff: workingSetTypeface.woff, className: 'kit-typeface-pangram' }, typefaceName, ' - When my six oclock alarm buzzes, I require a pot of good java.'))), this.renderRemoveWorkingSetTypeface(workingSetTypeface));
  },
  renderRemoveWorkingSetTypeface: function renderRemoveWorkingSetTypeface(workingSetTypeface) {
    var _state2 = this.state,
        isFocused = _state2.isFocused,
        preparingToDelete = _state2.preparingToDelete;
    var fontFamily = workingSetTypeface.family,
        fontWeight = workingSetTypeface.weight,
        fontStyle = workingSetTypeface.style;

    var typefaceName = fontFamily + ' ' + fontWeight + ' ' + (fontStyle !== 'normal' ? fontStyle : '');
    var makeDeleteTooltip = function makeDeleteTooltip() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], {
        icon: 'ficon-times-circle',
        content: 'Remove ' + typefaceName
      });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'asset-remove cursor-pointer',
      onClick: workingSetTypeface.custom ? this.handleConfirmRemoveTypeface : this.handleRemoveClicked,
      onMouseEnter: this.handlePreparingToDelete,
      onMouseLeave: this.handleNotPreparingToDelete
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RemoveTypefaceModal__["a" /* default */], {
      show: this.state.showConfirmRemoveModal,
      workingSetTypeface: workingSetTypeface,
      onRemovedTypeface: this.handleRemoveTypefaceConfirmed,
      onClosed: this.handleRemoveTypefaceClosed
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { position: 'relative' } }, isFocused && preparingToDelete ? makeDeleteTooltip() : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })));
  },
  renderErrored: function renderErrored() {
    var workingSetTypeface = this.props.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-typeface asset asset-error asset-typeface asset-typeface-error br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'inline-block text-danger word-wrap' }, 'Upload of ', workingSetTypeface.name, ' failed')), this.renderRemoveWorkingSetTypeface(workingSetTypeface));
  },
  renderProcessing: function renderProcessing() {
    var workingSetTypeface = this.props.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm' }), 'adding ', workingSetTypeface.name, ' \u2026'));
  },
  renderRemoving: function renderRemoving() {
    var workingSetTypeface = this.props.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm' }), 'removing ', workingSetTypeface.name, ' \u2026'));
  },
  render: function render() {
    var _props2 = this.props,
        workingSetTypeface = _props2.workingSetTypeface,
        kitToken = _props2.kitToken;
    var isRemoving = this.state.isRemoving;

    var value = null;

    switch (workingSetTypeface.status) {
      case 'finished':
        value = this.renderFinished();
        break;
      case 'errored':
        value = this.renderErrored();
        break;
      default:
        value = this.renderProcessing();
    }

    if (isRemoving) {
      value = this.renderRemoving();
    }

    return value;
  }
}));

/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_components_fillWithPlaceholders__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_requests_components_Done__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ImageSummaryCard__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ImageCardPlaceholder__ = __webpack_require__(464);
















var NUMBER_OF_IMAGES_NEEDED = 8;
var IMAGE_MULTIPLES = 4;

var mapStateToProps = function mapStateToProps(state, props) {
  var kitToken = props.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var ImagesSummary = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImagesSummary',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      usingFocused: false,
      showUsageBetaTooltip: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetImages: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-images']
      })
    });
  },
  handleUsingFocused: function handleUsingFocused() {
    this.setState({ usingFocused: !this.state.usingFocused });
  },
  toggleShowUsageBetaTooltip: function toggleShowUsageBetaTooltip() {
    this.setState({ showUsageBetaTooltip: !this.state.showUsageBetaTooltip });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all()
    };
  },
  renderImages: function renderImages() {
    var kitToken = this.props.kitToken;
    var workingSetImagesRequest = this.requests.workingSetImages;

    var rm = this.resourceManager();
    var workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();
    var sortedWorkingSetImages = workingSetImages.filter(function (record) {
      return record.status === "finished";
    }).sortBy(function (record) {
      return record.createdAt.unix();
    }).reverse();

    var cardElements = sortedWorkingSetImages.take(NUMBER_OF_IMAGES_NEEDED).map(function (workingSetImage, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ImageSummaryCard__["a" /* default */], {
        key: workingSetImage.id,
        kitToken: kitToken,
        workingSetImage: workingSetImage
      });
    });

    var elements = Object(__WEBPACK_IMPORTED_MODULE_6_utils_components_fillWithPlaceholders__["a" /* default */])(cardElements, {
      placeholder: __WEBPACK_IMPORTED_MODULE_14__ImageCardPlaceholder__["a" /* default */],
      multipleOf: IMAGE_MULTIPLES,
      minimum: NUMBER_OF_IMAGES_NEEDED,
      props: { kitToken: kitToken }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'grid-assets grid-assets-xs-4 kit-assets kit-assets-images-sm' }, elements);
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-images-summary m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderUsage: function renderUsage() {
    var _resources = this.resources(),
        workingSetImages = _resources.workingSetImages;

    var showUsageBetaTooltip = this.state.showUsageBetaTooltip;

    var imagesUsed = workingSetImages.size;
    var usageBetaTooltip = this.state.showUsageBetaTooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], { noIcon: true, content: "Use as many images as you'd like<br /> while this feature is in beta" }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onMouseEnter: this.toggleShowUsageBetaTooltip, onMouseLeave: this.toggleShowUsageBetaTooltip, className: 'text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'has-tooltip' }, usageBetaTooltip, 'Using ', imagesUsed, ' of \u221E available'));
  },
  render: function render() {
    var kitToken = this.props.kitToken;

    var rm = this.resourceManager();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components_ResourcesMatching__["a" /* default */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/images', className: 'link-dashed-none' }, 'Images')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/images/upload', className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-preview' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components_Requesting__["a" /* default */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components_Done__["a" /* default */], { all: true, render: this.renderImages })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-b-sm m-xs-t-0' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-footer' }, this.renderUsage())));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(ImagesSummary));

/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Tooltip__ = __webpack_require__(14);







var ImageSummaryCard = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImageSummaryCard',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetImage: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      imageFocused: false
    };
  },
  handleImageFocused: function handleImageFocused() {
    this.setState({ imageFocused: !this.state.imageFocused });
  },
  render: function render() {
    var _props = this.props,
        kitToken = _props.kitToken,
        workingSetImage = _props.workingSetImage;
    var imageFocused = this.state.imageFocused;

    var editTooltip = imageFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Tooltip__["d" /* default */], { content: 'Edit ' + workingSetImage.name, icon: 'ficon-pencil' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/images/' + workingSetImage.id, className: 'm-xs-b-lg asset asset-image link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner', onMouseOver: this.handleImageFocused, onMouseOut: this.handleImageFocused }, editTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview bg-img-checkered' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'asset-source', src: workingSetImage.optimizedUrl, alt: workingSetImage.name }))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ImageSummaryCard);

/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);









/* eslint-disable react/prop-types */
var MESSAGE_PROPS = {
  naming_issues: {
    alertType: 'danger',
    title: function title() {
      return 'Naming Issues';
    },
    body: function body(message) {
      var elements = Object.keys(message.payload).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: key }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-danger font-weight-semibold' }, key), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-long-arrow-right m-xs-x-xs' }), message.payload[key]);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Your site refers to the same icon in multiple ways. To keep them working, you need to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-danger font-weight-semibold' }, 'rename the following icons on your site'), ':'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'p-xs-l-lg m-xs-b-sm' }, elements));
    }
  },
  just_published: {
    alertType: 'success',
    title: function title() {
      return 'First Publish!';
    },
    body: function body(message, props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Nice work! Now you\'ll want to add your embed code to your site and check out your ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + props.kitToken + '/docs', className: 'text-success' }, 'documentation'), '.');
    }
  },
  publish_your_kit: {
    alertType: 'primary',
    title: function title() {
      return 'Publish Your Kit!';
    },
    body: function body() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Once you\'ve added your icons and typefaces, remember to publish your kit. We\'ll generate and update all your files so they\'re ready to use!');
    }
  },
  add_icons: {
    alertType: 'primary',
    title: function title() {
      return 'Add Icons?';
    },
    body: function body(message, props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Need some icons? You can ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + props.kitToken + '/icons/new' }, 'add icons'), ' or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + props.kitToken + '/icons/upload' }, 'upload your own'), '?');
    }
  },
  add_typefaces: {
    alertType: 'primary',
    title: function title() {
      return 'Add Typefaces?';
    },
    body: function body(message, props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Your kit has no typefaces. Want to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + props.kitToken + '/typefaces/new' }, 'add typefaces'), ' or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + props.kitToken + '/typefaces/upload' }, 'upload your own'), '?');
    }
  }
};
/* eslint-enable react/prop-types */

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var KitMessages = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitMessages',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    messages: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.list.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default.a],

  render: function render() {
    var _this = this;

    var messageElements = [];
    var messages = this.props.messages;

    messageElements = messages.map(function (message) {
      var messageProps = MESSAGE_PROPS[message.messageType];
      var deleteKitMessage = function deleteKitMessage(event) {
        event.preventDefault();

        _this.setRequest({
          deleteKitMessage: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
            method: __WEBPACK_IMPORTED_MODULE_7_requests__["a" /* DELETE */],
            url: ['api', 'kits', _this.props.kitToken, 'messages', message.id],
            record: message
          })
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: message.id, className: 'alert alert-' + messageProps.alertType + ' bg-body text-sm m-xs-y-md', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: deleteKitMessage, type: 'button', className: 'close close-dangle-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, messageProps.title(message, _this.props)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), messageProps.body(message, _this.props));
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, messageElements);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(KitMessages));

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components_Done__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_MainNavMixin__ = __webpack_require__(214);














var POLL_KIT_INTERVAL = 5 * 1000;
var SHOULD_TAKE_LESS_THAN = 5; // in minutes
var EXTRA_MINUTES = 5;
var POLL_KIT_TIMEOUT = (SHOULD_TAKE_LESS_THAN + EXTRA_MINUTES) * 60 * 1000;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;
  var next = ownProps.location.query.next;

  return {
    kitToken: kitToken,
    next: next,
    requests: state.requests
  };
};

var MigrateController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'MigrateController',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    next: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_MainNavMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      migrating: false,
      beganPolling: null,
      hasFinished: false,
      hasFailedMigration: false,
      hasTimedOut: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });
  },
  transitions: function transitions(register) {
    var migration = {
      request: this.requests.migrateKit,
      from: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["f" /* IS_QUEUED */],
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["a" /* HAS_ERRORS */],
      call: function call(rm) {
        this.beginPolling();
      }
    };

    register(Object.assign({}, migration, {
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["a" /* HAS_ERRORS */]
    }));

    register(Object.assign({}, migration, {
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["c" /* HAS_NO_CONTENT */]
    }));

    register(Object.assign({}, migration, {
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.setState({
          hasFailedMigration: true
        });
      }
    }));

    register({
      request: this.requests.kit,
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var kit = rm.type(this.requests.kit, 'kits').get();

        if (kit.version === 2) {
          // eslint-disable-line no-undef
          __WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken);
        } else {
          this.startMigration();
        }

        this.setState({ migrating: kit.migrating });
      }
    });

    register({
      request: this.requests.pollKit,
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var beganPolling = this.state.beganPolling;

        var kit = rm.type(this.requests.kit, 'kits').get();
        var hasTimedOut = Date.now() - beganPolling > POLL_KIT_TIMEOUT;
        var kitAtLatestVersion = kit.version === 2; // eslint-disable-line no-undef

        var migrating = kit.migrating;

        if (!hasTimedOut && !kitAtLatestVersion) {
          setTimeout(this.poll, POLL_KIT_INTERVAL);
        }

        if (hasTimedOut) {
          migrating = false;
        }

        this.setState({ migrating: migrating, hasFinished: kitAtLatestVersion, hasTimedOut: hasTimedOut });
      }
    });
  },
  startMigration: function startMigration() {
    this.setState({ migrating: true });

    this.setRequest({
      migrateKit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["c" /* POST */],
        url: ['api', 'kits', this.props.kitToken, 'migrations']
      })
    });
  },
  beginPolling: function beginPolling() {
    this.setState({
      beganPolling: Date.now()
    });

    setTimeout(this.poll, POLL_KIT_INTERVAL);
  },
  poll: function poll() {
    this.setRequest({
      pollKit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken],
        useCache: false
      })
    });
  },
  renderMigrationPending: function renderMigrationPending() {
    var _state = this.state,
        migrating = _state.migrating,
        hasTimedOut = _state.hasTimedOut;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-success-lightest p-xs-a-2x text-xs-center m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'm-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'animated pulseOpacity text-success infinite m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-md block' }), 'Patience. Maintaining your kit we are.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-xl font-weight-bold' }, 'Less than ', SHOULD_TAKE_LESS_THAN, ' minutes to complete this should take.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lead font-weight-normal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'We\'re updating some of your kit\'s behind-the-scenes technical details. None of your icons, typefaces, or images will be changed or published during this process.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-r-xs' }, 'Taking far longer than expected?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-danger' }, 'Let us know'))));
  },
  renderTimedOut: function renderTimedOut() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-danger-lightest p-xs-a-2x text-xs-center m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-danger m-xs-b-lg ' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-lg block' }), 'Failed, we have.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-xl font-weight-bold' }, 'Update your kit we could not. Help you must seek.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lead font-weight-normal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-r-xs' }, 'We were not able to complete maintenance on your kit. Please'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-danger' }, 'Let us know'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-l-xs' }, 'and we\'ll help get things back on track.'))));
  },
  renderMigrationFailed: function renderMigrationFailed() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-danger-lightest p-xs-a-2x text-xs-center m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-danger m-xs-b-lg ' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-lg block' }), 'Failed, we have.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-xl font-weight-bold' }, 'Update your kit we could not. Help you must seek.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lead font-weight-normal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-r-xs' }, 'We were not able to complete maintenance on your kit. Please'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-danger' }, 'Let us know'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-l-xs' }, 'and we\'ll help get things back on track.'))));
  },
  renderMigrationFinished: function renderMigrationFinished() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-success-lightest p-xs-a-2x text-xs-center m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'm-xs-b-lg ' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-b-sm text-success' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-lg block' }), 'Successful our mission was.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-xl font-weight-bold' }, 'For your patience we thank you.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead font-weight-normal' }, 'Your kit, and its contents have been polished and tuned to work with the latest and greatest Fort Awesome updates. Go ahead and jump back into making something awesome.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'btn btn-primary-outline btn-lg', href: this.props.next || '/kits/' + this.props.kitToken }, 'Okay, let\'s get back to work!'));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;
    var _requests = this.requests,
        kitRequest = _requests.kit,
        subscriptionRequest = _requests.subscription;

    var rm = this.resourceManager();
    var kit = rm.type(kitRequest, 'kits').find({ token: kitToken });
    var subscription = rm.type(subscriptionRequest, 'subscriptions').get();
    var _state2 = this.state,
        hasFinished = _state2.hasFinished,
        hasTimedOut = _state2.hasTimedOut,
        hasFailedMigration = _state2.hasFailedMigration;

    var value = null;

    if (hasFinished) {
      value = this.renderMigrationFinished();
    }

    if (!hasFinished) {
      value = this.renderMigrationPending();
    }

    if (hasTimedOut) {
      value = this.renderTimedOut();
    }

    if (hasFailedMigration) {
      value = this.renderMigrationFailed();
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-summary gg gg-middle m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'text-3x gg-col kit-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { className: 'link-dashed-none', to: '/kits/' + kit.token }, kit.name)))), this.renderNav(kit, subscription, { disabled: true }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-components' }, value));
  },
  render: function render() {
    var requests = [this.requests.kit, this.requests.subscription];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components_ResourcesMatching__["a" /* default */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components_Requesting__["a" /* default */], { any: requests }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_6_components_Spinner__["b" /* SIZE_LARGE */] }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components_Done__["a" /* default */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(MigrateController));

/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localstorage__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_components_fillWithPlaceholders__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IconCard__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IconCardPlaceholder__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IconSettings__ = __webpack_require__(461);

















var GRID_MINIMUM_ICONS_NEEDED = 16;
var GRID_ICON_MULTIPLES = 8;

var LIST_MINIMUM_ICONS_NEEDED = 10;
var LIST_ICON_MULTIPLES = 5;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var IconsController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconsController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_6_react_localstorage___default.a, __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      usingFocused: false,
      customFocused: false,
      showGridFocused: false,
      showListFocused: false,
      showIconsAsGrid: true,
      sortBy: 'updated_at',
      sortFunction: 'sortByRecentlyModified'
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });
  },
  getStateFilterKeys: function getStateFilterKeys() {
    return ['showIconsAsGrid', 'sortBy', 'sortFunction'];
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.removeWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_11_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.setRequest({
          workingSetIcons: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
            url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
            useCache: false
          })
        });
      }
    });
  },
  handleFocused: function handleFocused() {
    this.setState({ focused: !this.state.focused });
  },
  handleUsingFocused: function handleUsingFocused() {
    this.setState({ usingFocused: !this.state.usingFocused });
  },
  handleCustomFocused: function handleCustomFocused() {
    this.setState({ customFocused: !this.state.customFocused });
  },
  handleShowGridFocused: function handleShowGridFocused() {
    this.setState({ showGridFocused: !this.state.showGridFocused });
  },
  handleShowListFocused: function handleShowListFocused() {
    this.setState({ showListFocused: !this.state.showListFocused });
  },
  handleRemovedIcon: function handleRemovedIcon(workingSetIcon) {
    this.setRequest({
      removeWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', workingSetIcon.id],
        record: workingSetIcon
      })
    });
  },
  handleShowAsGrid: function handleShowAsGrid(event) {
    this.setState({ showIconsAsGrid: true });
  },
  handleShowAsList: function handleShowAsList(event) {
    this.setState({ showIconsAsGrid: false });
  },
  handleSort: function handleSort(event) {
    switch (event.target.value) {
      case 'created_at':
        this.setState({ sortBy: 'created_at', sortFunction: 'sortByRecentlyAdded' });
        break;
      case 'name':
        this.setState({ sortBy: 'name', sortFunction: 'sortByName' });
        break;
      default:
        this.setState({ sortBy: 'updated_at', sortFunction: 'sortByRecentlyModified' });
    }
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get()
    };
  },
  sortByRecentlyAdded: function sortByRecentlyAdded(workingSetIcons) {
    return workingSetIcons.sortBy(function (record) {
      return record.createdAt.unix();
    }).reverse();
  },
  sortByRecentlyModified: function sortByRecentlyModified(workingSetIcons) {
    return workingSetIcons.sortBy(function (record) {
      return record.updatedAt.unix();
    }).reverse();
  },
  sortByName: function sortByName(workingSetIcons) {
    return workingSetIcons.sortBy(function (record) {
      return record.name;
    });
  },
  renderUsingLabel: function renderUsingLabel() {
    var _resources = this.resources(),
        workingSetIcons = _resources.workingSetIcons,
        subscription = _resources.subscription;

    var iconsPerKitAllowed = subscription.iconsPerKitAllowed;
    var iconsAllowed = iconsPerKitAllowed === Infinity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u221E') : iconsPerKitAllowed;
    var popover = null;

    if (this.state.usingFocused) {
      popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], {
        noIcon: true,
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Using ', workingSetIcons.size, ' of ', iconsAllowed, ' icons per kit', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'available in your plan')
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'use-count', onMouseOver: this.handleUsingFocused, onMouseOut: this.handleUsingFocused }, popover, 'Using ', workingSetIcons.size, ' of ', iconsAllowed, ' available');
  },
  renderSortOptions: function renderSortOptions() {
    var sortBy = this.state.sortBy;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'inline-block valign-middle m-xs-l-lg kit-display-option' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'kit-icons-sort', className: 'sr-only' }, 'Sort Icons by:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { className: 'c-select br-a text-sm text text-muted', id: 'kit-icons-sort', value: sortBy, onChange: this.handleSort }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { value: 'updated_at' }, 'Recently Modified'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { value: 'created_at' }, 'Recently Added'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { value: 'name' }, 'A \u2014 Z'))));
  },
  renderViewOptions: function renderViewOptions() {
    var _state = this.state,
        showIconsAsGrid = _state.showIconsAsGrid,
        showGridFocused = _state.showGridFocused,
        showListFocused = _state.showListFocused;

    var gridActive = showIconsAsGrid ? 'active' : '';
    var listActive = showIconsAsGrid ? '' : 'active';
    var gridPopover = showGridFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Grid view' }) : null;
    var listPopover = showListFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], { noIcon: true, content: 'List view' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'inline-block valign-middle text-xs-right kit-display-option' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
      className: 'radio-inline m-xs-a-0 m-xs-r-md p-xs-a-0 view-option ' + gridActive,
      onClick: this.handleShowAsGrid,
      onMouseOver: this.handleShowGridFocused,
      onMouseOut: this.handleShowGridFocused
    }, gridPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-th ' + gridActive, title: 'View icons as grid' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', {
      className: 'radio-inline m-xs-a-0 p-xs-a-0 view-option ' + listActive,
      onClick: this.handleShowAsList,
      onMouseOver: this.handleShowListFocused,
      onMouseOut: this.handleShowListFocused
    }, listPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-th-list ' + listActive, title: 'View icons as list' }))));
  },
  renderCustomLabel: function renderCustomLabel() {
    var _resources2 = this.resources(),
        workingSetIcons = _resources2.workingSetIcons,
        subscription = _resources2.subscription;

    var customCount = workingSetIcons.filter(function (workingSetIcon) {
      return workingSetIcon.custom;
    }).size;
    var customAllowed = subscription.customIconsAllowed === Infinity ? '&infin;' : subscription.customIconsAllowed;

    var popover = null;

    if (this.state.customFocused) {
      popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], {
        noIcon: true,
        content: 'Using ' + customCount + ' of ' + customAllowed + ' uploaded icons<br>available in your plan'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'use-count-uploaded', onMouseOver: this.handleCustomFocused, onMouseOut: this.handleCustomFocused }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded' }), ' ', customCount);
  },
  renderFailureAlert: function renderFailureAlert() {
    var _resources3 = this.resources(),
        workingSetIcons = _resources3.workingSetIcons;

    var failedWorkingSetIcons = workingSetIcons.filter(function (workingSetIcon) {
      return workingSetIcon.status === 'errored';
    });

    var value = null;

    if (!failedWorkingSetIcons.isEmpty()) {
      value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-danger bg-body m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Upload your icons we could not.'), ' Please try again or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'danger' }, 'let us know'), ' if you continue to have trouble.');
    }

    return value;
  },
  renderIcons: function renderIcons() {
    var _this = this;

    var kitToken = this.props.kitToken;
    var _state2 = this.state,
        showIconsAsGrid = _state2.showIconsAsGrid,
        sortFunction = _state2.sortFunction;

    var _resources4 = this.resources(),
        workingSetIcons = _resources4.workingSetIcons;

    var sortedWorkingSetIcons = this[sortFunction](workingSetIcons.filter(function (record) {
      return !record.logo;
    }));
    var cardElements = sortedWorkingSetIcons.map(function (workingSetIcon, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__IconCard__["a" /* default */], {
        key: workingSetIcon.id,
        kitToken: kitToken,
        workingSetIcon: workingSetIcon,
        onRemoveIcon: _this.handleRemovedIcon,
        showInList: !showIconsAsGrid
      });
    }).push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__IconCardPlaceholder__["a" /* default */], { key: 'first-placeholder', kitToken: kitToken }));

    var elements = Object(__WEBPACK_IMPORTED_MODULE_7_utils_components_fillWithPlaceholders__["a" /* default */])(cardElements, {
      placeholder: __WEBPACK_IMPORTED_MODULE_14__IconCardPlaceholder__["a" /* default */],
      multipleOf: showIconsAsGrid ? GRID_ICON_MULTIPLES : LIST_ICON_MULTIPLES,
      minimum: showIconsAsGrid ? GRID_MINIMUM_ICONS_NEEDED : LIST_MINIMUM_ICONS_NEEDED,
      props: { kitToken: kitToken }
    });

    var spacingClass = showIconsAsGrid ? 'grid-assets-xs-8' : 'grid-assets-xs-5';
    var layoutClass = showIconsAsGrid ? 'kit-assets-grid animated fadeIn' : 'kit-assets-list animated fadeIn';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'grid-assets ' + spacingClass + ' kit-assets kit-assets-named ' + layoutClass + ' kit-assets-icons' }, elements);
  },
  renderCluestick: function renderCluestick() {
    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-y-md text-xs-center', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ficon-4x text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-captain-america ficon-fw' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-hawkeye ficon-fw' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-thor ficon-fw' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-ironman ficon-fw' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-upload-icon ficon-fw' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-md font-weight-semibold' }, 'Assemble the perfect icon set for your site!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead text-muted m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/new', className: 'text-white' }, 'Choose'), ' from our awesome icon sets and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/upload', className: 'text-white' }, 'upload your own'), '.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'We\u2019ll turn them into an icon font that\u2019s speedy, bulletproof, and super-simple-to-use (just like Font Awesome).'));
  },
  renderMain: function renderMain() {
    var _resources5 = this.resources(),
        workingSetIcons = _resources5.workingSetIcons;

    var cluestick = null;

    if (workingSetIcons.size === 0) {
      cluestick = this.renderCluestick();
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md gg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, this.renderUsingLabel(), ' \xB7 ', this.renderCustomLabel(), ' \xB7 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'Get More')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right p-xs-l-md' }, this.renderViewOptions(), this.renderSortOptions()))), cluestick, this.renderFailureAlert(), this.renderIcons());
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-icons m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_9_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    var kitToken = this.props.kitToken;

    var mainRequests = [this.requests.workingSetIcons, this.requests.subscription];

    var _resources6 = this.resources(),
        workingSetIcons = _resources6.workingSetIcons;

    var addLabel = null;

    if (workingSetIcons.size > 0) {
      addLabel = 'Add';
    } else {
      addLabel = 'Add your first ICON';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title gg-col' }, 'Icons \u2009', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__IconSettings__["a" /* default */], { kitToken: kitToken })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/new', className: 'link-dashed-none m-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle m-xs-r-xs' }), addLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/upload', className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["c" /* Requesting */], { any: mainRequests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { all: mainRequests, render: this.renderMain }))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(IconsController));

/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_WoffEmbeddedText__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__settings__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TypefacesSettings__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RemoveTypefaceModal__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TypefaceCardPlaceholder__ = __webpack_require__(462);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}



















var PAD_LIST_WITH_ADDS_TO = 4;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var TypefacesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefacesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showSettings: false,
      showAllowedTooltip: false,
      showCustomTooltip: false,
      showConfirmRemoveModalFor: null,
      preparingToDelete: null,
      focusedOn: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      typefaceSettings: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings']
      })
    });

    this.setRequest({
      characterSets: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["b" /* GET */],
        url: ['api', 'character-sets']
      })
    });
  },
  handleSettingsClicked: function handleSettingsClicked(event) {
    event.preventDefault();

    this.setState({
      showSettings: true
    });
  },
  handleSettingsClosed: function handleSettingsClosed() {
    this.setState({
      showSettings: false
    });
  },
  handleSettingsSaved: function handleSettingsSaved(typefaceSettings) {
    this.setRequest({
      updateTypefaceSettings: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["d" /* PUT */],
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
        record: typefaceSettings
      })
    });

    this.setState({
      showSettings: false
    });
  },
  removeWorkingSetTypeface: function removeWorkingSetTypeface(workingSetTypeface) {
    this.setState({
      isRemoving: workingSetTypeface
    });

    this.setRequest({
      removeWorkingSetTypeface: new __WEBPACK_IMPORTED_MODULE_11_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_11_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        record: workingSetTypeface
      })
    });
  },
  handleConfirmedRemoveTypeface: function handleConfirmedRemoveTypeface(workingSetTypeface) {
    this.removeWorkingSetTypeface(workingSetTypeface);

    this.setState({ showConfirmRemoveModalFor: null });
  },
  handleCloseConfirmRemoveTypeface: function handleCloseConfirmRemoveTypeface() {
    this.setState({ showConfirmRemoveModalFor: null });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all(),
      typefaceSettings: rm.type(this.requests.typefaceSettings, 'typeface-settings').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get()
    };
  },
  renderRemoveWorkingSetTypeface: function renderRemoveWorkingSetTypeface(workingSetTypeface) {
    var _this = this;

    var focusedOn = this.state.focusedOn === workingSetTypeface;
    var fontFamily = workingSetTypeface.family,
        fontWeight = workingSetTypeface.weight,
        fontStyle = workingSetTypeface.style;

    var typefaceName = fontFamily + ' ' + fontWeight + ' ' + (fontStyle !== 'normal' ? fontStyle : '');
    var preparingToDelete = this.state.preparingToDelete === workingSetTypeface;
    var handleDeleteClicked = function handleDeleteClicked(event) {
      event.preventDefault();
      event.stopPropagation();

      _this.removeWorkingSetTypeface(workingSetTypeface);
    };
    var confirmRemoveTypeface = function confirmRemoveTypeface(event) {
      event.preventDefault();
      event.stopPropagation();

      _this.setState({ showConfirmRemoveModalFor: workingSetTypeface });
    };
    var handlePreparingToDelete = function handlePreparingToDelete() {
      _this.setState({ preparingToDelete: workingSetTypeface });
    };
    var handleNotPreparingToDelete = function handleNotPreparingToDelete() {
      _this.setState({ preparingToDelete: null });
    };
    var makeDeleteTooltip = function makeDeleteTooltip() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["d" /* default */], {
        icon: 'ficon-times-circle',
        position: __WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["a" /* TOOLTIP_POSITION_RIGHT */],
        content: 'Remove ' + typefaceName
      });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'asset-remove cursor-pointer',
      onClick: workingSetTypeface.custom ? confirmRemoveTypeface : handleDeleteClicked,
      onMouseEnter: handlePreparingToDelete,
      onMouseLeave: handleNotPreparingToDelete
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { position: 'relative' } }, focusedOn && preparingToDelete ? makeDeleteTooltip() : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })));
  },
  renderWorkingSetTypefaceFinished: function renderWorkingSetTypefaceFinished(workingSetTypeface) {
    var _this2 = this;

    var fontFamily = workingSetTypeface.family,
        fontWeight = workingSetTypeface.weight,
        fontStyle = workingSetTypeface.style;

    var typefaceName = fontFamily + ' ' + fontWeight + ' ' + (fontStyle !== 'normal' ? fontStyle : '');
    var makeEditViewTooltip = function makeEditViewTooltip() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["d" /* default */], {
        icon: 'ficon-pencil',
        position: __WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["b" /* TOOLTIP_POSITION_TOP */],
        content: 'Edit ' + typefaceName
      });
    };
    var focusedOn = this.state.focusedOn === workingSetTypeface;
    var preparingToDelete = this.state.preparingToDelete === workingSetTypeface;
    var handleFocusedOnTypeface = function handleFocusedOnTypeface() {
      _this2.setState({ focusedOn: workingSetTypeface });
    };
    var handleFocusedOnNothing = function handleFocusedOnNothing() {
      _this2.setState({ focusedOn: null });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], {
      key: 'working-set-typeface-' + workingSetTypeface.id,
      to: '/kits/' + this.props.kitToken + '/typefaces/' + workingSetTypeface.id,
      className: 'kit-typeface kit-typeface-emphasis asset asset-typeface link-dashed-none br-a',
      onMouseEnter: handleFocusedOnTypeface,
      onMouseLeave: handleFocusedOnNothing
    }, focusedOn && !preparingToDelete ? makeEditViewTooltip() : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_WoffEmbeddedText__["a" /* default */], {
      className: 'kit-typeface-pangram',
      text: __WEBPACK_IMPORTED_MODULE_13__settings__["c" /* TYPEFACE_PREVIEW_SPECIMEN */],
      woff: workingSetTypeface.woff
    }))), this.renderRemoveWorkingSetTypeface(workingSetTypeface));
  },
  renderWorkingSetTypefaceErrored: function renderWorkingSetTypefaceErrored(workingSetTypeface) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'working-set-typeface-' + workingSetTypeface.id, className: 'kit-typeface asset asset-error asset-typeface asset-typeface-error br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'inline-block text-danger word-wrap' }, 'Upload of ', workingSetTypeface.name, ' failed')), this.renderRemoveWorkingSetTypeface(workingSetTypeface));
  },
  renderWorkingSetTypefaceProcessing: function renderWorkingSetTypefaceProcessing(workingSetTypeface) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'working-set-typeface-' + workingSetTypeface.id, className: 'kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm' }), 'adding ', workingSetTypeface.name, ' \u2026'));
  },
  renderWorkingSetTypefaceRemoving: function renderWorkingSetTypefaceRemoving(workingSetTypeface) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'working-set-typeface-' + workingSetTypeface.id, className: 'kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm' }), 'removing ', workingSetTypeface.name, ' \u2026'));
  },
  renderFailureAlert: function renderFailureAlert() {
    var _resources = this.resources(),
        workingSetTypefaces = _resources.workingSetTypefaces;

    var failedWorkingSetTypefaces = workingSetTypefaces.filter(function (workingSetTypeface) {
      return workingSetTypeface.status === 'errored';
    });

    var value = null;

    if (!failedWorkingSetTypefaces.isEmpty()) {
      value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-danger bg-body m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Upload your typefaces we could not.'), ' Please try again or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-danger' }, 'let us know'), ' if you continue to have trouble.');
    }

    return value;
  },
  renderWorkingSetTypeface: function renderWorkingSetTypeface(workingSetTypeface) {
    var isRemoving = this.state.isRemoving;

    var value = null;

    switch (workingSetTypeface.status) {
      case 'finished':
        value = this.renderWorkingSetTypefaceFinished(workingSetTypeface);
        break;
      case 'errored':
        value = this.renderWorkingSetTypefaceErrored(workingSetTypeface);
        break;
      default:
        value = this.renderWorkingSetTypefaceProcessing(workingSetTypeface);
    }

    if (workingSetTypeface === isRemoving) {
      value = this.renderWorkingSetTypefaceRemoving(workingSetTypeface);
    }

    return value;
  },
  renderGroups: function renderGroups() {
    var _this3 = this;

    var _resources2 = this.resources(),
        workingSetTypefaces = _resources2.workingSetTypefaces;

    var needsThisManyAdds = workingSetTypefaces.size >= PAD_LIST_WITH_ADDS_TO ? 1 : PAD_LIST_WITH_ADDS_TO - workingSetTypefaces.size;
    var groupedWorkingSetTypefaceElements = workingSetTypefaces.groupBy(function (workingSetTypeface) {
      return workingSetTypeface.family;
    }).sortBy(function (_, family) {
      return family;
    }).map(function (groupedWorkingSetTypefaces, family) {
      var stylesCount = groupedWorkingSetTypefaces.size;
      var makeFamilySummary = function makeFamilySummary() {
        var label = stylesCount === 1 ? 'Style' : 'Styles';
        var sizes = groupedWorkingSetTypefaces.map(function (workingSetTypeface) {
          var style = workingSetTypeface.style === 'normal' ? '' : workingSetTypeface.style;
          var size = workingSetTypeface.optimizedSize ? __WEBPACK_IMPORTED_MODULE_4_numeral___default()(workingSetTypeface.optimizedSize).format('0b') : '?';

          return workingSetTypeface.weight + ' ' + style + ' (' + size + ')';
        }).join(' · ');

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pull-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, stylesCount, ' ', label), ' \xB7 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, sizes));
      };
      var workingSetTypefaceElements = groupedWorkingSetTypefaces.map(_this3.renderWorkingSetTypeface);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-typeface-group m-xs-b-lg', key: 'typeface-' + family }, workingSetTypefaceElements, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted asset-label', 'data-role': 'group-details' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-typeface-group-name', 'data-role': 'group-name' }, family), makeFamilySummary()));
    });
    var addElements = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Range"])(0, needsThisManyAdds).map(function (index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TypefaceCardPlaceholder__["a" /* default */], { key: 'add-typeface-' + index, kitToken: _this3.props.kitToken });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-assets kit-assets-named kit-assets-typefaces' }, [].concat(_toConsumableArray(groupedWorkingSetTypefaceElements.values())), addElements);
  },
  renderUsage: function renderUsage() {
    function toggleTooltip(what) {
      var nextState = {};
      nextState[what] = !this.state[what];
      this.setState(nextState);
    }

    var _resources3 = this.resources(),
        workingSetTypefaces = _resources3.workingSetTypefaces,
        subscription = _resources3.subscription;

    var _state = this.state,
        showAllowedTooltip = _state.showAllowedTooltip,
        showCustomTooltip = _state.showCustomTooltip;

    var typefacesAllowed = subscription.workingSetTypefacesAllowed;
    var typefacesUsed = workingSetTypefaces.size;
    var typefacesOutOf = typefacesAllowed === Infinity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u221E') : typefacesAllowed;

    var customTypefacesAllowed = subscription.customTypefacesAllowed;
    var customUsed = workingSetTypefaces.filter(function (i) {
      return i.custom;
    }).size;
    var customOutOf = customTypefacesAllowed === Infinity ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u221E') : customTypefacesAllowed;

    var makeTooltip = function makeTooltip(used, outOf, what) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["d" /* default */], {
        noIcon: true,
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Using ', used, ' of ', outOf, ' ', what, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), ' per kit available in your plan')
      });
    };

    var allowedTooltip = showAllowedTooltip ? makeTooltip(typefacesUsed, typefacesOutOf, 'typefaces') : null;
    var customTooltip = showCustomTooltip ? makeTooltip(customUsed, customOutOf, 'uploaded typefaces') : null;
    var toggleAllowed = toggleTooltip.bind(this, 'showAllowedTooltip');
    var toggleCustom = toggleTooltip.bind(this, 'showCustomTooltip');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      onMouseEnter: toggleAllowed,
      onMouseLeave: toggleAllowed,
      style: { position: 'relative' },
      className: 'text-muted'
    }, allowedTooltip, 'Using ', typefacesUsed, ' of ', typefacesOutOf, ' available'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, ' \xB7 '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      onMouseEnter: toggleCustom,
      onMouseLeave: toggleCustom,
      style: { position: 'relative' },
      className: 'use-count-uploaded'
    }, customTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded' }), ' ', customUsed), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, ' \xB7 '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'Get More'));
  },
  renderCluestick: function renderCluestick() {
    var kitToken = this.props.kitToken;

    var _resources4 = this.resources(),
        workingSetTypefaces = _resources4.workingSetTypefaces;

    var cluestickElement = null;

    if (workingSetTypefaces.size === 0) {
      cluestickElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-y-md text-xs-center', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-typeface ficon-5x' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-md font-weight-semibold' }, 'Shrink and serve your site\u2019s typefaces!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead text-muted m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/new', className: 'text-white' }, 'Choose'), ' from our hand-picked typefaces and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/upload', className: 'text-white' }, 'upload your own'), '.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'We\u2019ll help you subset down to just the languages your site uses, then serve them up right on your site.'));
    }

    return cluestickElement;
  },
  renderRemoveTypefaceModal: function renderRemoveTypefaceModal() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RemoveTypefaceModal__["a" /* default */], {
      show: !!this.state.showConfirmRemoveModalFor,
      workingSetTypeface: this.state.showConfirmRemoveModalFor,
      onRemovedTypeface: this.handleConfirmedRemoveTypeface,
      onClosed: this.handleCloseConfirmRemoveTypeface
    });
  },
  renderSpinner: function renderSpinner() {
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-typefaces m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_8_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    var kitToken = this.props.kitToken;
    var _requests = this.requests,
        workingSetTypefacesRequest = _requests.workingSetTypefaces,
        subscriptionRequest = _requests.subscription,
        typefaceSettingsRequest = _requests.typefaceSettings,
        characterSetsRequest = _requests.characterSets;

    var _resources5 = this.resources(),
        workingSetTypefaces = _resources5.workingSetTypefaces,
        typefaceSettings = _resources5.typefaceSettings,
        characterSets = _resources5.characterSets;

    var addLabel = workingSetTypefaces.size > 0 ? 'Add Typefaces' : 'Add your first TYPEFACE';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title gg-col' }, 'Typefaces \u2009', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleSettingsClicked, href: '#', className: 'text-muted text-lg has-tooltip link-dashed-none valign-middle m-xs-l-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { all: [typefaceSettingsRequest, characterSetsRequest] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear' })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/new', className: 'link-dashed-none m-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle m-xs-r-xs' }), addLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/upload', className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { all: [workingSetTypefacesRequest, subscriptionRequest], render: this.renderUsage }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { request: workingSetTypefacesRequest, render: this.renderCluestick }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { request: workingSetTypefacesRequest, render: this.renderFailureAlert }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { request: workingSetTypefacesRequest, render: this.renderGroups }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["c" /* Requesting */], { request: workingSetTypefacesRequest, render: this.renderSpinner })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { request: workingSetTypefacesRequest, render: this.renderRemoveTypefaceModal }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_requests_components__["a" /* Done */], { all: [typefaceSettingsRequest, characterSetsRequest] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TypefacesSettings__["a" /* default */], {
      show: this.state.showSettings,
      typefaceSettings: typefaceSettings,
      characterSets: characterSets,
      onClosed: this.handleSettingsClosed,
      onSaved: this.handleSettingsSaved
    })));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(TypefacesController));

/***/ }),

/***/ 1015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Facets__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_StylesheetLink__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ImageCard__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ImageCardPlaceholder__ = __webpack_require__(464);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}





















var NUMBER_OF_IMAGES_NEEDED = 16;
var IMAGE_MULTIPLES = 4;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests,
    jobs: state.jobs
  };
};

var ImagesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImagesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_14_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__["d" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      deleting: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(),
      refreshing: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(),
      showConfirmDeleteImage: null,
      showUsageBetaTooltip: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetImages: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-images']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.refreshWorkingSetImage,
      to: __WEBPACK_IMPORTED_MODULE_14_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var workingSetImage = rm.type(this.requests.refreshWorkingSetImage, 'working-set-images').get();

        this.setState({
          refreshing: this.state.refreshing.filterNot(function (n) {
            return n.id === workingSetImage.id;
          })
        });
      }
    });
  },
  isDeleting: function isDeleting(workingSetImage) {
    var deletingIds = this.state.deleting.map(function (n) {
      return n.id;
    });

    return deletingIds.includes(workingSetImage.id);
  },
  handleDeleteImage: function handleDeleteImage(workingSetImage) {
    this.setState({
      deleting: this.state.deleting.push(workingSetImage)
    });

    this.setRequest({
      deletingWorkingSetImage: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', workingSetImage.id],
        record: workingSetImage
      })
    });
  },
  toggleShowUsageBetaTooltip: function toggleShowUsageBetaTooltip() {
    this.setState({ showUsageBetaTooltip: !this.state.showUsageBetaTooltip });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get()
    };
  },
  renderHeaderIntro: function renderHeaderIntro(withCluestick) {
    var alertClassname = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('well m-xs-b-lg text-xs-center', { 'br-t-0 bg-info-dark': withCluestick }, { 'bg-info': !withCluestick });

    var labelClassname = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('label font-weight-semibold text-white inline-block valign-middle m-xs-r-md p-xs-a-sm', { 'bg-info': withCluestick }, { 'bg-info-light': !withCluestick });

    var cluestick = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-b-0 text-xs-center br-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-5x ficon-curate' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-md font-weight-semibold' }, 'Let us frame your images for the web!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead text-muted m-xs-b-0' }, 'Upload an image and we\u2019ll automatically make it smaller. No visible quality loss, no resizing. It\u2019s awesome.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, withCluestick ? cluestick : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: alertClassname }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: labelClassname }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'This feature is in '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-upper text-tracking' }, 'Beta')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 inline-block valign-middle text-muted' }, 'We\u2019re still polishing up this feature. If you have any trouble, feedback, or notice anything, ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-white' }, 'let us know'), '.')));
  },
  renderUsage: function renderUsage() {
    var _resources = this.resources(),
        workingSetImages = _resources.workingSetImages;

    var showUsageBetaTooltip = this.state.showUsageBetaTooltip;

    var imagesUsed = workingSetImages.size;
    var usageBetaTooltip = this.state.showUsageBetaTooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["d" /* default */], { noIcon: true, content: "Use as many images as you'd like<br /> while this feature is in beta" }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onMouseEnter: this.toggleShowUsageBetaTooltip, onMouseLeave: this.toggleShowUsageBetaTooltip, className: 'text-muted m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'has-tooltip' }, usageBetaTooltip, 'Using ', imagesUsed, ' of \u221E available'));
  },
  renderMain: function renderMain() {
    var _this = this;

    var kitToken = this.props.kitToken;

    var _resources2 = this.resources(),
        workingSetImages = _resources2.workingSetImages;

    var workingSetImagesElements = workingSetImages.sort(function (a, b) {
      var val = 0;
      var aJobState = _this.jobState(a);
      var bJobState = _this.jobState(b);

      if (a.createdAt.isAfter(b.createdAt)) {
        val = -1;
      } else if (b.createdAt.isAfter(a.createdAt)) {
        val = 1;
      }

      if (aJobState === __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__["b" /* FINISHED */] && bJobState === __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__["c" /* PROCESSING */]) {
        val = 1;
      } else if (bJobState === __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__["b" /* FINISHED */] && aJobState === __WEBPACK_IMPORTED_MODULE_16__mixins_JobMixin__["c" /* PROCESSING */]) {
        val = -1;
      }

      return val;
    }).map(function (workingSetImage) {
      var jobState = _this.jobState(workingSetImage);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ImageCard__["a" /* default */], {
        key: workingSetImage.id,
        kitToken: kitToken,
        workingSetImage: workingSetImage,
        jobState: jobState,
        isDeleting: _this.isDeleting(workingSetImage),
        onDeleteImage: _this.handleDeleteImage
      });
    });

    var elements = Object(__WEBPACK_IMPORTED_MODULE_8_utils_components_fillWithPlaceholders__["a" /* default */])(workingSetImagesElements, {
      placeholder: __WEBPACK_IMPORTED_MODULE_18__ImageCardPlaceholder__["a" /* default */],
      multipleOf: IMAGE_MULTIPLES,
      minimum: NUMBER_OF_IMAGES_NEEDED,
      props: { kitToken: kitToken }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-components' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-summary m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-header gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'kit-asset-title gg-col' }, 'Images'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-asset-actions gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { className: 'link-dashed-none', to: '/kits/' + this.props.kitToken + '/images/upload' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded m-xs-r-xs' }), 'Upload'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-sm' }), this.renderUsage(), this.renderHeaderIntro(!workingSetImagesElements.size > 0), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'grid-assets grid-assets-xs-4 kit-assets kit-assets-named kit-assets-images-md' }, [].concat(_toConsumableArray(elements)))));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-images m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_11_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    var _requests = this.requests,
        workingSetImagesRequest = _requests.workingSetImages,
        subscriptionRequest = _requests.subscription;

    var mainRequests = [workingSetImagesRequest, subscriptionRequest];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["c" /* Requesting */], { any: mainRequests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["a" /* Done */], { all: mainRequests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(ImagesController));

/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_JobMixin__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RemoveImageModal__ = __webpack_require__(468);










var ImageCard = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImageCard',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    jobState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_7__mixins_JobMixin__["c" /* PROCESSING */], __WEBPACK_IMPORTED_MODULE_7__mixins_JobMixin__["b" /* FINISHED */], __WEBPACK_IMPORTED_MODULE_7__mixins_JobMixin__["a" /* ERRORED */]]).isRequired,
    isDeleting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    workingSetImage: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record.isRequired,
    onDeleteImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      imageFocused: false,
      removeFocused: false,
      showConfirmation: false
    };
  },
  handleShowConfirmRemoveImage: function handleShowConfirmRemoveImage(event) {
    event.preventDefault();

    this.setState({ showConfirmation: true });
  },
  handleRemoveImageCanceled: function handleRemoveImageCanceled() {
    this.setState({ showConfirmation: false });
  },
  handleRemoveImageConfirmed: function handleRemoveImageConfirmed(event) {
    var _this = this;

    if (event && event.preventDefault) {
      event.preventDefault();
    }

    this.setState({ showConfirmation: false }, function () {
      _this.props.onDeleteImage(_this.props.workingSetImage);
    });
  },
  handleImageFocused: function handleImageFocused() {
    this.setState({ imageFocused: !this.state.imageFocused });
  },
  handleRemoveFocused: function handleRemoveFocused(event) {
    this.setState({ removeFocused: !this.state.removeFocused });
  },
  renderRemoveImageModal: function renderRemoveImageModal() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RemoveImageModal__["a" /* default */], {
      show: this.state.showConfirmation,
      workingSetImage: this.props.workingSetImage,
      onRemovedImage: this.handleRemoveImageConfirmed,
      onClosed: this.handleRemoveImageCanceled
    });
  },
  renderAssetRemove: function renderAssetRemove() {
    var removeFocused = this.state.removeFocused;

    var removeTooltip = removeFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { content: 'Delete Image', icon: 'ficon-trash' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'asset-remove cursor-pointer',
      onClick: this.handleShowConfirmRemoveImage,
      onMouseOver: this.handleRemoveFocused,
      onMouseOut: this.handleRemoveFocused
    }, removeTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }));
  },
  renderFailedAssetRemove: function renderFailedAssetRemove() {
    var removeFocused = this.state.removeFocused;

    var removeTooltip = removeFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { content: 'Clear', icon: 'ficon-times' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'asset-remove cursor-pointer',
      onClick: this.handleShowConfirmRemoveImage,
      onMouseOver: this.handleRemoveFocused,
      onMouseOut: this.handleRemoveFocused
    }, removeTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }));
  },
  renderTransitional: function renderTransitional(workingSetImage, label) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset asset-processing asset-image asset-image-processing br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block word-wrap p-xs-x-md' }, label + ' ' + workingSetImage.name)));
  },
  renderProcessing: function renderProcessing(workingSetImage) {
    return this.renderTransitional(workingSetImage, 'optimizing');
  },
  renderDeleting: function renderDeleting(workingSetImage) {
    return this.renderTransitional(workingSetImage, 'deleting');
  },
  renderErrored: function renderErrored(workingSetImage) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset asset-image asset-error asset-image-failed br-a', onMouseOver: this.handleImageFocused, onMouseOut: this.handleImageFocused }, this.renderRemoveImageModal(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center line-height-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block text-danger word-wrap p-xs-x-md' }, 'Upload of ', workingSetImage.name, ' failed.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + this.props.kitToken + '/images/upload', className: 'text-danger block' }, 'Try again')), this.renderFailedAssetRemove());
  },
  renderFinished: function renderFinished(workingSetImage) {
    var imageFocused = this.state.imageFocused;

    var editTooltip = imageFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { content: 'Edit ' + workingSetImage.name, icon: 'ficon-pencil' }) : null;
    var percentSaved = workingSetImage.optimizedSize / workingSetImage.originalSize * 100;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + this.props.kitToken + '/images/' + workingSetImage.id, className: 'asset asset-image link-dashed-none' }, this.renderRemoveImageModal(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner', onMouseOver: this.handleImageFocused, onMouseOut: this.handleImageFocused }, editTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview bg-img-checkered' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'asset-source', src: workingSetImage.optimizedUrl, alt: workingSetImage.name })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-performance image-performance-sm bg-gray-lighter m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'image-performance-value br-r bg-primary', style: { width: percentSaved + '%' } })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-label text-sm gg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col gg-col-1 p-xs-r-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 text-truncate' }, workingSetImage.name)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col gg-col-1 text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-nowrap m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'File size: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-primary' }, __WEBPACK_IMPORTED_MODULE_5_numeral___default()(workingSetImage.optimizedSize).format('0.0 b')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted m-xs-l-xs text-strike' }, __WEBPACK_IMPORTED_MODULE_5_numeral___default()(workingSetImage.originalSize).format('0.0 b')))))), this.renderAssetRemove());
  },
  render: function render() {
    var _props = this.props,
        workingSetImage = _props.workingSetImage,
        jobState = _props.jobState,
        isDeleting = _props.isDeleting;

    var value = null;

    switch (workingSetImage.status) {
      case "finished":
        value = this.renderFinished(workingSetImage);
        break;
      case "errored":
        value = this.renderErrored(workingSetImage);
        break;
      default:
        value = this.renderProcessing(workingSetImage);
    }

    if (isDeleting) {
      value = this.renderDeleting(workingSetImage);
    }

    return value;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ImageCard);

/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);











var POPOVER_TIMEOUT = 2000; // in ms

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var DocumentationController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DocumentationController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      shareableDocumentationUrlCopied: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.props.kitToken })
    };
  },
  handleShareableDocumentationCopied: function handleShareableDocumentationCopied() {
    var _this = this;

    var disable = function disable() {
      return _this.setState({ shareableDocumentationUrlCopied: false });
    };

    this.setState({ shareableDocumentationUrlCopied: true }, function () {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },
  renderShareResourceDoc: function renderShareResourceDoc() {
    var _resources = this.resources(),
        kit = _resources.kit;

    var shareableDocumentationUrlCopied = this.state.shareableDocumentationUrlCopied;

    var shareableDocumentationUrl = '' + location.origin + kit.shareableDocumentationPath;
    var shareableDocumentationUrlPopover = shareableDocumentationUrlCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Doc Link Copied!' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-body m-xs-b-lg p-xs-x-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-share ficon-2x text-gray-lighter m-xs-r-sm block m-xs-b-sm' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col p-xs-l-sm p-xs-r-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Share this doc'), ' with your team, clients, or your bookmarks.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col bg-gray-lighter inset p-xs-x-md p-xs-y-sm br-l' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shareable-doc-url' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-truncate' }, shareableDocumentationUrl))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, shareableDocumentationUrlPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default.a, { text: shareableDocumentationUrl, onCopy: this.handleShareableDocumentationCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0', title: 'Copy' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' }))))))));
  },
  renderMain: function renderMain() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.renderShareResourceDoc(), this.props.children);
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-documentation m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(DocumentationController));

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({ viewBox: "0 0 1008 1008" }, this.props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { fill: "currentColor", d: "M432 936h504V576H702q-22 0-38-16t-16-38V288H432v648zm144-810V90q0-8-5-13t-13-5H162q-8 0-13 5t-5 13v36q0 8 5 13t13 5h396q8 0 13-5t5-13zm144 378h168L720 336v168zm288 72v378q0 22-16 38t-38 16H414q-22 0-38-16t-16-38v-90H54q-22 0-38-16T0 810V54q0-22 16-38T54 0h612q22 0 38 16t16 38v185q12 7 20 15l230 230q16 16 27 43t11 49z" }));
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SVG);

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UploadIconForm__ = __webpack_require__(474);













var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var UploadLogoController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadLogoController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return this.upgradeModalState(this.props);
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'subscriptions'],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */]
      })
    });

    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */]
      })
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState(this.upgradeModalState(nextProps));

    var rm = this.resourceManager(nextProps);

    if (rm.requests.isDone(this.requests.refreshWorkingSetIcons)) {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/icons');
    }
  },
  upgradeModalState: function upgradeModalState(props) {
    var showUpgradeModal = this.state ? this.state.showUpgradeModal : false;
    var upgradeModalReason = this.state ? this.state.upgradeModalReason : null;

    if (!this.canAddCustomIcons(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["d" /* NO_CUSTOM_ICONS_ALLOWED */];
    }

    if (this.maxedOutForCustomIcons(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["a" /* MAX_CUSTOM_ICONS */];
    }

    if (!this.canAddIconsToKit(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["b" /* MAX_ICONS_PER_KIT */];
    }

    return { showUpgradeModal: showUpgradeModal, upgradeModalReason: upgradeModalReason };
  },
  canAddCustomIcons: function canAddCustomIcons(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddCustomIcons = true;

    if (rm.requests.isDone(this.requests.subscription)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();

      canAddCustomIcons = subscription.customIconsAllowed > 0;
    }

    return canAddCustomIcons;
  },
  maxedOutForCustomIcons: function maxedOutForCustomIcons(props) {
    if (!this.requests) {
      return false;
    }

    var rm = this.resourceManager(props || this.props);
    var maxedOutForCustomIcons = false;

    if (rm.requests.allDone([this.requests.subscription, this.requests.customIcons])) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();
      var customIcons = rm.type(this.requests.customIcons, 'icons').all();

      maxedOutForCustomIcons = subscription.customIconsAllowed <= customIcons.size;
    }

    return maxedOutForCustomIcons;
  },
  canAddIconsToKit: function canAddIconsToKit(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddIconsToKit = true;

    if (rm.requests.isDone(this.requests.subscription) && rm.requests.isDone(this.requests.workingSetIcons)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();
      var workingSetIcons = rm.type(this.requests.workingSetIcons, 'working-set-icons').all();

      canAddIconsToKit = workingSetIcons.size < subscription.iconsPerKitAllowed;
    }

    return canAddIconsToKit;
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all()
    };
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    location.assign('/upgrade');
  },
  handleHideUpgradeModal: function handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false
    });
  },
  handleUploadIconClicked: function handleUploadIconClicked() {
    if (!this.canAddCustomIcons()) {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["d" /* NO_CUSTOM_ICONS_ALLOWED */]
      });
    }
  },
  handleUploadIconSucceeded: function handleUploadIconSucceeded() {
    this.setRequest({
      refreshWorkingSetIcons: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        useCache: false
      })
    });
  },
  handleUploadIconNotAllowed: function handleUploadIconNotAllowed() {
    this.setState({
      showUpgradeModal: true,
      upgradeModalReason: __WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["a" /* MAX_CUSTOM_ICONS */]
    });
  },
  renderUploadIcon: function renderUploadIcon() {
    var _resources = this.resources(),
        subscription = _resources.subscription;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__UpgradeModal__["f" /* default */], {
      isOpen: this.state.showUpgradeModal,
      reason: this.state.upgradeModalReason,
      subscription: subscription,
      onOkayClicked: this.handleHideUpgradeModal,
      onUpgradeClicked: this.handleRequestToUpgrade,
      onCloseClicked: this.handleHideUpgradeModal
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UploadIconForm__["a" /* default */], {
      isLogo: true,
      dispatch: this.props.dispatch,
      kitToken: this.props.kitToken,
      isAllowed: this.canAddCustomIcons(),
      onUploadIconClicked: this.handleUploadIconClicked,
      onSuccess: this.handleUploadIconSucceeded,
      onNotAllowed: this.handleUploadIconNotAllowed
    }));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;

    var _resources2 = this.resources(),
        kit = _resources2.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Header__["a" /* default */], { heading: 'Upload Your Logo' }), this.renderUploadIcon());
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_6_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadLogoController));

/***/ }),

/***/ 1022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return undefined;
});

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tooltip__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToStaticMarkup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'drop-files table m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'drop-progress', style: { display: 'none' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('progress', { className: 'progress progress-info progress', value: '0', max: '100' }, '0%')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'drop-preview m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { 'data-dz-thumbnail': true, role: 'presentation', className: 'file-source' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'drop-metadata word-wrap' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'drop-name block m-xs-b-xs', 'data-dz-name': true }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'drop-size text-muted block', 'data-dz-size': true })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'error text-danger', 'data-dz-errormessage': true })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'drop-remove-file' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'wrapper-file-remove-popover' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tooltip__["d" /* default */], { className: 'file-remove-popover', content: 'Delete file', icon: 'ficon-trash', forceVisibility: false })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { 'data-dz-remove': true, type: 'button', className: 'file-remove bg-gray-lightest close close-dangle show', 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash', title: 'Remove file' }))))));

/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AddIcons__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UpgradeModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_requests_components__ = __webpack_require__(15);


















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  var ic = ownProps.location.query.ic;
  var activeFacetIds = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Set"])(ic ? ic.split(',') : []).map(function (iconSetId) {
    return parseInt(iconSetId, 10);
  });

  return {
    kitToken: kitToken,
    requests: state.requests,
    query: ownProps.location.query.q || '', // eslint-disable-line id-length
    activeFacetIds: activeFacetIds,
    searchResults: state.kitIconSetSearch.get('results')
  };
};

var AddIconsController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'AddIconsController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    searchResults: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    activeFacetIds: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.set
  },

  contextTypes: {
    iconsSearchIndexName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      query: '',
      searchResults: null,
      subscription: null,
      iconSets: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["List"])(),
      iconSetIdsInSubscription: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Set"])(),
      workingSetIcons: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["List"])()
    };
  },
  getInitialState: function getInitialState() {
    return {
      triedToRequestDataAgain: false,
      showUpgradeModal: false,
      upgradeModalReason: null,
      shouldRequestWorkingSetIcons: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.requestData();
  },
  requestData: function requestData() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons']
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      iconSets: new __WEBPACK_IMPORTED_MODULE_13_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_13_requests__["b" /* GET */],
        url: ['api', 'icon-sets']
      })
    });
  },
  canAddIconsToKit: function canAddIconsToKit() {
    var requests = [this.requests.kit, this.requests.workingSetIcons];
    var retval = false;

    if (this.resourceManager().requests.allDone(requests)) {
      var _resources = this.resources(),
          workingSetIcons = _resources.workingSetIcons,
          subscription = _resources.subscription;

      retval = workingSetIcons.size < subscription.iconsPerKitAllowed;
    }

    return retval;
  },
  handleExceededIconsInKit: function handleExceededIconsInKit() {
    this.setState({
      showUpgradeModal: true,
      upgradeModalReason: __WEBPACK_IMPORTED_MODULE_12__components_UpgradeModal__["b" /* MAX_ICONS_PER_KIT */]
    });
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    location.assign('/upgrade');
  },
  handleHideUpgradeModal: function handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false
    });
  },
  handleTryLoadingDataAgain: function handleTryLoadingDataAgain() {
    this.clearRequests();
    this.requestData();

    this.setState({ triedToRequestDataAgain: true });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      icons: rm.type(this.requests.iconSets, 'icons').all(),
      iconSets: rm.type(this.requests.iconSets, 'icon-sets').all()
    };
  },
  renderIcons: function renderIcons() {
    var _props = this.props,
        kitToken = _props.kitToken,
        query = _props.query,
        activeFacetIds = _props.activeFacetIds;

    var _resources2 = this.resources(),
        subscription = _resources2.subscription,
        workingSetIcons = _resources2.workingSetIcons,
        iconSets = _resources2.iconSets,
        icons = _resources2.icons;

    var index = this.context.iconsSearchIndexName;

    var donePath = '/kits/' + kitToken + '/icons';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_UpgradeModal__["f" /* default */], {
      isOpen: this.state.showUpgradeModal,
      reason: this.state.upgradeModalReason,
      subscription: subscription,
      onOkayClicked: this.handleHideUpgradeModal,
      onUpgradeClicked: this.handleRequestToUpgrade,
      onCloseClicked: this.handleHideUpgradeModal
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_AddIcons__["a" /* default */], {
      key: 'add-icons',
      dispatch: this.props.dispatch,
      requests: this.props.requests,
      onExceededIconsInKit: this.handleExceededIconsInKit,
      index: index,
      kitToken: kitToken,
      donePath: donePath,
      query: query,
      subscription: subscription,
      activeFacetIds: activeFacetIds,
      canAddIconsToKit: this.canAddIconsToKit(),
      searchResults: this.props.searchResults,
      iconSets: iconSets.sortBy(function (iconSet) {
        return iconSet.name;
      }),
      icons: icons,
      iconSetIdsInSubscription: subscription.iconSets,
      workingSetIcons: workingSetIcons
    }));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_9_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderFailed: function renderFailed() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-loading-failed' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { disabled: this.state.triedToRequestDataAgain, onClick: this.handleTryLoadingDataAgain, className: 'btn btn-muted pull-right m-xs-t-md m-xs-l-lg' }, 'Try again'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-oi' }), 'Oi. Some of the data failed to load. This can happen sometimes because the Internet is an unreliable creature.')));
  },
  renderMain: function renderMain() {
    var _resources3 = this.resources(),
        kit = _resources3.kit;

    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Header__["a" /* default */], { heading: 'Add Icons', donePath: '/kits/' + kitToken + '/icons' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/icons/new' }, 'All Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/icons/upload' }, 'Upload an Icon')), this.renderIcons());
  },
  render: function render() {
    var _requests = this.requests,
        kitRequest = _requests.kit,
        iconSetsRequest = _requests.iconSets,
        workingSetIconsRequest = _requests.workingSetIcons,
        subscriptionRequest = _requests.subscription;

    var requests = [kitRequest, iconSetsRequest, workingSetIconsRequest, subscriptionRequest];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_requests_components__["c" /* Requesting */], { any: requests, render: this.renderSpinner, failure: this.renderFailed }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(AddIconsController));

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_infinite__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_infinite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_infinite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_SearchField__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconSet__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconSearchResults__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_records_WorkingSetIcon__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AddIconsFacets__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__settings__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_records__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_requests_RequestsMixin__ = __webpack_require__(22);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();





















var ROW_HEIGHT = 40;
var ROW_ADDITIONAL_HEIGHT = 87.25;

var NewWorkingSetIcon = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Record"])({
  iconSet: '',
  icon: ''
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'AddIcons',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    onExceededIconsInKit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    donePath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    canAddIconsToKit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    subscription: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired,
    searchResults: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    iconSets: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record).isRequired,
    icons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record).isRequired,
    activeFacetIds: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.set,
    workingSetIcons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record).isRequired
  },

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_17_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      iconSetsByIconId: this.iconSetsByIconId(),
      interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])()
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.query.length > 0) {
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["g" /* searchForIcon */](this.props.query, this.props.index));
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var activeFacetIds = nextProps.activeFacetIds;

    var _preppedSearchResults = this.preppedSearchResults(nextProps),
        icons = _preppedSearchResults.icons;

    if (nextProps.searchResults && icons.isEmpty() && !activeFacetIds.isEmpty()) {
      this.navigateToQueryAndFacets(this.props.query, []);
    }

    this.setState({
      iconSetsByIconId: this.iconSetsByIconId()
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.addWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_17_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.setState({ interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])() });
      }
    });

    register({
      request: this.requests.addWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_17_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.setState({ interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])() });
      }
    });
  },
  iconSetsByIconId: function iconSetsByIconId() {
    var iconSetsById = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(this.props.iconSets.map(function (iconSet) {
      return [iconSet.id, iconSet];
    }));
    return Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(this.props.icons.map(function (icon) {
      return [icon.id, iconSetsById.get(icon.iconSet)];
    }));
  },
  handleSearchChanged: function handleSearchChanged(query) {
    var activeFacetIds = this.props.activeFacetIds;

    var nextActiveFacetIds = query === '' ? activeFacetIds.clear() : activeFacetIds;

    this.navigateToQueryAndFacets(query, nextActiveFacetIds);
  },
  handleNewSearch: function handleNewSearch() {
    this.navigateToQueryAndFacets('', this.props.activeFacetIds);
  },
  handleToggleFacet: function handleToggleFacet(id) {
    var activeFacetIds = this.props.activeFacetIds;

    var nextIconSetIds = activeFacetIds.includes(id) ? activeFacetIds.delete(id) : activeFacetIds.add(id);

    this.navigateToQueryAndFacets(this.props.query, nextIconSetIds);
  },
  navigateToQueryAndFacets: function navigateToQueryAndFacets(query, activeFacetIds) {
    var router = this.context.router;

    var nextQuery = {};

    if (query) {
      nextQuery.q = query; // eslint-disable-line id-length

      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["g" /* searchForIcon */](query, this.props.index));
    }

    if (activeFacetIds.join(',')) {
      nextQuery.ic = activeFacetIds.join(','); // eslint-disable-line id-length
    }

    __WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* browserHistory */].replace(router.createPath({
      pathname: '/kits/' + this.props.kitToken + '/icons/new',
      query: nextQuery
    }));
  },
  handleIconSelected: function handleIconSelected(iconSetToken, iconId, name) {
    if (!this.props.canAddIconsToKit) {
      this.props.onExceededIconsInKit();
    } else {
      this.setState({
        interimAdditions: this.state.interimAdditions.push(new __WEBPACK_IMPORTED_MODULE_11_records_WorkingSetIcon__["a" /* default */]({
          icon: iconId,
          name: name
        }))
      });

      this.setRequest({
        addWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_16_requests__["e" /* Request */]({
          method: __WEBPACK_IMPORTED_MODULE_16_requests__["c" /* POST */],
          url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
          record: new NewWorkingSetIcon({
            iconSet: iconSetToken,
            icon: name
          })
        })
      });
    }
  },
  handleIconDeselected: function handleIconDeselected(iconSetToken, iconId, name) {
    var selectedWorkingSetIcon = this.props.workingSetIcons.find(function (workingSetIcon) {
      return workingSetIcon.icon === iconId;
    });

    this.setRequest({
      deleteWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_16_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_16_requests__["a" /* DELETE */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', selectedWorkingSetIcon.id],
        record: selectedWorkingSetIcon
      })
    });
  },
  handleRequestToBuy: function handleRequestToBuy(iconSet) {
    var next = encodeURIComponent('' + location.pathname + location.search);
    location.assign('/sets/' + iconSet.slug + '/buy?next=' + next);
  },
  handleRequestToDownload: function handleRequestToDownload(iconSet) {
    location.assign('/sets/' + iconSet.slug + '/download');
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    var next = encodeURIComponent('' + location.pathname + location.search);
    location.assign('/upgrade?next=' + next);
  },
  iconMixinProps: function iconMixinProps() {
    var _this = this;

    var forIconSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var workingSetIcons = forIconSet ? this.props.workingSetIcons.filter(function (workingSetIcon) {
      return _this.state.iconSetsByIconId.get(workingSetIcon.icon, {}).id === forIconSet.id;
    }) : this.props.workingSetIcons;

    return {
      iconSetIdsInSubscription: this.props.subscription.iconSets,
      iconSetsByIconId: this.state.iconSetsByIconId,
      workingSetIcons: workingSetIcons.concat(this.state.interimAdditions),
      onIconSelected: this.handleIconSelected,
      onIconDeselected: this.handleIconDeselected,
      onRequestToBuy: this.handleRequestToBuy,
      onRequestToDownload: this.handleRequestToDownload,
      onRequestToUpgrade: this.handleRequestToUpgrade
    };
  },
  preppedSearchResults: function preppedSearchResults(props) {
    var searchResults = props.searchResults,
        iconSets = props.iconSets,
        icons = props.icons,
        activeFacetIds = props.activeFacetIds;

    var _ref = searchResults ? [searchResults.get('iconSetHits'), searchResults.get('iconSetCounts'), searchResults.get('iconHits'), searchResults.get('iconHighlights')] : [Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["OrderedSet"])(), Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(), Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["OrderedSet"])(), Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])()],
        _ref2 = _slicedToArray(_ref, 4),
        iconSetHits = _ref2[0],
        iconSetCounts = _ref2[1],
        iconHits = _ref2[2],
        iconHighlights = _ref2[3];

    var filteredIconSets = iconSets.filter(function (iconSet) {
      return iconSetHits.has(iconSet.id);
    });
    var allIcons = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(icons.filter(function (icon) {
      return activeFacetIds.isEmpty() ? true : activeFacetIds.has(icon.iconSet);
    }).map(function (icon) {
      return [icon.id, icon];
    }));
    var finalIcons = iconHits.map(function (iconId) {
      return allIcons.get(iconId);
    }).filter(function (icon) {
      return !!icon;
    });

    return { icons: finalIcons, iconHighlights: iconHighlights, filteredIconSets: filteredIconSets, iconSetCounts: iconSetCounts };
  },
  renderIconSetElements: function renderIconSetElements() {
    var _this2 = this;

    var _props = this.props,
        iconSets = _props.iconSets,
        icons = _props.icons,
        subscription = _props.subscription,
        canAddIconsToKit = _props.canAddIconsToKit,
        activeFacetIds = _props.activeFacetIds,
        workingSetIcons = _props.workingSetIcons;

    var iconSetIdsInSubscription = subscription.iconSets;

    var _splitIconSets = Object(__WEBPACK_IMPORTED_MODULE_15__utils_records__["b" /* splitIconSets */])(iconSets, icons, iconSetIdsInSubscription, workingSetIcons),
        available = _splitIconSets.available,
        unavailable = _splitIconSets.unavailable;

    var filteredIconSets = available.concat(unavailable);

    if (!activeFacetIds.isEmpty()) {
      filteredIconSets = filteredIconSets.filter(function (iconSet) {
        return activeFacetIds.has(iconSet.id);
      });
    }
    var iconsByIconSetId = icons.groupBy(function (icon) {
      return icon.iconSet;
    });
    var iconSetHeights = filteredIconSets.map(function (iconSet) {
      return Math.ceil(iconsByIconSetId.get(iconSet.id).size / __WEBPACK_IMPORTED_MODULE_14__settings__["b" /* SMALL_ICONS_PER_ROW */]) * ROW_HEIGHT + ROW_ADDITIONAL_HEIGHT;
    }).toJS();
    var iconSetElements = filteredIconSets.map(function (iconSet, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_IconSet__["a" /* default */], _extends({
        key: index,
        iconSet: iconSet,
        icons: iconsByIconSetId.get(iconSet.id),
        canAddIconsToKit: canAddIconsToKit
      }, _this2.iconMixinProps(iconSet)));
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-t-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_infinite___default.a, { containerHeight: 600, elementHeight: iconSetHeights, useWindowAsScrollContainer: true }, iconSetElements)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_AddIconsFacets__["a" /* default */], {
      activeIds: activeFacetIds,
      iconSets: iconSets,
      icons: icons,
      workingSetIcons: this.props.workingSetIcons,
      iconSetIdsInSubscription: iconSetIdsInSubscription,
      onSelect: this.handleToggleFacet,
      onDeselect: this.handleToggleFacet
    })));
  },
  renderSearchResults: function renderSearchResults() {
    var _props2 = this.props,
        activeFacetIds = _props2.activeFacetIds,
        searchResults = _props2.searchResults,
        subscription = _props2.subscription;

    var iconSetIdsInSubscription = subscription.iconSets;
    var searchResultsLoaded = !!searchResults;

    var _preppedSearchResults2 = this.preppedSearchResults(this.props),
        icons = _preppedSearchResults2.icons,
        iconHighlights = _preppedSearchResults2.iconHighlights,
        iconSetCounts = _preppedSearchResults2.iconSetCounts,
        filteredIconSets = _preppedSearchResults2.filteredIconSets;

    var searchResultElement = null;

    if (searchResultsLoaded && icons.isEmpty()) {
      searchResultElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-body p-xs-a-2x m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-xs-center m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x m-xs-b-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Found nothing we have. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleNewSearch, href: '#' }, 'A new search try?')));
    } else {
      searchResultElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_IconSearchResults__["a" /* default */], _extends({
        icons: icons,
        hasLoaded: searchResultsLoaded,
        rowCount: 8,
        highlightedIconNames: iconHighlights
      }, this.iconMixinProps()))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_AddIconsFacets__["a" /* default */], {
        activeIds: activeFacetIds,
        iconSets: filteredIconSets,
        icons: icons,
        workingSetIcons: this.props.workingSetIcons,
        iconSetIdsInSubscription: iconSetIdsInSubscription,
        countsFrom: iconSetCounts,
        onSelect: this.handleToggleFacet,
        onDeselect: this.handleToggleFacet
      })));
    }

    return searchResultElement;
  },
  render: function render() {
    var query = this.props.query;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8 col-xs-offset-2' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SearchField__["a" /* default */], { value: query, onChange: this.handleSearchChanged }))), query ? this.renderSearchResults() : this.renderIconSetElements());
  }
}));

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_IconMixin__ = __webpack_require__(148);










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconSet',

  propTypes: {
    iconSet: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired,
    icons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record).isRequired,
    iconSetIdsInSubscription: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired,
    canAddIconsToKit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onRequestToBuy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onRequestToDownload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onRequestToUpgrade: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_IconMixin__["c" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    var _this = this;

    var _props = this.props,
        iconSet = _props.iconSet,
        icons = _props.icons,
        iconSetIdsInSubscription = _props.iconSetIdsInSubscription;

    var inSubscription = iconSetIdsInSubscription.includes(iconSet.get('id'));
    var isPremium = iconSet.price > 0;
    var buyOrUpgradeClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('btn', 'btn-primary', 'm-xs-l-sm');
    var buyOrUpgrade = null;

    if (inSubscription) {
      if (isPremium) {
        var onDownloadClicked = function onDownloadClicked(event) {
          event.preventDefault();
          _this.props.onRequestToDownload(iconSet);
        };
        buyOrUpgrade = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: onDownloadClicked, className: buyOrUpgradeClassName }, 'Download');
      }
    } else {
      if (isPremium) {
        var onBuyClicked = function onBuyClicked(event) {
          event.preventDefault();
          _this.props.onRequestToBuy(iconSet);
        };
        buyOrUpgrade = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: onBuyClicked, className: buyOrUpgradeClassName }, 'Buy ', __WEBPACK_IMPORTED_MODULE_6_numeral___default()(iconSet.price).format('$0'));
      } else {
        var onUpgradeClicked = function onUpgradeClicked(event) {
          event.preventDefault();
          _this.props.onRequestToUpgrade();
        };
        buyOrUpgrade = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: onUpgradeClicked, className: buyOrUpgradeClassName }, 'Upgrade');
      }
    }

    var iconElements = this.renderIcons(icons, __WEBPACK_IMPORTED_MODULE_7__mixins_IconMixin__["b" /* SIZE_SMALL */]);
    var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('icon-set-preview', { 'unavailable': !inSubscription });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-a-0', 'data-role': 'set-name' }, iconSet.name)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted', 'data-role': 'set-details' }, iconSet.icons.size, ' icons \xB7 ', iconSet.optimizedFor, ' \xB7 v', iconSet.version, ' \xB7 by ', iconSet.creatorName, buyOrUpgrade))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icons' }, iconElements));
  }
}));

/***/ }),

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__ = __webpack_require__(14);









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconRow',

  propTypes: {
    rowKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    icons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.iterable,
    size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    workingSetIcons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record),
    iconSetIdsInSubscription: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
    iconSetsByIconId: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map,
    onIconSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onIconDeselected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onRequestToBuy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onRequestToUpgrade: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      focused: null
    };
  },
  handleIconFocused: function handleIconFocused(icon) {
    this.setState({
      focused: icon
    });
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        rowKey = _props.rowKey,
        icons = _props.icons,
        size = _props.size,
        options = _props.options,
        workingSetIcons = _props.workingSetIcons,
        iconSetsByIconId = _props.iconSetsByIconId,
        iconSetIdsInSubscription = _props.iconSetIdsInSubscription,
        onIconSelected = _props.onIconSelected,
        onIconDeselected = _props.onIconDeselected;

    var inWorkingSet = workingSetIcons.map(function (workingSetIcon) {
      return workingSetIcon.icon;
    });
    var makeAddRemoveTooltip = function makeAddRemoveTooltip(iconName, iconSetName, active) {
      var popoverProps = active ? { content: 'Remove ' + iconName, icon: 'ficon-times-circle' } : { content: 'Add ' + iconName, icon: 'ficon-plus-circle' };
      if (options.addIconSetName) {
        popoverProps.details = '(' + iconSetName + ')';
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], popoverProps);
    };
    var makeBuyTooltip = function makeBuyTooltip(iconName, iconSetName, iconSetPrice) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { content: 'Buy ' + iconSetName + ' ' + __WEBPACK_IMPORTED_MODULE_6_numeral___default()(iconSetPrice).format('$0'), details: '(' + iconName + ')', icon: 'ficon-dollar-circle' });
    };
    var makeUpgradeTooltip = function makeUpgradeTooltip(iconName, iconSetName) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { content: 'Upgrade to use ' + iconSetName, details: '(' + iconName + ')', icon: 'ficon-level-up-circle' });
    };
    var highlightedIconName = function highlightedIconName(icon) {
      return options.highlightedIconNames.get(icon.id, icon.name);
    };

    var iconElements = icons.map(function (icon, index) {
      var iconSet = iconSetsByIconId.get(icon.id);
      var active = inWorkingSet.includes(icon.id);
      var aClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('icon', { active: active }, { 'show-add': _this.state.focused === icon }, { 'unavailable': !iconSetIdsInSubscription.includes(iconSet.id) });
      var iconClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('icon-set-preview-icon', 'icon-set-preview-' + size + '-' + iconSet.slug, 'icon-set-preview-' + size + '-' + iconSet.slug + '-' + icon.name);

      var onClicked = function onClicked() {};
      var popover = null;

      if (_this.state.focused === icon) {
        if (iconSetIdsInSubscription.includes(iconSet.get('id'))) {
          onClicked = function onClicked(event) {
            event.preventDefault();
            (active ? onIconDeselected : onIconSelected)(iconSet.token, icon.id, icon.name);
          };
          popover = makeAddRemoveTooltip(highlightedIconName(icon), iconSet.name, active);
        } else if (iconSet.price > 0) {
          onClicked = function onClicked(event) {
            event.preventDefault();

            _this.props.onRequestToBuy(iconSet);
          };
          popover = makeBuyTooltip(highlightedIconName(icon), iconSet.name, iconSet.price);
        } else {
          onClicked = function onClicked(event) {
            event.preventDefault();

            _this.props.onRequestToUpgrade();
          };
          popover = makeUpgradeTooltip(highlightedIconName(icon), iconSet.name);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { key: rowKey + '-' + index, onMouseOver: function onMouseOver() {
          return _this.handleIconFocused(icon);
        }, onMouseOut: _this.handleIconFocused, className: aClassName, onClick: onClicked, href: '#' }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: iconClassName }));
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, iconElements);
  }
}));

/***/ }),

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_IconMixin__ = __webpack_require__(148);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconSearchResults',

  propTypes: {
    icons: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.orderedSet.isRequired,
    hasLoaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    highlightedIconNames: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_IconMixin__["c" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    var _props = this.props,
        icons = _props.icons,
        hasLoaded = _props.hasLoaded,
        highlightedIconNames = _props.highlightedIconNames;

    var iconElements = this.renderIcons(icons, __WEBPACK_IMPORTED_MODULE_5__mixins_IconMixin__["a" /* SIZE_LARGE */], { addIconSetName: true, highlightedIconNames: highlightedIconNames, rowCount: 8 });
    var label = hasLoaded ? icons.size + ' matching icons' : 'Searching…';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-set-preview-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted' }, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icons' }, iconElements));
  }
}));

/***/ }),

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Facets__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_records__ = __webpack_require__(222);









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'AddIconsFacets',

  propTypes: {
    activeIds: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.set.isRequired,
    iconSets: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.record).isRequired,
    icons: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterableOf(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.record).isRequired,
    workingSetIcons: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.record).isRequired,
    iconSetIdsInSubscription: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired,
    countsFrom: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map,
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onDeselect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      countsFrom: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()
    };
  },
  handleFacetSelected: function handleFacetSelected(facetItem) {
    this.props.onSelect(facetItem.source.id);
  },
  handleFacetDeselected: function handleFacetDeselected(facetItem) {
    this.props.onDeselect(facetItem.source.id);
  },
  render: function render() {
    var _props = this.props,
        iconSets = _props.iconSets,
        icons = _props.icons,
        iconSetIdsInSubscription = _props.iconSetIdsInSubscription,
        workingSetIcons = _props.workingSetIcons,
        countsFrom = _props.countsFrom,
        activeIds = _props.activeIds;

    var _splitIconSets = Object(__WEBPACK_IMPORTED_MODULE_7__utils_records__["b" /* splitIconSets */])(iconSets, icons, iconSetIdsInSubscription, workingSetIcons),
        availableUsed = _splitIconSets.availableUsed,
        availableNotUsed = _splitIconSets.availableNotUsed,
        unavailable = _splitIconSets.unavailable;

    var count = countsFrom.isEmpty() ? function (iconSet) {
      return iconSet.icons.size;
    } : function (iconSet) {
      return countsFrom.get(iconSet.id);
    };
    var makeFacetItem = function makeFacetItem(iconSet) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_components_Facets__["a" /* FacetItem */])({
        source: iconSet,
        label: iconSet.name,
        selected: activeIds.has(iconSet.id),
        count: count(iconSet),
        tooltip: 'Show only'
      });
    };
    var availableUsedFacetItems = availableUsed.map(makeFacetItem);
    var availableNotUsedFacetItems = availableNotUsed.map(makeFacetItem);
    var unavailableFacetItems = unavailable.map(makeFacetItem);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Facets__["b" /* default */], {
      heading: 'Icon Sets',
      onFacetSelected: this.handleFacetSelected,
      onFacetDeselected: this.handleFacetDeselected,
      groups: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({
        included: availableUsedFacetItems,
        available: availableNotUsedFacetItems,
        unavailable: unavailableFacetItems
      })
    });
  }
}));

/***/ }),

/***/ 1048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UploadIconForm__ = __webpack_require__(474);














var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var UploadIconController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadIconController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return this.upgradeModalState(this.props);
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'subscriptions'],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */]
      })
    });

    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */]
      })
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState(this.upgradeModalState(nextProps));

    var rm = this.resourceManager(nextProps);

    if (rm.requests.isDone(this.requests.refreshWorkingSetIcons)) {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/icons');
    }
  },
  upgradeModalState: function upgradeModalState(props) {
    var showUpgradeModal = this.state ? this.state.showUpgradeModal : false;
    var upgradeModalReason = this.state ? this.state.upgradeModalReason : null;

    if (!this.canAddCustomIcons(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["d" /* NO_CUSTOM_ICONS_ALLOWED */];
    }

    if (this.maxedOutForCustomIcons(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["a" /* MAX_CUSTOM_ICONS */];
    }

    if (!this.canAddIconsToKit(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["b" /* MAX_ICONS_PER_KIT */];
    }

    return { showUpgradeModal: showUpgradeModal, upgradeModalReason: upgradeModalReason };
  },
  canAddCustomIcons: function canAddCustomIcons(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddCustomIcons = true;

    if (rm.requests.isDone(this.requests.subscription)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();

      canAddCustomIcons = subscription.customIconsAllowed > 0;
    }

    return canAddCustomIcons;
  },
  maxedOutForCustomIcons: function maxedOutForCustomIcons(props) {
    return false;
    // if (!this.requests) {
    //   return false;
    // }

    // const rm = this.resourceManager(props || this.props);
    // let maxedOutForCustomIcons = false;

    // if (rm.requests.allDone([this.requests.subscription, this.requests.customIcons])) {
    //   const subscription = rm.type(this.requests.subscription, 'subscriptions').get();
    //   const customIcons = rm.type(this.requests.customIcons, 'icons').all();

    //   maxedOutForCustomIcons = subscription.customIconsAllowed <= customIcons.size;
    // }

    // return maxedOutForCustomIcons;
  },
  canAddIconsToKit: function canAddIconsToKit(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddIconsToKit = true;

    if (rm.requests.isDone(this.requests.subscription) && rm.requests.isDone(this.requests.workingSetIcons)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();
      var workingSetIcons = rm.type(this.requests.workingSetIcons, 'working-set-icons').all();

      canAddIconsToKit = workingSetIcons.size < subscription.iconsPerKitAllowed;
    }

    return canAddIconsToKit;
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all()
    };
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    location.assign('/upgrade');
  },
  handleHideUpgradeModal: function handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false
    });
  },
  handleUploadIconClicked: function handleUploadIconClicked() {
    if (!this.canAddCustomIcons()) {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["d" /* NO_CUSTOM_ICONS_ALLOWED */]
      });
    }
  },
  handleUploadIconSucceeded: function handleUploadIconSucceeded() {
    this.setRequest({
      refreshWorkingSetIcons: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        useCache: false
      })
    });
  },
  handleUploadIconNotAllowed: function handleUploadIconNotAllowed() {
    this.setState({
      showUpgradeModal: true,
      upgradeModalReason: __WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["a" /* MAX_CUSTOM_ICONS */]
    });
  },
  renderUploadIcon: function renderUploadIcon() {
    var _resources = this.resources(),
        subscription = _resources.subscription;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UpgradeModal__["f" /* default */], {
      isOpen: this.state.showUpgradeModal,
      reason: this.state.upgradeModalReason,
      subscription: subscription,
      onOkayClicked: this.handleHideUpgradeModal,
      onUpgradeClicked: this.handleRequestToUpgrade,
      onCloseClicked: this.handleHideUpgradeModal
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UploadIconForm__["a" /* default */], {
      isLogo: false,
      dispatch: this.props.dispatch,
      kitToken: this.props.kitToken,
      isAllowed: this.canAddCustomIcons(),
      onUploadIconClicked: this.handleUploadIconClicked,
      onSuccess: this.handleUploadIconSucceeded,
      onNotAllowed: this.handleUploadIconNotAllowed
    }));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;

    var _resources2 = this.resources(),
        kit = _resources2.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], { heading: 'Add Icons', donePath: '/kits/' + kitToken + '/icons' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/icons/new' }, 'All Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/icons/upload' }, 'Upload an Icon')), this.renderUploadIcon());
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_6_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadIconController));

/***/ }),

/***/ 1049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IconPreview__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EditIconForm__ = __webpack_require__(1051);














var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;
  var workingSetIconId = ownProps.params.workingSetIconId;

  return {
    requests: state.requests,
    kitToken: kitToken,
    workingSetIconId: workingSetIconId
  };
};

var EditIconController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EditIconController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetIconId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      workingSetIcon: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIconId]
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      workingSetIcon: rm.type(this.requests.workingSetIcon, 'working-set-icons').get(),
      icon: rm.type(this.requests.workingSetIcon, 'icons').get(),
      iconSet: rm.type(this.requests.workingSetIcon, 'icon-sets').get()
    };
  },
  renderMain: function renderMain() {
    var _resources = this.resources(),
        kit = _resources.kit,
        subscription = _resources.subscription,
        workingSetIcon = _resources.workingSetIcon,
        icon = _resources.icon,
        iconSet = _resources.iconSet;

    var previewClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('asset-preview-rendering', { 'asset-uploaded-preview-rendering': workingSetIcon.custom });
    var heading = workingSetIcon.logo ? 'Edit / View Logo' : 'Edit / View Icons';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/icons', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], { kit: kit, heading: heading, headingIcon: 'ficon-pencil', showUpload: workingSetIcon.custom }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EditIconForm__["a" /* default */], {
      dispatch: this.props.dispatch,
      kitToken: kit.token,
      allowSvgEditing: !subscription.freePlan,
      workingSetIcon: workingSetIcon
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: previewClass }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__IconPreview__["a" /* default */], {
      kitToken: kit.token,
      iconSet: iconSet,
      icon: icon,
      workingSetIcon: workingSetIcon
    })))));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    var requests = [this.requests.workingSetIcon, this.requests.subscription];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["c" /* Requesting */], { any: requests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(EditIconController));

/***/ }),

/***/ 1050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedIcon__ = __webpack_require__(116);









var PREVIEW_TAB_LIGHT = 'PREVIEW_TAB_LIGHT';
var PREVIEW_TAB_DARK = 'PREVIEW_TAB_DARK';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconPreview',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    iconSet: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record,
    icon: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record,
    workingSetIcon: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      previewTab: PREVIEW_TAB_LIGHT
    };
  },
  handleLightPreviewClicked: function handleLightPreviewClicked(event) {
    event.preventDefault();

    this.setState({ previewTab: PREVIEW_TAB_LIGHT });
  },
  handleDarkPreviewClicked: function handleDarkPreviewClicked(event) {
    event.preventDefault();

    this.setState({ previewTab: PREVIEW_TAB_DARK });
  },
  render: function render() {
    var _props = this.props,
        kitToken = _props.kitToken,
        iconSet = _props.iconSet,
        workingSetIcon = _props.workingSetIcon;

    var isLightPreview = this.state.previewTab === PREVIEW_TAB_LIGHT;
    var isDarkPreview = this.state.previewTab === PREVIEW_TAB_DARK;

    var custom = workingSetIcon.custom;
    var optimizedFor = workingSetIcon.optimizedFor;

    var lightTabClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('nav-item', { active: isLightPreview });
    var darkTabClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('nav-item', { active: isDarkPreview });
    var gridClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('grid', 'grid-' + optimizedFor);
    var alertClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('well p-xs-a-lg text-xs-center', { 'bg-body': isLightPreview, 'bg-gray': isDarkPreview });

    var attribution = null;

    if (custom) {
      attribution = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-origin asset-origin-uploaded' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded' }), ' Uploaded by'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong asset-origin-author' }, 'You'));
    } else {
      attribution = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-set' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'Icon Set'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong' }, iconSet.name, ' \xB7  v', iconSet.version));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: lightTabClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', onClick: this.handleLightPreviewClicked, href: '#' }, 'Light')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: darkTabClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', onClick: this.handleDarkPreviewClicked, href: '#' }, 'Dark'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: alertClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: gridClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedIcon__["a" /* default */], { woff: workingSetIcon.woff }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table table-condensed m-xs-t-md text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, attribution, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-optimized' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'Optimized for'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, workingSetIcon.optimizedFor)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-history' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'Last Edited'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, workingSetIcon.updatedAt.fromNow())), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-use-desktop' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'HTML use'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'p-xs-r-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'code code-highlight' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'class="'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetIcon.cssClass), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, '"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</i>'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm m-xs-b-0 text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/docs' }, 'More on how to use your kit\'s icons')))))));
  }
}));

/***/ }),

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OptimizedForSelect__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RemoveIconModal__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SvgInspection__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(53);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};



















var UpdateWorkingSetIcon = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Record"])({
  name: null,
  optimizedFor: null,
  unicodeChar: null,
  logo: false,
  svg: '',
  ignoreWarnings: false
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var EditIconForm = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EditIconForm',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetIcon: __WEBPACK_IMPORTED_MODULE_7_react_immutable_proptypes___default.a.record,
    allowSvgEditing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      name: this.props.workingSetIcon.name,
      unicodeChar: this.props.workingSetIcon.unicodeChar,
      optimizedFor: this.props.workingSetIcon.optimizedFor,
      showPasteSvgSource: true,
      showConfirmDeleteIcon: false,
      dropzone: null,
      svgSource: this.props.workingSetIcon ? this.props.workingSetIcon.svg : null,
      svgInspection: null,
      svgErrors: null
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (!this.state.svgSource) {
      this.setState({
        svgSource: this.props.workingSetIcon ? this.props.workingSetIcon.svg : null
      });
    }
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.updateWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.handleUpdateComplete();
      }
    });

    register({
      request: this.requests.deleteWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.handleDeleteComplete();
      }
    });

    register({
      request: this.requests.updateWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["a" /* HAS_ERRORS */],
      call: function call(rm) {
        var svgErrors = rm.requests.errorsFor(this.requests.updateWorkingSetIcon).get('svg');

        if ((typeof svgErrors === 'undefined' ? 'undefined' : _typeof(svgErrors)) === 'object') {
          this.setState({
            svgInspection: svgErrors[0]
          });
        } else {
          this.setState({
            svgErrors: svgErrors
          });
        }
      }
    });

    register({
      request: this.requests.updateWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.clearRequests();

        this.setState({
          buildFailed: true
        });

        if (this.state.dropzone) {
          this.state.dropzone.removeAllFiles();
        }
      }
    });
  },
  handleUpdateComplete: function handleUpdateComplete() {
    __WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/icons');
  },
  handleDeleteComplete: function handleDeleteComplete() {
    __WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/icons');
  },
  handleFileRemoved: function handleFileRemoved() {
    this.setState({
      svgInspection: null,
      svgErrors: null
    });
  },
  handleDropzoneInit: function handleDropzoneInit(dropzone) {
    this.setState({
      dropzone: dropzone
    });
  },
  handleSvgChanged: function handleSvgChanged(svgSource) {
    this.setState({
      svgSource: svgSource
    });
  },
  handleNameChanged: function handleNameChanged() {
    this.setState({
      name: this._name.value
    });
  },
  handleUnicodeCharChanged: function handleUnicodeCharChanged() {
    this.setState({
      unicodeChar: this._unicodeChar.value
    });
  },
  handleOptimizedForChanged: function handleOptimizedForChanged(value) {
    this.setState({
      optimizedFor: value
    });
  },
  handleToggleSourceVersusUpload: function handleToggleSourceVersusUpload(event) {
    event.preventDefault();

    this.setState({
      showPasteSvgSource: !this.state.showPasteSvgSource
    });
  },
  handleSaveClicked: function handleSaveClicked(event) {
    event.preventDefault();

    this.upload();
  },
  handleUploadAnyway: function handleUploadAnyway() {
    this.setState({
      svgInspection: null
    });

    this.upload(true);
  },
  upload: function upload() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    this.setState({
      svgInspection: null,
      svgErrors: null
    });

    if (this.state.showPasteSvgSource) {
      this.updateSvgSource(force);
    } else {
      this.updateViaDropzone(force);
    }
  },
  updateRecord: function updateRecord(force) {
    return UpdateWorkingSetIcon({
      name: this._name.value,
      unicodeChar: this.state.unicodeChar,
      optimizedFor: this.state.optimizedFor,
      logo: this.props.workingSetIcon.logo,
      ignoreWarnings: force
    });
  },
  updateSvgSource: function updateSvgSource(force) {
    var record = this.updateRecord(force).set('svg', this.state.svgSource);

    this.setRequest({
      updateWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["d" /* PUT */],
        record: record
      })
    });
  },
  updateViaDropzone: function updateViaDropzone(force) {
    var record = this.updateRecord(force);
    var request = new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
      url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
      method: __WEBPACK_IMPORTED_MODULE_9_requests__["d" /* PUT */],
      record: record
    });

    this.setRequest({
      updateWorkingSetIcon: request
    }, { skipDispatch: true });

    this.props.dispatch(__WEBPACK_IMPORTED_MODULE_16__actions__["i" /* updateWorkingSetIconFromDropzone */](request, record, this.state.dropzone));
  },
  handleDeleteClicked: function handleDeleteClicked(event) {
    event.preventDefault();

    if (this.props.workingSetIcon.custom) {
      this.setState({
        showConfirmDeleteIcon: true
      });
    } else {
      this.deleteWorkingSetIcon();
    }
  },
  handleDeleteIconConfirmed: function handleDeleteIconConfirmed() {
    var _this = this;

    this.setState({
      showConfirmDeleteIcon: false
    }, function () {
      _this.deleteWorkingSetIcon();
    });
  },
  handleDeleteIconCanceled: function handleDeleteIconCanceled() {
    this.setState({
      showConfirmDeleteIcon: false
    });
  },
  deleteWorkingSetIcon: function deleteWorkingSetIcon() {
    this.setRequest({
      deleteWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons', this.props.workingSetIcon.id],
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["a" /* DELETE */],
        record: this.props.workingSetIcon
      })
    });
  },
  renderPastOrDropzone: function renderPastOrDropzone(which) {
    var svgErrors = this.state.svgErrors;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["e" /* default */], {
      onDropzoneInit: this.handleDropzoneInit,
      onSourceChanged: this.handleSvgChanged,
      onSuggestedFilename: this.handleSuggestedFilename,
      onFileRemoved: this.handleFileRemoved,
      source: this.props.workingSetIcon.svg,
      error: svgErrors,
      type: __WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["c" /* SVG */],
      which: which
    });
  },
  renderPaste: function renderPaste() {
    var changeSourceOrUpload = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleToggleSourceVersusUpload, href: '#' }, 'Need to upload an SVG file instead?'));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.renderPastOrDropzone(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["b" /* PASTE */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, changeSourceOrUpload)));
  },
  renderDropzone: function renderDropzone() {
    var changeSourceOrUpload = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleToggleSourceVersusUpload, href: '#' }, 'Want to paste from Illustrator CC instead?'));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.renderPastOrDropzone(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["a" /* DROPZONE */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, changeSourceOrUpload)));
  },
  renderError: function renderError() {
    var rm = this.resourceManager();
    var svgInspection = this.state.svgInspection;

    var error = null;

    if (svgInspection) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SvgInspection__["a" /* default */], { onContinueAnyway: this.handleUploadAnyway, results: svgInspection });
    }

    if (rm.requests.hasFailed(this.requests.updateWorkingSetIcon)) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-warning', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oi!'), " We had trouble saving your icon. Why don\u2019t you try again.");
    }

    if (rm.requests.hasFailed(this.requests.deleteWorkingSetIcon)) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-danger', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oops!'), ' There was an issue deleting your custom icon. Our support team has been notified.');
    }

    return error;
  },
  render: function render() {
    var _this2 = this;

    var _props = this.props,
        workingSetIcon = _props.workingSetIcon,
        allowSvgEditing = _props.allowSvgEditing;
    var updateWorkingSetIconRequest = this.requests.updateWorkingSetIcon;

    var custom = workingSetIcon.custom;
    var rm = this.resourceManager();
    var formGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('form-group', 'row', 'string', 'required');
    var nameFormGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(formGroupClassName, { 'has-danger': rm.requests.errorsFor(updateWorkingSetIconRequest).get('name') });
    var unicodeCharFormGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(formGroupClassName, { 'has-danger': rm.requests.errorsFor(updateWorkingSetIconRequest).get('unicodeChar') });

    var deleteIconClassName = custom ? __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ficon', 'p-xs-l-xs', 'ficon-trash') : __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ficon', 'p-xs-l-xs', 'ficon-times-circle');
    var deleteDisabled = rm.requests.isQueued(this.requests.deleteWorkingSetIcon);
    var saveDisabled = rm.requests.isQueued(this.requests.updateWorkingSetIcon);
    var somethingFailed = rm.requests.hasFailed(this.requests.updateWorkingSetIcon);
    var deleteLabel = deleteDisabled ? 'Deleting...' : 'Delete Icon';
    var saveLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Edit Icon ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));
    var editSvg = null;

    if (somethingFailed) {
      saveDisabled = false;
    }

    if (saveDisabled) {
      saveLabel = 'Saving...';
    }

    if (allowSvgEditing) {
      editSvg = this.state.showPasteSvgSource ? this.renderPaste() : this.renderDropzone();
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RemoveIconModal__["a" /* default */], {
      show: this.state.showConfirmDeleteIcon,
      kitToken: this.props.kitToken,
      workingSetIcon: this.props.workingSetIcon,
      onRemovedIcon: this.handleDeleteIconConfirmed,
      onClosed: this.handleDeleteIconCanceled
    }), this.renderError(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple-form form-horizontal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: nameFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Icon Name ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: function ref(input) {
        return _this2._name = input;
      }, onChange: this.handleNameChanged, className: 'string required form-control', type: 'text', value: this.state.name }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["b" /* HasErrors */], { request: updateWorkingSetIconRequest, errorKey: 'name' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, rm.requests.errorsFor(updateWorkingSetIconRequest).get('name'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, 'Lowercase letters, numbers, and hyphens allowed.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: formGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Optimized for ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OptimizedForSelect__["a" /* default */], { disabled: !allowSvgEditing, onChanged: this.handleOptimizedForChanged, value: this.state.optimizedFor }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, "The size you\u2019ve designed your icon to look the best at."))), editSvg, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: unicodeCharFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Unicode ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: function ref(input) {
        return _this2._unicodeChar = input;
      }, onChange: this.handleUnicodeCharChanged, className: 'string required form-control', type: 'text', value: this.state.unicodeChar }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["b" /* HasErrors */], { request: updateWorkingSetIconRequest, errorKey: 'unicodeChar' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, rm.requests.errorsFor(updateWorkingSetIconRequest).get('unicodeChar'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: formGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleSaveClicked, disabled: saveDisabled, className: 'btn btn-primary btn-block btn-lg' }, saveLabel), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'hr m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'hr-text bg-white' }, 'or'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-offset-3 p-xs-r-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + this.props.kitToken + '/icons', className: 'btn btn-secondary btn-block btn-lg' }, 'Cancel')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 p-xs-l-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleDeleteClicked, disabled: deleteDisabled, className: 'btn btn-secondary btn-block btn-lg' }, deleteLabel, ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: deleteIconClassName }))))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(EditIconForm));

/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_records_WorkingSetTypeface__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UpgradeModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TypefaceExample__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TypefaceFacets__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_records__ = __webpack_require__(222);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};




















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var AddWorkingTypeface = Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Record"])({
  typefaceId: null
});

var AddTypefaceController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'AddTypefaceController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showUpgradeModal: false,
      interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])()
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      typefaces: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'typefaces']
      })
    });

    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces']
      })
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.addWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.setState({ interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])() });
      }
    });

    register({
      request: this.requests.addWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["e" /* IS_NOT_ALLOWED */],
      call: function call(rm) {
        this.setState({ interimAdditions: Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])() });
      }
    });
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    location.assign('/upgrade');
  },
  handleHideUpgradeModal: function handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false
    });
  },
  handleAddTypefaceClicked: function handleAddTypefaceClicked(typeface) {
    var _resources = this.resources(),
        subscription = _resources.subscription,
        workingSetTypefaces = _resources.workingSetTypefaces;

    if (workingSetTypefaces.size < subscription.workingSetTypefacesAllowed) {
      this.setState({
        interimAdditions: this.state.interimAdditions.push(new __WEBPACK_IMPORTED_MODULE_7_records_WorkingSetTypeface__["a" /* default */]({ typeface: typeface.id }))
      });

      this.setRequest({
        addWorkingSetTypeface: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
          url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
          method: __WEBPACK_IMPORTED_MODULE_8_requests__["c" /* POST */],
          record: new AddWorkingTypeface({
            typefaceId: typeface.id
          })
        })
      });
    } else {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: __WEBPACK_IMPORTED_MODULE_14__components_UpgradeModal__["c" /* MAX_TYPEFACES_PER_KIT */]
      });
    }
  },
  handleDeleteTypefaceClicked: function handleDeleteTypefaceClicked(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["a" /* DELETE */],
        record: workingSetTypeface
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      typefaces: rm.type(this.requests.typefaces, 'typefaces').all(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all()
    };
  },
  renderTypefaces: function renderTypefaces() {
    var _resources2 = this.resources(),
        subscription = _resources2.subscription,
        typefaces = _resources2.typefaces,
        workingSetTypefaces = _resources2.workingSetTypefaces;

    var args = {
      typefaces: Object(__WEBPACK_IMPORTED_MODULE_17__utils_records__["a" /* sortTypefaces */])(typefaces.filter(function (i) {
        return i.system;
      })),
      workingSetTypefaces: workingSetTypefaces.concat(this.state.interimAdditions)
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TypefaceExample__["a" /* default */], _extends({}, args, {
      onTypefaceSelected: this.handleAddTypefaceClicked,
      onTypefaceDeselected: this.handleDeleteTypefaceClicked
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TypefaceFacets__["a" /* default */], args)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_UpgradeModal__["f" /* default */], {
      isOpen: this.state.showUpgradeModal,
      reason: this.state.upgradeModalReason,
      subscription: subscription,
      onOkayClicked: this.handleHideUpgradeModal,
      onUpgradeClicked: this.handleRequestToUpgrade,
      onCloseClicked: this.handleHideUpgradeModal
    }));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_12_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;

    var _resources3 = this.resources(),
        kit = _resources3.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["a" /* default */], { heading: 'Add Typefaces', donePath: '/kits/' + kitToken + '/typefaces' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/typefaces/new' }, 'All Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/typefaces/upload' }, 'Upload a Typeface')), this.renderTypefaces());
  },
  render: function render() {
    var requests = [this.requests.kit, this.requests.subscription, this.requests.workingSetTypefaces, this.requests.typefaces];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["c" /* Requesting */], { any: requests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(AddTypefaceController));

/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_StylesheetLink__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_typefaces__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(69);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}













/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefaceExample',

  propTypes: {
    typefaces: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterable.isRequired,
    workingSetTypefaces: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterable.isRequired,
    onTypefaceSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onTypefaceDeselected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      focusedTypeface: null,
      loadedStylesheetsFor: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Set"])()
    };
  },
  renderFamily: function renderFamily(family, typefaces, includedTypefaceIds) {
    var _this = this;

    var workingSetTypefaces = this.props.workingSetTypefaces;

    var handleFocusNothing = function handleFocusNothing(typeface) {
      _this.setState({ focusedTypeface: null });
    };
    var typefacesElements = typefaces.map(function (typeface) {
      var isIncluded = includedTypefaceIds.includes(typeface.id);
      var handleClicked = function handleClicked(event) {
        event.preventDefault();

        if (isIncluded) {
          _this.props.onTypefaceDeselected(workingSetTypefaces.find(function (i) {
            return i.typeface === typeface.id;
          }));
        } else {
          _this.props.onTypefaceSelected(typeface);
        }
      };
      var handleFocusTypeface = function handleFocusTypeface() {
        _this.setState({ focusedTypeface: typeface });
      };
      var popover = _this.state.focusedTypeface === typeface ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], {
        content: (isIncluded ? 'Remove' : 'Add') + ' ' + typeface.weight + ' ' + typeface.style,
        icon: isIncluded ? 'ficon-times-circle' : 'ficon-plus-circle',
        position: __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["a" /* TOOLTIP_POSITION_RIGHT */]
      }) : null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
        key: 'typeface-' + typeface.id,
        href: '#',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('typeface', { active: isIncluded }),
        onClick: handleClicked,
        onMouseEnter: handleFocusTypeface,
        onMouseLeave: handleFocusNothing,
        style: { position: 'relative' }
      }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { fontFamily: typeface.family, fontWeight: typeface.weight, fontStyle: typeface.style }, className: 'specimen' }, __WEBPACK_IMPORTED_MODULE_10__settings__["c" /* TYPEFACE_PREVIEW_SPECIMEN */]));
    });
    var stylesheetLoaded = this.state.loadedStylesheetsFor.has(family);
    var handleStylesheetLoaded = function handleStylesheetLoaded() {
      _this.setState({
        loadedStylesheetsFor: _this.state.loadedStylesheetsFor.add(family)
      });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_StylesheetLink__["a" /* default */], {
      onLoaded: handleStylesheetLoaded,
      href: Object(__WEBPACK_IMPORTED_MODULE_9__utils_typefaces__["a" /* stylesheetUrl */])(typefaces)
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { position: 'relative', minHeight: '5rem' } }, stylesheetLoaded ? typefacesElements : null));
  },
  render: function render() {
    var _this2 = this;

    var _props = this.props,
        typefaces = _props.typefaces,
        workingSetTypefaces = _props.workingSetTypefaces;

    var includedTypefaceIds = workingSetTypefaces.map(function (workingSetTypeface) {
      return workingSetTypeface.typeface;
    });
    var typefaceElements = typefaces.groupBy(function (typeface) {
      return typeface.family;
    }).map(function (typefacesForFamily, family) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'family-' + family, className: 'typefamily-preview' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-bottom' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-a-0' }, family)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-muted' }, family, ' \xB7 ', typefacesForFamily.size, ' ', typefacesForFamily.size === 1 ? 'Style' : 'Styles'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-t-md m-xs-b-md' }), _this2.renderFamily(family, typefacesForFamily, includedTypefaceIds));
    }).flatten(1).values();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [].concat(_toConsumableArray(typefaceElements)));
  }
}));

/***/ }),

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stylesheetUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


function googleStylesheetUrl(typefaces) {
  var family = typefaces.first().family;
  var weightsAndStyles = typefaces.map(function (typeface) {
    return '' + typeface.weight + (typeface.style !== 'normal' ? typeface.style : '');
  }).join(',');
  var familyQuery = family + ':' + weightsAndStyles;

  return 'https://fonts.googleapis.com/css?family=' + familyQuery;
}

function customStylesheetUrl(typefaces) {
  var family = typefaces.first().family;

  return '/api/typefaces/stylesheet?family=' + family;
}

function stylesheetUrl(typefaces) {
  var normalizedTypefaces = typefaces;

  if (!normalizedTypefaces) {
    throw new Error('No typefaces provided');
  }

  if (normalizedTypefaces instanceof __WEBPACK_IMPORTED_MODULE_0_immutable__["Record"]) {
    normalizedTypefaces = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([typefaces]);
  }

  return normalizedTypefaces.first().system ? googleStylesheetUrl(normalizedTypefaces) : customStylesheetUrl(normalizedTypefaces);
}

/***/ }),

/***/ 1055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Facets__ = __webpack_require__(220);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefaceFacets',

  propTypes: {
    typefaces: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list,
    workingSetTypefaces: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    var _props = this.props,
        typefaces = _props.typefaces,
        workingSetTypefaces = _props.workingSetTypefaces;

    var includedTypefaceIds = workingSetTypefaces.map(function (workingSetTypeface) {
      return workingSetTypeface.typeface;
    });
    var families = typefaces.groupBy(function (typeface) {
      return typeface.family;
    });
    var groupCounts = families.map(function (typefacesByFamily, family) {
      return typefacesByFamily.size;
    });
    var groupedFamilies = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])(families.keys()).groupBy(function (family) {
      var intersection = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Set"])(families.get(family).map(function (i) {
        return i.id;
      })).intersect(includedTypefaceIds);
      return intersection.isEmpty() ? 'available' : 'included';
    });
    var facetItems = groupedFamilies.map(function (familiesByStatus, status) {
      return familiesByStatus.map(function (family) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_components_Facets__["a" /* FacetItem */])({ label: family, count: groupCounts.get(family) });
      });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Facets__["b" /* default */], { heading: 'Typefaces', groups: facetItems });
  }
}));

/***/ }),

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UpgradeModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UploadTypefaceForm__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_requests_components__ = __webpack_require__(15);















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var UploadTypefaceController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadTypefaceController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return this.upgradeModalState(this.props);
  },
  componentDidMount: function componentDidMount() {
    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      characterSets: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'character-sets'],
        useCache: false
      })
    });

    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      typefaceSettings: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings']
      })
    });

    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_5_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_5_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces']
      })
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState(this.upgradeModalState(nextProps));
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.refreshWorkingSetTypefaces,
      to: __WEBPACK_IMPORTED_MODULE_6_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        __WEBPACK_IMPORTED_MODULE_7_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/typefaces');
      }
    });
  },
  upgradeModalState: function upgradeModalState(props) {
    var showUpgradeModal = this.state ? this.state.showUpgradeModal : false;
    var upgradeModalReason = this.state ? this.state.upgradeModalReason : null;

    if (!this.canAddCustomTypefaces(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_11__components_UpgradeModal__["e" /* NO_CUSTOM_TYPEFACES_ALLOWED */];
    }

    if (!this.canAddTypefacesToKit(props)) {
      showUpgradeModal = true;
      upgradeModalReason = __WEBPACK_IMPORTED_MODULE_11__components_UpgradeModal__["c" /* MAX_TYPEFACES_PER_KIT */];
    }

    return { showUpgradeModal: showUpgradeModal, upgradeModalReason: upgradeModalReason };
  },
  canAddCustomTypefaces: function canAddCustomTypefaces(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddCustomTypefaces = true;

    if (rm.requests.isDone(this.requests.subscription)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();

      canAddCustomTypefaces = subscription.customTypefacesAllowed > 0;
    }

    return canAddCustomTypefaces;
  },
  canAddTypefacesToKit: function canAddTypefacesToKit(props) {
    if (!this.requests) {
      return true;
    }

    var rm = this.resourceManager(props || this.props);
    var canAddTypefacesToKit = true;

    if (rm.requests.isDone(this.requests.subscription) && rm.requests.isDone(this.requests.workingSetTypefaces)) {
      var subscription = rm.type(this.requests.subscription, 'subscriptions').get();
      var workingSetTypefaces = rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all();

      canAddTypefacesToKit = workingSetTypefaces.size < subscription.workingSetTypefacesAllowed;
    }

    return canAddTypefacesToKit;
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      typefaceSettings: rm.type(this.requests.typefaceSettings, 'typeface-settings').get(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all()
    };
  },
  handleRequestToUpgrade: function handleRequestToUpgrade() {
    location.assign('/upgrade');
  },
  handleHideUpgradeModal: function handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false
    });
  },
  handleUploadTypefaceClicked: function handleUploadTypefaceClicked() {
    if (!this.canAddCustomTypefaces()) {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: __WEBPACK_IMPORTED_MODULE_11__components_UpgradeModal__["e" /* NO_CUSTOM_TYPEFACES_ALLOWED */]
      });
    }
  },
  renderUploadTypeface: function renderUploadTypeface() {
    var _resources = this.resources(),
        subscription = _resources.subscription,
        characterSets = _resources.characterSets,
        typefaceSettings = _resources.typefaceSettings;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UpgradeModal__["f" /* default */], {
      isOpen: this.state.showUpgradeModal,
      reason: this.state.upgradeModalReason,
      subscription: subscription,
      onOkayClicked: this.handleHideUpgradeModal,
      onUpgradeClicked: this.handleRequestToUpgrade,
      onCloseClicked: this.handleHideUpgradeModal
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UploadTypefaceForm__["a" /* default */], {
      dispatch: this.props.dispatch,
      kitToken: this.props.kitToken,
      characterSets: characterSets,
      typefaceSettings: typefaceSettings,
      isAllowed: this.canAddCustomTypefaces() && this.canAddTypefacesToKit(),
      onUploadTypefaceClicked: this.handleUploadTypefaceClicked
    }));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;

    var _resources2 = this.resources(),
        kit = _resources2.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], { heading: 'Add Typefaces', donePath: '/kits/' + kitToken + '/typefaces' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/typefaces/new' }, 'All Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_NavLink__["a" /* default */], { to: '/kits/' + kitToken + '/typefaces/upload' }, 'Upload a Typeface')), this.renderUploadTypeface());
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_9_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    var requests = [this.requests.subscription, this.requests.kit, this.requests.typefaceSettings, this.requests.characterSets, this.requests.workingSetTypefaces];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_requests_components__["c" /* Requesting */], { any: requests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadTypefaceController));

/***/ }),

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PasteOrDropzone__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__settings__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TypefaceSubsetting__ = __webpack_require__(218);

















var NewTypeface = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Record"])({
  kitId: null,
  family: null,
  weight: null,
  style: null,
  subsetting: null,
  characterSets: null
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var UploadTypefaceForm = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadTypefaceForm',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    characterSets: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    typefaceSettings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    onUploadTypefaceClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isAllowed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      subsetting: this.props.typefaceSettings.defaultSubsetting,
      characterSets: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Set"])(this.props.typefaceSettings.characterSets),
      uploadFailed: false
    };
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.uploadWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.clearRequests();

        this.setState({
          uploadFailed: true
        });

        this.state.dropzone.removeAllFiles();
      }
    });

    register({
      request: this.requests.uploadWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/typefaces');
      }
    });
  },
  handleDropzoneInit: function handleDropzoneInit(dropzone) {
    this.setState({
      dropzone: dropzone
    });
  },
  handleSubsettingChanged: function handleSubsettingChanged(subsetting) {
    this.setState({
      subsetting: subsetting
    });
  },
  handleCharacterSetChanged: function handleCharacterSetChanged(id, isChecked) {
    var characterSets = this.state.characterSets;

    this.setState({
      characterSets: isChecked ? characterSets.add(id) : characterSets.delete(id)
    });
  },
  uploadRecord: function uploadRecord() {
    return NewTypeface({
      kitId: this.props.kitToken,
      family: this.refs.family.value,
      weight: this.refs.weight.value,
      style: this.refs.style.value,
      subsetting: this.state.subsetting,
      characterSets: this.state.characterSets
    });
  },
  handleUploadClicked: function handleUploadClicked(event) {
    event.preventDefault();

    this.props.onUploadTypefaceClicked();

    var record = this.uploadRecord();
    var request = new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
      url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      method: __WEBPACK_IMPORTED_MODULE_9_requests__["c" /* POST */],
      record: record
    });

    this.setState({
      uploadFailed: false
    });

    this.setRequest({
      uploadWorkingSetTypeface: request
    }, { skipDispatch: true });

    if (this.props.isAllowed) {
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* createWorkingSetTypeface */](request, record, this.state.dropzone));
    }
  },
  renderError: function renderError() {
    var isAllowed = this.props.isAllowed;
    var uploadFailed = this.state.uploadFailed;

    var error = null;

    if (!isAllowed) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-primary bg-body', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Well shoot!'), ' You\'ll have to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'upgrade'), ' before you can add another typeface.');
    } else if (uploadFailed) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-danger bg-body', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Dangit!'), ' There was an issue uploading your custom typeface. Our support team has been notified.');
    }

    return error;
  },
  renderUploadIconButton: function renderUploadIconButton() {
    var rm = this.resourceManager();
    var uploadTypefaceButtonElement = null;
    var className = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('btn', 'btn-primary', 'btn-block', 'btn-lg');

    if (rm.requests.isQueued(this.requests.uploadWorkingSetTypeface)) {
      uploadTypefaceButtonElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, 'disabled') }, 'Uploading typeface\u2026');
    } else {
      uploadTypefaceButtonElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleUploadClicked, className: className }, 'Upload Typeface ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));
    }

    return uploadTypefaceButtonElement;
  },
  render: function render() {
    var characterSets = this.props.characterSets;

    var rm = this.resourceManager();
    var makeOption = function makeOption(value) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { key: value, value: value }, value);
    };
    var weightOptions = __WEBPACK_IMPORTED_MODULE_13__settings__["e" /* TYPEFACE_WEIGHTS */].map(makeOption);
    var styleOptions = __WEBPACK_IMPORTED_MODULE_13__settings__["d" /* TYPEFACE_STYLES */].map(makeOption);
    var formGroupClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('form-group', 'row', 'string', 'required');
    var familyFormGroupClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(formGroupClassName, { 'has-danger': rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('family') });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-1' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple_form form-horizontal' }, this.renderError(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: familyFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Family ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: 'family', className: 'string required form-control', type: 'text' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["b" /* HasErrors */], { request: this.requests.uploadWorkingSetTypeface, errorKey: 'family' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('family'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, 'Name of your typeface family. Identical typeface families will be grouped together.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PasteOrDropzone__["e" /* default */], {
      onDropzoneInit: this.handleDropzoneInit,
      type: __WEBPACK_IMPORTED_MODULE_12__PasteOrDropzone__["d" /* TYPEFACE */],
      error: rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('typeface'),
      wrapperClassName: 'col-xs-8',
      which: __WEBPACK_IMPORTED_MODULE_12__PasteOrDropzone__["a" /* DROPZONE */]
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row select required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'select required col-xs-3 form-control-label p-xs-r-sm' }, 'Weight ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { ref: 'weight', className: 'select required form-control' }, weightOptions))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row select required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'select required col-xs-3 form-control-label p-xs-r-sm' }, 'Style ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { ref: 'style', className: 'select required form-control' }, styleOptions))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-3 form-control-label p-xs-r-sm' }, 'Character Subsetting ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TypefaceSubsetting__["b" /* default */], {
      subsetting: this.state.subsetting,
      selectedCharacterSetIds: this.state.characterSets,
      characterSets: characterSets,
      onSubsettingChanged: this.handleSubsettingChanged,
      onCharacterSetChanged: this.handleCharacterSetChanged
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8 col-xs-offset-3' }, this.renderUploadIconButton()))))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadTypefaceForm));

/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_requests_methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__settings__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RemoveTypefaceModal__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PasteOrDropzone__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TypefacePreview__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TypefaceSubsetting__ = __webpack_require__(218);




















var UpdateWorkingSetTypeface = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Record"])({
  id: null,
  family: null,
  weight: null,
  style: null,
  subsetting: null,
  characterSets: null
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;
  var workingSetTypefaceId = ownProps.params.workingSetTypefaceId;

  return {
    kitToken: kitToken,
    workingSetTypefaceId: workingSetTypefaceId,
    requests: state.requests
  };
};

var EditTypefaceController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EditTypefaceController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetTypefaceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showConfirmDeleteTypeface: false,
      family: '',
      weight: '',
      style: '',
      subsetting: 'none',
      characterSets: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Set"])(),
      deletingFailed: false,
      uploadFailed: false,
      buildFailed: false
    };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        kitToken = _props.kitToken,
        workingSetTypefaceId = _props.workingSetTypefaceId;

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_4_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_4_requests__["b" /* GET */],
        url: ['api', 'kits', kitToken]
      })
    });

    this.setRequest({
      workingSetTypeface: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_4_requests__["b" /* GET */],
        url: ['api', 'kits', kitToken, 'working-set-typefaces', workingSetTypefaceId]
      })
    });

    this.setRequest({
      characterSets: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_4_requests__["b" /* GET */],
        url: ['api', 'character-sets']
      })
    });
  },
  transitions: function transitions(register) {
    var typefacesPath = '/kits/' + this.props.kitToken + '/typefaces';

    register({
      request: this.requests.workingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var workingSetTypeface = rm.type(this.requests.workingSetTypeface, 'working-set-typefaces').get();

        this.setState({
          family: workingSetTypeface.family,
          weight: workingSetTypeface.weight,
          style: workingSetTypeface.style,
          subsetting: workingSetTypeface.subsetting,
          characterSets: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Set"])(workingSetTypeface.characterSets)
        });
      }
    });

    register({
      request: this.requests.updateWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        __WEBPACK_IMPORTED_MODULE_8_react_router__["e" /* browserHistory */].replace(typefacesPath);
      }
    });

    register({
      request: this.requests.updateWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call() {
        this.setState({
          uploadFailed: true
        });
      }
    });

    register({
      request: this.requests.deleteWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call() {
        __WEBPACK_IMPORTED_MODULE_8_react_router__["e" /* browserHistory */].replace(typefacesPath);
      }
    });

    register({
      request: this.requests.deleteWorkingSetTypeface,
      to: __WEBPACK_IMPORTED_MODULE_5_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call() {
        this.setState({
          deletingFailed: true
        });
      }
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      workingSetTypeface: rm.type(this.requests.workingSetTypeface, 'working-set-typefaces').get(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all()
    };
  },
  handleDropzoneInit: function handleDropzoneInit(dropzone) {
    this.setState({
      dropzone: dropzone
    });
  },
  handleFamilyChanged: function handleFamilyChanged(event) {
    this.setState({
      family: event.target.value
    });
  },
  handleSubsettingChanged: function handleSubsettingChanged(subsetting) {
    this.setState({
      subsetting: subsetting
    });
  },
  handleCharacterSetsChanged: function handleCharacterSetsChanged(characterSet, isChecked) {
    var characterSets = this.state.characterSets;

    this.setState({
      characterSets: isChecked ? characterSets.add(characterSet) : characterSets.delete(characterSet)
    });
  },
  handleWeightChanged: function handleWeightChanged(event) {
    this.setState({
      weight: event.target.value
    });
  },
  handleStyleChanged: function handleStyleChanged(event) {
    this.setState({
      style: event.target.value
    });
  },
  handleEditTypefaceClicked: function handleEditTypefaceClicked(event) {
    var kitToken = this.props.kitToken;

    var _resources = this.resources(),
        workingSetTypeface = _resources.workingSetTypeface;

    var record = UpdateWorkingSetTypeface({
      id: workingSetTypeface.id,
      family: this.state.family,
      weight: this.state.weight,
      style: this.state.style,
      subsetting: this.state.subsetting,
      characterSets: this.state.characterSets.toArray().join(',')
    });

    event.preventDefault();

    var request = new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
      url: ['api', 'kits', kitToken, 'working-set-typefaces', workingSetTypeface.id],
      method: __WEBPACK_IMPORTED_MODULE_4_requests__["d" /* PUT */],
      record: record
    });

    this.setRequest({
      updateWorkingSetTypeface: request
    }, { skipDispatch: this.hasFiles() });

    if (this.hasFiles()) {
      this.props.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["j" /* updateWorkingSetTypeface */](request, record, this.state.dropzone));
    }
  },
  hasFiles: function hasFiles() {
    var dropzone = this.state.dropzone;

    return dropzone ? dropzone.files.length > 0 : false;
  },
  handleDeleteTypefaceClicked: function handleDeleteTypefaceClicked(event) {
    event.preventDefault();

    this.setState({
      showConfirmDeleteTypeface: true
    });
  },
  handleDeleteTypefaceConfirmed: function handleDeleteTypefaceConfirmed() {
    var _resources2 = this.resources(),
        workingSetTypeface = _resources2.workingSetTypeface;

    this.setState({
      showConfirmDeleteTypeface: false
    });

    this.deleteWorkingSetTypeface(workingSetTypeface);
  },
  handleRemoveFromKitClicked: function handleRemoveFromKitClicked() {
    var _resources3 = this.resources(),
        workingSetTypeface = _resources3.workingSetTypeface;

    this.deleteWorkingSetTypeface(workingSetTypeface);
  },
  deleteWorkingSetTypeface: function deleteWorkingSetTypeface(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        method: __WEBPACK_IMPORTED_MODULE_6_requests_methods__["a" /* DELETE */],
        record: workingSetTypeface
      })
    });
  },
  handleConfirmDeleteTypefaceClosed: function handleConfirmDeleteTypefaceClosed() {
    this.setState({
      showConfirmDeleteTypeface: false
    });
  },
  handleFileAdded: function handleFileAdded() {
    this.forceUpdate();
  },
  handleFileRemoved: function handleFileRemoved() {
    this.forceUpdate();
  },
  renderError: function renderError() {
    var error = null;
    var _state = this.state,
        buildFailed = _state.buildFailed,
        uploadFailed = _state.uploadFailed,
        deletingFailed = _state.deletingFailed;

    if (buildFailed || uploadFailed) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-warning', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oi!'), ' We had trouble saving your typeface. Why don\u2019t you try again.');
    }

    if (deletingFailed) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-danger', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oops!'), ' There was an issue deleting your typeface. Our support team has been notified.');
    }

    return error;
  },
  renderEditTypefaceButton: function renderEditTypefaceButton() {
    var rm = this.resourceManager();
    var workingSetTypefaceUpdating = rm.requests.isQueued(this.requests.updateWorkingSetTypeface);
    var label = workingSetTypefaceUpdating ? 'Saving...' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Edit Typeface ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleEditTypefaceClicked, className: 'btn btn-primary btn-block btn-lg', disabled: workingSetTypefaceUpdating }, label);
  },
  renderTypefaceSubsetting: function renderTypefaceSubsetting() {
    var _resources4 = this.resources(),
        characterSets = _resources4.characterSets;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-3 form-control-label p-xs-r-sm' }, 'Character Subsetting ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TypefaceSubsetting__["b" /* default */], {
      subsetting: this.state.subsetting,
      selectedCharacterSetIds: this.state.characterSets,
      characterSets: characterSets,
      onSubsettingChanged: this.handleSubsettingChanged,
      onCharacterSetChanged: this.handleCharacterSetsChanged
    })));
  },
  renderTypefacePreview: function renderTypefacePreview() {
    var _resources5 = this.resources(),
        workingSetTypeface = _resources5.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 typeface-asset-preview-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__TypefacePreview__["a" /* default */], {
      workingSetTypeface: workingSetTypeface
    }));
  },
  renderNonCustomTypeface: function renderNonCustomTypeface() {
    var kitToken = this.props.kitToken;

    var _resources6 = this.resources(),
        workingSetTypeface = _resources6.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple_form form-horizontal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'col-xs-3 form-control-label' }, 'Family'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 form-control-static' }, workingSetTypeface.family)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'col-xs-3 form-control-label' }, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 form-control-static' }, workingSetTypeface.weight)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'col-xs-3 form-control-label' }, 'Style'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 form-control-static' }, workingSetTypeface.style)), this.renderTypefaceSubsetting(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, this.renderEditTypefaceButton(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'hr m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'hr-text bg-white' }, 'or'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-offset-3 p-xs-r-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces', className: 'btn btn-secondary btn-block btn-lg' }, 'Cancel')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 p-xs-l-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleRemoveFromKitClicked, href: '#', className: 'btn btn-secondary btn-lg' }, 'Remove from Kit ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times-circle p-xs-l-xs' }))))), workingSetTypeface ? this.renderTypefacePreview() : null);
  },
  renderCustomTypeface: function renderCustomTypeface() {
    var kitToken = this.props.kitToken;

    var _resources7 = this.resources(),
        workingSetTypeface = _resources7.workingSetTypeface;

    var makeOption = function makeOption(value) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { key: value, value: value }, value);
    };
    var typefaceErrors = this.resourceManager().requests.errorsFor(this.requests.updateWorkingSetTypeface);
    var weightOptions = __WEBPACK_IMPORTED_MODULE_12__settings__["e" /* TYPEFACE_WEIGHTS */].map(makeOption);
    var styleOptions = __WEBPACK_IMPORTED_MODULE_12__settings__["d" /* TYPEFACE_STYLES */].map(makeOption);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, this.renderError(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple_form form-horizontal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row string required working_set_typeface_family' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label' }, 'Family ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'string required form-control', onChange: this.handleFamilyChanged, type: 'text', value: this.state.family }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, 'Name of your typeface family. Identical typeface families will be grouped together.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row select required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'select required col-xs-3 form-control-label' }, 'Weight ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { value: this.state.weight, onChange: this.handleWeightChanged, className: 'select required form-control' }, weightOptions))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row select required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'select required col-xs-3 form-control-label' }, 'Style ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { value: this.state.style, onChange: this.handleStyleChanged, className: 'select required form-control' }, styleOptions))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PasteOrDropzone__["e" /* default */], {
      onDropzoneInit: this.handleDropzoneInit,
      onFileAdded: this.handleFileAdded,
      onFileRemoved: this.handleFileRemoved,
      type: __WEBPACK_IMPORTED_MODULE_15__PasteOrDropzone__["d" /* TYPEFACE */],
      uploadLabel: 'Replace Original',
      error: typefaceErrors.first(),
      wrapperClassName: 'col-xs-9',
      which: __WEBPACK_IMPORTED_MODULE_15__PasteOrDropzone__["a" /* DROPZONE */]
    }), this.renderTypefaceSubsetting(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, this.renderEditTypefaceButton(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'hr m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'hr-text bg-white' }, 'or'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-offset-3 p-xs-r-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces', className: 'btn btn-secondary btn-block btn-lg' }, 'Cancel')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 p-xs-l-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleDeleteTypefaceClicked, href: '#', className: 'btn btn-secondary btn-block btn-lg' }, 'Delete Typeface ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash p-xs-l-xs' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RemoveTypefaceModal__["a" /* default */], {
      workingSetTypeface: workingSetTypeface,
      show: this.state.showConfirmDeleteTypeface,
      onRemovedTypeface: this.handleDeleteTypefaceConfirmed,
      onClosed: this.handleConfirmDeleteTypefaceClosed
    })))), workingSetTypeface ? this.renderTypefacePreview() : null);
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_11_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  renderMain: function renderMain() {
    var _resources8 = this.resources(),
        kit = _resources8.kit,
        workingSetTypeface = _resources8.workingSetTypeface;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/typefaces', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header__["a" /* default */], { kit: kit, heading: 'Edit / View Typeface', headingIcon: 'ficon-pencil', showUpload: workingSetTypeface.custom }), workingSetTypeface.custom ? this.renderCustomTypeface() : this.renderNonCustomTypeface());
  },
  render: function render() {
    var requests = [this.requests.subscription, this.requests.kit, this.requests.workingSetTypeface, this.requests.characterSets];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["c" /* Requesting */], { any: requests, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["a" /* Done */], { all: requests, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps)(EditTypefaceController));

/***/ }),

/***/ 1059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedText__ = __webpack_require__(216);









var PREVIEW_TAB_LIGHT = 'PREVIEW_TAB_LIGHT';
var PREVIEW_TAB_DARK = 'PREVIEW_TAB_DARK';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefacePreview',

  propTypes: {
    workingSetTypeface: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      previewTab: PREVIEW_TAB_LIGHT
    };
  },
  handleLightPreviewClicked: function handleLightPreviewClicked(event) {
    event.preventDefault();

    this.setState({ previewTab: PREVIEW_TAB_LIGHT });
  },
  handleDarkPreviewClicked: function handleDarkPreviewClicked(event) {
    event.preventDefault();

    this.setState({ previewTab: PREVIEW_TAB_DARK });
  },
  render: function render() {
    var workingSetTypeface = this.props.workingSetTypeface;

    var fullName = workingSetTypeface.family + ' ' + workingSetTypeface.weight + ' ' + workingSetTypeface.style;
    var isLightPreview = this.state.previewTab === PREVIEW_TAB_LIGHT;
    var isDarkPreview = this.state.previewTab === PREVIEW_TAB_DARK;
    var lightTabClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-item', { active: isLightPreview });
    var darkTabClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-item', { active: isDarkPreview });
    var alertClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('well', { 'bg-body': isLightPreview, 'bg-gray-dark': isDarkPreview });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: lightTabClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', onClick: this.handleLightPreviewClicked, href: '#' }, 'Light')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: darkTabClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', onClick: this.handleDarkPreviewClicked, href: '#' }, 'Dark'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_WoffEmbeddedText__["a" /* default */], { woff: workingSetTypeface.woff, className: alertClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'text-nowrap' }, fullName), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-nowrap' }, fullName), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-nowrap' }, fullName), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-nowrap' }, fullName), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5', { className: 'text-nowrap' }, fullName), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'He smiled understandingly-much more than understandingly. It was one of those rare smiles with a quality of eternal reassurance in it, that you may come across four or five times in life. It faced\u2013or seemed to face\u2013the whole eternal world for an instant, and then concentrated on you with an irresistible prejudice in your favor. It understood you just as far as you wanted to be understood, believed in you as you would like to believe in yourself, and assured you that it had precisely the impression of you that, at your best, you hoped to convey.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table table-condensed m-xs-t-md text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-history' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'Last Edited'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, workingSetTypeface.updatedAt.fromNow())), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-size' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'File Size'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_5_numeral___default()(workingSetTypeface.optimizedSize).format('0b'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-use' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-normal' }, 'CSS use'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'p-xs-r-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'code code-highlight' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '.example ', '{'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'font-family:'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetTypeface.family), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ';'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'font-weight:'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetTypeface.weight), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ';'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'font-style:'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetTypeface.style), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ';'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '}'))))))));
  }
}));

/***/ }),

/***/ 1060:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UploadImageForm__ = __webpack_require__(1061);













var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var UploadImageController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadImageController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'subscriptions'],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */]
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get()
    };
  },
  handleUploadImageSucceeded: function handleUploadImageSucceeded() {
    __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/images');
  },
  renderUploadImage: function renderUploadImage() {
    var _resources = this.resources(),
        subscription = _resources.subscription;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UploadImageForm__["a" /* default */], {
      dispatch: this.props.dispatch,
      kitToken: this.props.kitToken,
      onSuccess: this.handleUploadImageSucceeded,
      onNotAllowed: this.handleUploadImageNotAllowed
    }));
  },
  renderMain: function renderMain() {
    var kitToken = this.props.kitToken;

    var _resources2 = this.resources(),
        kit = _resources2.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/images', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], { heading: 'Add an Image' }), this.renderUploadImage());
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_6_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadImageController));

/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_localstorage__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PasteOrDropzone__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_ImageFormMixin__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OptimizedForSelect__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HelpUploadingIcons__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DirectToCloudDropzone__ = __webpack_require__(485);


















var NewWorkingSetImage = Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Record"])({
  name: null,
  uploadedUrl: null
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var UploadImageForm = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadImageForm',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_ImageFormMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      uploadFailed: false
    };
  },
  uploadRecord: function uploadRecord() {
    return NewWorkingSetImage({
      name: this.state.name,
      uploadedUrl: this.state.imageUrl
    });
  },
  handleUploadClicked: function handleUploadClicked() {
    var record = this.uploadRecord();
    var request = new __WEBPACK_IMPORTED_MODULE_14_requests__["e" /* Request */]({
      url: ['api', 'kits', this.props.kitToken, 'working-set-images'],
      method: __WEBPACK_IMPORTED_MODULE_14_requests__["c" /* POST */],
      record: record
    });

    this.setState({
      uploading: true
    });

    this.setRequest({
      uploadImage: request
    }, { skipDispatch: true });

    this.props.dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* createImageFromDropzone */](request, record, this.state.dropzone));
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.uploadImage,
      to: __WEBPACK_IMPORTED_MODULE_15_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.props.onSuccess();
      }
    });

    register({
      request: this.requests.uploadImage,
      to: __WEBPACK_IMPORTED_MODULE_15_requests_RequestsMixin__["a" /* HAS_ERRORS */],
      call: function call(rm) {
        this.setState({ uploading: false });
      }
    });

    register({
      request: this.requests.uploadImage,
      to: __WEBPACK_IMPORTED_MODULE_15_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.setState({
          uploading: false,
          uploadFailed: true
        });
      }
    });
  },
  render: function render() {
    var rm = this.resourceManager();
    var stopDnD = function stopDnD(event) {
      event.preventDefault();
      event.stopPropagation();
    };
    var uploadFailedElement = this.state.uploadFailed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-danger bg-body has-icon', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning alert-icon text-lg' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oops!'), ' There was an issue uploading your image. Try again.')) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row', onDragOver: stopDnD, onDrop: stopDnD }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8 form-horizontal' }, uploadFailedElement, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group required m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DirectToCloudDropzone__["a" /* default */], this.directToCloudDropzoneProps())), this.nameFormGroup(this.requests.uploadImage), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { disabled: !this.state.imageUrl || this.state.uploading || this.state.nameIsInvalid, className: 'btn btn-primary btn-block btn-lg', onClick: this.handleUploadClicked }, 'Upload Image ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-4 p-xs-l-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 text-sm' }, 'Fort Awesome can process, serve, and optimize ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'JPGs, PNGs, and SVGs'), ' formatted image files.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body text-sm m-xs-y-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, 'Need help?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-t-sm m-xs-b-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'p-xs-l-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/help#qa-images-format' }, 'What image types and sizes do you support?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/help#qa-images-how' }, 'How does Fort Awesome optimize images?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/help#qa-images-views' }, 'Do live images count as pageviews?')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, 'Not sure where to find images?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-t-sm m-xs-b-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 text-sm' }, 'We recommend ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://unsplash.com' }, 'Unsplash'), ', ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://picjumbo.com/' }, 'picjumbo'), ', and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://www.gratisography.com/' }, 'Gratisography'), '.'))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadImageForm));

/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ImagePreview__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EditImageForm__ = __webpack_require__(1065);














var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;
  var workingSetImageId = ownProps.params.workingSetImageId;

  return {
    requests: state.requests,
    kitToken: kitToken,
    workingSetImageId: workingSetImageId
  };
};

var EditImageController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EditImageController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetImageId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      workingSetImage: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', this.props.workingSetImageId]
      })
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.deleteWorkingSetImage,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/images');
      }
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      workingSetImage: rm.type(this.requests.workingSetImage, 'working-set-images').get()
    };
  },
  handleDeleteWorkingSetImage: function handleDeleteWorkingSetImage(workingSetImage) {
    this.setRequest({
      deleteWorkingSetImage: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', workingSetImage.id],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["a" /* DELETE */],
        record: workingSetImage
      })
    });
  },
  handleWorkingSetImageUpdated: function handleWorkingSetImageUpdated() {
    __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/images');
  },
  renderMain: function renderMain() {
    var _resources = this.resources(),
        kit = _resources.kit,
        workingSetImage = _resources.workingSetImage;

    var formElement = workingSetImage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EditImageForm__["a" /* default */], {
      kitToken: kit.token,
      workingSetImage: workingSetImage,
      onDeleteWorkingSetImage: this.handleDeleteWorkingSetImage,
      onSuccess: this.handleWorkingSetImageUpdated
    }) : null;
    var previewElement = workingSetImage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ImagePreview__["a" /* default */], {
      kitToken: kit.token,
      workingSetImage: workingSetImage
    }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/images', className: 'link-dashed-none' }, '\u2039 Back to ', kit.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], { kit: kit, heading: 'Edit / View Image', headingIcon: 'ficon-pencil' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, formElement), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 image-asset-preview-rendering' }, previewElement)));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_6_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(EditImageController));

/***/ }),

/***/ 1063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImagePreviewModal__ = __webpack_require__(1064);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}











var ORIGINAL = 'ORIGINAL';
var OPTIMIZED = 'OPTIMIZED';
var SIZE_FORMAT = '0 b';
var POPOVER_TIMEOUT = 2000; // in ms

var ImagePreview = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImagePreview',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetImage: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record
  },

  getInitialState: function getInitialState() {
    return {
      showAssetType: OPTIMIZED,
      showLargerImage: false,
      imagesLoaded: [],
      cdnLinkCopied: false
    };
  },
  handleShowOptimized: function handleShowOptimized() {
    this.setState({ showAssetType: OPTIMIZED });
  },
  handleShowOriginal: function handleShowOriginal() {
    this.setState({ showAssetType: ORIGINAL });
  },
  widthAndHeight: function widthAndHeight() {
    if (this._image) {
      return [this._image.naturalWidth, this._image.naturalHeight];
    } else {
      return [null, null];
    }
  },
  handleImageLoaded: function handleImageLoaded() {
    var imagesLoaded = [].concat(_toConsumableArray(this.state.imagesLoaded));

    imagesLoaded.push(this.state.showAssetType);

    this.setState({
      imagesLoaded: imagesLoaded
    });
  },
  handleCdnUrlClicked: function handleCdnUrlClicked(event) {
    event.target.select();
  },
  handleCdnUrlCopied: function handleCdnUrlCopied() {
    var _this = this;

    var disable = function disable() {
      return _this.setState({ cdnLinkCopied: false });
    };

    this.setState({ cdnLinkCopied: true }, function () {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },
  handleImageClicked: function handleImageClicked(event) {
    event.preventDefault();

    this.setState({
      showLargerImage: true
    });
  },
  handleShowLargerImageClosed: function handleShowLargerImageClosed() {
    this.setState({
      showLargerImage: false
    });
  },
  render: function render() {
    var _this2 = this;

    var workingSetImage = this.props.workingSetImage;
    var _state = this.state,
        showAssetType = _state.showAssetType,
        imagesLoaded = _state.imagesLoaded,
        cdnLinkCopied = _state.cdnLinkCopied;

    var showOptimized = showAssetType === OPTIMIZED;
    var showOriginal = showAssetType === ORIGINAL;
    var imageUrl = showOptimized ? workingSetImage.optimizedUrl : workingSetImage.originalUrl;
    var percentLeft = workingSetImage.optimizedSize / workingSetImage.originalSize * 100;
    var percentSaved = 100 - percentLeft;
    var imageLoaded = ~imagesLoaded.indexOf(showAssetType);

    var _widthAndHeight = this.widthAndHeight(),
        _widthAndHeight2 = _slicedToArray(_widthAndHeight, 2),
        width = _widthAndHeight2[0],
        height = _widthAndHeight2[1];

    var dimensions = imageLoaded ? width + ' x ' + height : 'Loading...';
    var cdnLinkCopiedPopover = cdnLinkCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Link Copied!' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ImagePreviewModal__["a" /* default */], { isOpen: this.state.showLargerImage, onClosed: this.handleShowLargerImageClosed, workingSetImage: workingSetImage }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix asset-uploaded-preview' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("nav-item", { active: showOptimized }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleShowOptimized, className: 'nav-link', href: '#' }, 'Optimized')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("nav-item", { active: showOriginal }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleShowOriginal, className: 'nav-link', href: '#' }, 'Original'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-img-checkered text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleImageClicked, href: '#', className: 'asset-preview-large-toggle block link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'asset-preview-large-toggle-icon ficon ficon-3x ficon-search text-white br-circle p-xs-a-lg block', title: 'View a larger version' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onLoad: this.handleImageLoaded, ref: function ref(r) {
        return _this2._image = r;
      }, className: 'asset-uploaded-preview-display', src: imageUrl, alt: workingSetImage.name })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'image-performance bg-gray-lighter' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'image-performance-value br-r bg-primary', style: { width: percentLeft + '%' } })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table table-condensed m-xs-t-md text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-size' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, 'Original Size'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_7_numeral___default()(workingSetImage.originalSize).format(SIZE_FORMAT)))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-size' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, 'Optimized Size'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-primary' }, __WEBPACK_IMPORTED_MODULE_7_numeral___default()(workingSetImage.optimizedSize).format(SIZE_FORMAT)), ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'text-primary font-weight-normal' }, '(', __WEBPACK_IMPORTED_MODULE_7_numeral___default()(percentSaved).format('0'), '% saved)'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-dimensions' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, 'Dimensions'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, dimensions)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-history' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, 'Last Edited'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, workingSetImage.updatedAt.fromNow())), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-cdn-url' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-t-sm block' }, 'CDN URL')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'has-tooltip p-xs-r-0 p-xs-l-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col p-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { defaultValue: workingSetImage.publishedUrl, onClick: this.handleCdnUrlClicked, className: 'table bg-white form-control-static p-xs-a-0 br-r-0 block b-a-0 text-truncate' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, cdnLinkCopiedPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default.a, { text: workingSetImage.publishedUrl, onCopy: this.handleCdnUrlCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary btn-sm', title: 'Copy' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' }))))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-use' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap' }, 'HTML use'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'p-xs-r-0 p-xs-l-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'code code-highlight word-wrap' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<img'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'src="'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetImage.publishedUrl), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, '"'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'alt=""'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm m-xs-b-0 text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Accessibility heads up'), ': Provide a text equivalent with the alt attribute for your image.'))))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ImagePreview);

/***/ }),

/***/ 1064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);








var OPTIMIZED = 'OPTIMIZED';
var ORIGINAL = 'ORIGINAL';

var ImagePreviewModal = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImagePreviewModal',

  propTypes: {
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    workingSetImage: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record.isRequired,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      type: OPTIMIZED
    };
  },
  handleShowOptimized: function handleShowOptimized(event) {
    event.preventDefault();

    this.setState({ type: OPTIMIZED });
  },
  handleShowOriginal: function handleShowOriginal(event) {
    event.preventDefault();

    this.setState({ type: ORIGINAL });
  },
  handleClosed: function handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },
  render: function render() {
    var workingSetImage = this.props.workingSetImage;
    var type = this.state.type;

    var showOriginal = type === ORIGINAL;
    var showOptimized = type === OPTIMIZED;
    var imgSrc = showOptimized ? workingSetImage.optimizedUrl : workingSetImage.originalUrl;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Modal__["a" /* default */], { contentLabel: 'Image preview', isOpen: this.props.isOpen, onRequestClose: this.handleClosed, className: 'modal-fw' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content asset-preview-large-modal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'close close-dangle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { onClick: this.handleShowOptimized, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('nav-item', { active: showOptimized }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#' }, 'Optimized (', __WEBPACK_IMPORTED_MODULE_6_numeral___default()(workingSetImage.optimizedSize).format('0.0 b'), ')')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { onClick: this.handleShowOriginal, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('nav-item', { active: showOriginal }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#' }, 'Original (', __WEBPACK_IMPORTED_MODULE_6_numeral___default()(workingSetImage.originalSize).format('0.0 b'), ')'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-img-checkered p-xs-ymd text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'asset-uploaded-preview-source', src: imgSrc, alt: workingSetImage.name })))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ImagePreviewModal);

/***/ }),

/***/ 1065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_ImageFormMixin__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DirectToCloudDropzone__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RemoveImageModal__ = __webpack_require__(468);















var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var EditImageForm = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'EditImageForm',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetImage: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record.isRequired,
    onSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onDeleteWorkingSetImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_ImageFormMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      updating: false,
      showConfirmDeleteImage: false
    };
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.updateImage,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        this.props.onSuccess();
      }
    });

    register({
      request: this.requests.updateImage,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["a" /* HAS_ERRORS */],
      call: function call(rm) {
        this.setState({ updating: false });
      }
    });

    register({
      request: this.requests.uploadImage,
      to: __WEBPACK_IMPORTED_MODULE_9_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.setState({
          uploading: false,
          uploadFailed: true
        });
      }
    });
  },
  updateRecord: function updateRecord() {
    var record = this.props.workingSetImage.set('name', this.state.name);

    if (this.state.imageUrl) {
      record = record.set('uploadedUrl', this.state.imageUrl);
    }

    return record;
  },
  handleEditClicked: function handleEditClicked() {
    var record = this.updateRecord();
    var request = new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
      url: ['api', 'kits', this.props.kitToken, 'working-set-images', record.id],
      method: __WEBPACK_IMPORTED_MODULE_8_requests__["d" /* PUT */],
      record: record
    });

    this.setState({
      updating: true
    });

    this.setRequest({
      updateImage: request
    }, { skipDispatch: true });

    this.props.dispatch(__WEBPACK_IMPORTED_MODULE_10__actions__["h" /* updateImageFromDropzone */](request, record, this.state.dropzone));
  },
  handleDeleteImageClicked: function handleDeleteImageClicked(event) {
    event.preventDefault();

    this.setState({ showConfirmDeleteImage: true });
  },
  handleDeleteImageConfirmed: function handleDeleteImageConfirmed() {
    var _this = this;

    this.setState({
      showConfirmDeleteImage: false
    }, function () {
      _this.props.onDeleteWorkingSetImage(_this.props.workingSetImage);
    });
  },
  handleDeleteImageCanceled: function handleDeleteImageCanceled() {
    this.setState({
      showConfirmDeleteImage: false
    });
  },
  render: function render() {
    var _props = this.props,
        kitToken = _props.kitToken,
        workingSetImage = _props.workingSetImage;

    var nameHasNotChanged = workingSetImage.name === this.state.name;
    var editDisabled = this.state.updating || this.state.nameIsInvalid || nameHasNotChanged && !this.state.imageUrl;
    var uploadFailedElement = this.state.uploadFailed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-danger bg-body has-icon', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning alert-icon text-lg' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Oops!'), ' There was an issue uploading your image. Try again.')) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RemoveImageModal__["a" /* default */], {
      show: this.state.showConfirmDeleteImage,
      workingSetImage: workingSetImage,
      onRemovedImage: this.handleDeleteImageConfirmed,
      onClosed: this.handleDeleteImageCanceled
    }), uploadFailedElement, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple-form form-horizontal', action: '', method: '' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string col-xs-3 form-control-label p-xs-r-sm' }, 'Replace Original'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DirectToCloudDropzone__["a" /* default */], this.directToCloudDropzoneProps()))), this.nameFormGroup(this.requests.updateImage), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleEditClicked, disabled: editDisabled, className: 'btn btn-primary btn-block btn-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Edit Image ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'hr m-xs-t-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'hr-text bg-white' }, 'or'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-offset-3 p-xs-r-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/images', className: 'btn btn-secondary btn-block btn-lg' }, 'Cancel')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 p-xs-l-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleDeleteImageClicked, href: '#', className: 'btn btn-secondary btn-block btn-lg' }, 'Delete Image', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash p-xs-l-xs' })))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(EditImageForm));

/***/ }),

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);








var DeleteKit = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DeleteKit',

  propTypes: {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    token: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showConfirmation: false,
      deleting: false,
      focused: false
    };
  },
  handleOpened: function handleOpened() {
    this.setState({ showConfirmation: true });
  },
  handleClosed: function handleClosed() {
    this.setState({ showConfirmation: false });
  },
  handleDeleted: function handleDeleted() {
    this.setState({ deleting: true });
  },
  handleFocused: function handleFocused() {
    this.setState({ focused: !this.state.focused });
  },
  render: function render() {
    var deleteClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('btn', 'btn-lg', 'btn-danger', { disabled: this.state.deleting });

    var deleteLabel = this.state.deleting ? 'Deleting...' : 'Delete';

    var popover = this.state.focused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { content: 'Delete Kit', icon: 'ficon-trash' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-remove cursor-pointer', onClick: this.handleOpened, onMouseOver: this.handleFocused, onMouseOut: this.handleFocused }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Confirm delete kit', isOpen: this.state.showConfirmation, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { type: 'button', className: 'close close-dangle', onClick: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Close')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, 'Confirm Delete Kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-body text-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning ficon-2x pull-left m-xs-t-sm m-xs-b-xl p-xs-r-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Are you sure you would like to delete this kit? These icons will no longer load on any websites.'), 'This action cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table text-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'min-width text-nowrap p-xs-r-xl' }, 'Kit Name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, this.props.name)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'min-width text-nowrap p-xs-r-xl' }, 'Kit ID'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, this.props.token))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-secondary', onClick: this.handleClosed }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'kits/' + this.props.token, className: deleteClassName, 'data-method': 'delete', rel: 'nofollow', onClick: this.handleDeleted }, deleteLabel)))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DeleteKit);

/***/ }),

/***/ 1067:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_WoffEmbeddedIcon__ = __webpack_require__(116);







var Icon = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Icon',

  propTypes: {
    woff: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    class_name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  render: function render() {
    var woff = this.props.woff;

    var value = null;

    if (woff) {
      value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_WoffEmbeddedIcon__["a" /* default */], { className: this.props.class_name, woff: this.props.woff });
    }

    return value;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_SearchField__ = __webpack_require__(483);








var SetsSearchIntegrator = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SetsSearchIntegrator',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      query: ''
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.query.length > 0) {
      this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* searchForSet */])(this.props.query, this.props.index));
    }
  },
  handleSearchChanged: function handleSearchChanged(query) {
    this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* searchForSet */])(query, this.props.index));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_SearchField__["a" /* default */], { value: this.props.query, onChange: this.handleSearchChanged });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var mapStateToProps = function mapStateToProps(state) {
    return { query: state.searchForSet.query };
  };

  var Connected = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(SetsSearchIntegrator);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_4_store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Connected, props));
});

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SetsResults__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(192);









var SetsResultsIntegrator = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SetsResultsIntegrator',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    hits: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    hitsPerPage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    count: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  },

  componentDidMount: function componentDidMount() {
    this.makeListedIconSetsVisible();
  },
  componentDidUpdate: function componentDidUpdate() {
    this.makeListedIconSetsVisible();
  },
  makeListedIconSetsVisible: function makeListedIconSetsVisible(makeVisible) {
    var node = $(__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this));
    var cards = node.parent().nextAll();
    var nav = node.parent().siblings('.sets-nav');

    if (this.props.query) {
      cards.hide();
      nav.hide();
    } else {
      cards.show();
      nav.show();
    }
  },
  handleIconClicked: function handleIconClicked(iconName, iconSetSlug) {
    this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* navigateToSet */])(iconSetSlug));
  },
  render: function render() {
    var _props = this.props,
        query = _props.query,
        hits = _props.hits,
        hitsPerPage = _props.hitsPerPage,
        count = _props.count;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SetsResults__["a" /* default */], { onIconClicked: this.handleIconClicked, query: query, hits: hits, hitsPerPage: hitsPerPage, count: count }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var mapStateToProps = function mapStateToProps(state) {
    var _state$searchForSet = state.searchForSet,
        query = _state$searchForSet.query,
        results = _state$searchForSet.results;
    var hits = results.hits,
        hitsPerPage = results.hitsPerPage,
        count = results.count;

    return { query: query, hits: hits, hitsPerPage: hitsPerPage, count: count };
  };

  var Connected = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(SetsResultsIntegrator);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Connected, null));
});

/***/ }),

/***/ 1070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SetsResultsIcon__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SetsResultsPlaceholder__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_components_fillWithPlaceholders__ = __webpack_require__(95);









var SetsResults = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SetsResults',

  propTypes: {
    onIconClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    hits: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    hitsPerPage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    count: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    iconsPerRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      iconsPerRow: __WEBPACK_IMPORTED_MODULE_4__settings__["b" /* ICONS_PER_ROW */]
    };
  },
  title: function title() {
    var _props = this.props,
        query = _props.query,
        hitsPerPage = _props.hitsPerPage,
        count = _props.count;

    var titleElement = null;

    if (hitsPerPage < count) {
      titleElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-base text-muted m-xs-b-lg' }, 'Found ', count, ' results for ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, '\u201C', query, '\u201D'), ' (showing first ', hitsPerPage, ')');
    } else {
      titleElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-base text-muted m-xs-b-lg' }, 'Found ', count, ' results for ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, '\u201C', query, '\u201D'));
    }

    return titleElement;
  },
  render: function render() {
    var _this = this;

    if (!this.props.query) {
      return null;
    }

    var hits = this.props.hits;

    var icons = hits.map(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SetsResultsIcon__["a" /* default */], {
        key: result.id,
        name: result.name,
        unicodeChar: result.unicode_char,
        onClicked: _this.props.onIconClicked,
        iconSet: { name: result.icon_set.name, slug: result.icon_set.slug }
      });
    });

    icons = Object(__WEBPACK_IMPORTED_MODULE_7_utils_components_fillWithPlaceholders__["a" /* default */])(icons, { placeholder: __WEBPACK_IMPORTED_MODULE_6__SetsResultsPlaceholder__["a" /* default */], multipleOf: this.props.iconsPerRow });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.title(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'grid-assets grid-assets-animate grid-assets-sm-8' }, icons));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SetsResults);

/***/ }),

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var SetsResultsIcon = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SetsResultsIcon',

  propTypes: {
    onClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    unicodeChar: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    iconSet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      slug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    })
  },

  render: function render() {
    var _this = this;

    var iconClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('icon-set-preview-112-' + this.props.iconSet.slug, 'icon-set-preview-112-' + this.props.iconSet.slug + '-' + this.props.name);
    var onClicked = function onClicked(event) {
      event.preventDefault();

      _this.props.onClicked(_this.props.name, _this.props.iconSet.slug);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'asset asset-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'block asset-link link-dashed-none', onClick: onClicked }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-preview m-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: iconClassName })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-label' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block m-xs-b-xs' }, this.props.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block font-weight-semibold' }, this.props.iconSet.name))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SetsResultsIcon);

/***/ }),

/***/ 1072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);



var SetsResultsPlaceholder = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SetsResultsPlaceholder',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#' });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SetsResultsPlaceholder);

/***/ }),

/***/ 1073:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ShareResourceController__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_KitDocumentationController__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_KitDocumentationIconsController__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KitDocumentationTypefacesController__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_KitDocumentationImagesController__ = __webpack_require__(1078);













var ShareResourceIntegrator = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ShareResourceIntegrator',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  childContextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  getChildContext: function getChildContext() {
    return {
      kitToken: this.props.kitToken
    };
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["d" /* Router */], { history: Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* browserHistory */], __WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */]) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/share/:token', component: __WEBPACK_IMPORTED_MODULE_7__components_ShareResourceController__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'kit-documentation', component: __WEBPACK_IMPORTED_MODULE_8__components_KitDocumentationController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'kit-documentation/icons', component: __WEBPACK_IMPORTED_MODULE_9__components_KitDocumentationIconsController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'kit-documentation/typefaces', component: __WEBPACK_IMPORTED_MODULE_10__components_KitDocumentationTypefacesController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'kit-documentation/images', component: __WEBPACK_IMPORTED_MODULE_11__components_KitDocumentationImagesController__["a" /* default */] }))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  /* eslint-disable react/prop-types */
  var kitToken = props.kit;
  /* eslint-enable react/prop-types */

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareResourceIntegrator, { kitToken: kitToken });
});

/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);











var POPOVER_TIMEOUT = 2000; // in ms

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var KitDocumentationController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitDocumentationController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element
  },

  contextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      shareableDocumentationUrlCopied: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.context.kitToken]
      })
    });
  },
  handleCopied: function handleCopied() {
    var _this = this;

    var disable = function disable() {
      return _this.setState({ shareableDocumentationUrlCopied: false });
    };

    this.setState({ shareableDocumentationUrlCopied: true }, function () {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.context.kitToken })
    };
  },
  renderMain: function renderMain() {
    var _resources = this.resources(),
        kit = _resources.kit;

    var shareableDocumentationUrlCopied = this.state.shareableDocumentationUrlCopied;

    var shareableDocumentationUrl = '' + location.origin + kit.shareableDocumentationPath;
    var shareableDocumentationUrlPopover = shareableDocumentationUrlCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Doc Link Copied!' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dangle-up bg-gray-dark dashed dashed-bottom' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'container m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-body m-xs-b-0 br-b-0 p-xs-x-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-share ficon-2x text-gray-lighter m-xs-r-sm block m-xs-b-sm' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col p-xs-l-sm p-xs-r-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Share this doc'), ' with your team, clients, or your bookmarks.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col bg-gray-lighter inset p-xs-x-md p-xs-y-sm br-l' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shareable-doc-url' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-truncate font-weight-semibold' }, shareableDocumentationUrl))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, shareableDocumentationUrlPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default.a, { text: shareableDocumentationUrl, onCopy: this.handleCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0', title: 'Copy' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' })))))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg br-a-0 m-xs-b-0' }, this.props.children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well br-t-0 bg-body p-xs-a-lg dashed dashed-top' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Need an example or walkthrough? Check out our Fort Awesome how-to guides on ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://articles.fortawesome.com/how-to-using-fort-awesome-icons-f50ab11a2d2a' }, 'basic icon use'), ', \xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://articles.fortawesome.com/how-to-fort-awesome-assets-on-the-desktop-e3fd15df6f43' }, 'desktop use'), ', and \xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://articles.fortawesome.com/how-to-serve-fort-awesome-assets-yourself-5419b88ee2d4' }, 'serving things yourself'), '.'))));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-icons m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(KitDocumentationController));

/***/ }),

/***/ 1075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationSummaryController__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var KitDocumentationController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitDocumentationController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  contextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationSummaryController__["a" /* default */], { shareable: true, kitToken: this.context.kitToken });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(KitDocumentationController));

/***/ }),

/***/ 1076:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationIconsController__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var KitDocumentationIconsController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitDocumentationIconsController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  contextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationIconsController__["a" /* default */], { shareable: true, kitToken: this.context.kitToken });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(KitDocumentationIconsController));

/***/ }),

/***/ 1077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationTypefacesController__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var KitDocumentationTypefacesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitDocumentationTypefacesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  contextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationTypefacesController__["a" /* default */], { shareable: true, kitToken: this.context.kitToken });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(KitDocumentationTypefacesController));

/***/ }),

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationImagesController__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var KitDocumentationImagesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitDocumentationImagesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  contextTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_views_Kits_components_DocumentationImagesController__["a" /* default */], { shareable: true, kitToken: this.context.kitToken });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(KitDocumentationImagesController));

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_env__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CharacterSet__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconSet__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IconSettings__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Kit__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkingSet__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Publication__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KitMessage__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Subscription__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JobStatusTopic__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Typeface__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TypefaceSettings__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WorkingSetArchive__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__WorkingSetIcon__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__WorkingSetTypeface__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__WorkingSetImage__ = __webpack_require__(403);



















var recordsForType = {};

var NullRecord = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])();

var registry = {
  add: function add(type, record) {
    recordsForType[type] = record;

    return registry;
  },
  find: function find(type) {
    var record = recordsForType[type];

    if (!__WEBPACK_IMPORTED_MODULE_1_utils_env__["a" /* PRODUCTION */] && !record) {
      console.warn('Could not find record for ' + type);
    }

    return record || NullRecord;
  },
  typeFor: function typeFor(record) {
    return Object.keys(recordsForType).find(function (key) {
      return record === recordsForType[key] || record instanceof recordsForType[key];
    });
  }
};

registry.add('character-sets', __WEBPACK_IMPORTED_MODULE_2__CharacterSet__["a" /* default */]);
registry.add('icons', __WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */]);
registry.add('icon-sets', __WEBPACK_IMPORTED_MODULE_4__IconSet__["a" /* default */]);
registry.add('icon-settings', __WEBPACK_IMPORTED_MODULE_5__IconSettings__["a" /* default */]);
registry.add('kits', __WEBPACK_IMPORTED_MODULE_6__Kit__["a" /* default */]);
registry.add('working-sets', __WEBPACK_IMPORTED_MODULE_7__WorkingSet__["a" /* default */]);
registry.add('publications', __WEBPACK_IMPORTED_MODULE_8__Publication__["a" /* default */]);
registry.add('kit-messages', __WEBPACK_IMPORTED_MODULE_9__KitMessage__["a" /* default */]);
registry.add('subscriptions', __WEBPACK_IMPORTED_MODULE_10__Subscription__["a" /* default */]);
registry.add('job-status-topics', __WEBPACK_IMPORTED_MODULE_11__JobStatusTopic__["a" /* default */]);
registry.add('typefaces', __WEBPACK_IMPORTED_MODULE_12__Typeface__["a" /* default */]);
registry.add('typeface-settings', __WEBPACK_IMPORTED_MODULE_13__TypefaceSettings__["a" /* default */]);
registry.add('working-set-archives', __WEBPACK_IMPORTED_MODULE_14__WorkingSetArchive__["a" /* default */]);
registry.add('working-set-icons', __WEBPACK_IMPORTED_MODULE_15__WorkingSetIcon__["a" /* default */]);
registry.add('working-set-typefaces', __WEBPACK_IMPORTED_MODULE_16__WorkingSetTypeface__["a" /* default */]);
registry.add('working-set-images', __WEBPACK_IMPORTED_MODULE_17__WorkingSetImage__["a" /* default */]);

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conditionalComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




function conditionalComponent(displayName, params) {
  var anyFunc = params.any;
  var allFunc = params.all;
  var propTypes = params.propTypes || {};
  var shouldRenderFunc = params.shouldRender;
  var shouldFailureFunc = params.shouldFailure;

  return __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
    displayName: displayName,

    propTypes: Object.assign({}, {
      children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]),
      render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      failure: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      request: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
      any: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
      all: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool])
    }, propTypes),

    contextTypes: {
      manager: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
      request: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
    },

    render: function render() {
      var _props = this.props,
          request = _props.request,
          any = _props.any,
          all = _props.all;

      var shouldRender = false;
      var shouldFailure = false;
      var rendered = null;

      if (typeof request !== 'undefined' || typeof this.context.request !== 'undefined') {
        var thisRequest = request || this.context.request;
        shouldRender = this.context.manager.requests[allFunc]([thisRequest]);
      }

      if (typeof any !== 'undefined') {
        shouldRender = this.context.manager.requests[anyFunc](any);
        shouldFailure = this.context.manager.requests.anyFailed(any);
      }

      if (typeof all !== 'undefined') {
        shouldRender = this.context.manager.requests[allFunc](all);
        shouldFailure = this.context.manager.requests.anyFailed(all);
      }

      if (typeof shouldRenderFunc === 'function') {
        // Delegate to the component
        shouldRender = shouldRenderFunc.bind(this)(shouldRender);
      }

      if (typeof shouldFailureFunc === 'function') {
        // Delegate to the component
        shouldFalure = shouldFailureFunc.bind(this)(shouldFailure);
      }

      if (this.props.failure && shouldFailure) {
        rendered = this.props.failure() || null;
      } else if (this.props.render && shouldRender && !shouldFailure) {
        rendered = this.props.render() || null;
      } else if (shouldRender) {
        if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) === 1) {
          rendered = this.props.children;
        } else {
          rendered = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.props.children);
        }
      }

      return rendered;
    }
  });
}

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_WoffEmbeddedMixin__ = __webpack_require__(456);






var WoffEmbeddedIcon = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'WoffEmbeddedIcon',

  propTypes: {
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    unicodeChar: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    iconSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_WoffEmbeddedMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      className: null,
      unicodeChar: 'f000',
      iconSize: null
    };
  },
  renderIcon: function renderIcon() {
    var styles = {
      display: 'inline-block',
      fontFamily: '\'' + this._name + '\'',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontVariant: 'normal',
      fontStretch: 'normal',
      fontSize: this.props.iconSize,
      lineHeight: '1',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: this.props.className, style: styles }, String.fromCharCode(parseInt(this.props.unicodeChar, 16)));
  },
  render: function render() {
    return this.props.woff ? this.renderIcon() : null;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (WoffEmbeddedIcon);

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PASTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DROPZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SVG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TYPEFACE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone_component__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dropzone_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_DropzoneComponentMixin__ = __webpack_require__(476);








var PASTE = 'PASTE';
var DROPZONE = 'DROPZONE';
var SVG = 'SVG';
var TYPEFACE = 'TYPEFACE';

var messages = {
  SVG: {
    uploadLabel: 'SVG Upload',
    helpMessage: 'Uploaded SVG file should be a single color vector with non-overlapping paths.'
  },
  TYPEFACE: {
    uploadLabel: 'File',
    helpMessage: 'Select on OTF or TTF font file.'
  }
};

/* harmony default export */ __webpack_exports__["e"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'PasteOrDropzone',

  propTypes: {
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    which: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([PASTE, DROPZONE]),
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([SVG, TYPEFACE]),
    error: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    source: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    wrapperClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    uploadLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    helpMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a, __WEBPACK_IMPORTED_MODULE_6__mixins_DropzoneComponentMixin__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      options: [PASTE, DROPZONE],
      which: PASTE,
      error: null,
      wrapperClassName: 'col-xs-9'
    };
  },
  getInitialState: function getInitialState() {
    return {
      source: this.props.source
    };
  },
  handleSvgChanged: function handleSvgChanged() {
    var _this = this;

    this.setState({
      source: this.refs.source.value
    }, function () {
      _this.props.onSourceChanged(_this.refs.source.value);
    });
  },
  renderPaste: function renderPaste() {
    var error = this.props.error;

    var svgFormGroupClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('form-group', 'row', 'text', 'required', { 'has-danger': !!error });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: svgFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'text required col-xs-3 form-control-label p-xs-r-sm' }, 'Paste from Illustrator CC ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { onChange: this.handleSvgChanged, ref: 'source', value: this.state.source, className: 'text required form-control input-svg-source' }), error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, error) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, 'Copy your icon directly from Illustrator CC and paste in the above field. Icon should be a single color vector with non-overlapping paths.')));
  },
  renderDropzone: function renderDropzone() {
    var _props = this.props,
        error = _props.error,
        type = _props.type,
        wrapperClassName = _props.wrapperClassName;

    var svgFormGroupClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('form-group', 'row', 'text', 'required', { 'has-danger': !!error });

    var _dropzoneProps = this.dropzoneProps(),
        eventHandlers = _dropzoneProps.eventHandlers,
        djsConfig = _dropzoneProps.djsConfig;

    var config = {
      iconFiletypes: ['.svg'],
      showFiletypeIcon: true
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: svgFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'text required col-xs-3 form-control-label p-xs-r-sm' }, this.props.uploadLabel || messages[type].uploadLabel, ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: wrapperClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone_component___default.a, { config: config, eventHandlers: eventHandlers, djsConfig: djsConfig }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dz-message' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle' }), 'Drop files here or click to upload.')), error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, error) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, this.props.helpMessage || messages[type].helpMessage)));
  },
  render: function render() {
    return this.props.which === PASTE ? this.renderPaste() : this.renderDropzone();
  }
}));

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_BASE; });
/* unused harmony export SIZE_SMALL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var SIZE_LARGE = 'SIZE_LARGE';
var SIZE_BASE = 'SIZE_BASE';
var SIZE_SMALL = 'SIZE_SMALL';

var sizeToPixels = {
  SIZE_SMALL: '12px',
  SIZE_BASE: '14px',
  SIZE_LARGE: '28px'
};

/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Spinner',

  propTypes: {
    size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([SIZE_LARGE, SIZE_BASE, SIZE_SMALL])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: SIZE_BASE
    };
  },
  render: function render() {
    var style = {
      fontSize: sizeToPixels[this.props.size]
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading-spinner animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { style: style, className: 'ficon ficon-spin ficon-spinner-third' }));
  }
}));

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseJsonApiRepresentation;
/* harmony export (immutable) */ __webpack_exports__["b"] = handle204;
/* harmony export (immutable) */ __webpack_exports__["a"] = handle200;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_records__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_camelcase__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_camelcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_camelcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(190);








function parseJsonApiRepresentation(json) {
  var raw = json || {};
  var primaryData = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* arrayize */])(raw.data || []);
  var includedData = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* arrayize */])(raw.included || []);

  var representations = {};

  var _loop = function _loop(datum) {
    var Record = __WEBPACK_IMPORTED_MODULE_2_records__["a" /* registry */].find(datum.type);

    /* eslint-disable no-loop-func */
    var relationships = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(Object.keys(datum.relationships || {}).map(function (relatedType) {
      var related = datum.relationships[relatedType];

      if (!related.data) {
        return false;
      }

      var relatedValue = null;

      if (Array.isArray(related.data)) {
        relatedValue = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(related.data.map(function (i) {
          return parseInt(i.id, 10);
        }));
      } else {
        relatedValue = parseInt(related.data.id, 10);
      }

      return [__WEBPACK_IMPORTED_MODULE_3_camelcase___default()(relatedType), relatedValue];
    }).filter(function (item) {
      return !!item;
    })).toObject();
    /* eslint-enable no-loop-func */

    var attributes = Object.assign({}, datum.attributes, relationships);
    var link = datum.links.self.split('/').slice(1);

    Object(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* getOrSetArray */])(representations, datum.type).push(new Record(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* camelCast */])(Object.assign({}, { id: datum.id, link: link }, attributes))));
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = primaryData.concat(includedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var datum = _step.value;

      _loop(datum);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return representations;
}

function handle204(request, response) {
  return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
    if (request.method === __WEBPACK_IMPORTED_MODULE_5__methods__["a" /* DELETE */]) {
      resolve({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* RESPONSE_DELETED */],
        request: request,
        response: response
      });
    }

    if (request.method === __WEBPACK_IMPORTED_MODULE_5__methods__["d" /* POST */]) {
      resolve({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["k" /* RESPONSE_NO_CONTENT */],
        request: request,
        response: response
      });
    }
  });
}

function handle200(request, response) {
  return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
    response.json().then(function (json) {
      var type = request.method === __WEBPACK_IMPORTED_MODULE_5__methods__["d" /* POST */] ? __WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* RESPONSE_CREATED */] : __WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* RESPONSE_DATA */];

      resolve({
        type: type,
        request: request,
        response: response,
        data: parseJsonApiRepresentation(json)
      });
    }).catch(function (error) {
      resolve({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["j" /* RESPONSE_NOT_JSON */],
        request: request,
        response: response,
        error: error
      });
    });
  });
}

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TOOLTIP_TYPE_BLOCK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOOLTIP_TYPE_INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOOLTIP_POSITION_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOOLTIP_POSITION_RIGHT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tooltip_scss__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tooltip_scss__);







var TOOLTIP_TYPE_BLOCK = 'TOOLTIP_TYPE_BLOCK';
var TOOLTIP_TYPE_INLINE = 'TOOLTIP_TYPE_INLINE';
var TOOLTIP_POSITION_TOP = 'top';
var TOOLTIP_POSITION_RIGHT = 'right';

var Tooltip = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Tooltip',

  propTypes: {
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]).isRequired,
    details: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    noIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    position: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([TOOLTIP_POSITION_TOP, TOOLTIP_POSITION_RIGHT]),
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([TOOLTIP_TYPE_BLOCK, TOOLTIP_TYPE_INLINE]),
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    forceVisibility: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      details: null,
      position: TOOLTIP_POSITION_TOP,
      type: TOOLTIP_TYPE_BLOCK,
      icon: 'ficon-plus-circle',
      noIcon: false,
      className: '',
      forceVisibility: true
    };
  },
  renderTooltip: function renderTooltip() {
    var _props = this.props,
        content = _props.content,
        icon = _props.icon,
        noIcon = _props.noIcon,
        position = _props.position,
        className = _props.className,
        forceVisibility = _props.forceVisibility;

    var mergedClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tooltip', 'fade', 'in', 'text-base', className, 'tooltip-' + position);
    var contentClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tooltip-inner', 'text-center');
    var iconClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ficon', icon, 'm-xs-r-sm');
    var iconElement = noIcon ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: iconClassName });
    var details = this.props.details;

    var detailsElement = details ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-inverse-muted text-sm', dangerouslySetInnerHTML: { __html: details } }) : null;
    var style = forceVisibility ? { display: 'block' } : {};
    var contentElement = typeof content === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: content } }) : content;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { styleName: 'tooltip-' + position, style: style, className: mergedClassName, role: 'tooltip' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tooltip-arrow' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'tooltip-title', style: { display: 'none' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { styleName: 'content', className: contentClassName }, iconElement, contentElement, detailsElement));
  },
  render: function render() {
    var element = null;

    if (this.props.type === TOOLTIP_TYPE_BLOCK) {
      element = this.renderTooltip();
    } else {
      element = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { styleName: 'inline' }, '\xA0', this.renderTooltip());
    }

    return element;
  }
});

/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_4_react_css_modules___default()(Tooltip, __WEBPACK_IMPORTED_MODULE_5__Tooltip_scss___default.a));

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addedForRecord */
/* harmony export (immutable) */ __webpack_exports__["a"] = iconsAdded;
/* harmony export (immutable) */ __webpack_exports__["d"] = typefacesAdded;
/* harmony export (immutable) */ __webpack_exports__["b"] = imagesAdded;
/* harmony export (immutable) */ __webpack_exports__["c"] = needsPublishing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_records__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_records_WorkingSetIcon__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_records_WorkingSetTypeface__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_records_WorkingSetImage__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_publish__ = __webpack_require__(182);







function addedForRecord(kitMutations, kitToken, record) {
  var kitMutationsPath = ['changesSinceLastPublish', kitToken, __WEBPACK_IMPORTED_MODULE_0_records__["a" /* registry */].typeFor(record), __WEBPACK_IMPORTED_MODULE_5_reducers_publish__["MUTATION_TYPE_CREATED"]];

  return kitMutations.getIn(kitMutationsPath, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());
}

function iconsAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, __WEBPACK_IMPORTED_MODULE_2_records_WorkingSetIcon__["a" /* default */]);
}

function typefacesAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, __WEBPACK_IMPORTED_MODULE_3_records_WorkingSetTypeface__["a" /* default */]);
}

function imagesAdded(kitMutations, kitToken) {
  return addedForRecord(kitMutations, kitToken, __WEBPACK_IMPORTED_MODULE_4_records_WorkingSetImage__["a" /* default */]);
}

function needsPublishing(kitMutations, kitToken) {
  var kitMutationsPath = ['changesSinceLastPublish', kitToken];

  return kitMutations.getIn(kitMutationsPath, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size > 0;
}

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Feature__ = __webpack_require__(215);






/* harmony default export */ __webpack_exports__["a"] = ({
  propTypes: {
    shareable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      shareable: false
    };
  },

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  linkLocations: function linkLocations(kit) {
    var baseUrl = this.props.shareable ? '' + kit.shareableDocumentationPath : '/kits/' + kit.token + '/docs';

    return {
      summary: '' + baseUrl,
      icons: baseUrl + '/icons',
      typefaces: baseUrl + '/typefaces',
      images: baseUrl + '/images'
    };
  },
  renderSummarySub: function renderSummarySub() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'list-unstyled text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#get-started-build' }, 'Build your Kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#get-started-use' }, 'How to use your Kit')));
  },
  renderIconsSub: function renderIconsSub() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'list-unstyled text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-icons-inventory' }, 'Icons in this Kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-icons-use-web' }, 'Using your icons on the web')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-icons-use-desktop' }, 'Using your icons on the desktop')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-icons-troubleshooting' }, 'Troubleshooting Icons')));
  },
  renderTypefacesSub: function renderTypefacesSub() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'list-unstyled text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-typefaces-inventory' }, 'Typefaces in this kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-typefaces-use' }, 'Using your typefaces on the web')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-typefaces-troubleshooting' }, 'Troubleshooting Typefaces')));
  },
  renderImagesSub: function renderImagesSub() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'list-unstyled text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-images-inventory' }, 'Images in this kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'm-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#kit-components-images-troubleshooting' }, 'Troubleshooting images')));
  },
  renderNavigation: function renderNavigation(kit) {
    var someOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var options = Object.assign({}, {
      hasBeenPublished: false
    }, someOptions);
    var hasBeenPublished = options.hasBeenPublished;
    var router = this.context.router;

    var linkLocations = this.linkLocations(kit);
    var summary = linkLocations.summary,
        icons = linkLocations.icons,
        typefaces = linkLocations.typefaces,
        images = linkLocations.images;

    var iconsActive = router.isActive(icons);
    var typefacesActive = router.isActive(typefaces);
    var imagesActive = router.isActive(images);
    var summaryActive = router.isActive(summary) && !iconsActive && !typefacesActive && !imagesActive;

    var linkClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('block', 'link-dashed-none', { 'is-disabled': !hasBeenPublished }, { 'text-gray-lighter': !hasBeenPublished });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-components-nav' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Link */], { to: summary, className: 'block link-dashed-none m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('text-lg m-xs-b-xs', { 'text-gray': summaryActive }) }, 'Getting Started'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'How to start using your kit.')), summaryActive ? this.renderSummarySub() : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Link */], { to: icons, className: linkClasses }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('text-lg m-xs-b-xs', { 'text-gray': iconsActive }) }, 'Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Use your kit\'s icons in your project\'s code and on the desktop.')), iconsActive ? this.renderIconsSub() : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Link */], { to: typefaces, className: linkClasses }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('text-lg m-xs-b-xs', { 'text-gray': typefacesActive }) }, 'Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Use your kit\'s typefaces in your project\'s code.')), typefacesActive ? this.renderTypefacesSub() : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Feature__["a" /* default */], { name: 'images' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Link */], { to: images, className: linkClasses }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('text-lg m-xs-b-xs', { 'text-gray': imagesActive }) }, 'Images'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Store and use all of your photos, graphics, and visual assets')), imagesActive ? this.renderImagesSub() : ''));
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_SMALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_LARGE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IconRow__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings__ = __webpack_require__(69);







var SIZE_SMALL = 56;
var SIZE_LARGE = 112;

/* harmony default export */ __webpack_exports__["c"] = ({
  propTypes: {
    workingSetIcons: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record),
    iconSetIdsInSubscription: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,
    iconSetsByIconId: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map,
    onIconSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onIconDeselected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestToBuy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestToUpgrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      focused: null
    };
  },
  handleIconFocused: function handleIconFocused(icon) {
    this.setState({
      focused: icon
    });
  },
  renderIcons: function renderIcons(icons, size) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var optionsWithDefaults = Object.assign({}, { rowCount: __WEBPACK_IMPORTED_MODULE_5__settings__["b" /* SMALL_ICONS_PER_ROW */], addIconSetName: false, highlightedIconNames: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])() }, options);
    var iconElements = [];
    var pushElements = function pushElements(num, iconsSlice) {
      var rowKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      iconElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_IconRow__["a" /* default */], {
        key: rowKey,
        rowKey: rowKey,
        icons: iconsSlice.take(num),
        size: size,
        options: optionsWithDefaults,
        workingSetIcons: _this.props.workingSetIcons,
        iconSetIdsInSubscription: _this.props.iconSetIdsInSubscription,
        iconSetsByIconId: _this.props.iconSetsByIconId,
        onIconSelected: _this.props.onIconSelected,
        onIconDeselected: _this.props.onIconDeselected,
        onRequestToBuy: _this.props.onRequestToBuy,
        onRequestToUpgrade: _this.props.onRequestToUpgrade
      }));

      if (iconsSlice.size > num) {
        pushElements(num, iconsSlice.skip(num), rowKey + 1);
      }
    };

    pushElements(optionsWithDefaults.rowCount, icons);

    return iconElements;
  }
});

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResourcesMatching__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ResourcesMatching__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Requesting__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Requesting__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Done__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Done__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotFound__ = __webpack_require__(1001);
/* unused harmony reexport NotFound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HasErrors__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__HasErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Failed__ = __webpack_require__(1002);
/* unused harmony reexport Failed */













/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUTATION_TYPE_CREATED", function() { return MUTATION_TYPE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUTATION_TYPE_DELETED", function() { return MUTATION_TYPE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUTATION_TYPE_UNKNOWN", function() { return MUTATION_TYPE_UNKNOWN; });
/* harmony export (immutable) */ __webpack_exports__["kitMutations"] = kitMutations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests_methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(51);





var LOCAL_STORAGE_KEY = 'kitMutations';

var MUTATION_TYPE_CREATED = 'created';
var MUTATION_TYPE_DELETED = 'deleted';
var MUTATION_TYPE_UNKNOWN = 'unknown';

function kitTokenFromRequest(request) {
  var url = request.url;
  var kitToken = null;

  if (url[0] === 'api' && url[1] === 'kits' && url.length > 2) {
    kitToken = url[2];
  }

  return kitToken;
}

function typeFromRequest(request) {
  var url = request.url;
  var type = null;

  if (url.length > 3) {
    type = url[3];
  }

  return type;
}

function mutationTypeForRequest(request) {
  var mutationType = MUTATION_TYPE_UNKNOWN;

  if (request.method === __WEBPACK_IMPORTED_MODULE_2_requests_methods__["d" /* POST */]) {
    mutationType = MUTATION_TYPE_CREATED;
  }

  if (request.method === __WEBPACK_IMPORTED_MODULE_2_requests_methods__["a" /* DELETE */]) {
    mutationType = MUTATION_TYPE_DELETED;
  }

  return mutationType;
}

var fromLocalStorage = function fromLocalStorage() {
  var defaultValue = JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    changesSinceLastPublish: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
  }).toJS());
  var changesSinceLastPublish = void 0;

  try {
    changesSinceLastPublish = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  } catch (e) {}

  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(JSON.parse(changesSinceLastPublish || defaultValue));
};

function kitMutations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || fromLocalStorage();

  var indicatesMutation = [__WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["d" /* RESPONSE_CREATED */], __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["f" /* RESPONSE_DELETED */]];

  if (action.type === __WEBPACK_IMPORTED_MODULE_3_actions__["e" /* PUBLISHED */]) {
    nextState = nextState.updateIn(['changesSinceLastPublish', action.kitToken], function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
    });
  }

  if (~indicatesMutation.indexOf(action.type)) {
    var kitToken = kitTokenFromRequest(action.request);
    var type = typeFromRequest(action.request);
    var mutationType = mutationTypeForRequest(action.request);

    if (kitToken && ~['working-set-icons', 'working-set-typefaces', 'working-set-images'].indexOf(type)) {
      nextState = nextState.updateIn(['changesSinceLastPublish', kitToken, type, mutationType], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(), function (changesSinceLastPublish) {
        return changesSinceLastPublish.push(action.request.toImmutable());
      });
    }
  }

  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(nextState.toJS()));
  } catch (e) {}

  return nextState;
}

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encodeRecordToBody */
/* harmony export (immutable) */ __webpack_exports__["a"] = queueRequests;
/* harmony export (immutable) */ __webpack_exports__["b"] = refreshRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_fetch__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_urlencoded__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_decamelize__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_decamelize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_decamelize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_shareResourceToken__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__responseHandlers__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_env__ = __webpack_require__(88);











function routeResponse(request, response) {
  var statusCode = response.status;
  var responseHandler = __WEBPACK_IMPORTED_MODULE_6__responseHandlers__['handle' + statusCode];
  var promise = null;

  if (responseHandler) {
    promise = responseHandler(request, response);
  } else {
    promise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve({
      type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["l" /* RESPONSE_UNHANDLED_STATUS_CODE */],
      request: request,
      response: response
    });
  }

  return promise;
}

function encodeRecordToBody(record) {
  var neverEncodeKeys = ['link'];
  var mapped = record.toMap().mapEntries(function (entry) {
    return [__WEBPACK_IMPORTED_MODULE_3_decamelize___default()(entry[0], '_'), entry[1] && entry[1].toJS ? entry[1].toJS() : entry[1]];
  }).filterNot(function (value, key) {
    return value === null || ~neverEncodeKeys.indexOf(key);
  });

  return __WEBPACK_IMPORTED_MODULE_2_form_urlencoded___default()(mapped.toJS());
}

function makeRequest(dispatch, request) {
  var url = request.url,
      method = request.method,
      record = request.record;

  var fetchOptions = {
    url: url,
    method: method,
    headers: {}
  };
  var shareResourceToken = Object(__WEBPACK_IMPORTED_MODULE_4_utils_shareResourceToken__["a" /* getFromMeta */])();
  var isNewOrUpdate = ~[__WEBPACK_IMPORTED_MODULE_8__methods__["e" /* PUT */], __WEBPACK_IMPORTED_MODULE_8__methods__["d" /* POST */]].indexOf(request.method);

  if (!__WEBPACK_IMPORTED_MODULE_9_utils_env__["a" /* PRODUCTION */] && !record && isNewOrUpdate) {
    console.warn('A request was created as a POST or PUT but no associated record was found. This will fail to add or update any new records in existing representations.');
  }

  if (shareResourceToken) {
    fetchOptions.headers.Authorization = 'Bearer ' + shareResourceToken;
  }

  if (record && isNewOrUpdate) {
    fetchOptions.body = encodeRecordToBody(record);
    fetchOptions.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_utils_fetch__["a" /* default */])('/' + url.join('/'), fetchOptions).then(function (response) {
    return routeResponse(request, response).then(function (action) {
      return dispatch(action);
    });
  }).catch(function (error) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["b" /* REQUEST_UNCAUGHT_ERROR */],
      request: request,
      error: error
    });

    if (!__WEBPACK_IMPORTED_MODULE_9_utils_env__["a" /* PRODUCTION */]) {
      throw error;
    }
  });
}

function queueRequests(requests) {
  return function (dispatch) {
    var fetches = [];

    try {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = requests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var request = _step.value;

          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* REQUEST_QUEUED */],
            request: request
          });

          fetches.push(makeRequest(dispatch, request));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } catch (error) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["b" /* REQUEST_UNCAUGHT_ERROR */],
        requests: requests,
        error: error
      });

      if (!__WEBPACK_IMPORTED_MODULE_9_utils_env__["a" /* PRODUCTION */]) {
        throw error;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(fetches);
  };
}

function refreshRecord(record) {
  return function (dispatch) {
    var request = new __WEBPACK_IMPORTED_MODULE_5__Request__["a" /* default */]({
      url: record.link,
      useCache: false
    });

    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* REQUEST_QUEUED */],
      request: request
    });

    makeRequest(dispatch, request);
  };
}

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFromMeta;
function getFromMeta() {
  var tag = document.querySelector('meta[name=csrf-token]');
  return tag ? tag.content : '';
}

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}





var DEFAULTS = {
  useCache: true,
  method: __WEBPACK_IMPORTED_MODULE_0__methods__["b" /* GET */],
  url: [],
  record: null
};

var Request = function () {
  function Request() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Request);

    var _Object$assign = Object.assign({}, DEFAULTS, params),
        useCache = _Object$assign.useCache,
        method = _Object$assign.method,
        url = _Object$assign.url,
        record = _Object$assign.record;

    if (!~__WEBPACK_IMPORTED_MODULE_0__methods__["c" /* METHODS */].indexOf(method)) {
      throw Error('Method "' + method + '" is not valid. It should be one of ' + __WEBPACK_IMPORTED_MODULE_0__methods__["c" /* METHODS */].join(', '));
    }

    if (method === __WEBPACK_IMPORTED_MODULE_0__methods__["a" /* DELETE */] && !record) {
      throw Error('To send a DELETE request a record is required.');
    }

    this.uuid = __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4();
    this.useCache = useCache;
    this.method = method;
    this.url = url;
    this.record = record;
  }

  _createClass(Request, [{
    key: 'toJS',
    value: function toJS() {
      return {
        uuid: this.uuid,
        useCache: this.useCache,
        method: this.method,
        url: this.url,
        record: this.record ? this.record.toJS() : {}
      };
    }
  }, {
    key: 'toImmutable',
    value: function toImmutable() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.toJS());
    }
  }]);

  return Request;
}();

/* harmony default export */ __webpack_exports__["a"] = (Request);

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  iconId: null,
  workingSetId: null,
  jobStatusTopic: null,
  status: null,
  icon: null,
  workingSet: null,
  name: '',
  unicodeChar: '',
  optimizedFor: '',
  prefix: '',
  cssName: '',
  cssClass: '',
  logo: false,
  custom: false,
  svg: '',
  woff: '',
  createdAt: null,
  updatedAt: null
});

var WorkingSetIcon = function (_record) {
  _inherits(WorkingSetIcon, _record);

  function WorkingSetIcon() {
    _classCallCheck(this, WorkingSetIcon);

    return _possibleConstructorReturn(this, (WorkingSetIcon.__proto__ || Object.getPrototypeOf(WorkingSetIcon)).apply(this, arguments));
  }

  _createClass(WorkingSetIcon, [{
    key: 'createdAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetIcon.prototype.__proto__ || Object.getPrototypeOf(WorkingSetIcon.prototype), 'createdAt', this));
    }
  }, {
    key: 'updatedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetIcon.prototype.__proto__ || Object.getPrototypeOf(WorkingSetIcon.prototype), 'updatedAt', this));
    }
  }]);

  return WorkingSetIcon;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (WorkingSetIcon);

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  jobStatusTopic: null,
  status: null,
  custom: false,
  link: null,
  token: '',
  typeface: null,
  workingSet: null,
  family: '',
  cssClass: '',
  weight: '',
  style: '',
  subsetting: '',
  characterSets: [],
  originalSize: 0,
  optimizedSize: 0,
  woff: '',
  createdAt: null,
  updatedAt: null
});

var WorkingSetTypeface = function (_record) {
  _inherits(WorkingSetTypeface, _record);

  function WorkingSetTypeface() {
    _classCallCheck(this, WorkingSetTypeface);

    return _possibleConstructorReturn(this, (WorkingSetTypeface.__proto__ || Object.getPrototypeOf(WorkingSetTypeface)).apply(this, arguments));
  }

  _createClass(WorkingSetTypeface, [{
    key: 'createdAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetTypeface.prototype.__proto__ || Object.getPrototypeOf(WorkingSetTypeface.prototype), 'createdAt', this));
    }
  }, {
    key: 'updatedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetTypeface.prototype.__proto__ || Object.getPrototypeOf(WorkingSetTypeface.prototype), 'updatedAt', this));
    }
  }]);

  return WorkingSetTypeface;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (WorkingSetTypeface);

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = all;
/* harmony export (immutable) */ __webpack_exports__["b"] = any;
/* harmony export (immutable) */ __webpack_exports__["g"] = values;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrayize;
/* harmony export (immutable) */ __webpack_exports__["d"] = camelCast;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOrSetArray;
/* harmony export (immutable) */ __webpack_exports__["f"] = isArrayOfStrings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_camelcase__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_camelcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_camelcase__);


function all(iterable) {
  var retval = iterable.reduce(function (memo, value) {
    return memo && !!value;
  }, true);
  return retval && (iterable.size ? !!iterable.size : !!iterable.length);
}

function any(iterable) {
  var retval = iterable.reduce(function (memo, value) {
    return memo || !!value;
  }, false);
  return retval && (iterable.size ? !!iterable.size : !!iterable.length);
}

function values(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

function arrayize(obj) {
  if (!obj) {
    return [];
  }

  return Array.isArray(obj) ? obj : [obj];
}

function camelCast(attributes) {
  return Object.keys(attributes).map(function (key) {
    return [__WEBPACK_IMPORTED_MODULE_0_camelcase___default()(key), attributes[key]];
  });
}

function getOrSetArray(subject, type) {
  if (!subject[type]) {
    subject[type] = []; // eslint-disable-line no-param-reassign
  }
  return subject[type];
}

function isArrayOfStrings(subject) {
  var value = true;

  if (!Array.isArray(subject)) {
    value = false;
  } else {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = subject[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var elem = _step.value;

        if (typeof elem !== "string") {
          value = false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return value;
}

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUEUED", function() { return QUEUED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNKNOWN", function() { return UNKNOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OK_BUT_MISUNDERSTOOD", function() { return OK_BUT_MISUNDERSTOOD; });
/* harmony export (immutable) */ __webpack_exports__["requests"] = requests;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_env__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests_utils__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updaters__ = __webpack_require__(782);






var QUEUED = '--queued--';
var UNKNOWN = '--unknown--';
var OK_BUT_MISUNDERSTOOD = '--ok-but-misunderstood--';

function requests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    representations: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({}),
    resources: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({}),
    jobs: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({}),
    cache: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({}),
    status: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({}),
    errors: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({})
  });

  if (action.request) {
    nextState = nextState.setIn(['cache', action.request.uuid], action.request);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* REQUEST_QUEUED */]) {
    nextState = nextState.setIn(['status', action.request.uuid], QUEUED);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["l" /* RESPONSE_UNHANDLED_STATUS_CODE */]) {
    if (!__WEBPACK_IMPORTED_MODULE_1_utils_env__["a" /* PRODUCTION */]) {
      /* eslint-disable no-console */
      console.error('Unhandled status code for requests action');
      console.log(action);
      /* eslint-enable no-console */
    }

    nextState = nextState.setIn(['status', action.request.uuid], UNKNOWN);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["j" /* RESPONSE_NOT_JSON */]) {
    nextState = nextState.setIn(['status', action.request.uuid], OK_BUT_MISUNDERSTOOD);
  }

  if (~[__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* RESPONSE_DATA */], __WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* RESPONSE_CREATED */]].indexOf(action.type)) {
    nextState = Object(__WEBPACK_IMPORTED_MODULE_4__updaters__["e" /* retrieved */])(nextState, action);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* RESPONSE_CREATED */]) {
    nextState = Object(__WEBPACK_IMPORTED_MODULE_4__updaters__["a" /* created */])(nextState, action);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* RESPONSE_DELETED */]) {
    nextState = Object(__WEBPACK_IMPORTED_MODULE_4__updaters__["b" /* deleted */])(nextState, action);
  }

  if (~[__WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* RESPONSE_DATA */], __WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* RESPONSE_CREATED */]].indexOf(action.type)) {
    nextState = Object(__WEBPACK_IMPORTED_MODULE_4__updaters__["c" /* jobStatusTopic */])(nextState, action);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["k" /* RESPONSE_NO_CONTENT */]) {
    nextState = Object(__WEBPACK_IMPORTED_MODULE_4__updaters__["d" /* noContent */])(nextState, action);
  }

  if (~[__WEBPACK_IMPORTED_MODULE_3__actionTypes__["i" /* RESPONSE_NOT_FOUND */], __WEBPACK_IMPORTED_MODULE_3__actionTypes__["h" /* RESPONSE_NOT_ALLOWED */]].indexOf(action.type)) {
    nextState = nextState.setIn(['status', action.request.uuid], action.response.status);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* RESPONSE_BAD_REQUEST */]) {
    var nextErrors = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(Object(__WEBPACK_IMPORTED_MODULE_2_requests_utils__["d" /* camelCast */])(action.errors)).map(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_requests_utils__["f" /* isArrayOfStrings */])(error) ? error.join(', ') : error;
    });
    nextState = nextState.setIn(['status', action.request.uuid], action.response.status).setIn(['errors', action.request.uuid], nextErrors);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_3__actionTypes__["g" /* RESPONSE_FAILURE */]) {
    nextState = nextState.setIn(['status', action.request.uuid], action.response.status);
  }

  return nextState;
}

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_FOR_SET_NEW_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEARCH_FOR_SET_RESULTS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = searchForSet;
/* harmony export (immutable) */ __webpack_exports__["c"] = navigateToSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_algolia__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__(409);




var SEARCH_FOR_SET_NEW_QUERY = 'SEARCH_FOR_SET_NEW_QUERY';
var SEARCH_FOR_SET_RESULTS = 'SEARCH_FOR_SET_RESULTS';

function searchForSet(query, index) {
  var hitsPerPage = __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* HITS_PER_PAGE */];

  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* locationUpdate */])({
      query: {
        q: query
      }
    }));

    dispatch({
      type: SEARCH_FOR_SET_NEW_QUERY,
      query: query
    });

    Object(__WEBPACK_IMPORTED_MODULE_0_utils_algolia__["a" /* client */])().initIndex(index).search(query, { hitsPerPage: hitsPerPage }).then(function (results) {
      dispatch({
        type: SEARCH_FOR_SET_RESULTS,
        query: query,
        hits: results.hits,
        hitsPerPage: hitsPerPage,
        count: results.nbHits
      });
    });
  };
}

function navigateToSet(iconSetSlug) {
  location.assign('/sets/' + iconSetSlug);

  return function (dispatch) {};
}

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_NavLink__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Feature__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);







/* harmony default export */ __webpack_exports__["a"] = ({
  getInitialState: function getInitialState() {
    return {
      showEmbedCode: false,
      downloadFocused: false,
      embedCodeCopied: false
    };
  },
  handleEmbedCodeOpened: function handleEmbedCodeOpened(event) {
    event.preventDefault();

    this.setState({ showEmbedCode: true });
  },
  handleEmbedCodeClosed: function handleEmbedCodeClosed() {
    this.setState({ showEmbedCode: false, embedCodeCopied: false });
  },
  handleDownloadFocused: function handleDownloadFocused() {
    this.setState({ downloadFocused: !this.state.downloadFocused });
  },
  handleDownloadClicked: function handleDownloadClicked(event) {
    var kitToken = this.props.kitToken;
    var kitRequest = this.requests.kit;

    var rm = this.resourceManager();
    var kit = rm.type(kitRequest, 'kits').find({ token: kitToken });

    if (!kit.downloadable) {
      event.preventDefault();
    }
  },
  handleEmbedCodeCopied: function handleEmbedCodeCopied() {
    this.setState({ embedCodeCopied: true });
  },
  renderEmbedCodeModal: function renderEmbedCodeModal(kit) {
    var _state = this.state,
        showEmbedCode = _state.showEmbedCode,
        embedCodeCopied = _state.embedCodeCopied,
        embedCodeUrl = _state.embedCodeUrl,
        embedCodeScriptTag = _state.embedCodeScriptTag;

    var embedCodeCopiedPopover = embedCodeCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Embed Code Copied!' }) : null;
    var cachingNotice = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-md' }, 'Your embed code is set to live in the browser\'s cache for ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, '1 minute'), '. This means that you will need to wait a full minute after publishing to see your changes reflected. If you\'re impatient (like we are) you can force reload your page or clear your browser\'s cache.');
    var existingCodePromptElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body has-icon m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-info-circle ficon-lg alert-icon' }), cachingNotice, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-md' }, 'If you\'re replacing an existing icon font with Fort Awesome, don\'t forget to remove it from your website.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you\'re using Fort Awesome alongside an existing icon font ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '(like Font Awesome)'), ', remember to use a different CSS prefix.'));

    var value = null;

    if (embedCodeScriptTag) {
      value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Embed code', className: 'modal-dialog modal-lg', isOpen: showEmbedCode, onRequestClose: this.handleEmbedCodeClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleEmbedCodeClosed, type: 'button', className: 'close close-dangle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Close')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title', id: 'embed-code-modal-label' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-code p-xs-r-sm' }), ' Embed Code')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After your kit has been published, copy and paste the following embed code into the HTML of your website. Make sure it goes near the top of your ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<head>'), ' tag.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col pre text-sm bg-gray-dark inset-darkest font-family-monospace p-xs-x-md p-xs-y-sm br-l' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'code code-highlight' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<script'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'src="'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, embedCodeUrl), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, '"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</script>'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, embedCodeCopiedPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_copy_to_clipboard___default.a, { text: embedCodeScriptTag, onCopy: this.handleEmbedCodeCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' }))))), existingCodePromptElement), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleEmbedCodeClosed, type: 'button', className: 'btn btn-primary-outline' }, 'Close ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times-circle' })))));
    }

    return value;
  },
  renderNavDisabled: function renderNavDisabled() {
    var handleClickNoop = function handleClickNoop(event) {
      event.preventDefault();
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-nav nav nav-tabs-inline' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'pull-right nav' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Embed Code')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Download')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Documentation'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav m-xs-r-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Home')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Typefaces')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Feature__["a" /* default */], { name: 'images' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item disabled' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: handleClickNoop }, 'Images')))));
  },
  renderDownloadNavLink: function renderDownloadNavLink(kit, subscription, workingSetArchive) {
    var downloadFocused = this.state.downloadFocused;

    var isProcessing = workingSetArchive && workingSetArchive.status === 'processing';
    var isFinished = workingSetArchive && workingSetArchive.status === 'finished';
    var downloadClassName = isFinished ? 'has-tooltip nav-item' : 'has-tooltip nav-item disabled';
    var handleDownloadClicked = function handleDownloadClicked(event) {
      if (!workingSetArchive) {
        event.preventDefault();
      }
    };

    var popover = null;

    if (downloadFocused) {
      if (!workingSetArchive) {
        popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Publish your kit<br />to enable download' });
      }

      if (isProcessing) {
        popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Creating your download<br /> package now' });
      }

      if (!subscription.downloadAllowed) {
        popover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Upgrade to enable<br />kit download' });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: downloadClassName }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link',
      href: '/kits/' + kit.token + '/download',
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: handleDownloadClicked,
      onMouseOver: this.handleDownloadFocused,
      onMouseOut: this.handleDownloadFocused }, 'Download'));
  },
  renderNavEnabled: function renderNavEnabled(kit, subscription, options) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-nav nav nav-tabs-inline' }, this.renderEmbedCodeModal(kit), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'pull-right nav' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'nav-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', onClick: this.handleEmbedCodeOpened }, 'Embed Code')), this.renderDownloadNavLink(kit, subscription, options.workingSetArchive), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NavLink__["a" /* default */], { to: '/kits/' + kit.token + '/docs' }, 'Documentation')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav m-xs-r-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NavLink__["a" /* default */], { to: '/kits/' + kit.token, activeOnIndex: true }, 'Home'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NavLink__["a" /* default */], { to: '/kits/' + kit.token + '/icons' }, 'Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NavLink__["a" /* default */], { to: '/kits/' + kit.token + '/typefaces' }, 'Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Feature__["a" /* default */], { name: 'images' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_NavLink__["a" /* default */], { to: '/kits/' + kit.token + '/images' }, 'Images'))));
  },
  renderNav: function renderNav(kit, subscription) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var optionsWithDefaults = Object.assign({}, {
      disabled: false,
      workingSetArchive: null
    }, options);

    return optionsWithDefaults.disabled ? this.renderNavDisabled() : this.renderNavEnabled(kit, subscription, optionsWithDefaults);
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}





var featureIsEnabled = function featureIsEnabled(name) {
  return !![].concat(_toConsumableArray(window._features)).find(function (feature) {
    var _feature = _slicedToArray(feature, 2),
        featureName = _feature[0],
        featureIsEnabled = _feature[1];

    return featureName === name && featureIsEnabled;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Feature',

  propTypes: {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array])
  },

  render: function render() {
    var enabled = featureIsEnabled(this.props.name);
    var childrenCount = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children);

    var element = null;

    if (enabled && childrenCount === 1) {
      element = this.props.children;
    } else if (enabled && childrenCount > 1) {
      element = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.props.children);
    }

    return element;
  }
}));

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_WoffEmbeddedMixin__ = __webpack_require__(456);






var WoffEmbeddedText = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'WoffEmbeddedText',

  propTypes: {
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)]),
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_WoffEmbeddedMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_react_addons_pure_render_mixin___default.a],

  getStyles: function getStyles() {
    return {
      fontFamily: '\'' + this._name + '\''
    };
  },
  renderText: function renderText() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.props.className, style: this.getStyles() }, this.props.text);
  },
  renderChildren: function renderChildren() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: this.props.className, style: this.getStyles() }, this.props.children);
  },
  render: function render() {
    var value = null;

    if (this.props.children) {
      value = this.renderChildren();
    }

    if (this.props.text) {
      value = this.renderText();
    }

    return value;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (WoffEmbeddedText);

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'RemoveTypefaceModal',

  propTypes: {
    workingSetTypeface: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record,
    show: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onRemovedTypeface: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  handleConfirmation: function handleConfirmation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.props.onRemovedTypeface(this.props.workingSetTypeface);
  },
  handleClosed: function handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },
  render: function render() {
    var workingSetTypeface = this.props.workingSetTypeface;

    var _ref = workingSetTypeface || {},
        family = _ref.family,
        weight = _ref.weight,
        style = _ref.style;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Remove image', isOpen: this.props.show, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { type: 'button', className: 'close close-dangle', onClick: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning m-xs-r-md' }), 'Delete ', family, '?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-lg well bg-body' }, 'Are you sure you would like to permanently delete this typeface? This action cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table text-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-base text-normal text-muted valign-middle' }, 'Family'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong p-xs-r-2x valign-middle' }, family)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-base text-normal text-muted valign-middle' }, 'Weight'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong p-xs-r-2x valign-middle' }, weight)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-base text-normal text-muted valign-middle' }, 'Style'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong p-xs-r-2x valign-middle' }, style))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-secondary', onClick: this.handleClosed }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-danger', rel: 'nofollow', onClick: this.handleConfirmation }, 'Yes, Delete', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash m-xs-l-md' })))));
  }
}));

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUBSETTING_BASIC; });
/* unused harmony export SUBSETTING_CUSTOM */
/* unused harmony export SUBSETTING_NONE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);






var SUBSETTING_BASIC = 'basic';
var SUBSETTING_CUSTOM = 'custom';
var SUBSETTING_NONE = 'none';

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefaceSubsetting',

  propTypes: {
    subsetting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([SUBSETTING_BASIC, SUBSETTING_CUSTOM, SUBSETTING_NONE]),
    selectedCharacterSetIds: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.set,
    characterSets: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list,
    onSubsettingChanged: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onCharacterSetChanged: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  handleSubsettingChanged: function handleSubsettingChanged(event) {
    this.props.onSubsettingChanged(event.target.value);
  },
  handleCharacterSetChanged: function handleCharacterSetChanged(event) {
    var id = parseInt(event.target.value, 10);
    var isChecked = event.target.checked;

    this.props.onCharacterSetChanged(id, isChecked);
  },
  renderCharacterSets: function renderCharacterSets() {
    var _this = this;

    if (this.props.subsetting !== SUBSETTING_CUSTOM) {
      return null;
    }

    var characterSets = this.props.characterSets;

    var characterSetElements = characterSets.map(function (characterSet, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: characterSet.id, className: 'col-xs-4' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { htmlFor: 'customSubsetting' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        className: 'check_boxes optional',
        type: 'checkbox',
        checked: _this.props.selectedCharacterSetIds.includes(characterSet.id),
        onChange: _this.handleCharacterSetChanged,
        value: characterSet.id
      }), ' ', characterSet.name)));
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { 'data-role': 'character-sets' }, characterSetElements);
  },
  render: function render() {
    var subsetting = this.props.subsetting;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'radio' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', name: 'basicSubsetting', value: SUBSETTING_BASIC, onChange: this.handleSubsettingChanged, checked: subsetting === SUBSETTING_BASIC }), ' Basic Subsetting', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted text-sm m-xs-b-0' }, 'English, French, German, Italian, Portuguese, and Spanish'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'radio' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', name: 'customSubsetting', value: SUBSETTING_CUSTOM, onChange: this.handleSubsettingChanged, checked: subsetting === SUBSETTING_CUSTOM }), 'Custom Subsetting', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-sm text-muted m-xs-b-sm' }, 'Custom language support'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row clearfix' }, this.renderCharacterSets()))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'radio' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', name: 'noSubsetting', value: SUBSETTING_NONE, onChange: this.handleSubsettingChanged, checked: subsetting === SUBSETTING_NONE }), ' No Subsetting')));
  }
}));

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ANY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_QUEUED; });
/* unused harmony export IS_NOT_FOUND */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_NOT_ALLOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HAS_NO_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HAS_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HAS_FAILED; });
/* unused harmony export clearCachedRequestsQueue */
/* unused harmony export splitCacheable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__methods__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResourcesManager__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_env__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_camelcase__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_camelcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_camelcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(183);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};












var REQUESTS_STATE_KEY = '__@requests@__';

var ANY = 'ANY';
var IS_QUEUED = 'IS_QUEUED';
var IS_NOT_FOUND = 'IS_NOT_FOUND';
var IS_NOT_ALLOWED = 'IS_NOT_ALLOWED';
var IS_DONE = 'IS_DONE';
var HAS_NO_CONTENT = 'HAS_NO_CONTENT';
var HAS_ERRORS = 'HAS_ERRORS';
var HAS_FAILED = 'HAS_FAILED';

var cachedRequestsQueue = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();

function clearCachedRequestsQueue() {
  cachedRequestsQueue = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
}

function splitCacheable(requests, queue) {
  var cached = {};
  var notCached = {};
  var nextQueue = queue;

  Object.keys(requests).forEach(function (key) {
    var request = requests[key];
    var url = request.url.join('/');

    if (request.useCache && request.method === __WEBPACK_IMPORTED_MODULE_3__methods__["b" /* GET */] && nextQueue.has(url)) {
      cached[key] = nextQueue.get(url);
    } else {
      notCached[key] = request;

      if (request.method === __WEBPACK_IMPORTED_MODULE_3__methods__["b" /* GET */]) {
        nextQueue = nextQueue.set(url, request);
      }
    }
  });

  return { cached: cached, notCached: notCached, nextQueue: nextQueue };
}

/* harmony default export */ __webpack_exports__["g"] = ({
  propTypes: {
    requests: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  },

  hasRequest: function hasRequest(key) {
    return typeof this.requests !== 'undefined' ? !!this.requests[key] : false;
  },
  componentWillMount: function componentWillMount() {
    this.requests = {};
  },
  componentDidMount: function componentDidMount() {
    this.callTransitions(this.props, this.props, true);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.uncacheFailures(this.props.requests);
    this.callTransitions(this.props, nextProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearRequests();
  },
  uncacheFailures: function uncacheFailures(state) {
    cachedRequestsQueue = cachedRequestsQueue.filter(function (request) {
      var status = state.getIn(['status', request.uuid]);

      return typeof status === 'undefined' || status === __WEBPACK_IMPORTED_MODULE_6__reducers__["QUEUED"] || status >= 200 && status < 300;
    });
  },
  callTransitions: function callTransitions(lhProps, rhProps) {
    var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (typeof this.transitions !== 'function') {
      return;
    }

    var lhRm = this.resourceManager(lhProps);
    var rhRm = this.resourceManager(rhProps);
    var transitions = [];
    var register = function register(transition) {
      return transitions.push(transition);
    };

    this.transitions(register);

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var transition = _step.value;

        var _Object$assign = Object.assign({}, { from: ANY, to: ANY }, transition),
            from = _Object$assign.from,
            to = _Object$assign.to,
            request = _Object$assign.request;

        var fromState = from === ANY ? true : lhRm.requests[__WEBPACK_IMPORTED_MODULE_8_camelcase___default()(from)](request);
        var lastState = to === ANY ? true : lhRm.requests[__WEBPACK_IMPORTED_MODULE_8_camelcase___default()(to)](request);
        var toState = to === ANY ? true : rhRm.requests[__WEBPACK_IMPORTED_MODULE_8_camelcase___default()(to)](request);

        if (fromState && toState && (!lastState || initial)) {
          transition.call.bind(this)(rhRm);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  resourceManager: function resourceManager() {
    var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!__WEBPACK_IMPORTED_MODULE_7_utils_env__["a" /* PRODUCTION */] && !this.props.requests) {
      /* eslint-disable no-console */
      console.error('Trying to create resource manager but this.props.requests is ' + _typeof(this.props.requests));
      /* eslint-enable no-console */
    }

    var props = nextProps || this.props;

    return Object(__WEBPACK_IMPORTED_MODULE_5__ResourcesManager__["a" /* default */])({
      requests: this.requests,
      representations: props.requests.get('representations'),
      resources: props.requests.get('resources'),
      status: props.requests.get('status'),
      errors: props.requests.get('errors')
    });
  },
  setRequest: function setRequest(nextRequests) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object.keys(nextRequests).forEach(function (key) {
      var maybeRequest = nextRequests[key];

      if (!(maybeRequest instanceof __WEBPACK_IMPORTED_MODULE_4__Request__["a" /* default */])) {
        throw new Error('Cannot set request for ' + key + ' because it\'s not a Request instance');
      }
    });

    var nextOptions = Object.assign({}, { skipDispatch: false }, options);
    var nextState = {};

    var _splitCacheable = splitCacheable(nextRequests, cachedRequestsQueue),
        cached = _splitCacheable.cached,
        notCached = _splitCacheable.notCached,
        nextQueue = _splitCacheable.nextQueue;

    cachedRequestsQueue = nextQueue;

    this.requests = nextState[REQUESTS_STATE_KEY] = Object.assign({}, this.requests || {}, cached, notCached);

    this.setState(nextState, function () {
      if (!_this.props.dispatch) {
        throw new Error('No dispatch prop found on this component, cannot setRequest without it');
      }

      if (!nextOptions.skipDispatch) {
        _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* queueRequests */](Object.keys(notCached).map(function (i) {
          return notCached[i];
        })));
      }
    });
  },
  clearRequests: function clearRequests(requests) {
    var nextState = {};

    this.requests = nextState[REQUESTS_STATE_KEY] = {};

    this.setState(nextState);
  },
  deleteRequest: function deleteRequest(request) {
    var nextState = {};
    var requests = this.state[REQUESTS_STATE_KEY];

    var requestName = Object.keys(requests).find(function (key) {
      return requests[key] === request;
    });

    delete requests[requestName];

    this.requests = nextState[REQUESTS_STATE_KEY] = requests;

    this.setState(nextState);
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacetItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__ = __webpack_require__(14);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};









var NOOP = function NOOP() {
  return undefined;
};

var FacetItem = Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Record"])({
  label: '',
  selected: false,
  count: '',
  tooltip: '',
  source: null
});

var tooltipProps = {
  type: __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["c" /* TOOLTIP_TYPE_INLINE */],
  position: __WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["a" /* TOOLTIP_POSITION_RIGHT */],
  noIcon: true,
  forceVisibility: false
};

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Facets',

  propTypes: {
    heading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onFacetSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFacetDeselected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    groups: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.mapOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      included: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterable,
      available: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterable,
      unavailable: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.iterable
    })).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onFacetSelected: NOOP,
      onFacetDeselected: NOOP
    };
  },
  selectable: function selectable() {
    var _props = this.props,
        onFacetSelected = _props.onFacetSelected,
        onFacetDeselected = _props.onFacetDeselected;

    return onFacetSelected !== NOOP && onFacetDeselected !== NOOP;
  },
  renderGroup: function renderGroup(group) {
    var _this = this;

    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'facets';

    if (group.isEmpty()) {
      return null;
    }

    var groupElements = group.map(function (facetItem, key) {
      var popover = facetItem.tooltip ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tooltip__["d" /* default */], _extends({}, tooltipProps, { content: facetItem.tooltip })) : null;
      var handleFacetItemClicked = function handleFacetItemClicked(event) {
        event.preventDefault();

        if (!_this.selectable()) {
          return null;
        }

        return facetItem.selected ? _this.props.onFacetDeselected(facetItem) : _this.props.onFacetSelected(facetItem);
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { onClick: handleFacetItemClicked, className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({ checked: facetItem.selected }), key: 'facet-item-' + key }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, facetItem.label, ' ', facetItem.count ? ' · ' : '', facetItem.count), popover);
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: className }, groupElements);
  },
  render: function render() {
    var groups = this.props.groups;

    var togglable = groups.reduce(function (finalMemo, group) {
      return finalMemo || group.reduce(function (groupMemo, facetItem) {
        return groupMemo || facetItem.selected;
      }, false);
    }, false);
    var groupClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
      selectable: this.selectable(),
      togglable: togglable
    });
    var includedElements = this.renderGroup(groups.get('included', Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()), __WEBPACK_IMPORTED_MODULE_4_classnames___default()('facets in-kit', groupClassNames));
    var availableElements = this.renderGroup(groups.get('available', Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()), __WEBPACK_IMPORTED_MODULE_4_classnames___default()('facets available', groupClassNames));
    var unavailableElements = this.renderGroup(groups.get('unavailable', Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()), __WEBPACK_IMPORTED_MODULE_4_classnames___default()('facets unavailable', groupClassNames));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted m-xs-y-md' }, this.props.heading), includedElements, availableElements, unavailableElements);
  }
}));

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'OptimizedForSelect',

  propTypes: {
    onChanged: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false
    };
  },
  handleChanged: function handleChanged(event) {
    this.props.onChanged(this.refs.select.value);
  },
  render: function render() {
    var optimizedForOptionElements = [14, 16, 18, 21, 24, 28, 32, 36].map(function (size) {
      var sizePx = size + 'px';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option', { key: size, value: sizePx }, sizePx);
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select', { ref: 'select', disabled: this.props.disabled, onChange: this.handleChanged, className: 'form-control input-sm', value: this.props.value }, optimizedForOptionElements);
  }
}));

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = splitIconSets;
/* harmony export (immutable) */ __webpack_exports__["a"] = sortTypefaces;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


function splitIconSets(iconSets, icons, iconSetIdsInSubscription, workingSetIcons) {
  var iconSetsById = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(iconSets.map(function (iconSet) {
    return [iconSet.id, iconSet];
  }));
  var systemIconSets = iconSets.filterNot(function (iconSet) {
    return iconSet.custom;
  });
  var iconSetsByIconId = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(icons.map(function (icon) {
    return [icon.id, iconSetsById.get(icon.iconSet)];
  }));
  var iconSetsUsed = workingSetIcons.map(function (workingSetIcon) {
    return iconSetsByIconId.get(workingSetIcon.icon);
  });
  var available = systemIconSets.filter(function (iconSet) {
    return iconSetIdsInSubscription.includes(iconSet.id);
  });
  var availableUsed = available.filter(function (iconSet) {
    return iconSetsUsed.includes(iconSet);
  });
  var availableNotUsed = available.filter(function (iconSet) {
    return !availableUsed.includes(iconSet);
  });
  var unavailable = systemIconSets.filter(function (iconSet) {
    return !available.includes(iconSet);
  });

  return { available: available, availableUsed: availableUsed, availableNotUsed: availableNotUsed, unavailable: unavailable };
}

function sortTypefaces(typefaces) {
  var desiredStyleOrder = ['normal', 'italic'];

  return typefaces.sort(function (valueA, valueB) {
    var aStyleOrder = desiredStyleOrder.indexOf(valueA.style);
    var bStyleOrder = desiredStyleOrder.indexOf(valueB.style);

    if (valueA.family < valueB.family) {
      return -1;
    } else if (valueA.family > valueB.family) {
      return 1;
    }

    if (aStyleOrder < bStyleOrder) {
      return -1;
    } else if (aStyleOrder > bStyleOrder) {
      return 1;
    }

    if (valueA.weight < valueB.weight) {
      return -1;
    } else if (valueA.weight > valueB.weight) {
      return 1;
    }

    return 0;
  });
}

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return features; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var supported = !!Object.keys(Modernizr).map(function (c) {
  return !!c;
});
var features = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(Modernizr);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatch;
/* harmony export (immutable) */ __webpack_exports__["b"] = observer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests_actions__ = __webpack_require__(183);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}





var jobsStore = void 0;

function nonChattyObserve(store, select, onChange) {
  var currentState = void 0;

  function handleChange() {
    var nextState = select(store.getState());

    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  var unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}

function dispatch(action) {
  jobsStore.dispatch(action);
}

function observer(store) {
  var currentJobs = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
  var currentStatus = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();

  jobsStore = store;

  var jobDiscover = function jobDiscover(jobs) {
    var changedJobs = jobs.toSet().subtract(currentJobs);

    if (!changedJobs.isEmpty()) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* joinJobStatusTopics */])([].concat(_toConsumableArray(changedJobs))));
    }

    currentJobs = jobs.toSet();
  };

  var jobStatusFinished = function jobStatusFinished(status) {
    var _loop = function _loop(id, entry_status) {
      if (~['finished', 'errored'].indexOf(entry_status) && currentStatus.get(id) === 'processing') {
        jobsStore.getState().requests.get('representations').forEach(function (typeGrouping) {
          typeGrouping.forEach(function (record) {
            if (record.jobStatusTopic === id) {
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_requests_actions__["b" /* refreshRecord */])(record));
            }
          });
        });
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = status.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var id = _ref2[0];
        var entry_status = _ref2[1];

        _loop(id, entry_status);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    currentStatus = status;
  };

  nonChattyObserve(store, function (state) {
    return state['requests'].get('jobs');
  }, jobDiscover);

  nonChattyObserve(store, function (state) {
    return state['jobs'].get('status');
  }, jobStatusFinished);
}

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__csrfToken__ = __webpack_require__(185);


/* harmony default export */ __webpack_exports__["a"] = (function (url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var defaultOptions = {
    credentials: 'same-origin'
  };
  var defaultHeaders = {
    'X-CSRF-Token': Object(__WEBPACK_IMPORTED_MODULE_0__csrfToken__["a" /* getFromMeta */])()
  };

  var mergedHeaders = Object.assign({}, defaultHeaders, options.headers || {});
  var mergedOptions = Object.assign({}, defaultOptions, options, { headers: mergedHeaders });

  return fetch(url, mergedOptions);
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}







var customStyles = {
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    top: '0px',
    bottom: 'auto',
    border: 'none',
    backgroundColor: 'transparent',
    overflow: 'visible'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Modal',

  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired,
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isOpen: false
    };
  },
  componentWillMount: function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_react_modal___default.a.setAppElement('#react-modal');
  },
  componentDidMount: function componentDidMount() {
    this.bodyScroll(!this.props.isOpen);
  },
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    this.bodyScroll(!props.isOpen);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.bodyScroll(true);
  },
  bodyScroll: function bodyScroll(enabled) {
    document.getElementsByTagName('body')[0].style.overflow = enabled ? null : 'hidden';
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['className']);

    var modalClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('modal-dialog', className);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a, _extends({ className: modalClassName, style: customStyles }, props), this.props.children);
  }
}));

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_UNCAUGHT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_QUEUED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESPONSE_UNHANDLED_STATUS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESPONSE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESPONSE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESPONSE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESPONSE_NOT_JSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESPONSE_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESPONSE_BAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESPONSE_NO_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESPONSE_NOT_ALLOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESPONSE_FAILURE; });
var REQUEST_UNCAUGHT_ERROR = '@@REQUEST_UNCAUGHT_ERROR';
var REQUEST_QUEUED = '@@REQUEST_QUEUED';
var RESPONSE_UNHANDLED_STATUS_CODE = '@@RESPONSE_UNHANDLED_STATUS_CODE';
var RESPONSE_DATA = '@@RESPONSE_DATA';
var RESPONSE_CREATED = '@@RESPONSE_CREATED';
var RESPONSE_DELETED = '@@RESPONSE_DELETED';
var RESPONSE_NOT_JSON = '@@RESPONSE_NOT_JSON';
var RESPONSE_NOT_FOUND = '@@RESPONSE_NOT_FOUND';
var RESPONSE_BAD_REQUEST = '@@RESPONSE_BAD_REQUEST';
var RESPONSE_NO_CONTENT = '@@RESPONSE_NO_CONTENT';
var RESPONSE_NOT_ALLOWED = '@@RESPONSE_NOT_ALLOWED';
var RESPONSE_FAILURE = '@@RESPONSE_FAILURE';

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  workingSetId: null,
  jobStatusTopic: null,
  status: null,
  name: null,
  publishedUrl: null,
  originalUrl: null,
  originalSize: null,
  optimizedUrl: null,
  optimizedSize: null,
  uploadedUrl: null,
  createdAt: null,
  updatedAt: null
});

var WorkingSetImage = function (_record) {
  _inherits(WorkingSetImage, _record);

  function WorkingSetImage() {
    _classCallCheck(this, WorkingSetImage);

    return _possibleConstructorReturn(this, (WorkingSetImage.__proto__ || Object.getPrototypeOf(WorkingSetImage)).apply(this, arguments));
  }

  _createClass(WorkingSetImage, [{
    key: 'createdAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetImage.prototype.__proto__ || Object.getPrototypeOf(WorkingSetImage.prototype), 'createdAt', this));
    }
  }, {
    key: 'updatedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetImage.prototype.__proto__ || Object.getPrototypeOf(WorkingSetImage.prototype), 'updatedAt', this));
    }
  }, {
    key: 'originalUrl',
    get: function get() {
      return _get(WorkingSetImage.prototype.__proto__ || Object.getPrototypeOf(WorkingSetImage.prototype), 'originalUrl', this) + '?u=' + this.updatedAt.unix();
    }
  }, {
    key: 'optimizedUrl',
    get: function get() {
      return _get(WorkingSetImage.prototype.__proto__ || Object.getPrototypeOf(WorkingSetImage.prototype), 'optimizedUrl', this) + '?u=' + this.updatedAt.unix();
    }
  }]);

  return WorkingSetImage;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (WorkingSetImage);

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_algoliasearch__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_algoliasearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_algoliasearch__);


var _client = null;

var client = function client() {
  if (_client === null) {
    _client = __WEBPACK_IMPORTED_MODULE_0_algoliasearch___default()("B0NGO5DRPS", "c06627d992298ff1140a539a9da30b9c"); // eslint-disable-line no-undef
  }

  return _client;
};

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HITS_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ICONS_PER_ROW; });
var HITS_PER_PAGE = 25;
var ICONS_PER_ROW = 5;

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(190);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}





var TypeAccessor = function () {
  function TypeAccessor(requests, representations, resources, request, typeName) {
    _classCallCheck(this, TypeAccessor);

    this.requestUuid = request ? request.uuid : null;
    this.resource = resources.get(this.requestUuid, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).get(typeName, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
    this.representations = representations.get(typeName, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  }

  _createClass(TypeAccessor, [{
    key: 'get',
    value: function get(id) {
      var idString = id === undefined ? this.resource.first() : id.toString();

      return this.resource.includes(idString) ? this.representations.get(idString, null) : null;
    }
  }, {
    key: 'all',
    value: function all() {
      var _this = this;

      return this.resource.map(function (id) {
        return _this.representations.get(id);
      });
    }
  }, {
    key: 'filter',
    value: function filter(filterParamsOrId) {
      var _this2 = this;

      var filterParamsIsId = typeof filterParamsOrId === 'string' || typeof filterParamsOrId === 'number';
      var filterParams = filterParamsIsId ? { id: filterParamsOrId } : filterParamsOrId;

      var found = this.representations.filter(function (representation) {
        var matches = Object.keys(filterParams).map(function (key) {
          return filterParams[key] === representation[key];
        });

        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(matches);
      });

      return found.filter(function (representation) {
        return _this2.resource.includes(representation.id.toString());
      });
    }
  }, {
    key: 'find',
    value: function find(findParams) {
      var filtered = this.filter(findParams);

      return filtered.size === 1 ? filtered.first() : null;
    }
  }]);

  return TypeAccessor;
}();

var RequestsAccessor = function () {
  function RequestsAccessor(requests, status, errors) {
    _classCallCheck(this, RequestsAccessor);

    this.requests = requests;
    this.status = status;
    this.errors = errors;

    this.meansDone = [200, 201, 204];
    this.meansFailed = [500, 502, 503, 504];
  }

  _createClass(RequestsAccessor, [{
    key: '_requestsWithStatus',
    value: function _requestsWithStatus(requestsOrAll, status) {
      var _this3 = this;

      var statusChecker = typeof status === 'function' ? status : function (v) {
        return v === status;
      };
      var requests = requestsOrAll === true ? Object(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* values */])(this.requests) : Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* arrayize */])(requestsOrAll) || [];

      return requests.map(function (request) {
        return statusChecker(_this3.status.get(request ? request.uuid : null)) && !!~Object(__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* values */])(_this3.requests).indexOf(request);
      });
    }
  }, {
    key: 'isQueued',
    value: function isQueued(request) {
      if (!request) {
        return false;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus([request], __WEBPACK_IMPORTED_MODULE_1__reducers__["QUEUED"]));
    }
  }, {
    key: 'allQueued',
    value: function allQueued(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, __WEBPACK_IMPORTED_MODULE_1__reducers__["QUEUED"]));
    }
  }, {
    key: 'anyQueued',
    value: function anyQueued(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, __WEBPACK_IMPORTED_MODULE_1__reducers__["QUEUED"]));
    }
  }, {
    key: 'hasErrors',
    value: function hasErrors(request) {
      if (!request) {
        return false;
      }

      return this.allHaveErrors([request]);
    }
  }, {
    key: 'errorsFor',
    value: function errorsFor(request) {
      return this.hasErrors(request) ? this.errors.get(request.uuid, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
    }
  }, {
    key: 'allHaveErrors',
    value: function allHaveErrors(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, 400));
    }
  }, {
    key: 'anyHaveErrors',
    value: function anyHaveErrors(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, 400));
    }
  }, {
    key: 'isDone',
    value: function isDone(request) {
      if (!request) {
        return false;
      }

      return this.allDone([request]);
    }
  }, {
    key: 'allDone',
    value: function allDone(requestsOrAll) {
      var _this4 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, function (status) {
        return ~_this4.meansDone.indexOf(status);
      }));
    }
  }, {
    key: 'anyDone',
    value: function anyDone(requestsOrAll) {
      var _this5 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, function (status) {
        return ~_this5.meansDone.indexOf(status);
      }));
    }
  }, {
    key: 'isNotFound',
    value: function isNotFound(request) {
      if (!request) {
        return false;
      }

      return this.allNotFound([request]);
    }
  }, {
    key: 'allNotFound',
    value: function allNotFound(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, 404));
    }
  }, {
    key: 'anyNotFound',
    value: function anyNotFound(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, 404));
    }
  }, {
    key: 'isNotAllowed',
    value: function isNotAllowed(request) {
      if (!request) {
        return false;
      }

      return this.allNotAllowed([request]);
    }
  }, {
    key: 'allNotAllowed',
    value: function allNotAllowed(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, 403));
    }
  }, {
    key: 'anyNotAllowed',
    value: function anyNotAllowed(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, 403));
    }
  }, {
    key: 'hasNoContent',
    value: function hasNoContent(request) {
      if (!request) {
        return false;
      }

      return this.allNoContent([request]);
    }
  }, {
    key: 'allNoContent',
    value: function allNoContent(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, 204));
    }
  }, {
    key: 'anyNoContent',
    value: function anyNoContent(requestsOrAll) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, 204));
    }
  }, {
    key: 'hasFailed',
    value: function hasFailed(request) {
      if (!request) {
        return false;
      }

      return this.allFailed([request]);
    }
  }, {
    key: 'allFailed',
    value: function allFailed(requestsOrAll) {
      var _this6 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* all */])(this._requestsWithStatus(requestsOrAll, function (status) {
        return ~_this6.meansFailed.indexOf(status);
      }));
    }
  }, {
    key: 'anyFailed',
    value: function anyFailed(requestsOrAll) {
      var _this7 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* any */])(this._requestsWithStatus(requestsOrAll, function (status) {
        return ~_this7.meansFailed.indexOf(status);
      }));
    }
  }]);

  return RequestsAccessor;
}();

/* harmony default export */ __webpack_exports__["a"] = (function (params) {
  var requests = params.requests,
      representations = params.representations,
      resources = params.resources,
      status = params.status,
      errors = params.errors;

  return {
    type: function type() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new (Function.prototype.bind.apply(TypeAccessor, [null].concat([requests, representations, resources], _toConsumableArray(args))))();
    },

    requests: new RequestsAccessor(requests, status, errors),
    _args: params
  };
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ResourcesMatching',

  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]),
    manager: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    element: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    request: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  childContextTypes: {
    manager: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    request: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      element: 'div'
    };
  },
  getChildContext: function getChildContext() {
    return {
      manager: this.props.manager,
      request: this.props.request
    };
  },
  render: function render() {
    var _this = this;

    var wrap = function wrap(children) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this.props.element, {}, children);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) === 1 ? this.props.children : wrap(this.props.children);
  }
}));

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAB_ADD */
/* unused harmony export TAB_UPLOAD */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);







var TAB_ADD = 'TAB_ADD';
var TAB_UPLOAD = 'TAB_UPLOAD';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Header',

  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
    heading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    headingIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    showUpload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onTabChanged: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    donePath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      headingIcon: 'ficon-plus-circle',
      showUpload: false,
      onTabChanged: function onTabChanged() {},
      donePath: null
    };
  },
  handleAllIconSetsClicked: function handleAllIconSetsClicked(event, tab) {
    event.preventDefault();

    this.props.onTabChanged(TAB_ADD);
  },
  handleUploadAnIconClicked: function handleUploadAnIconClicked(event) {
    event.preventDefault();

    this.props.onTabChanged(TAB_UPLOAD);
  },
  render: function render() {
    var _props = this.props,
        heading = _props.heading,
        headingIcon = _props.headingIcon,
        donePath = _props.donePath,
        showUpload = _props.showUpload;

    var headingIconClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ficon', headingIcon);

    var doneElement = null;
    var navElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-b-lg' });
    var uploadElement = null;

    if (donePath) {
      doneElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: donePath, className: 'btn btn-secondary btn-lg' }, 'Done Adding'));
    }

    if (this.props.children) {
      navElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline' }, this.props.children);
    }

    if (showUpload) {
      uploadElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'label label-info text-sm p-xs-x-md p-xs-y-sm m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded ficon-lg m-xs-r-xs' }), ' Uploaded'));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-bottom m-xs-b-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'm-xs-t-sm m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: headingIconClassName }), '\u2009 ', heading)), uploadElement, doneElement), navElement);
  }
}));

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_crc__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_crc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_crc__);




var DATA_ATTRIBUTE = 'data-woff-embedded-name';

/* harmony default export */ __webpack_exports__["a"] = ({
  propTypes: {
    woff: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  },

  componentWillMount: function componentWillMount() {
    this.addFontFaceDeclaration(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.woff !== this.props.woff) {
      this.addFontFaceDeclaration(nextProps);
    }
  },
  addFontFaceDeclaration: function addFontFaceDeclaration(props) {
    if (props.woff) {
      var oldName = this._name;
      var newName = __WEBPACK_IMPORTED_MODULE_2_js_crc___default.a.crc32(props.woff).toString();
      var style = document.querySelector('[' + DATA_ATTRIBUTE + '="' + (oldName || newName) + '"]') || document.createElement('style');

      this._name = newName;

      if (oldName !== newName) {
        style.innerText = this.fontFaceDeclaration(props);
        style.setAttribute(DATA_ATTRIBUTE, this._name);
      }

      if (!style.parentNode) {
        document.querySelector('head').appendChild(style);
      }
    }
  },
  fontFaceDeclaration: function fontFaceDeclaration(props) {
    return '@font-face {' + ('  font-family: \'' + this._name + '\';') + ('  src: url(data:application/x-font-woff;charset=utf-8;base64,' + props.woff + ') format(\'woff\');') + '}';
  }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conditionalComponent__ = __webpack_require__(115);




/* eslint-disable object-shorthand,func-names */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__conditionalComponent__["a" /* default */])('HasErrors', {
  all: 'allHaveErrors',
  any: 'anyHaveErrors',
  propTypes: {
    errorKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  },
  shouldRender: function shouldRender(computedShouldRender) {
    var retval = computedShouldRender;

    if (computedShouldRender && this.props.errorKey) {
      retval = !!this.context.manager.requests.errorsFor(this.props.request || this.context.request).get(this.props.errorKey);
    }

    return retval;
  }
}));
/* eslint-enable object-shorthand */

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_WoffEmbeddedIcon__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RemoveIconModal__ = __webpack_require__(459);











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconCard',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetIcon: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired,
    onRemoveIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    showInList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      showInList: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      iconFocused: false,
      removeFocused: false,
      showConfirmation: false,
      isRemoving: false
    };
  },
  getRemoveTooltip: function getRemoveTooltip() {
    var workingSetIcon = this.props.workingSetIcon;

    var removeTooltip = null;

    if (workingSetIcon.custom) {
      removeTooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { content: 'Delete Icon', icon: 'ficon-trash' });
    } else {
      removeTooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { content: 'Remove from Kit', icon: 'ficon-times' });
    }

    return removeTooltip;
  },
  handleIconFocused: function handleIconFocused() {
    this.setState({ iconFocused: !this.state.iconFocused });
  },
  handleRemoveFocused: function handleRemoveFocused() {
    this.setState({ removeFocused: !this.state.removeFocused });
  },
  handleRemoved: function handleRemoved(event) {
    event.preventDefault();
    event.stopPropagation();

    var _props = this.props,
        workingSetIcon = _props.workingSetIcon,
        onRemoveIcon = _props.onRemoveIcon;

    if (workingSetIcon.custom && workingSetIcon.status === 'finished') {
      this.setState({ showConfirmation: true });
    } else {
      this.setState({ isRemoving: true });
      onRemoveIcon(workingSetIcon);
    }
  },
  handleConfirmation: function handleConfirmation(event) {
    var _props2 = this.props,
        workingSetIcon = _props2.workingSetIcon,
        onRemoveIcon = _props2.onRemoveIcon;

    this.setState({
      showConfirmation: false,
      isRemoving: true
    });

    onRemoveIcon(workingSetIcon);
  },
  handleClosed: function handleClosed() {
    this.setState({ showConfirmation: false });
  },
  renderFinished: function renderFinished() {
    var _props3 = this.props,
        workingSetIcon = _props3.workingSetIcon,
        kitToken = _props3.kitToken,
        showInList = _props3.showInList;

    var linkClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('kit-icon', 'asset', 'asset-icon', 'link-dashed-none', 'asset-hover-emphasized', { 'asset-uploaded': workingSetIcon.custom });
    var _state = this.state,
        iconFocused = _state.iconFocused,
        removeFocused = _state.removeFocused,
        showConfirmation = _state.showConfirmation;

    var removable = ~['finished', 'errored'].indexOf(workingSetIcon.status);
    var editTooltip = iconFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { content: 'Edit ' + workingSetIcon.name, icon: 'ficon-pencil' }) : null;
    var removeTooltip = removeFocused && removable ? this.getRemoveTooltip() : null;
    var indicator = workingSetIcon.custom ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-uploaded' }) : null;
    var icon = showInList ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_WoffEmbeddedIcon__["a" /* default */], { woff: workingSetIcon.woff, iconSize: workingSetIcon.optimizedFor }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_WoffEmbeddedIcon__["a" /* default */], { woff: workingSetIcon.woff });

    var modal = null;

    if (workingSetIcon.custom) {
      modal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RemoveIconModal__["a" /* default */], {
        show: showConfirmation,
        kitToken: kitToken,
        workingSetIcon: workingSetIcon,
        onRemovedIcon: this.handleConfirmation,
        onClosed: this.handleClosed
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/' + workingSetIcon.id, className: linkClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner', onMouseOver: this.handleIconFocused, onMouseOut: this.handleIconFocused }, editTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview' }, icon), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-label icon-label text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'asset-label-copy' }, workingSetIcon.name), ' ', indicator)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-remove cursor-pointer link-dashed-none', onClick: this.handleRemoved, onMouseOver: this.handleRemoveFocused, onMouseOut: this.handleRemoveFocused }, removeTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), modal);
  },
  renderErrored: function renderErrored() {
    var workingSetIcon = this.props.workingSetIcon;
    var removeFocused = this.state.removeFocused;

    var removable = ~['finished', 'errored'].indexOf(workingSetIcon.status);
    var removeTooltip = removeFocused && removable ? this.getRemoveTooltip() : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset asset-error asset-icon asset-icon-error br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'block text-danger text-sm word-wrap p-xs-x-md m-xs-b-sm' }, 'Upload failed.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-remove cursor-pointer link-dashed-none', onClick: this.handleRemoved, onMouseOver: this.handleRemoveFocused, onMouseOut: this.handleRemoveFocused }, removeTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })));
  },
  renderRemoving: function renderRemoving() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset asset-processing asset-icon asset-icon-processing br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-sm m-xs-x-sm' }, 'removing\u2026')));
  },
  renderProcessing: function renderProcessing() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset asset-processing asset-icon asset-icon-processing br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner text-xs-center animated infinite pulseOpacity' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-sm m-xs-x-sm' }, 'adding\u2026')));
  },
  render: function render() {
    var workingSetIcon = this.props.workingSetIcon;
    var isRemoving = this.state.isRemoving;

    var value = null;

    switch (workingSetIcon.status) {
      case 'finished':
        value = this.renderFinished();
        break;
      case 'errored':
        value = this.renderErrored();
        break;
      default:
        value = this.renderProcessing();
    }

    if (isRemoving) {
      value = this.renderRemoving();
    }

    return value;
  }
}));

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_WoffEmbeddedIcon__ = __webpack_require__(116);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'RemoveIconModal',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    workingSetIcon: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record.isRequired,
    show: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onRemovedIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  handleConfirmation: function handleConfirmation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.props.onRemovedIcon(this.props.workingSetIcon);
  },
  handleClosed: function handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Remove icon', isOpen: this.props.show, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { type: 'button', className: 'close close-dangle', onClick: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning m-xs-r-md' }), 'Delete ', this.props.workingSetIcon.name, '?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-lg well bg-body' }, 'Are you sure you would like to permanently delete this icon? This action cannot be undone.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table text-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-base text-normal text-muted valign-middle' }, 'Icon'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong p-xs-r-2x valign-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_WoffEmbeddedIcon__["a" /* default */], { woff: this.props.workingSetIcon.woff }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-base text-normal text-muted valign-middle' }, 'Name'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-strong p-xs-r-2x valign-middle' }, this.props.workingSetIcon.name))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-secondary', onClick: this.handleClosed }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-danger', rel: 'nofollow', onClick: this.handleConfirmation }, 'Yes, Delete', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash m-xs-l-md' })))));
  }
}));

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconCardPlaceholder',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/new', className: 'asset asset-blank asset-icon asset-icon-blank br-a link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Add'), ' Icon'));
  }
}));

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components__ = __webpack_require__(15);












var mapStateToProps = function mapStateToProps(state, props) {
  return {
    kitToken: props.kitToken,
    requests: state.requests
  };
};

var IconSettings = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IconSettings',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      showModal: false,
      settings: null,
      isFocused: false,
      isSaving: false
    };
  },
  componentWillMount: function componentWillMount() {
    var settings = this.state.settings;

    this.setRequest({
      iconSettings: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'icon-settings']
      })
    });

    var rm = this.resourceManager();
    var iconSettings = rm.type(this.requests.iconSettings, 'icon-settings').get();

    if (!settings && rm.requests.isDone(this.requests.iconSettings)) {
      this.setState({ settings: iconSettings });
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var rm = this.resourceManager(nextProps);
    var settings = this.state.settings;

    var iconSettings = rm.type(this.requests.iconSettings, 'icon-settings').get();

    if (!settings && rm.requests.isDone(this.requests.iconSettings)) {
      this.setState({ settings: iconSettings });
    }

    if (rm.requests.isDone(this.requests.updateIconSettings)) {
      this.setState({
        settings: iconSettings,
        isSaving: false,
        showModal: false
      });
    }

    if (rm.requests.hasErrors(this.requests.updateIconSettings)) {
      this.setState({
        isSaving: false
      });
    }
  },
  handleOpened: function handleOpened(event) {
    event.preventDefault();

    this.setState({ showModal: true, isFocused: false });
  },
  handleClosed: function handleClosed() {
    this.setState({ showModal: false });
  },
  handleFocused: function handleFocused() {
    this.setState({ isFocused: !this.state.isFocused });
  },
  handleSaved: function handleSaved() {
    var settings = this.state.settings;

    this.setState({ isSaving: true });

    this.setRequest({
      updateIconSettings: new __WEBPACK_IMPORTED_MODULE_8_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'icon-settings'],
        method: __WEBPACK_IMPORTED_MODULE_8_requests__["d" /* PUT */],
        record: settings
      })
    });
  },
  handlePrefixChanged: function handlePrefixChanged(event) {
    var settings = this.state.settings;

    this.setState({
      settings: settings.set(event.target.name, event.target.value)
    });
  },
  handleChecked: function handleChecked(event) {
    var settings = this.state.settings;

    this.setState({
      settings: settings.set(event.target.name, event.target.checked)
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').all()
    };
  },
  renderModal: function renderModal() {
    var _state = this.state,
        showModal = _state.showModal,
        isSaving = _state.isSaving,
        settings = _state.settings;

    var rm = this.resourceManager();
    var cssPrefixClassNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('form-group', 'row', 'required', { 'has-danger': rm.requests.hasErrors(this.requests.updateIconSettings) });

    var submitLabel = isSaving ? 'Saving...' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Save Icon Settings ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Modal__["a" /* default */], { contentLabel: 'Icon settings', isOpen: showModal, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-dialog', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'close close-dangle', 'aria-label': 'Close' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title', id: 'icon-settings-modal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear text-gray-lighter m-xs-r-xs' }), ' Icon Settings')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple_form form-horizontal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cssPrefixClassNames }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-4 form-control-label p-xs-r-sm' }, 'CSS Prefix ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'required form-control', type: 'text', value: settings.cssPrefix, name: 'cssPrefix', onChange: this.handlePrefixChanged }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["b" /* HasErrors */], { request: this.requests.updateIconSettings, errorKey: 'cssPrefix' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, rm.requests.errorsFor(this.requests.updateIconSettings).get('cssPrefix'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted p-xs-t-xs' }, 'Namespaces all classes in your kit.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'e.g. <i class=\'', settings.cssPrefix, ' ', settings.cssPrefix, '-check ', settings.cssPrefix, '-lg\'></i>'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row text required', 'data-role': 'field-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'text required col-xs-4 form-control-label' }, 'CSS Features ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.15 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.largerIconSizes, name: 'largerIconSizes', onChange: this.handleChecked }), ' Larger Icon Sizes')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.05 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.fixedWidthIcons, name: 'fixedWidthIcons', onChange: this.handleChecked }), ' Fixed Width Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.23 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.listIcons, name: 'listIcons', onChange: this.handleChecked }), ' List Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.19 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.borderedPulledIcons, name: 'borderedPulledIcons', onChange: this.handleChecked }), ' Bordered & Pulled Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.49 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.spinningIcons, name: 'spinningIcons', onChange: this.handleChecked }), ' Animated Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.97 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.rotatedFlippedIcons, name: 'rotatedFlippedIcons', onChange: this.handleChecked }), ' Rotated & Flipped Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted pull-xs-right' }, '.27 KB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.stackedIcons, name: 'stackedIcons', onChange: this.handleChecked }), ' Stacked Icons')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Reduce kit size by selecting fewer CSS features.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row text required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-4 form-control-label p-xs-y-0 p-xs-r-sm' }, 'Accessibility ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.autoA11y, name: 'autoA11y', onChange: this.handleChecked }), ' Automatically make icons more accessible', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Have accessibility best practices applied automatically to your icons.'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row text required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-4 form-control-label p-xs-y-0 p-xs-r-sm' }, 'Performance ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'checkbox' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'boolean', type: 'checkbox', checked: settings.asyncLoading, name: 'asyncLoading', onChange: this.handleChecked }), ' Load CSS asynchronously', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-sm text-muted m-xs-b-0' }, 'Don\'t let icons slow down your pages from loading. Load them in quickly in the background.'))))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'btn btn-link' }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleSaved, type: 'submit', disabled: isSaving, className: 'btn btn-primary' }, submitLabel))))));
  },
  renderMain: function renderMain() {
    var isFocused = this.state.isFocused;

    var popover = isFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Icon Settings', position: __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["a" /* TOOLTIP_POSITION_RIGHT */] }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'text-muted text-lg has-tooltip link-dashed-none', onClick: this.handleOpened, onMouseOver: this.handleFocused, onMouseOut: this.handleFocused }, popover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear' })), this.renderModal());
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager(), request: this.requests.iconSettings, element: 'span' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components__["a" /* Done */], { render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(IconSettings));

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefaceCardPlaceholder',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  render: function render() {
    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/typefaces/new', className: 'asset asset-blank asset-typeface asset-typeface-blank br-a link-dashed-none p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle m-xs-r-xs' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Add'), ' Typeface'));
  }
}));

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TypefaceSubsetting__ = __webpack_require__(218);









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TypefacesSettings',

  propTypes: {
    show: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    typefaceSettings: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record,
    characterSets: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onSaved: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return this.getState(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    this.setState(this.getState(props));
  },
  getState: function getState(props) {
    var typefaceSettings = props.typefaceSettings;

    return {
      subsetting: typefaceSettings ? typefaceSettings.defaultSubsetting : __WEBPACK_IMPORTED_MODULE_7__TypefaceSubsetting__["a" /* SUBSETTING_BASIC */],
      characterSets: typefaceSettings ? Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Set"])(typefaceSettings.characterSets) : Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Set"])()
    };
  },
  handleSubsettingChanged: function handleSubsettingChanged(subsetting) {
    this.setState({ subsetting: subsetting });
  },
  handleCharacterSetChanged: function handleCharacterSetChanged(id, isChecked) {
    var characterSets = this.state.characterSets;

    this.setState({
      characterSets: isChecked ? characterSets.add(id) : characterSets.delete(id)
    });
  },
  handleClosed: function handleClosed(event) {
    if (event) {
      event.preventDefault();
    }

    this.props.onClosed();
  },
  handleSaved: function handleSaved(event) {
    var nextTypefaceSettings = this.props.typefaceSettings.set('defaultSubsetting', this.state.subsetting).set('characterSets', this.state.characterSets);

    this.props.onSaved(nextTypefaceSettings);
  },
  renderModalBody: function renderModalBody() {
    var _state = this.state,
        subsetting = _state.subsetting,
        selectedCharacterSetIds = _state.characterSets;
    var characterSets = this.props.characterSets;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { className: 'simple_form form-horizontal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row required' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'required col-xs-4 form-control-label p-xs-r-sm' }, 'Character Subsetting ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TypefaceSubsetting__["b" /* default */], {
      subsetting: subsetting,
      selectedCharacterSetIds: selectedCharacterSetIds,
      characterSets: characterSets,
      onSubsettingChanged: this.handleSubsettingChanged,
      onCharacterSetChanged: this.handleCharacterSetChanged
    })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted m-xs-b-0' }, 'When adding a typeface to your kit, these options will be selected by default.'));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Typeface settings', isOpen: this.props.show, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-dialog', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'close close-dangle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear text-gray-lighter m-xs-r-xs' }), ' Typeface Settings')), this.renderModalBody(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'btn btn-link' }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleSaved, type: 'submit', className: 'btn btn-primary' }, 'Save Typeface Settings ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }))))));
  }
}));

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'ImageCardPlaceholder',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Link */], { to: '/kits/' + this.props.kitToken + '/images/upload', className: 'asset asset-blank asset-image asset-image-blank link-dashed-none br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-plus-circle' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Add'), ' Image'));
  }
}));

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_url_parse__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_url_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_url_parse__);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}








var HALLMARK = '_stylesheet_link_';
var _stylesheetUrls = Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])();

function reconcileHeadWithStylesheets(stylesheetUrls) {
  var head = document.getElementsByTagName('head')[0];
  var links = head.getElementsByTagName('link');
  var queue = stylesheetUrls;

  return new __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a(function (resolve, reject) {
    [].concat(_toConsumableArray(links)).map(function (link) {
      if (link.getAttribute('role') !== HALLMARK) {
        return;
      }

      var url = link.getAttribute('data-url');
      var cacheToken = link.getAttribute('data-cache-token');
      var stillNeeded = queue.has(url);
      var hasNotChanged = queue.get(url, '') === cacheToken;

      if (stillNeeded && hasNotChanged) {
        queue = queue.remove(url);
      } else {
        head.removeChild(link);
      }
    });

    queue.forEach(function (cacheToken, url) {
      var link = document.createElement('link');
      var parsedUrl = __WEBPACK_IMPORTED_MODULE_5_url_parse___default()(url, true);

      if (cacheToken) {
        parsedUrl.set('query', Object.assign({}, parsedUrl.query, { _: cacheToken }));
      }

      link.setAttribute('data-url', url);
      link.setAttribute('data-cache-token', cacheToken);
      link.setAttribute('href', parsedUrl.toString());
      link.setAttribute('role', HALLMARK);
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');

      head.appendChild(link);

      link.addEventListener('load', function (event) {
        if (event.path && event.path[event.path.length - 1] === document) {
          resolve(url, cacheToken);
        } else {
          resolve(url, cacheToken);
        }
      });
    });
  });
}

function addStylesheetUrl(url, cacheToken) {
  _stylesheetUrls = _stylesheetUrls.set(url, cacheToken);

  return reconcileHeadWithStylesheets(_stylesheetUrls);
}

function removeStylesheetUrl(url) {
  _stylesheetUrls = _stylesheetUrls.delete(url);

  return reconcileHeadWithStylesheets(_stylesheetUrls);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'StylesheetLink',

  propTypes: {
    href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    cacheToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onLoaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    keep: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      cacheToken: '',
      onLoaded: function onLoaded() {
        return undefined;
      },
      keep: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    addStylesheetUrl(this.props.href, this.props.cacheToken).then(function () {
      _this.props.onLoaded();
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    if (!this.props.keep) {
      removeStylesheetUrl(this.props.href);
    }
  },
  render: function render() {
    return null;
  }
}));

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROCESSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERRORED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);




var PROCESSING = "processing";
var FINISHED = "finished";
var ERRORED = "errored";

/* harmony default export */ __webpack_exports__["d"] = ({
  propTypes: {
    jobs: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.map,
    requests: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  },

  jobState: function jobState(subject) {
    var state = null;
    var jobStatusTopicId = subject.jobStatusTopic;

    if (jobStatusTopicId) {
      state = this.props.jobs.get('status').get(jobStatusTopicId, PROCESSING);
    }

    return state;
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'RemoveImageModal',

  propTypes: {
    workingSetImage: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record,
    show: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onRemovedImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  handleConfirmation: function handleConfirmation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.props.onRemovedImage(this.props.workingSetImage);
  },
  handleClosed: function handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },
  render: function render() {
    var workingSetImage = this.props.workingSetImage;

    var name = workingSetImage ? workingSetImage.name : "";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Remove image', isOpen: !!(this.props.show && workingSetImage), onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { type: 'button', className: 'close close-dangle', onClick: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning m-xs-r-md' }), 'Delete ', name, '?')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-lg well bg-body' }, 'Are you sure you would like to permanently delete this image? This action cannot be undone.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-secondary', onClick: this.handleClosed }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', className: 'btn btn-lg btn-danger', rel: 'nofollow', onClick: this.handleConfirmation }, 'Yes, Delete', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-trash m-xs-l-md' })))));
  }
}));

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_DocumentationMixin__ = __webpack_require__(147);














var POPOVER_TIMEOUT = 2000; // in ms

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var DocumentationSummaryController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DocumentationSummaryController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    showShareResourceDoc: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_DocumentationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getDefaultProps: function getDefaultProps() {
    return {
      showShareResourceDoc: true
    };
  },
  getInitialState: function getInitialState() {
    return {
      usePane: 'use-automatically',
      embedCodeCopied: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      publications: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'publications']
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.props.kitToken }),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(function (p) {
        return p.status === 'finished';
      })
    };
  },
  handleEmbedCodeCopied: function handleEmbedCodeCopied() {
    var _this = this;

    this.setState({ embedCodeCopied: true }, function () {
      setTimeout(function () {
        _this.setState({ embedCodeCopied: false });
      }, POPOVER_TIMEOUT);
    });
  },
  handleTabClicked: function handleTabClicked(event) {
    event.preventDefault();

    this.setState({ usePane: event.currentTarget.rel });
  },
  renderAlert: function renderAlert() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'layout-center-center well bg-danger bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning ficon-4x text-muted block m-xs-b-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-2x m-xs-b-md' }, 'This documentation is incomplete ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'until you publish.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead text-muted m-xs-b-0' }, 'You\'ll be able to use your kit\'s assets and we\'ll show you exactly how to use them here once you ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'publish your kit'), '.'));
  },
  renderAutomatically: function renderAutomatically() {
    var _resources = this.resources(),
        kit = _resources.kit;

    var embedCodeCopied = this.state.embedCodeCopied;

    var linkClasses = __WEBPACK_IMPORTED_MODULE_4_classnames___default()({ 'is-disabled': kit.hasNeverBeenPublished }, { 'text-gray-lighter': kit.hasNeverBeenPublished });
    var tabClass = this.state.usePane === 'use-automatically' ? 'active' : 'hide';
    var embedCodeScriptTag = '<script src="https://' + "use.fortawesome.com" + '/' + kit.token + '.js"></script>'; // eslint-disable-line no-undef
    var embedCodeCopiedPopover = embedCodeCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Embed Code Copied!' }) : null;
    var directCssLink = function directCssLink(type) {
      return 'https://' + "use.fortawesome.com" + '/kits/' + kit.token + '/publications/latest/' + type + '.css';
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { role: 'tabpanel', className: tabClass, id: 'use-automatically' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-lg' }, 'The easiest way to use your kit - no need to manually update source files, maximum performance optimization, and use your kit with a single line of code.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Publish Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit\'s documentation and bust any caches (with extreme prejudice). If you\'ve made a change you want to use, ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'make sure you publish'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Reference Your Kit in Your Code'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'After your kit has been published, ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'copy and paste the kit\'s unique embed code into the HTML of your website'), '. Make sure it goes near the top of your ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<head>'), ' tag.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted text-small m-xs-b-sm' }, 'This Kit\'s Embed Code'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-middle m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col pre text-sm bg-gray-dark inset-darkest font-family-monospace p-xs-x-md p-xs-y-sm br-l' }, embedCodeScriptTag), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, embedCodeCopiedPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard___default.a, { text: embedCodeScriptTag, onCopy: this.handleEmbedCodeCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0', title: 'Copy' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' }))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body has-icon m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-info-circle ficon-lg alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you\'re switching over to Fort Awesome from an existing icon font, don\'t forget to remove it from your website.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'If you\'re using Fort Awesome alongside an existing icon font (like Font Awesome), remember to use a different CSS prefix.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'If you\'d like to use the CSS directly you can reference the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: directCssLink('woff') }, 'WOFF CSS'), ', ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: directCssLink('woff2') }, 'WOFF2 CSS'), ', or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: directCssLink('eot') }, 'EOT CSS'), '.')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Call icons and typefaces in your UI'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'You\'ll then be able to call your icons and typefaces as you\'ve set them up. Learn how to use your ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/docs/icons', className: linkClasses }, 'icons'), ' and', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/docs/typefaces', className: linkClasses }, ' typefaces'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Still need help getting started? Check out ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { target: '_blank', href: 'https://articles.fortawesome.com/how-to-using-fort-awesome-icons-f50ab11a2d2a' }, 'our how-to article on using icons'), '.')));
  },
  renderManually: function renderManually() {
    var tabClass = this.state.usePane === 'use-manually' ? 'active' : 'hide';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { role: 'tabpanel', className: tabClass, id: 'use-manually' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-lg' }, 'Want to place your files just so and serve them up your way and in your existing workflows? We completely get that. You can do so while still getting Fort Awesome\'s variety, customization, and bulletproof rendering.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Publish Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit\'s documentation and bust any caches (with extreme prejudice). If you\'ve made a change you want to use,', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'make sure you publish'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Download Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'After your kit has been published, you\'ll want to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'download a fresh copy of your kit\'s contents'), ' and move them alongside your project\'s files.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Call icons and typefaces in your UI'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'Directly in your code, you\'ll then be able to call your icons and typefaces as you\'ve set them up.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'Each kit comes with detailed documentation on how to reference every asset you\'ve added'), '. Be sure to read and share it with your team.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Still need help getting started? Check out ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { target: '_blank', href: 'https://articles.fortawesome.com/how-to-serve-fort-awesome-assets-yourself-5419b88ee2d4' }, 'our how-to article on serving your kit\'s assets yourself'), '.')));
  },
  renderDesktop: function renderDesktop() {
    var tabClass = this.state.usePane === 'use-desktop' ? 'active' : 'hide';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { role: 'tabpanel', className: tabClass, id: 'use-desktop' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-lg' }, 'Looking to use your kit\'s icons in design-based desktop apps? You can them both as a icon-font (a la how you would use Font Awesome\'s cheatsheet) or leverage the raw SVG versions of each.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Publish Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit\'s documentation. If you\'ve made a change you want to use, ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'make sure you publish'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Download Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'After your kit has been published, you\'ll want to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'download a fresh copy of your kit\'s contents'), ' locally.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'm-xs-t-0 m-xs-b-xs text-lg' }, 'Use Icon Fonts or SVGs'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Find the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '*.otf'), ' files in your downloaded kit, set it as the font in your current desktop application, and copy and paste the icons (not the unicode) directly from your kit\'s documentation into your designs. Conversely, you can also open any of the individual ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '*.svg'), ' files for deeper manipulation.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Still need help getting started? Check out ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { target: '_blank', href: 'https://articles.fortawesome.com/how-to-fort-awesome-assets-on-the-desktop-e3fd15df6f43' }, 'our how-to article on use your kit\'s assets on the desktop'), '.')));
  },
  renderMain: function renderMain() {
    var _resources2 = this.resources(),
        kit = _resources2.kit,
        finishedPublications = _resources2.finishedPublications;

    var useAutomaticallyClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('nav-item', { active: this.state.usePane === 'use-automatically' });
    var useManuallyClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('nav-item', { active: this.state.usePane === 'use-manually' });
    var useDesktopClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('nav-item', { active: this.state.usePane === 'use-desktop' });
    var alertHtml = finishedPublications.isEmpty() ? this.renderAlert() : '';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-push-9 p-xs-l-xl' }, this.renderNavigation(kit, { hasBeenPublished: !finishedPublications.isEmpty() })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-pull-3' }, alertHtml, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'get-started-build m-xs-b-xl', id: 'get-started-build' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Build your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If you haven\'t already, you\'ll want to add icons and typefaces for your site to use. Fort Awesome will take it from there when it comes to performance, and ease of use. Not sure where to start? Here are a few pointers:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body has-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-star ficon-lg alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, 'Add Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Take advantage of ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/sets/starter' }, 'our starter icon library'), ', other ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/sets/premium' }, 'premium icon sets'), ', or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/icons/upload' }, 'upload your own icons'), ' to round out the perfect look and set for your site.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body has-icon m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-font ficon-lg alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, 'Add Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Have Fort Awesome manage and render your site\'s typefaces too. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/typefaces/new' }, 'Choose from our included typefaces'), ' or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/typefaces/upload' }, 'upload your own'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'get-started-use m-xs-b-xl', id: 'get-started-use' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'How to use your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-' }, 'Once you\'ve added some icons, typefaces, and settings, you\'ve got a few options for easily using your kit in your project.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'nav nav-tabs-inline m-xs-b-lg', role: 'tablist' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: useAutomaticallyClass }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', rel: 'use-automatically', role: 'tab', onClick: this.handleTabClicked }, 'Automatically served by Fort Awesome')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: useManuallyClass }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', rel: 'use-manually', role: 'tab', onClick: this.handleTabClicked }, 'Manually served by you')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: useDesktopClass }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'nav-link', href: '#', rel: 'use-desktop', role: 'tab', onClick: this.handleTabClicked }, 'Desktop app use'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-content p-xs-l-lg p-xs-r-lg' }, this.renderAutomatically(), this.renderManually(), this.renderDesktop())))));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-documentation-summary m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_9_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(DocumentationSummaryController));

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icons_Copy__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_KitFrame__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_kit__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_DocumentationMixin__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Spinner__ = __webpack_require__(13);

















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations
  };
};

var DocumentationIconsController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DocumentationIconsController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitMutations: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_DocumentationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      copiedUnicodeChar: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      publications: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'publications']
      })
    });

    this.setRequest({
      iconSettings: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'icon-settings']
      })
    });

    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_10_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_10_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons']
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.props.kitToken }),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(function (p) {
        return p.status === 'finished';
      }),
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all()
    };
  },
  handleIconCopied: function handleIconCopied(unicodeChar) {
    var _this = this;

    this.setState({
      copiedUnicodeChar: unicodeChar
    }, function () {
      setTimeout(function () {
        _this.setState({ copiedUnicodeChar: null });
      }, 2000);
    });
  },
  renderPrefixAlert: function renderPrefixAlert() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-danger bg-body has-icon m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-warning alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Heads up! You\'re using the same icon prefix (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, 'fa-'), ') as ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'http://fontawesome.io/', target: '_blank' }, 'Font Awesome'), ' uses. If you want to keep using both, you should either 1) change your kit\'s icon prefix (found in icon settings) to avoid any icon collisions, or add all of the Font Awesome icons you\'re using into your kit and remove the reference to Font Awesome.'));
  },
  renderIconsInKit: function renderIconsInKit() {
    var _this2 = this;

    var _resources = this.resources(),
        kit = _resources.kit,
        iconSettings = _resources.iconSettings,
        workingSetIcons = _resources.workingSetIcons;

    var sortedWorkingSetIcons = workingSetIcons.sortBy(function (record) {
      return record.createdAt.unix();
    }).reverse();
    var unpublishedIcons = Object(__WEBPACK_IMPORTED_MODULE_13__utils_kit__["a" /* iconsAdded */])(this.props.kitMutations, this.props.kitToken).map(function (request) {
      return request.getIn(['record', 'icon']);
    });
    var iconElements = sortedWorkingSetIcons.filter(function (workingSetIcon) {
      return !unpublishedIcons.includes(workingSetIcon.name);
    }).map(function (workingSetIcon, index) {
      var unicodeChar = String.fromCodePoint(parseInt(workingSetIcon.unicodeChar, 16));
      var handleIconCopied = function handleIconCopied() {
        return _this2.handleIconCopied(unicodeChar);
      };
      var copiedAlert = null;

      if (_this2.state.copiedUnicodeChar === unicodeChar) {
        copiedAlert = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-success alert-copy-confirmation m-xs-b-0 text-xs-center block text-white br-a p-xs-x-sm p-xs-y-xs p-xs-t-md', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Copied'));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: workingSetIcon.id, className: 'asset asset-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-preview m-xs-b-xs' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: workingSetIcon.prefix + ' ' + workingSetIcon.prefix + '-lg' }, unicodeChar)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-label text-base' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-gray-darker font-weight-semibold block m-xs-b-xs' }, workingSetIcon.cssName), copiedAlert, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon-label-details block' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-muted m-xs-r-xs inline-block valign-middle' }, workingSetIcon.unicodeChar), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_copy_to_clipboard___default.a, { text: unicodeChar, onCopy: handleIconCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { title: 'Copy to clipboard', className: 'btn btn-link link-dashed-none m-xs-x-0 m-xs-l-sm text-muted inline-block valign-middle' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icons_Copy__["a" /* default */], { height: '12px', width: '12px' }))))));
    });
    var kitFrameElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_KitFrame__["a" /* default */], { kitToken: kit.token }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'grid-assets grid-assets-xs-6' }, iconElements));
    var noIconsElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x' }, 'This Kit Doesn\'t Have Any Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead m-xs-b-0 text-muted' }, 'Hey. It looks like you don\'t have any icons currently in this kit. Its pretty easy to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/icons/new', className: 'text-white' }, 'add some'), ' or even ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/icons/upload', className: 'text-white' }, 'upload your own'), '.'));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { id: 'kit-components-icons-inventory', className: 'kit-components-icons-inventory m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Icons in this Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-t-sm m-xs-b-md' }), iconElements.isEmpty() ? noIconsElement : kitFrameElement, iconSettings.cssPrefix === 'fa' ? this.renderPrefixAlert() : '');
  },
  renderIconSizes: function renderIconSizes(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Larger Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'To increase icon sizes relative to their container, add one of the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-lg'), ' (33% increase),', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-2x'), ', ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-3x'), ', ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-4x'), ', or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-5x'), 'classes.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search ficon-lg' }), ' ', cssPrefix, '-lg'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search ficon-2x' }), ' ', cssPrefix, '-2x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search ficon-3x' }), ' ', cssPrefix, '-3x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search ficon-4x' }), ' ', cssPrefix, '-4x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search ficon-5x' }), ' ', cssPrefix, '-5x')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-search ', cssPrefix, '-lg"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-lg'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-search ', cssPrefix, '-2x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-2x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-search ', cssPrefix, '-3x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-3x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-search ', cssPrefix, '-4x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-4x'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-search ', cssPrefix, '-5x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-5x'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body has-icon m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-info-circle ficon-lg alert-icon' }), ' If your icons are getting chopped off on top and bottom, make sure you have sufficient line-height.'));
  },
  renderIconFixedWidth: function renderIconFixedWidth(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Fixed Width Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Use ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-fw'), ' to set icons at a fixed width. Great to use when different icon widths throw off alignment. Especially useful in things like nav lists & list groups.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-4' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-group m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'list-group-item', href: '#' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-home ficon-fw' }), '\xA0 Home'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'list-group-item', href: '#' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-book ficon-fw' }), '\xA0 Library'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'list-group-item', href: '#' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-pencil ficon-fw' }), '\xA0 Applications'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'list-group-item', href: '#' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear ficon-fw' }), '\xA0 Settings'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-home ', cssPrefix, '-fw"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' Home'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-book ', cssPrefix, '-fw"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' Library'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-pencil ', cssPrefix, '-fw"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' Applications'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-cog ', cssPrefix, '-fw"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' Settings'))));
  },
  renderIconLists: function renderIconLists(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'List Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Use ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-ul'), ' and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-li'), ' to easily replace default bullets in unordered lists.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'ficon-ul m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon-li ficon ficon-check-square' }), ' List icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon-li ficon ficon-check-square' }), ' can be used'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon-li ficon ficon-spinner ficon-spin' }), ' as bullets'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon-li ficon ficon-square' }), ' in lists'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<ul'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-ul"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<li><i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-li ', cssPrefix, ' ', cssPrefix, '-check-square"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), 'List icons', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</li>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<li><i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-li ', cssPrefix, ' ', cssPrefix, '-check-square"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), 'can be used', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</li>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<li><i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-li ', cssPrefix, ' ', cssPrefix, '-spinner ', cssPrefix, '-spin"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), 'as bullets', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</li>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<li><i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-li ', cssPrefix, ' ', cssPrefix, '-square"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), 'in lists', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</li>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</ul>')))));
  },
  renderIconBordered: function renderIconBordered(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Bordered & Pulled Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Use ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-border'), ' and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, 'pull-right'), ' or ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, 'pull-left'), 'for easy pull quotes or article icons.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-quote-left ficon-3x pull-left ficon-border' }), ' Gatsby believed in the green light, the orgastic future that year by year recedes before us. It eluded us then, but that\u2019s no matter\u2014tomorrow we will run faster, stretch out our arms farther\u2026 And then one fine morning\u2014 So we beat on, boats against the current, borne back ceaselessly into the past.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-quote-left ', cssPrefix, '-3x pull-left ', cssPrefix, '-border"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), 'Gatsby believed in the green light...')));
  },
  renderIconAnimated: function renderIconAnimated(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Animated Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Use the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-spin'), ' class to get any icon to rotate. Works well with ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-spinner'), ', ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-refresh'), ', and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-cog'), '.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'btn btn-secondary btn-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-spinner ficon-spin' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'btn btn-secondary btn-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-sync ficon-spin' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'btn btn-secondary btn-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-gear ficon-spin' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-spinner ', cssPrefix, '-spin"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-refresh ', cssPrefix, '-spin"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-cog ', cssPrefix, '-spin"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-warning bg-body has-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning ficon-lg alert-icon' }), ' Just a heads up. CSS3 animations aren\'t supported in IE8 - IE9.'));
  },
  renderIconRotated: function renderIconRotated(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Rotated & Flipped'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'To arbitrarily rotate and flip icons, use the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-rotate-*'), 'and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-flip-*'), ' classes.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag' }), '\xA0 normal', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-rotate-90' }), '\xA0fa-rotate-90', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-rotate-180' }), '\xA0fa-rotate-180', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-rotate-270' }), '\xA0fa-rotate-270', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-flip-horizontal' }), '\xA0fa-flip-horizontal', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-flip-vertical' }), '\xA0fa-flip-vertical')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' normal'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-rotate-90"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-rotate-90'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-rotate-180"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-rotate-180'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-rotate-270"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-rotate-270'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-flip-horizontal"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-flip-horizontal'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-flip-vertical"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), ' ', cssPrefix, '-flip-vertical'))));
  },
  renderIconStacked: function renderIconStacked(cssPrefix) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Stacked Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'To stack multiple icons, use the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-stack'), ' class on the parent, the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-stack-1x'), ' for the regularly sized icon, and ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-stack-2x'), 'for the larger icon. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, cssPrefix, '-inverse'), ' can be used as an alternative icon color. You can even throw larger icon classes on the parent to get further control of sizing.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains icons which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'ficon-stack ficon-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-square-o ficon-stack-2x' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-twitter ficon-stack-1x' })), cssPrefix, '-twitter on ', cssPrefix, '-square-o', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'ficon-stack ficon-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-circle ficon-stack-2x' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-flag ficon-stack-1x ficon-inverse' })), cssPrefix, '-flag on ', cssPrefix, '-circle', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'ficon-stack ficon-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-square ficon-stack-2x' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-code ficon-stack-1x ficon-inverse' })), cssPrefix, '-code on ', cssPrefix, '-square', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'ficon-stack ficon-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-camera ficon-stack-1x' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-ban ficon-stack-2x text-danger' })), cssPrefix, '-ban on ', cssPrefix, '-camera'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'p-xs-b-md-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<span'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-stack ', cssPrefix, '-lg"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-square-o ', cssPrefix, '-stack-2x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-twitter ', cssPrefix, '-stack-1x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</span>'), ' ', cssPrefix, '-twitter on ', cssPrefix, '-square-o', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'p-xs-b-md-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<span'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-stack ', cssPrefix, '-lg"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-circle ', cssPrefix, '-stack-2x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-flag ', cssPrefix, '-stack-1x ', cssPrefix, '-inverse"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</span>'), ' ', cssPrefix, '-flag on ', cssPrefix, '-circle', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<br>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'p-xs-b-md-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<span'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-stack ', cssPrefix, '-lg"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-square ', cssPrefix, '-stack-2x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-code ', cssPrefix, '-stack-1x ', cssPrefix, '-inverse"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</span>'), ' ', cssPrefix, '-code on ', cssPrefix, '-square', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<br>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'p-xs-b-md-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<span'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, '-stack ', cssPrefix, '-lg"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-camera ', cssPrefix, '-stack-1x"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '\xA0\xA0\xA0<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', cssPrefix, ' ', cssPrefix, '-ban ', cssPrefix, '-stack-2x text-danger"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '</span>'), ' ', cssPrefix, '-ban on ', cssPrefix, '-camera'))));
  },
  renderIconManual: function renderIconManual() {
    var _resources2 = this.resources(),
        kit = _resources2.kit;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Using CSS Only'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can render icons purely using CSS (rather than through dedicated HTML elements).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'css' }, '.icon-selector ', '{', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-family: \'', kit.subsetName, '\';', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0display: inline-block;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-size: inherit;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-weight: normal;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-style: normal;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0line-height: 1;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0text-rendering: auto;', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '}', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '.icon-selector:before ', '{', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0content: \'\\f001\'; /* your icon\'s unicode here */', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '}')));
  },
  renderUsingIconsOnWeb: function renderUsingIconsOnWeb() {
    var _resources3 = this.resources(),
        iconSettings = _resources3.iconSettings;

    var cssPrefix = iconSettings.cssPrefix;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-icons-use m-xs-b-xl', id: 'kit-components-icons-use-web' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Using your icons on the web'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'You can place your Fort Awesome icons just about anywhere using your CSS kit prefix', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, iconSettings.cssPrefix), ' and the icon\'s name. Fort Awesome icons are designed to be used with inline elements (we like the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<i>'), ' tag, but you can use ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<span>'), ' too).'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm text-upper text-muted' }, 'Example'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon-2339 fa fa-search' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<i'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, ' class='), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, '"', iconSettings.cssPrefix, ' ', iconSettings.cssPrefix, '-search"'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '></i>'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body has-icon m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-info-circle alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'If you change the font-size of the icon\'s container, the icon gets bigger. Same things goes for color, drop shadow, and anything else you can imagine with CSS.'))), iconSettings.largerIconSizes ? this.renderIconSizes(cssPrefix) : '', iconSettings.fixedWidthIcons ? this.renderIconFixedWidth(cssPrefix) : '', iconSettings.listIcons ? this.renderIconLists(cssPrefix) : '', iconSettings.borderedPulledIcons ? this.renderIconBordered(cssPrefix) : '', iconSettings.spinningIcons ? this.renderIconAnimated(cssPrefix) : '', iconSettings.rotatedFlippedIcons ? this.renderIconRotated(cssPrefix) : '', iconSettings.stackedIcons ? this.renderIconStacked(cssPrefix) : '', this.renderIconManual());
  },
  renderUsingIconsOnDesktop: function renderUsingIconsOnDesktop() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-icons-use m-xs-b-xl', id: 'kit-components-icons-use-desktop' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Using your icons on the desktop'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Looking to use your kit\'s icons in design-based desktop apps? You can them both as a icon-font (a la how you would use Font Awesome\'s cheatsheet) or leverage the raw SVG versions of each.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'm-xs-t-0 m-xs-b-xs text-base' }, 'Publish Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit\'s documentation. If you\'ve made a change you want to use, ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'make sure you publish'), '.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'm-xs-t-0 m-xs-b-xs text-base' }, 'Download Your Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'After your kit has been published, you\'ll want to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', { className: 'font-weight-semibold' }, 'download a fresh copy of your kit\'s contents'), ' locally.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg gg-top m-xs-b-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'm-xs-t-0 m-xs-b-xs text-base' }, 'Use Icon Fonts or SVGs'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Find the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '*.otf'), ' files in your downloaded kit, set it as the font in your current desktop application, and copy and paste the icons (not the unicode) directly from your kit\'s documentation into your designs. Conversely, you can also open any of the individual ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '*.svg'), ' files for deeper manipulation.'))));
  },
  renderTroubleshootingIcons: function renderTroubleshootingIcons() {
    var _resources4 = this.resources(),
        iconSettings = _resources4.iconSettings;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-icons-troubleshooting', id: 'kit-components-icons-troubleshooting' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Troubleshooting Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'typefaces-weights m-xs-b-lg', id: 'typefaces-weights' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'My kit\'s icons aren\'t showing up on my pages'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If your icons aren\'t rendering properly, you\'ll want to check the following:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you published all changes/updates to you kit?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you either reference your kit\'s embed code or the path to downloaded assets in your pages\' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<head>'), '?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you reference the correct icon name? Check for typos (we know by experience)!'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Are you using any other Icon Font libraries with the same kit prefix (', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, iconSettings.cssPrefix, '-'), ') as your kit?'))));
  },
  renderUnpublishedChangesAlert: function renderUnpublishedChangesAlert() {
    var retval = null;

    var kitMutations = this.props.kitMutations;

    var _resources5 = this.resources(),
        kit = _resources5.kit;

    var iconsHaveBeenAdded = !Object(__WEBPACK_IMPORTED_MODULE_13__utils_kit__["a" /* iconsAdded */])(kitMutations, kit.token).isEmpty();

    if (iconsHaveBeenAdded) {
      retval = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body has-icon m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-warning alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Hmm, you\'ve added some icons that you haven\'t published yet. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Publish to see them here'), ' and to use them in your project.'));
    }

    return retval;
  },
  renderMain: function renderMain() {
    var _resources6 = this.resources(),
        kit = _resources6.kit,
        finishedPublications = _resources6.finishedPublications;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-push-9 p-xs-l-xl' }, this.renderNavigation(kit, { hasBeenPublished: !finishedPublications.isEmpty() })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-pull-3' }, this.renderUnpublishedChangesAlert(), this.renderIconsInKit(), this.renderUsingIconsOnWeb(), this.renderUsingIconsOnDesktop(), this.renderTroubleshootingIcons()));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-documentation-icons m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_15_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps)(DocumentationIconsController));

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);





var noop = function noop() {};
var FIX_IFRAME_HEIGHT_INTERVAL = 200; // in ms

var Frame = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Frame',

  propTypes: {
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    initialContent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    mountTarget: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    contentDidMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    contentDidUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initialContent: '<!DOCTYPE html><html><head></head><body><div></div></body></html>',
      contentDidMount: noop,
      contentDidUpdate: noop
    };
  },
  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    this.renderFrameContents();
  },
  componentDidUpdate: function componentDidUpdate() {
    this.renderFrameContents();
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;

    var doc = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).contentDocument;

    if (doc) {
      __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unmountComponentAtNode(doc.body);
    }
  },
  getEmbedCodeScriptNode: function getEmbedCodeScriptNode() {
    var element = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).contentDocument.createElement('script');

    element.setAttribute('src', 'https://' + "use.fortawesome.com" + '/' + this.props.kitToken + '.js'); // eslint-disable-line no-undef

    return element;
  },
  resizeIFrame: function resizeIFrame() {
    if (!this._isMounted) {
      return;
    }

    var iframeElement = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this);
    var contentDocument = iframeElement.contentDocument;
    var correctHeight = contentDocument.querySelector('body > div').scrollHeight;

    if (iframeElement.height !== correctHeight) {
      iframeElement.height = correctHeight;
    }

    this._resizeIFrameTimer = setTimeout(this.resizeIFrame, FIX_IFRAME_HEIGHT_INTERVAL);
  },
  renderFrameContents: function renderFrameContents() {
    if (!this._isMounted) {
      return;
    }

    var doc = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).contentDocument;

    if (doc && doc.readyState === 'complete') {
      var initialRender = !this._setInitialContent;
      var contents = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', undefined, this.props.children);

      if (!this._setInitialContent) {
        doc.open();
        doc.write(this.props.initialContent);
        doc.close();

        doc.body.classList.add('iframe-body');
        doc.body.classList.add('v-kit-doc-partial');
        doc.head.appendChild(document.head.querySelector('link[data-style="main"]').cloneNode());
        doc.head.appendChild(this.getEmbedCodeScriptNode());

        this._setInitialContent = true;
      }

      var callback = initialRender ? this.props.contentDidMount : this.props.contentDidUpdate;
      var mountTarget = void 0;

      if (this.props.mountTarget) {
        mountTarget = doc.querySelector(this.props.mountTarget);
      } else {
        mountTarget = doc.body.children[0];
      }

      __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, contents, mountTarget, callback);

      this.resizeIFrame();
    } else {
      setTimeout(this.renderFrameContents, 0);
    }
  },
  render: function render() {
    var props = Object.assign({}, this.props);

    delete props.initialContent;
    delete props.contentDidMount;
    delete props.contentDidUpdate;
    delete props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', Object.assign({ style: { border: 'none', width: '100%' }, scrolling: 'no' }, props, { children: undefined }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Frame);

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_records__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_KitFrame__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_kit__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_DocumentationMixin__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Spinner__ = __webpack_require__(13);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations
  };
};

var DocumentationTypefacesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DocumentationTypefacesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitMutations: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_DocumentationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      publications: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'publications']
      })
    });

    this.setRequest({
      iconSettings: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'icon-settings']
      })
    });

    this.setRequest({
      workingSetTypefaces: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces']
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.props.kitToken }),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(function (p) {
        return p.status === 'finished';
      }),
      iconSettings: rm.type(this.requests.iconSettings, 'icon-settings').get(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all()
    };
  },
  renderUsingTypefacesOnWeb: function renderUsingTypefacesOnWeb() {
    var _resources = this.resources(),
        kit = _resources.kit,
        iconSettings = _resources.iconSettings;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-typefaces-use m-xs-b-xl', id: 'kit-components-typefaces-use' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Using your typefaces on the web'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Fort Awesome takes care of the set up (using CSS\'s ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '@font-face'), ') of using custom fonts on the web. If you are using Fort Awesome\'s CDN, all you need do is follow the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/docs' }, 'getting started instructions'), ' to publish (or download) your kit and reference its updated embed code in your project.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Once you are referencing your kit\'s assets, you have a couple of ways you can call your typefaces:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Referencing font names in your CSS rules (recommended)'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Fort Awesome takes the names you gave your kit\'s typefaces and creates unique ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, 'font-family'), 'names you can reference within your project\'s CSS. You have typographical control and can make broad rules so that as much or as little of your content renders in a specific font. Below are examples of rules to add to your CSS.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains typefaces which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'css' }, '// I\'m a broad reference', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'body ', '{', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-family: "Lato";', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0...', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '}')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains typefaces which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'css' }, '// I\'m a very specific reference', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'footer.app .about ', '{', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-family: "Lato";', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0...', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '}'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'example m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'Using utility classes in your HTML'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'Fort Awesome also creates some useful preset CSS rules and HTML class names to make it easier to display the right typeface in a pinch. After you publish your kit, you\'ll be able to add a unique per-typeface ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, 'class'), ' attribute to any HTML element.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains typefaces which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, '<p class="', iconSettings.cssPrefix, '-lato">', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0This text will be rendered in Lato', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '</p>')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'This example contains typefaces which may not be in your kit')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, '<p class="', iconSettings.cssPrefix, '-lato">', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0This text will be rendered in Lato,', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0<span class="', iconSettings.cssPrefix, '-open-sans"> while this text will be rendered in Open Sans </span>', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '</p>'))));
  },
  renderTypefacesInKit: function renderTypefacesInKit() {
    var _resources2 = this.resources(),
        kit = _resources2.kit,
        workingSetTypefaces = _resources2.workingSetTypefaces;

    var groupedWorkingSetTypefaces = workingSetTypefaces.groupBy(function (workingSetTypeface) {
      return workingSetTypeface.family;
    });
    var unpublishedTypefaces = Object(__WEBPACK_IMPORTED_MODULE_12__utils_kit__["d" /* typefacesAdded */])(this.props.kitMutations, this.props.kitToken).map(function (request) {
      return request.getIn(['record', 'typefaceId']);
    });

    var typefacesList = groupedWorkingSetTypefaces.map(function (groupedList, index) {
      var sortedList = groupedList.sortBy(function (record) {
        return record.weight;
      });
      var workingSetTypeface = sortedList.first();
      var styleLength = sortedList.size;

      var typefacesStylesList = sortedList.filter(function (typeface) {
        return !unpublishedTypefaces.includes(typeface.typeface);
      }).map(function (typeface, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: typeface.id, className: 'kit-typeface-pangram text-2x', style: { fontFamily: typeface.family, fontWeight: typeface.weight, fontStyle: typeface.style } }, 'When my six o\u2019clock alarm buzzes, I require a pot of good java.');
      });

      if (typefacesStylesList.size === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { key: workingSetTypeface.family, className: 'kit-typeface kit-typeface-arvo m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-body br-t well p-xs-a-lg m-xs-b-0' }, typefacesStylesList), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-y-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base text-muted m-xs-b-lg' }, workingSetTypeface.family, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'pull-right font-weight-normal' }, styleLength, ' ', styleLength > 1 ? 'styles' : 'style')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-base m-xs-b-0 font-weight-normal' }, 'Using in CSS')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'css' }, '.element ', '{', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-family: "', workingSetTypeface.family, '";', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0...', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0// optional styling', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-weight: ', workingSetTypeface.weight, ';', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\xA0\xA0font-style: ', workingSetTypeface.style, ';', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '}')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-gray-lightest text-sm text-muted br-b-0 m-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-base m-xs-b-0 font-weight-normal' }, 'Using in HTML')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre', { className: 'bg-gray-dark inset-darkest br-b p-xs-a-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', { className: 'html' }, '<h2 class="', workingSetTypeface.cssClass, '">I\'m a heading using a utility class<h2>')));
    });
    var kitFrameElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_KitFrame__["a" /* default */], { kitToken: kit.token }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [].concat(_toConsumableArray(typefacesList))));
    var noTypefacesElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x' }, 'This Kit Doesn\'t Have Any Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead m-xs-b-0 text-muted' }, 'Hey. It looks like you don\'t have any typefaces currently in this kit. Its pretty easy to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/typefaces/new', className: 'text-white' }, 'add some'), ' or even ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/typefaces/upload', className: 'text-white' }, 'upload your own'), '.'));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-typefaces-inventory m-xs-b-xl', id: 'kit-components-typefaces-inventory' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Typefaces in this kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), typefacesList.isEmpty() ? noTypefacesElement : kitFrameElement);
  },
  renderTroubleshootingTypefaces: function renderTroubleshootingTypefaces() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { className: 'kit-components-typefaces-troubleshooting', id: 'kit-components-typefaces-troubleshooting' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Troubleshooting Typefaces'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'typefaces-not-rendering m-xs-b-lg', id: 'typefaces-not-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'My kit\'s typefaces aren\'t rendering properly on my site or app'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If your typefaces aren\'t rendering properly, you\'ll want to check the following:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you published all changes/updates to you kit?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you either referenced your kit\'s embed code or the path to downloaded assets in your pages\' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<head>'), '?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you named your typefaces uniquely (to avoid different versions of a typefaces found on users\' local operating systems)?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you added the provided font-family names in your own CSS or used the utility HTML class names correctly?'))));
  },
  renderUnpublishedChangesAlert: function renderUnpublishedChangesAlert() {
    var retval = null;

    var kitMutations = this.props.kitMutations;

    var _resources3 = this.resources(),
        kit = _resources3.kit;

    var typefacesHaveBeenAdded = !Object(__WEBPACK_IMPORTED_MODULE_12__utils_kit__["d" /* typefacesAdded */])(kitMutations, kit.token).isEmpty();

    if (typefacesHaveBeenAdded) {
      retval = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body has-icon m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-warning alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Hmm, you\'ve added some typefaces that you haven\'t published yet. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Publish to see them here'), ' and to use them in your project.'));
    }

    return retval;
  },
  renderMain: function renderMain() {
    var _resources4 = this.resources(),
        kit = _resources4.kit,
        finishedPublications = _resources4.finishedPublications;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-push-9 p-xs-l-xl' }, this.renderNavigation(kit, { hasBeenPublished: !finishedPublications.isEmpty() })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-pull-3' }, this.renderUnpublishedChangesAlert(), this.renderTypefacesInKit(), this.renderUsingTypefacesOnWeb(), this.renderTroubleshootingTypefaces()));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-documentation-typefaces m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_14_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(DocumentationTypefacesController));

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_records__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_copy_to_clipboard__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_kit__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_DocumentationMixin__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers_publish__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Tooltip__ = __webpack_require__(14);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}




















var POPOVER_TIMEOUT = 2000; // in ms

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests,
    kitMutations: state.kitMutations
  };
};

var DocumentationImagesController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DocumentationImagesController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kitMutations: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_DocumentationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      sizes: Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"])(),
      loadingFailed: Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])(),
      cdnUrlCopied: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_14_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_14_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      publications: new __WEBPACK_IMPORTED_MODULE_14_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_14_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'publications']
      })
    });

    this.setRequest({
      workingSetImages: new __WEBPACK_IMPORTED_MODULE_14_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_14_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-images']
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({ token: this.props.kitToken }),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(function (p) {
        return p.status === 'finished';
      }),
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all()
    };
  },
  handleCdnUrlClicked: function handleCdnUrlClicked(event) {
    event.target.select();
  },
  handleCdnUrlCopied: function handleCdnUrlCopied(workingSetImage) {
    var _this = this;

    var disable = function disable() {
      return _this.setState({ cdnUrlCopied: false });
    };

    this.setState({ cdnUrlCopied: workingSetImage }, function () {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },
  renderImagesInKit: function renderImagesInKit() {
    var _this2 = this;

    var cdnUrlCopied = this.state.cdnUrlCopied;

    var _resources = this.resources(),
        kit = _resources.kit,
        workingSetImages = _resources.workingSetImages;

    var unpublishedImages = Object(__WEBPACK_IMPORTED_MODULE_11__utils_kit__["b" /* imagesAdded */])(this.props.kitMutations, this.props.kitToken).map(function (request) {
      return request.getIn(['record', 'name']);
    });

    var imageElements = workingSetImages.filter(function (workingSetImage) {
      return workingSetImage.status === "finished";
    }).filterNot(function (workingSetImage) {
      return unpublishedImages.includes(workingSetImage.name);
    }).sortBy(function (workingSetImage) {
      return workingSetImage.createdAt.unix();
    }).reverse().map(function (workingSetImage) {
      var percentLeft = workingSetImage.optimizedSize / workingSetImage.originalSize * 100;
      var handleCdnUrlClicked = function handleCdnUrlClicked(event) {
        event.target.select();
      };
      var handleCdnUrlCopied = function handleCdnUrlCopied(event) {
        _this2.handleCdnUrlCopied(workingSetImage);
      };
      var handleImageLoaded = function handleImageLoaded(event) {
        _this2.setState({
          sizes: _this2.state.sizes.set(workingSetImage.id, [event.target.naturalWidth, event.target.naturalHeight])
        });
      };
      var handleImageError = function handleImageError() {
        _this2.setState({
          loadingFailed: _this2.state.loadingFailed.push(workingSetImage.id)
        });
      };
      var loadingFailed = _this2.state.loadingFailed.includes(workingSetImage.id);
      var imageSize = _this2.state.sizes.get(workingSetImage.id, null);
      var cdnUrlCopied = _this2.state.cdnUrlCopied === workingSetImage;
      var cdnUrlCopiedPopover = cdnUrlCopied ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Tooltip__["d" /* default */], { noIcon: true, content: 'Link Copied!' }) : null;

      var sizeLabel = imageSize ? imageSize[0] + ' x ' + imageSize[1] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Loading \u2026');

      var imgElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'link-dashed-none block text-xs-center', href: workingSetImage.publishedUrl, target: '_blank', title: 'view original file' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onLoad: handleImageLoaded, onError: handleImageError, className: 'asset-source', src: workingSetImage.publishedUrl, alt: workingSetImage.name }));

      if (_this2.state.loadingFailed.includes(workingSetImage.id)) {
        imgElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-alert' }), ' Failed to load this image. Did you publish?');
        sizeLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u2014');
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: workingSetImage.id, className: 'm-xs-b-xl asset asset-image' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-preview bg-img-checkered' }, imgElement), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'image-performance-sm bg-primary-light m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'image-performance-value br-r bg-primary', style: { width: percentLeft + '%' } })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'asset-label text-sm row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 text-truncate' }, workingSetImage.name)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 text-xs-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'File size: '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-primary' }, __WEBPACK_IMPORTED_MODULE_10_numeral___default()(workingSetImage.optimizedSize).format('0.0 b')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-primary-lighter m-xs-l-xs text-strike' }, __WEBPACK_IMPORTED_MODULE_10_numeral___default()(workingSetImage.originalSize).format('0.0 b'))))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6 p-xs-r-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'table table-condensed text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-dimensions' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap sr-only' }, 'Dimensions'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'p-xs-x-0 p-xs-t-0 b-t-0' }, sizeLabel)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-cdn-url' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap sr-only' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'm-xs-t-sm block' }, 'CDN URL')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'has-tooltip p-xs-x-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col p-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onClick: handleCdnUrlClicked, className: 'table bg-white form-control-static p-xs-a-0 br-r-0 block b-a-0 text-truncate', defaultValue: workingSetImage.publishedUrl })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width has-tooltip' }, cdnUrlCopiedPopover, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_copy_to_clipboard___default.a, { text: workingSetImage.publishedUrl, onCopy: handleCdnUrlCopied }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'copy-control btn btn-primary btn-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-copy' }))))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { className: 'asset-use' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { scope: 'row', className: 'text-nowrap sr-only' }, 'HTML use'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'p-xs-x-0' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'code code-highlight word-wrap' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '<img'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'src="'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 's' }, workingSetImage.publishedUrl), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, '"'), '\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'na' }, 'alt=""'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'nt' }, '>'))))))))));
    });

    var noImagesElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-primary bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x' }, 'This Kit Doesn\'t Have Any Images'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'lead m-xs-b-0 text-muted' }, 'Hey. It looks like you don\'t have any images currently in this kit. Its pretty easy to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* Link */], { to: '/kits/' + kit.token + '/images/upload', className: 'text-white' }, 'upload some'), '.'));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { id: 'kit-components-images-inventory', className: 'kit-components-images-inventory kit-assets-images kit-assets-images-lg m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Images in this Kit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), imageElements.isEmpty() ? noImagesElement : [].concat(_toConsumableArray(imageElements)));
  },
  renderUnpublishedChangesAlert: function renderUnpublishedChangesAlert() {
    var retval = null;

    var kitMutations = this.props.kitMutations;

    var _resources2 = this.resources(),
        kit = _resources2.kit;

    var imagesHaveBeenAdded = !Object(__WEBPACK_IMPORTED_MODULE_11__utils_kit__["b" /* imagesAdded */])(kitMutations, kit.token).isEmpty();

    if (imagesHaveBeenAdded) {
      retval = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body has-icon m-xs-b-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-lg ficon-warning alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0' }, 'Hmm, you\'ve added some images that you haven\'t published yet. ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Publish to see them here'), ' and to use them in your project.'));
    }

    return retval;
  },
  renderTroubleshootingImages: function renderTroubleshootingImages() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section', { id: 'kit-components-images-troubleshooting', className: 'kit-components-images-troubleshooting' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { className: 'text-2x m-xs-b-0' }, 'Troubleshooting Images'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'hr-lg m-xs-y-sm' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article', { className: 'images-not-rendering m-xs-b-lg', id: 'images-not-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-lg' }, 'My kit\'s images aren\'t rendering properly on my site or app'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, 'If your images aren\'t rendering properly, you\'ll want to check the following:'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Did you published all changes/updates to you kit?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, 'Is your markup correct? Both the image URL and the ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code', null, '<img />'), ' tag need to be correct.'))));
  },
  renderMain: function renderMain() {
    var _resources3 = this.resources(),
        kit = _resources3.kit,
        finishedPublications = _resources3.finishedPublications;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-3 col-xs-push-9 p-xs-l-xl' }, this.renderNavigation(kit, { hasBeenPublished: !finishedPublications.isEmpty() })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-pull-3' }, this.renderUnpublishedChangesAlert(), this.renderImagesInKit(), this.renderTroubleshootingImages()));
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'is-loading is-loading-documentation-images m-xs-x-0 bg-body p-xs-a-xl br-a' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_16_components_Spinner__["b" /* SIZE_LARGE */] }));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["d" /* ResourcesMatching */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["c" /* Requesting */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components__["a" /* Done */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(DocumentationImagesController));

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localstorage__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_requests_components__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OptimizedForSelect__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HelpUploadingIcons__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SvgInspection__ = __webpack_require__(478);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};



















var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    requests: state.requests
  };
};

var NewWorkingSetIcon = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Record"])({
  name: null,
  optimizedFor: null,
  logo: false,
  svg: '',
  ignoreWarnings: false
});

var UploadIconForm = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UploadIconForm',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    onUploadIconClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onNotAllowed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isLogo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isAllowed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_7_react_localstorage___default.a, __WEBPACK_IMPORTED_MODULE_6_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    return {
      name: '',
      optimizedFor: '14px',
      showPasteSvgSource: true,
      dropzone: null,
      svgSource: null,
      svgInspection: null,
      svgErrors: null
    };
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.uploadWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["e" /* IS_NOT_ALLOWED */],
      call: function call(rm) {
        this.props.onNotAllowed();
      }
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["b" /* HAS_FAILED */],
      call: function call(rm) {
        this.clearRequests();

        this.state.dropzone.removeAllFiles();
      }
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["a" /* HAS_ERRORS */],
      call: function call(rm) {
        var svgErrors = rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('svg');

        if ((typeof svgErrors === 'undefined' ? 'undefined' : _typeof(svgErrors)) === "object") {
          this.setState({
            svgInspection: svgErrors[0]
          });
        } else {
          this.setState({
            svgErrors: svgErrors
          });
        }
      }
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: __WEBPACK_IMPORTED_MODULE_10_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        __WEBPACK_IMPORTED_MODULE_4_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/icons');
      }
    });
  },
  getStateFilterKeys: function getStateFilterKeys() {
    return ['showPasteSvgSource', 'optimizedFor'];
  },
  handleDropzoneInit: function handleDropzoneInit(dropzone) {
    this.setState({
      dropzone: dropzone
    });
  },
  handleSvgChanged: function handleSvgChanged(svgSource) {
    this.setState({
      svgSource: svgSource
    });
  },
  handleOptimizedForChanged: function handleOptimizedForChanged(value) {
    this.setState({
      optimizedFor: value
    });
  },
  handleToggleSourceVersusUpload: function handleToggleSourceVersusUpload(event) {
    event.preventDefault();

    this.setState({
      showPasteSvgSource: !this.state.showPasteSvgSource
    });
  },
  handleIconNameChanged: function handleIconNameChanged(event) {
    this.setState({
      name: this._name.value
    });
  },
  handleSuggestedFilename: function handleSuggestedFilename(fileName) {
    if (this.state.name === '') {
      this.setState({
        name: fileName
      });
    }
  },
  handleFileRemoved: function handleFileRemoved() {
    this.setState({
      svgInspection: null,
      svgErrors: null
    });
  },
  uploadRecord: function uploadRecord(force) {
    return NewWorkingSetIcon({
      name: this._name.value,
      optimizedFor: this.state.optimizedFor,
      logo: this.props.isLogo,
      ignoreWarnings: force
    });
  },
  uploadSvgSourceClicked: function uploadSvgSourceClicked(svgSource, force) {
    var record = this.uploadRecord(force).set('svg', svgSource);

    this.setRequest({
      uploadWorkingSetIcon: new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        method: __WEBPACK_IMPORTED_MODULE_9_requests__["c" /* POST */],
        record: record
      })
    });
  },
  uploadViaDropzoneClicked: function uploadViaDropzoneClicked(dropzoneInstance, force) {
    var record = this.uploadRecord(force);
    var request = new __WEBPACK_IMPORTED_MODULE_9_requests__["e" /* Request */]({
      url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      method: __WEBPACK_IMPORTED_MODULE_9_requests__["c" /* POST */],
      record: record
    });

    this.setRequest({
      uploadWorkingSetIcon: request
    }, { skipDispatch: true });

    this.props.dispatch(__WEBPACK_IMPORTED_MODULE_12__actions__["e" /* createWorkingSetIconFromDropzone */](request, record, dropzoneInstance));
  },
  handleUploadIconClicked: function handleUploadIconClicked() {
    this.props.onUploadIconClicked();

    this.upload();
  },
  handleUploadAnyway: function handleUploadAnyway() {
    this.upload(true);
  },
  upload: function upload() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    this.setState({
      svgInspection: null,
      svgErrors: null
    });

    if (this.props.isAllowed) {
      if (this.state.showPasteSvgSource) {
        this.uploadSvgSourceClicked(this.state.svgSource, force);
      } else {
        this.uploadViaDropzoneClicked(this.state.dropzone, force);
      }
    }
  },
  renderError: function renderError() {
    var isAllowed = this.props.isAllowed;
    var svgInspection = this.state.svgInspection;

    var error = null;

    if (!isAllowed) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'build-error', className: 'alert alert-primary bg-body', role: 'alert' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Well shoot!'), ' You\'ll have to ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/upgrade' }, 'upgrade'), ' before you can add another icon.');
    }

    if (svgInspection) {
      error = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SvgInspection__["a" /* default */], { onContinueAnyway: this.handleUploadAnyway, results: svgInspection });
    }

    return error;
  },
  renderUploadIconButton: function renderUploadIconButton() {
    var isLogo = this.props.isLogo;

    var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('btn', 'btn-primary', 'btn-block', 'btn-lg');
    var label = isLogo ? 'Logo' : 'Icon';

    var uploadIconButtonElement = null;

    if (this.resourceManager().requests.isQueued(this.requests.uploadWorkingSetIcon)) {
      uploadIconButtonElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, 'disabled') }, 'Uploading ', label.toLowerCase(), "\u2026");
    } else {
      uploadIconButtonElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleUploadIconClicked, className: className }, 'Upload ', label, ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));
    }

    return uploadIconButtonElement;
  },
  renderPasteOrDropzone: function renderPasteOrDropzone(which) {
    var svgErrors = this.state.svgErrors;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["e" /* default */], {
      onDropzoneInit: this.handleDropzoneInit,
      onSourceChanged: this.handleSvgChanged,
      onSuggestedFilename: this.handleSuggestedFilename,
      onFileRemoved: this.handleFileRemoved,
      error: svgErrors,
      type: __WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["c" /* SVG */],
      which: which
    });
  },
  renderCopyPaste: function renderCopyPaste() {
    var changeSourceOrUpload = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'alt-upload' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleToggleSourceVersusUpload, href: '#' }, 'Need to upload an SVG file instead?'));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.renderPasteOrDropzone(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["b" /* PASTE */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, changeSourceOrUpload, this.renderUploadIconButton())));
  },
  renderUpload: function renderUpload() {
    var changeSourceOrUpload = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'alt-upload' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.handleToggleSourceVersusUpload, href: '#' }, 'Want to paste from Illustrator CC instead?'));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.renderPasteOrDropzone(__WEBPACK_IMPORTED_MODULE_13__PasteOrDropzone__["a" /* DROPZONE */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'form-group row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9 col-xs-offset-3' }, changeSourceOrUpload, this.renderUploadIconButton())));
  },
  render: function render() {
    var _this = this;

    var rm = this.resourceManager();
    var formGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('form-group', 'row', 'string', 'required');
    var nameFormGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(formGroupClassName, 'forms_build_icon_name', { 'has-danger': rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('name') });
    var optimizedForFormGroupClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(formGroupClassName, 'forms_build_icon_optimized_for');
    var stopDnD = function stopDnD(event) {
      event.preventDefault();
      event.stopPropagation();
    };
    var showBuildingIconFor = this.state.showBuildingIconFor;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["d" /* ResourcesMatching */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-b-lg', onDragOver: stopDnD, onDrop: stopDnD }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-8 form-horizontal p-xs-r-xl' }, this.renderError(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: nameFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Icon Name ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: function ref(c) {
        return _this._name = c;
      }, onChange: this.handleIconNameChanged, value: this.state.name, className: 'string required form-control', type: 'text' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_requests_components__["b" /* HasErrors */], { request: this.requests.uploadWorkingSetIcon, errorKey: 'name' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help text-muted' }, rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('name'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, 'Lowercase letters, numbers, and hyphens allowed.'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: optimizedForFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Optimized for ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OptimizedForSelect__["a" /* default */], { onChanged: this.handleOptimizedForChanged, value: this.state.optimizedFor }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted p-xs-t-xs' }, "The size you\u2019ve designed your icon to look the best at."))), this.state.showPasteSvgSource ? this.renderCopyPaste() : this.renderUpload()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-4 p-xs-l-xl' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-b-0 text-sm' }, 'Your icon should be ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'fully expanded and have no overlapping paths'), '.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HelpUploadingIcons__["a" /* default */], null))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(UploadIconForm));

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_noop__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dropzone__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DropzonePreviewTemplate__ = __webpack_require__(1024);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}







var FILESIZE_BASE = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  propTypes: {
    options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    onDropzoneInit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSourceChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFileAdded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFileRemoved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSuggestedFilename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFilesizeTooLarge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      maxFiles: 1,
      maxFilesize: 20,
      thumbnailWidth: 500,
      onDropzoneInit: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onSourceChanged: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onFileAdded: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onFileRemoved: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onSuggestedFilename: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onSuccess: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */],
      onFilesizeTooLarge: __WEBPACK_IMPORTED_MODULE_2_utils_noop__["a" /* default */]
    };
  },
  handleDropzoneInit: function handleDropzoneInit(dropzoneInstance) {
    var _this = this;

    this.setState({
      dropzone: dropzoneInstance
    }, function () {
      _this.props.onDropzoneInit(dropzoneInstance);
    });
  },
  handleAddedFile: function handleAddedFile(file) {
    var fileName = file.name;
    var slugify = function slugify(str) {
      return fileName.toLowerCase().substr(0, fileName.indexOf('.')).replace(/[^a-z\-]/, '');
    };

    this.props.onFileAdded(fileName);
    this.props.onSuggestedFilename(slugify(fileName));
  },
  handleDrop: function handleDrop(file) {
    this.state.dropzone.removeAllFiles();
  },
  handleRemovedFile: function handleRemovedFile(file) {
    this.props.onFileRemoved(file.name);
  },
  handleProcessing: function handleProcessing() {
    var progressElement = this.getProgressNode();

    if (progressElement) {
      progressElement.style.display = 'block';
    }
  },
  handleUploadProgress: function handleUploadProgress(_file, percentage) {
    this.getProgressBarNode().value = '' + percentage;
  },
  handleSuccess: function handleSuccess(file, response) {
    var progressElement = this.getProgressNode();

    if (progressElement) {
      progressElement.style.display = 'none';
    }

    this.props.onSuccess(file);
  },
  handleError: function handleError(file, xhr) {
    var maximumSize = this.props.maxFilesize * FILESIZE_BASE * FILESIZE_BASE;
    var progressElement = this.getProgressNode();

    file.previewElement.classList.remove('dz-processing');
    file.status = __WEBPACK_IMPORTED_MODULE_3_dropzone___default.a.QUEUED;
    file.processing = false;
    file.upload.progress = 0;
    file.upload.bytesSent = 0;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = file.previewElement.querySelectorAll("[data-dz-errormessage]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var errorMessage = _step.value;

        errorMessage.textContent = '';
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (progressElement) {
      progressElement.style.display = 'none';
    }

    if (file.size > maximumSize) {
      this.state.dropzone.removeFile(file);
      this.props.onFilesizeTooLarge(file.size, maximumSize);
    }
  },
  handleMaxFilesExceeded: function handleMaxFilesExceeded(file) {
    this.state.dropzone.removeFile(file);
  },
  getProgressNode: function getProgressNode() {
    return document.querySelector('.drop-progress');
  },
  getProgressBarNode: function getProgressBarNode() {
    return document.querySelector('.drop-progress .progress');
  },
  dropzoneProps: function dropzoneProps() {
    var _Object$assign;

    var extraEventHandlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var extraDropzoneConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var eventHandlers = Object.assign({}, (_Object$assign = {
      init: this.handleDropzoneInit,
      drop: function drop() {},
      addedfile: this.handleAddedFile
    }, _defineProperty(_Object$assign, 'drop', this.handleDrop), _defineProperty(_Object$assign, 'removedfile', this.handleRemovedFile), _defineProperty(_Object$assign, 'processing', this.handleProcessing), _defineProperty(_Object$assign, 'uploadprogress', this.handleUploadProgress), _defineProperty(_Object$assign, 'success', this.handleSuccess), _defineProperty(_Object$assign, 'error', this.handleError), _defineProperty(_Object$assign, 'maxfilesexceeded', this.handleMaxFilesExceeded), _Object$assign), extraEventHandlers);

    var test = 'asdf';

    var djsConfig = Object.assign({}, {
      url: '-deferred-',
      autoProcessQueue: false,
      maxFiles: this.props.maxFiles,
      maxFilesize: this.props.maxFilesize,
      filesizeBase: FILESIZE_BASE,
      thumbnailWidth: this.props.thumbnailWidth,
      thumbnailHeight: null,
      previewTemplate: __WEBPACK_IMPORTED_MODULE_4_components_DropzonePreviewTemplate__["a" /* default */]
    }, extraDropzoneConfig);

    return { eventHandlers: eventHandlers, djsConfig: djsConfig };
  }
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);



/* eslint-disable max-len */
var URLS = {
  preppingForUpload: 'https://articles.fortawesome.com/prepping-icons-with-pathfinder-4452f6ba2e37',
  advancedIconDesign: 'https://articles.fortawesome.com/advanced-icon-design-whitespace-bdd63e6cde3b',
  visualConsistency: 'https://articles.fortawesome.com/creating-an-awesome-icon-set-part-1-visual-consistency-and-setup-ec325b1d443f',
  sixTipsForIcons: 'https://articles.fortawesome.com/creating-an-awesome-icon-set-part-2-6-tips-for-designing-crisp-readable-icons-78339363eb80'
};
/* eslint-enable max-len */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'HelpUploadingIcons',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-primary bg-body text-sm m-xs-y-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'text-base' }, 'Help Uploading Icons'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'm-xs-t-sm m-xs-b-md' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm' }, 'Getting Started with Fort Awesome'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'm-xs-b-lg p-xs-l-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: URLS.preppingForUpload }, 'Prepping Icons for Upload')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: URLS.advancedIconDesign }, 'Advanced Icon Design: Whitespace'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'text-sm' }, 'Build an Awesome Icon Set'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'p-xs-l-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: URLS.visualConsistency }, 'Visual Consistency and Setup')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: URLS.sixTipsForIcons }, '6 Tips for Designing Crisp, Readable Icons'))));
  }
}));

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}





var WHAT_TO_DO_FOR_CODES = {
  PARSE_FAILED: "Try re-exporting as a standards-compliant SVG.",
  SHAPE_STROKES: "Remove or expand any strokes.",
  LOTS_OF_POINTS: "Try simplifying your object by removing points or merging objects together.",
  OVERLAPPING_POINTS: "Look through your layers for objects sitting underneath other objects and remove them if they are not needed.",
  SKETCH_FORMAT: "Export the file as SVG.",
  INKSCAPE_FORMAT: "Export the file as SVG.",
  LOW_PRECISION: "Resize your artboard to a height of 1008 and resize your icon to fit inside the larger area.",
  INVISIBLE_OBJECTS: "Remove any objects that are not part of your icon.",
  EVERYTHING_HIDDEN: "Check the file and try exporting a new SVG. You may need to create a brand new document in your editor and start from scratch.",
  CONTAINS_IMAGES: "Remove any images because they cannot be converted into icons.",
  MISSING_VIEWBOX: "Make sure your SVG has a \"viewBox\", which the spec requires. Try exporting a new SVG, maybe?",
  IS_SVG_FONT: "Get the original icons from this SVG Font and use those instead.",
  EXCEEDS_VIEWBOX: "Double-check that you intend to have objects outside the artboard.",
  CONTAINS_TEXT: "Convert text objects that use fonts to outlines."
};

var SvgInspection = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SvgInspection',

  propTypes: {
    results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    onContinueAnyway: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  resultsToString: function resultsToString() {
    var results = this.props.results;
    var _results$messages = results.messages,
        errors = _results$messages.errors,
        warnings = _results$messages.warnings;

    var messagesToString = function messagesToString(messages) {
      return [].concat(_toConsumableArray(messages)).map(function (message) {
        return message.desc;
      }).join(', ');
    };
    var errorsAsString = errors.length > 0 ? 'errors: ' + messagesToString(errors) : '';
    var warningsAsString = warnings.length > 0 ? 'warnings: ' + messagesToString(warnings) : '';

    return 'status: ' + results.stoplight + '; ' + errorsAsString + warningsAsString;
  },
  renderHelpScoutSupport: function renderHelpScoutSupport(type) {
    var prompt = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Help! I don\'t understand this. Let me talk to a ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strike', null, 'Jedi'), ' human!');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:help@fortawesome.com', className: 'text-' + type }, prompt);
  },
  renderMessages: function renderMessages(messages) {
    return [].concat(_toConsumableArray(messages)).map(function (message, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, message.desc, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, ' How you can fix this: '), WHAT_TO_DO_FOR_CODES[message.code]);
    });
  },
  renderErrors: function renderErrors() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-danger bg-body has-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-warning ficon-lg alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-y-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-7 col-xs-offset-1 p-xs-x-0 text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'The dark side this SVG is.', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Fix it you must.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-4' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x text-muted' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'p-xs-l-md' }, this.renderMessages(this.props.results.messages.errors)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-sm-center' }, this.renderHelpScoutSupport('danger')));
  },
  renderWarnings: function renderWarnings() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'alert alert-info bg-body has-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-exclamation-circle ficon-lg alert-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row m-xs-y-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-7 col-xs-offset-1 D-xs-x-0 text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, 'The path to the dark side this SVG may be.')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-4' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-yoda ficon-4x text-muted' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: 'p-xs-l-md m-xs-b-md' }, this.renderMessages(this.props.results.messages.warnings)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { className: 'btn btn-info btn-lg m-xs-b-sm', onClick: this.props.onContinueAnyway }, 'That\'s okay, upload it anyway!')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-sm-center' }, this.renderHelpScoutSupport('info')));
  },
  render: function render() {
    return this.props.results.stoplight === "red" ? this.renderErrors() : this.renderWarnings();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SvgInspection);

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);





var KEY_CODE_ESC = 27;
var DELAY_ON_CHANGE_BY = 200; // in ms
var MASK_VALUE_CHANGE_DELTA = 800; // in ms

var SearchField = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SearchField',

  propTypes: {
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFocus: true,
      placeholder: 'Search Icons',
      value: ''
    };
  },
  getInitialState: function getInitialState() {
    return {
      value: this.props.value,
      lastChange: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this.debouncedOnChange = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      var _props;

      (_props = _this.props).onChange.apply(_props, arguments);
    }, DELAY_ON_CHANGE_BY);

    if (this.props.autoFocus) {
      this.refs.searchQuery.focus();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (Date.now() - this.state.lastChange > MASK_VALUE_CHANGE_DELTA) {
      this.setState({
        value: nextProps.value
      });
    }
  },
  handleSearchQueryChanged: function handleSearchQueryChanged(event) {
    var value = this.refs.searchQuery.value;

    this.debouncedOnChange(value);

    this.setState({
      value: value,
      lastChange: Date.now()
    });
  },
  handleSearchQueryKeyDown: function handleSearchQueryKeyDown(event) {
    if (event.keyCode === KEY_CODE_ESC) {
      this.clearValue();
    }
  },
  handleClearValueClicked: function handleClearValueClicked(event) {
    event.preventDefault();

    this.clearValue();
  },
  clearValue: function clearValue() {
    var _this2 = this;

    this.setState({ value: '' }, function () {
      _this2.debouncedOnChange(_this2.state.value);

      _this2.refs.searchQuery.focus();
    });
  },
  render: function render() {
    var controlIndicator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-search' });

    if (this.state.value.length > 0) {
      controlIndicator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', onClick: this.handleClearValueClicked, className: 'link-dashed-none' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'has-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      ref: 'searchQuery',
      type: 'text',
      name: 'q',
      className: 'form-control form-control-lg input-search',
      autoComplete: 'off',
      placeholder: this.props.placeholder,
      value: this.state.value,
      onChange: this.handleSearchQueryChanged,
      onKeyDown: this.handleSearchQueryKeyDown
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'input-icon form-control-lg' }, controlIndicator));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SearchField);

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_requests_components__ = __webpack_require__(15);





var FILE_NAME_PATTERN = /^[A-Za-z0-9\-_@]+\.(png|svg|jpg|jpeg)$/;
var FILE_TYPE_PATTERN = /^.+\.(png|svg|jpg|jpeg)$/;

var formatFilesize = function formatFilesize(filesize) {
  return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(filesize / 1000 / 1000).format('0.0') + ' MB';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInitialState: function getInitialState() {
    return {
      name: this.props.workingSetImage ? this.props.workingSetImage.name : "",
      nameIsInvalid: false,
      uploading: false,
      imageUrl: null,
      filesizeExceededBy: null,
      bucketPolicyFailed: false,
      fileTypeNotSupported: false
    };
  },
  isUpdating: function isUpdating() {
    return !!this.props.workingSetImage;
  },
  directToCloudDropzoneProps: function directToCloudDropzoneProps() {
    return {
      onDropzoneInit: this.handleDropzoneInit,
      onFileAdded: this.handleFileAdded,
      onFileRemoved: this.handleFileRemoved,
      onTemporaryDestinationCreated: this.handleTemporaryDestinationCreated,
      onBucketPolicyFailure: this.handleBucketPolicyFailure,
      onFilesizeTooLarge: this.handleFilesizeTooLarge
    };
  },
  extensionLooksWrong: function extensionLooksWrong() {
    var isWrong = false;

    var _state = this.state,
        name = _state.name,
        dropzone = _state.dropzone;

    var dropzoneFile = (dropzone || { files: [] }).files.length > 0 ? this.state.dropzone.files[0].name : "";
    var extension = function extension(str) {
      return str.split(".").pop();
    };

    if (dropzoneFile && name) {
      if (extension(dropzoneFile) !== extension(name)) {
        isWrong = true;
      }
    }

    return isWrong;
  },
  extensionNotSupported: function extensionNotSupported() {
    var name = this.state.name;

    return ~name.indexOf('.') && name.split('.').pop().length > 1 && this.state.fileTypeNotSupported;
  },
  handleDropzoneInit: function handleDropzoneInit(dropzone) {
    this.setState({
      dropzone: dropzone
    });
  },
  handleTemporaryDestinationCreated: function handleTemporaryDestinationCreated(imageUrl) {
    this.setState({
      imageUrl: imageUrl
    });
  },
  handleFileAdded: function handleFileAdded(filename) {
    var nextState = {
      filesizeExceededBy: null
    };

    var nextFilename = filename.toLowerCase();

    if (!this.isUpdating()) {
      nextState.name = nextFilename;
      nextState.nameIsInvalid = !nextFilename.match(FILE_NAME_PATTERN);
      nextState.fileTypeNotSupported = !nextFilename.match(FILE_TYPE_PATTERN);
    }

    this.setState(nextState);
  },
  handleFileRemoved: function handleFileRemoved() {
    this.setState({ imageUrl: null });
  },
  handleNameChanged: function handleNameChanged(event) {
    var name = this._name.value;

    this.setState({
      name: name,
      nameIsInvalid: name.length > 0 && !name.match(FILE_NAME_PATTERN),
      fileTypeNotSupported: !name.match(FILE_TYPE_PATTERN)
    });
  },
  handleFilesizeTooLarge: function handleFilesizeTooLarge(actualSize, maximumSize) {
    this.setState({
      filesizeExceededBy: {
        actualSize: actualSize,
        maximumSize: maximumSize
      }
    });
  },
  handleBucketPolicyFailure: function handleBucketPolicyFailure() {
    this.setState({
      bucketPolicyFailed: true
    });
  },
  nameFormGroup: function nameFormGroup(request) {
    var _this = this;

    var rm = this.resourceManager();
    var dropzone = this.state.dropzone;

    var nameFormGroupClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('form-group row string required', { 'has-danger': this.state.filesizeExceededBy || this.extensionNotSupported() || this.state.nameIsInvalid || rm.requests.errorsFor(request).get('name') });
    var fileTooLargeElement = this.state.filesizeExceededBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help' }, formatFilesize(this.state.filesizeExceededBy.actualSize), ' is too large (maximum of ', formatFilesize(this.state.filesizeExceededBy.maximumSize), ')') : null;
    var bucketPolicyFailedElement = this.state.bucketPolicyFailed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help' }, 'Woops! We had a problem preparing the upload. Try again.') : null;
    var extensionLooksWrongElement = this.extensionLooksWrong() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help' }, 'Hmm. You might double-check that file extension. They don\'t match.') : null;
    var fileTypeNotSupportedElement = this.extensionNotSupported() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help' }, 'That file type is not supported right now.') : null;
    var maximumSizeInMB = dropzone ? dropzone.options.maxFilesize : "";

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_requests_components__["d" /* ResourcesMatching */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: nameFormGroupClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label', { className: 'string required col-xs-3 form-control-label p-xs-r-sm' }, 'Image Name', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { title: 'Required' }, '*')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { ref: function ref(c) {
        _this._name = c;
      }, type: 'text', value: this.state.name, onChange: this.handleNameChanged, className: 'string required form-control', required: true }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_requests_components__["b" /* HasErrors */], { request: request, errorKey: 'name' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-help' }, rm.requests.errorsFor(request).get('name'))), fileTooLargeElement, bucketPolicyFailedElement, extensionLooksWrongElement, fileTypeNotSupportedElement, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'text-muted m-xs-t-sm' }, 'Letters, numbers, underscores, and hyphens allowed. Must end with "jpg", "png", or "svg". Max size ', maximumSizeInMB, 'MB.'))));
  }
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_parse__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_url_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_fetch__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone_component__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dropzone_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_form_urlencoded__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_form_urlencoded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_form_urlencoded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_DropzoneComponentMixin__ = __webpack_require__(476);











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'DirectToCloudDropzone',

  propTypes: {
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    error: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    uploadLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    helpMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onTemporaryDestinationCreated: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBucketPolicyFailure: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a, __WEBPACK_IMPORTED_MODULE_9__mixins_DropzoneComponentMixin__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      error: null,
      uploadLabel: 'Upload',
      helpMessage: 'Help'
    };
  },
  handleDropzoneAccept: function handleDropzoneAccept(dropzone, file, done) {
    var _this = this;

    var dropzoneElement = document.querySelector('.dropzone');

    dropzoneElement.classList.add('dz-max-files-reached');

    var extension = file.name.split('.').pop();
    var options = {
      method: 'POST',
      body: __WEBPACK_IMPORTED_MODULE_8_form_urlencoded___default()({
        extension: extension,
        content_type: file.type,
        size: file.size
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    };
    var prepareFile = function prepareFile(representation) {
      var attributes = representation.data.attributes;
      var parsedUrl = __WEBPACK_IMPORTED_MODULE_4_url_parse___default()(attributes.url, true);
      var bucket = parsedUrl.host.split('.')[0];
      var imageUrl = 'https://s3.amazonaws.com/' + bucket + '/' + attributes['form-data'].key;

      /* eslint-disable no-param-reassign */
      dropzone.options.url = attributes.url;
      file.bucketPolicy = attributes['form-data'];
      /* eslint-enable no-param-reassign */

      _this.props.onTemporaryDestinationCreated(imageUrl);

      done();
    };
    var bucketFailure = function bucketFailure() {
      _this.props.onBucketPolicyFailure();
      _this.state.dropzone.removeFile(file);
    };

    Object(__WEBPACK_IMPORTED_MODULE_5_utils_fetch__["a" /* default */])('/api/bucket-policies', options).then(function (response) {
      if (response.status === 200) {
        response.json().then(prepareFile);
      } else {
        bucketFailure();
      }
    }).catch(function (error) {
      bucketFailure();
    });
  },
  handleDropzoneSending: function handleDropzoneSending(file, xhr, formData) {
    Object.keys(file.bucketPolicy).forEach(function (key) {
      formData.append(key, file.bucketPolicy[key]);
    });
  },
  handleDropzoneComplete: function handleDropzoneComplete(file) {
    file.complete = true;
  },
  render: function render() {
    var _this2 = this;

    var error = this.props.error;

    var _dropzoneProps = this.dropzoneProps({}, {
      accept: function accept(file, done) {
        _this2.handleDropzoneAccept(_this2.state.dropzone, file, done);
      },
      sending: this.handleDropzoneSending,
      complete: this.handleDropzoneComplete
    }),
        eventHandlers = _dropzoneProps.eventHandlers,
        djsConfig = _dropzoneProps.djsConfig;

    var config = {
      showFiletypeIcon: true
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone_component___default.a, { config: config, eventHandlers: eventHandlers, djsConfig: djsConfig }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dz-message' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong', null, 'Drop your image here or click to upload one.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'm-xs-t-xs m-xs-b-0' }, 'We ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-heart' }), ' JPG, PNG, and SVG files.'))), error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, error) : null);
  }
}));

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_function_name__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_string_raw__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_from_code_point__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_code_point_at__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_repeat__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_starts_with__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_ends_with__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_includes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_regexp_flags__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_match__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_replace__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_split__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_search__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_array_from__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_of__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_copy_within__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_find__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find_index__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_fill__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_iterator__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_number_is_finite__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_integer__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_nan__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_epsilon__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_acosh__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_asinh__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_atanh__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_cbrt__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_clz32__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cosh__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_expm1__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_fround__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_hypot__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_imul__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_log1p__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log10__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log2__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_sign__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sinh__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_tanh__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_trunc__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es7_array_includes__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_object_values__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_entries__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_string_pad_start__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_end__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_web_timers__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_immediate__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_dom_iterable__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_regenerator_runtime_runtime__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_whatwg_fetch__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_webpacker_react__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_webpacker_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_webpacker_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_initializers__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_views_Kits_integrators_KitIntegrator__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_views_Kits_components_DeleteKit__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_views_Kits_components_Icon__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_views_Sets_integrators_SetsSearchIntegrator__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_views_Sets_integrators_SetsResultsIntegrator__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_views_ShareResource_integrators_ShareResourceIntegrator__ = __webpack_require__(1073);































































































/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb












__WEBPACK_IMPORTED_MODULE_96_webpacker_react___default.a.setup({
  KitIntegrator: __WEBPACK_IMPORTED_MODULE_98_views_Kits_integrators_KitIntegrator__["a" /* default */],
  DeleteKit: __WEBPACK_IMPORTED_MODULE_99_views_Kits_components_DeleteKit__["a" /* default */],
  Icon: __WEBPACK_IMPORTED_MODULE_100_views_Kits_components_Icon__["a" /* default */],
  SetsSearchIntegrator: __WEBPACK_IMPORTED_MODULE_101_views_Sets_integrators_SetsSearchIntegrator__["a" /* default */],
  SetsResultsIntegrator: __WEBPACK_IMPORTED_MODULE_102_views_Sets_integrators_SetsResultsIntegrator__["a" /* default */],
  ShareResourceIntegrator: __WEBPACK_IMPORTED_MODULE_103_views_ShareResource_integrators_ShareResourceIntegrator__["a" /* default */]
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UNHANDLED_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOCATION_REPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOCATION_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PUBLISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JOBS_JOIN_TOPIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JOBS_TOPIC_STATE; });
/* unused harmony export unhandledError */
/* unused harmony export locationReplace */
/* harmony export (immutable) */ __webpack_exports__["h"] = locationUpdate;
/* harmony export (immutable) */ __webpack_exports__["i"] = published;
/* harmony export (immutable) */ __webpack_exports__["g"] = joinJobStatusTopics;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateJobStatusTopicState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_history__ = __webpack_require__(735);


var UNHANDLED_ERROR = 'UNHANDLED_ERROR';
var LOCATION_REPLACE = 'LOCATION_REPLACE';
var LOCATION_UPDATE = 'LOCATION_UPDATE';
var PUBLISHED = 'PUBLISHED';
var JOBS_JOIN_TOPIC = 'JOBS_JOIN_TOPIC';
var JOBS_TOPIC_STATE = 'JOBS_TOPIC_STATE';

function unhandledError(error) {
  return function (dispatch) {
    dispatch({
      type: UNHANDLED_ERROR,
      error: error
    });
  };
}

function locationReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch) {
    Object(__WEBPACK_IMPORTED_MODULE_0_utils_history__["a" /* replace */])(params);

    dispatch({
      type: LOCATION_REPLACE,
      pathname: params.pathname,
      query: params.query
    });
  };
}

function locationUpdate() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch) {
    Object(__WEBPACK_IMPORTED_MODULE_0_utils_history__["b" /* update */])(params);

    dispatch({
      type: LOCATION_UPDATE,
      pathname: params.pathname,
      query: params.query
    });
  };
}

function published(kitToken) {
  return function (dispatch) {
    dispatch({
      type: PUBLISHED,
      kitToken: kitToken
    });
  };
}

function joinJobStatusTopics(jobStatusTopics) {
  return function (dispatch) {
    dispatch({
      type: JOBS_JOIN_TOPIC,
      jobStatusTopics: jobStatusTopics
    });
  };
};

function updateJobStatusTopicState(topic, state) {
  return function (dispatch) {
    dispatch({
      type: JOBS_TOPIC_STATE,
      topic: topic,
      state: state
    });
  };
}

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET; });
/* unused harmony export HEAD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return METHODS; });
var GET = 'get';
var HEAD = 'head';
var POST = 'post';
var PUT = 'put';
var DELETE = 'delete';
var METHODS = [GET, HEAD, POST, PUT, DELETE];

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__workingSetIcons__ = __webpack_require__(809);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__workingSetIcons__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__workingSetIcons__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workingSetTypefaces__ = __webpack_require__(812);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__workingSetTypefaces__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__workingSetTypefaces__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workingSetImages__ = __webpack_require__(813);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__workingSetImages__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__workingSetImages__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(814);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__search__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__search__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__search__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__search__["d"]; });





/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conditionalComponent__ = __webpack_require__(115);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__conditionalComponent__["a" /* default */])('Requesting', {
  all: 'allQueued',
  any: 'anyQueued'
}));

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conditionalComponent__ = __webpack_require__(115);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__conditionalComponent__["a" /* default */])('Done', {
  all: 'allDone',
  any: 'anyDone'
}));

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ASSET_POLLING_INTERVAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SMALL_ICONS_PER_ROW; });
/* unused harmony export LARGE_ICONS_PER_ROW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_RESULTS_HITS_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TYPEFACE_PREVIEW_SPECIMEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TYPEFACE_WEIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TYPEFACE_STYLES; });
var ASSET_POLLING_INTERVAL = 1000;
var SMALL_ICONS_PER_ROW = 16;
var LARGE_ICONS_PER_ROW = 8;
var SEARCH_RESULTS_HITS_PER_PAGE = 1000;
var TYPEFACE_PREVIEW_SPECIMEN = 'When my six o’clock alarm buzzes, I require a pot of good java.';
var TYPEFACE_WEIGHTS = ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'];
var TYPEFACE_STYLES = ['normal', 'italic', 'oblique'];

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logging__ = __webpack_require__(815);



/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(87);


/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logging__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__publish__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jobs__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__requests_reducers__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Sets_reducers__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Kits_reducers__ = __webpack_require__(807);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};












/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(_extends({}, __WEBPACK_IMPORTED_MODULE_2__logging__, __WEBPACK_IMPORTED_MODULE_3__location__, __WEBPACK_IMPORTED_MODULE_4__browser__, __WEBPACK_IMPORTED_MODULE_5__publish__, __WEBPACK_IMPORTED_MODULE_6__jobs__, __WEBPACK_IMPORTED_MODULE_7__requests_reducers__, __WEBPACK_IMPORTED_MODULE_8__views_Sets_reducers__, __WEBPACK_IMPORTED_MODULE_9__views_Kits_reducers__, {
  routing: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["routerReducer"]
})));

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["unhandledError"] = unhandledError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(51);



function unhandledError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Stack"])();

  if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* UNHANDLED_ERROR */]) {
    nextState = nextState.push(action.error);
  }

  return nextState;
}

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replace;
/* harmony export (immutable) */ __webpack_exports__["b"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);



var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();

/* unused harmony default export */ var _unused_webpack_default_export = (history);

function replace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var pathname = params.pathname || location.pathname;
  var query = params.query || __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);
  var qs = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(query);
  var search = qs.length > 0 ? '?' + qs : '';

  history.replace({
    pathname: pathname,
    search: search
  });
}

function update() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var query = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);
  var nextQuery = params.query;

  replace({
    pathname: params.pathname,
    query: Object.assign({}, query, nextQuery)
  });
}

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["location"] = location;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(51);




function location() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    pathname: window.location.pathname,
    query: __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search)
  });

  if (~[__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* LOCATION_REPLACE */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* LOCATION_UPDATE */]].indexOf(action.type)) {
    nextState = nextState.set('pathname', action.pathname || nextState.get('pathname')).set('query', action.query || nextState.get('query'));
  }

  return nextState;
}

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["browserInformation"] = browserInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_supported__ = __webpack_require__(278);



function browserInformation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    supported: __WEBPACK_IMPORTED_MODULE_1_utils_supported__["b" /* supported */],
    features: __WEBPACK_IMPORTED_MODULE_1_utils_supported__["a" /* features */]
  });

  return nextState;
}

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["jobs"] = jobs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phoenix_socket__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phoenix_socket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_phoenix_socket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domready__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domready___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domready__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_userToken__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_jobs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(51);








var JOB_STATUS_PROCESSING = 'processing';
var JOB_STATUS_FINISHED = 'finished';
var JOB_STATUS_ERRORED = 'errored';

var socket = void 0;

__WEBPACK_IMPORTED_MODULE_3_domready___default()(function () {
  var userToken = Object(__WEBPACK_IMPORTED_MODULE_4_utils_userToken__["a" /* getFromMeta */])();

  if (!socket && userToken) {
    socket = new __WEBPACK_IMPORTED_MODULE_2_phoenix_socket__["Socket"]("wss://forge.fortawesome.com/socket", {
      params: { token: userToken }
    });

    socket.connect();
  }
});

function jobs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    connected: false,
    channels: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({}),
    status: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({})
  });

  if (action.type === __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* JOBS_JOIN_TOPIC */]) {
    nextState = nextState.set('connected', !!socket);

    action.jobStatusTopics.forEach(function (jobStatusTopic) {
      var channel = nextState.get('channels').has(jobStatusTopic.id) ? nextState.get('channels').get(jobStatusTopic.id).channel : socket.channel('job:' + jobStatusTopic.topic, {});

      nextState = nextState.update('status', function (status) {
        return status.set(jobStatusTopic.id, jobStatusTopic.active ? JOB_STATUS_PROCESSING : JOB_STATUS_FINISHED);
      });

      if (jobStatusTopic.active && channel.state === 'closed') {
        channel.join();

        channel.on('status', function (payload) {
          Object(__WEBPACK_IMPORTED_MODULE_5_store_jobs__["a" /* dispatch */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["j" /* updateJobStatusTopicState */])(jobStatusTopic.topic, payload.state));
        });
      }

      nextState = nextState.update('channels', function (channels) {
        return channels.set(jobStatusTopic.id, { channel: channel, jobStatusTopic: jobStatusTopic });
      });
    });
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* JOBS_TOPIC_STATE */]) {
    var _nextState$get$find = nextState.get('channels').find(function (channelAndJobStatusTopic) {
      return channelAndJobStatusTopic.jobStatusTopic.topic === action.topic;
    }),
        jobStatusTopic = _nextState$get$find.jobStatusTopic;

    nextState = nextState.update('status', function (status) {
      return status.set(jobStatusTopic.id, action.state);
    });
  }

  return nextState;
}

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFromMeta;
function getFromMeta() {
  var tag = document.querySelector('meta[name=user-token]');
  return tag ? tag.content : '';
}

/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFromMeta;
function getFromMeta() {
  var tag = document.querySelector('meta[name=share-resource-token]');
  return tag ? tag.content : '';
}

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__2xx__ = __webpack_require__(132);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parseJsonApiRepresentation", function() { return __WEBPACK_IMPORTED_MODULE_0__2xx__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle204", function() { return __WEBPACK_IMPORTED_MODULE_0__2xx__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle200", function() { return __WEBPACK_IMPORTED_MODULE_0__2xx__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__4xx__ = __webpack_require__(780);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle400", function() { return __WEBPACK_IMPORTED_MODULE_1__4xx__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle403", function() { return __WEBPACK_IMPORTED_MODULE_1__4xx__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle404", function() { return __WEBPACK_IMPORTED_MODULE_1__4xx__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__5xx__ = __webpack_require__(781);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle500", function() { return __WEBPACK_IMPORTED_MODULE_2__5xx__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle502", function() { return __WEBPACK_IMPORTED_MODULE_2__5xx__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle503", function() { return __WEBPACK_IMPORTED_MODULE_2__5xx__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "handle504", function() { return __WEBPACK_IMPORTED_MODULE_2__5xx__["d"]; });




/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var CharacterSet = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  code: '',
  name: '',
  characters: []
});

/* harmony default export */ __webpack_exports__["a"] = (CharacterSet);

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Icon = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  iconSetId: null,
  iconSet: null,
  name: '',
  unicodeChar: '',
  optimizedFor: '',
  prefix: '',
  cssName: '',
  cssClass: '',
  status: ''
});

/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var IconSet = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  token: null,
  icons: [],
  name: '',
  slug: '',
  optimizedFor: '',
  version: '',
  creatorName: '',
  updatedAt: '',
  custom: false,
  premium: false,
  price: 0
});

/* harmony default export */ __webpack_exports__["a"] = (IconSet);

/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var IconSettings = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  cssPrefix: null,
  autoA11y: true,
  asyncLoading: true,
  largerIconSizes: true,
  fixedWidthIcons: true,
  listIcons: true,
  borderedPulledIcons: true,
  spinningIcons: true,
  rotatedFlippedIcons: true,
  stackedIcons: true
});

/* harmony default export */ __webpack_exports__["a"] = (IconSettings);

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Kit = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  token: '',
  name: '',
  subsetName: '',
  archived: false,
  version: 0,
  migrating: false,
  downloadedAt: null,
  downloadCount: null,
  downloadable: false,
  needsPublishing: false,
  publishable: false,
  publishStatus: null,
  publishText: '',
  hasNeverBeenPublished: false,
  shareableDocumentationPath: ''
});

/* harmony default export */ __webpack_exports__["a"] = (Kit);

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var WorkingSet = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  kitId: null,
  status: null
});

/* harmony default export */ __webpack_exports__["a"] = (WorkingSet);

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  jobStatusTopic: null,
  startedAt: null,
  erroredAt: null,
  finishedAt: null,
  status: null
});

var Publication = function (_record) {
  _inherits(Publication, _record);

  function Publication() {
    _classCallCheck(this, Publication);

    return _possibleConstructorReturn(this, (Publication.__proto__ || Object.getPrototypeOf(Publication)).apply(this, arguments));
  }

  _createClass(Publication, [{
    key: 'startedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(Publication.prototype.__proto__ || Object.getPrototypeOf(Publication.prototype), 'startedAt', this));
    }
  }, {
    key: 'erroredAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(Publication.prototype.__proto__ || Object.getPrototypeOf(Publication.prototype), 'erroredAt', this));
    }
  }, {
    key: 'finishedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(Publication.prototype.__proto__ || Object.getPrototypeOf(Publication.prototype), 'finishedAt', this));
    }
  }]);

  return Publication;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (Publication);

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var KitMessage = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  kit: '',
  messageType: '',
  payload: false
});

/* harmony default export */ __webpack_exports__["a"] = (KitMessage);

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  freePlan: false,
  iconSets: [],
  kitsAllowed: 0,
  downloadAllowed: false,
  iconsPerKitAllowed: 0,
  customIconsAllowed: 0,
  customTypefacesAllowed: 0,
  workingSetTypefacesAllowed: 0
});

var Subscription = function (_record) {
  _inherits(Subscription, _record);

  function Subscription() {
    _classCallCheck(this, Subscription);

    return _possibleConstructorReturn(this, (Subscription.__proto__ || Object.getPrototypeOf(Subscription)).apply(this, arguments));
  }

  _createClass(Subscription, [{
    key: 'toJS',
    value: function toJS() {
      var extra = {
        customIconsAllowed: this.customIconsAllowed,
        customTypefacesAllowed: this.customTypefacesAllowed,
        iconsPerKitAllowed: this.iconsPerKitAllowed,
        kitsAllowed: this.kitsAllowed,
        workingSetTypefacesAllowed: this.workingSetTypefacesAllowed
      };

      return Object.assign({}, _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'toJS', this).call(this), extra);
    }
  }, {
    key: 'customIconsAllowed',
    get: function get() {
      var val = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'customIconsAllowed', this);
      return val === -1 ? Infinity : val;
    }
  }, {
    key: 'customTypefacesAllowed',
    get: function get() {
      var val = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'customTypefacesAllowed', this);
      return val === -1 ? Infinity : val;
    }
  }, {
    key: 'iconsPerKitAllowed',
    get: function get() {
      var val = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'iconsPerKitAllowed', this);
      return val === -1 ? Infinity : val;
    }
  }, {
    key: 'kitsAllowed',
    get: function get() {
      var val = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'kitsAllowed', this);
      return val === -1 ? Infinity : val;
    }
  }, {
    key: 'workingSetTypefacesAllowed',
    get: function get() {
      var val = _get(Subscription.prototype.__proto__ || Object.getPrototypeOf(Subscription.prototype), 'workingSetTypefacesAllowed', this);
      return val === -1 ? Infinity : val;
    }
  }]);

  return Subscription;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (Subscription);

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var JobStatusTopic = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  topic: '',
  active: false
});

/* harmony default export */ __webpack_exports__["a"] = (JobStatusTopic);

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Typeface = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  name: '',
  family: '',
  weight: '',
  style: '',
  creatorName: '',
  system: false,
  fileSize: 0
});

/* harmony default export */ __webpack_exports__["a"] = (Typeface);

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var TypefaceSettings = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  link: null,
  defaultSubsetting: '',
  characterSets: []
});

/* harmony default export */ __webpack_exports__["a"] = (TypefaceSettings);

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;if (getter === undefined) {
      return undefined;
    }return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var record = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  jobStatusTopic: null,
  publication: null,
  workingSet: null,
  status: null,
  link: null,
  createdAt: null,
  updatedAt: null
});

var WorkingSetArchive = function (_record) {
  _inherits(WorkingSetArchive, _record);

  function WorkingSetArchive() {
    _classCallCheck(this, WorkingSetArchive);

    return _possibleConstructorReturn(this, (WorkingSetArchive.__proto__ || Object.getPrototypeOf(WorkingSetArchive)).apply(this, arguments));
  }

  _createClass(WorkingSetArchive, [{
    key: 'createdAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetArchive.prototype.__proto__ || Object.getPrototypeOf(WorkingSetArchive.prototype), 'createdAt', this));
    }
  }, {
    key: 'updatedAt',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_get(WorkingSetArchive.prototype.__proto__ || Object.getPrototypeOf(WorkingSetArchive.prototype), 'updatedAt', this));
    }
  }]);

  return WorkingSetArchive;
}(record);

/* harmony default export */ __webpack_exports__["a"] = (WorkingSetArchive);

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handle400;
/* harmony export (immutable) */ __webpack_exports__["b"] = handle403;
/* harmony export (immutable) */ __webpack_exports__["c"] = handle404;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(40);


function handle400(request, response) {
  return new Promise(function (resolve, reject) {
    response.json().then(function (json) {
      resolve({
        type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
        request: request,
        response: response,
        errors: json.errors || {}
      });
    }).catch(function (error) {
      resolve({
        type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
        request: request,
        response: response,
        errors: { unknown: 'Bad request' }
      });
    });
  });
}

function handle403(request, response) {
  return new Promise(function (resolve, reject) {
    resolve({
      type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* RESPONSE_NOT_ALLOWED */],
      request: request,
      response: response
    });
  });
}

function handle404(request, response) {
  return new Promise(function (resolve, reject) {
    resolve({
      type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* RESPONSE_NOT_FOUND */],
      request: request,
      response: response
    });
  });
}

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handle500;
/* harmony export (immutable) */ __webpack_exports__["b"] = handle502;
/* harmony export (immutable) */ __webpack_exports__["c"] = handle503;
/* harmony export (immutable) */ __webpack_exports__["d"] = handle504;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(40);


function handleFailure(request, response) {
  return new Promise(function (resolve, reject) {
    resolve({
      type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* RESPONSE_FAILURE */],
      request: request,
      response: response
    });
  });
}

function handle500() {
  return handleFailure.apply(undefined, arguments);
}

function handle502() {
  return handleFailure.apply(undefined, arguments);
}

function handle503() {
  return handleFailure.apply(undefined, arguments);
}

function handle504() {
  return handleFailure.apply(undefined, arguments);
}

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = retrieved;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleted;
/* harmony export (immutable) */ __webpack_exports__["a"] = created;
/* harmony export (immutable) */ __webpack_exports__["d"] = noContent;
/* harmony export (immutable) */ __webpack_exports__["c"] = jobStatusTopic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_records__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(783);




function retrieved(state, action) {
  var _split = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* split */])(action.data),
      representations = _split.representations,
      resources = _split.resources;

  return state.set('representations', Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* updateRepresentations */])(state.get('representations'), representations, action.request)).setIn(['resources', action.request.uuid], resources).setIn(['status', action.request.uuid], action.response.status);
}

function deleted(state, action) {
  var record = action.request.record;

  var representations = state.get('representations');
  var resources = state.get('resources');
  var type = __WEBPACK_IMPORTED_MODULE_1_records__["a" /* registry */].typeFor(record);
  var nextRepresentations = representations.deleteIn([type, record.id.toString()]);
  var nextResources = resources.map(function (resource) {
    return resource.update(type, function (idList) {
      var index = idList ? idList.indexOf(record.id.toString()) : -1;
      return ~index ? idList.delete(index) : idList;
    });
  });

  return state.set('representations', nextRepresentations).set('resources', nextResources).setIn(['status', action.request.uuid], action.response.status);
}

function created(state, action) {
  var nextState = state;

  var _split2 = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* split */])(action.data),
      createdResources = _split2.resources;

  var createdRequest = action.request;

  nextState = nextState.updateIn(['resources'], function (resources) {
    return resources.map(function (resource, requestId) {
      var request = state.getIn(['cache', requestId]);
      var retval = resource;

      var nextResource = resource.withMutations(function (mutableResource) {
        createdResources.forEach(function (createdResource, type) {
          if (!mutableResource.has(type)) {
            mutableResource.set(type, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
          }
        });
      });

      if (request.url.join('/') === createdRequest.url.join('/')) {
        retval = nextResource.map(function (resourceList, type) {
          var nextResourceList = resourceList.concat(createdResources.get(type, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()));

          return nextResourceList.toOrderedSet().toList();
        });
      }

      return retval;
    });
  });

  return nextState;
}

function noContent(state, action) {
  return state.setIn(['status', action.request.uuid], action.response.status);
}

function jobStatusTopic(state, action) {
  var jobStatusTopics = action.data['job-status-topics'] || [];

  var nextState = state;

  if (jobStatusTopics.length > 0) {
    nextState = nextState.updateIn(['jobs'], function (jobs) {
      jobStatusTopics.forEach(function (jobStatusTopic) {
        jobs = jobs.set(jobStatusTopic.id, jobStatusTopic.set('id', parseInt(jobStatusTopic.id, 10)));
      });

      return jobs;
    });
  }

  return nextState;
}

/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = split;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateRepresentations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__methods__ = __webpack_require__(52);



function split(data) {
  var representations = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().asMutable();
  var resources = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().asMutable();

  Object.keys(data).map(function (key) {
    data[key].map(function (datum) {
      representations.setIn([key, datum.id.toString()], datum);
      if (!resources.has(key)) {
        resources.set(key, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
      }
      resources.update(key, function (typeList) {
        return typeList.push(datum.id.toString());
      });
    });
  });

  return {
    representations: representations.asImmutable(),
    resources: resources.asImmutable()
  };
}

function updateRepresentations(prev, next, request) {
  var retval = prev;

  if (~[__WEBPACK_IMPORTED_MODULE_1__methods__["b" /* GET */], __WEBPACK_IMPORTED_MODULE_1__methods__["d" /* POST */], __WEBPACK_IMPORTED_MODULE_1__methods__["e" /* PUT */]].indexOf(request.method)) {
    retval = prev.mergeDeep(next);
  }

  return retval;
}

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["searchForSet"] = searchForSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);



function searchForSet() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var locationQuery = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);

  var nextState = state || {
    query: locationQuery.q || '', // eslint-disable-line id-length
    results: { hits: [], hitsPerPage: 0, count: 0 }
  };

  if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* SEARCH_FOR_SET_NEW_QUERY */]) {
    nextState = Object.assign({}, state, { query: action.query });
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* SEARCH_FOR_SET_RESULTS */]) {
    var hits = action.hits,
        hitsPerPage = action.hitsPerPage,
        count = action.count;

    nextState = Object.assign({}, state, { results: { hits: hits, hitsPerPage: hitsPerPage, count: count } });
  }

  return nextState;
}

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kitIconSetSearch__ = __webpack_require__(808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "kitIconSetSearch", function() { return __WEBPACK_IMPORTED_MODULE_0__kitIconSetSearch__["a"]; });


/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = kitIconSetSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




function kitIconSetSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  var locationQuery = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search);

  var nextState = state || Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    query: locationQuery.q || '', // eslint-disable-line id-length
    results: null
  });

  if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* SEARCH_FOR_ICON_NEW_QUERY */]) {
    nextState = nextState.set('query', action.query);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* SEARCH_FOR_ICON_EMPTY_QUERY */]) {
    nextState = nextState.set('query', '').set('results', null);
  }

  if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* SEARCH_FOR_ICON_RESULTS */]) {
    nextState = nextState.set('results', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
      iconSetHits: action.iconSetHits,
      iconSetCounts: action.iconSetCounts,
      iconHits: action.iconHits,
      iconHighlights: action.iconHighlights,
      count: action.count
    }));
  }

  return nextState;
}

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromDropzone */
/* harmony export (immutable) */ __webpack_exports__["a"] = createWorkingSetIconFromDropzone;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateWorkingSetIconFromDropzone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_csrfToken__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_requests_responseHandlers_2xx__ = __webpack_require__(132);





var WORKING_SET_ICON_METHOD_CREATE = 'WORKING_SET_ICON_METHOD_CREATE';
var WORKING_SET_ICON_METHOD_UPDATE = 'WORKING_SET_ICON_METHOD_UPDATE';

function fromDropzone(type, request, record, dropzoneInstance) {
  return function (dispatch) {
    var errors = { name: [], svg: [] };
    var hasErrors = function hasErrors() {
      return errors.name.length > 0 || errors.svg.length > 0;
    };

    /* eslint-disable no-param-reassign */
    dropzoneInstance.options.paramName = 'svg';
    dropzoneInstance.options.headers = {
      'X-CSRF-Token': Object(__WEBPACK_IMPORTED_MODULE_0_utils_csrfToken__["a" /* getFromMeta */])()
    };
    dropzoneInstance.options.url = '/' + request.url.join('/');
    dropzoneInstance.options.method = request.method;
    dropzoneInstance.options.params = {
      name: record.name,
      optimized_for: record.optimizedFor,
      logo: record.logo,
      ignore_warnings: record.ignoreWarnings
    };

    if (type === WORKING_SET_ICON_METHOD_UPDATE) {
      dropzoneInstance.options.params['unicode_char'] = record.unicodeChar;
    }
    /* eslint-enable no-param-reassign */

    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["a" /* REQUEST_QUEUED */],
      request: request
    });

    if (record.name.length === 0) {
      errors.name.push('is required');
    }

    if (dropzoneInstance.files.length === 0) {
      errors.svg.push('is required');
    }

    if (hasErrors()) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
        response: new Response('', { status: 400 }),
        request: request,
        errors: errors
      });
    } else {
      dropzoneInstance.on('success', function (file, json) {
        dispatch({
          type: request.method === __WEBPACK_IMPORTED_MODULE_2_requests__["c" /* POST */] ? __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["d" /* RESPONSE_CREATED */] : __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["e" /* RESPONSE_DATA */],
          request: request,
          response: new Response('', { status: 200 }),
          data: Object(__WEBPACK_IMPORTED_MODULE_3_requests_responseHandlers_2xx__["c" /* parseJsonApiRepresentation */])(json)
        });
      });
      dropzoneInstance.on('error', function (file, json, xhr) {
        if (xhr.status === 403) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["h" /* RESPONSE_NOT_ALLOWED */],
            request: request,
            response: new Response('', { status: 403 })
          });
        } else if (xhr.status === 400) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
            request: request,
            response: new Response('', { status: 400 }),
            errors: json.errors
          });
        } else {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["g" /* RESPONSE_FAILURE */],
            request: request,
            response: new Response('', { status: xhr.status })
          });
        }
      });

      dropzoneInstance.processQueue();
    }

    return request;
  };
}

function createWorkingSetIconFromDropzone(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_ICON_METHOD_CREATE, request, record, dropzoneInstance);
}

function updateWorkingSetIconFromDropzone(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_ICON_METHOD_UPDATE, request, record, dropzoneInstance);
}

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWorkingSetTypeface;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateWorkingSetTypeface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_csrfToken__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests_responseHandlers_2xx__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_requests__ = __webpack_require__(9);





var WORKING_SET_TYPEFACE_METHOD_CREATE = 'WORKING_SET_TYPEFACE_METHOD_CREATE';
var WORKING_SET_TYPEFACE_METHOD_UPDATE = 'WORKING_SET_TYPEFACE_METHOD_UPDATE';

function fromDropzone(type, request, record, dropzoneInstance) {
  return function (dispatch) {
    var errors = { family: [], weight: [], style: [], typeface: [] };
    var hasErrors = function hasErrors() {
      return errors.family.length > 0 || errors.typeface.length > 0;
    };
    var creating = request.method === __WEBPACK_IMPORTED_MODULE_3_requests__["c" /* POST */];

    /* eslint-disable no-param-reassign */
    dropzoneInstance.options.paramName = 'typeface';
    dropzoneInstance.options.headers = {
      'X-CSRF-Token': Object(__WEBPACK_IMPORTED_MODULE_0_utils_csrfToken__["a" /* getFromMeta */])()
    };
    dropzoneInstance.options.url = '/' + request.url.join('/');
    dropzoneInstance.options.method = request.method;
    dropzoneInstance.options.params = {
      kit_id: record.kitId,
      family: record.family,
      weight: record.weight,
      style: record.style,
      subsetting: record.subsetting,
      character_sets: record.characterSets.toArray ? record.characterSets.toArray() : record.characterSets
    };
    /* eslint-enable no-param-reassign */

    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["a" /* REQUEST_QUEUED */],
      request: request
    });

    if (record.family.length === 0) {
      errors.family.push('is required');
    }

    if (dropzoneInstance.files.length === 0 && creating) {
      errors.typeface.push('is required');
    }

    if (hasErrors()) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
        response: new Response('', { status: 400 }),
        request: request,
        errors: errors
      });
    } else {
      dropzoneInstance.on('success', function (file, json) {
        dispatch({
          type: request.method === __WEBPACK_IMPORTED_MODULE_3_requests__["c" /* POST */] ? __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["d" /* RESPONSE_CREATED */] : __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["e" /* RESPONSE_DATA */],
          request: request,
          response: new Response('', { status: 200 }),
          data: Object(__WEBPACK_IMPORTED_MODULE_2_requests_responseHandlers_2xx__["c" /* parseJsonApiRepresentation */])(json)
        });
      });
      dropzoneInstance.on('error', function (file, json, xhr) {
        dropzoneInstance.removeAllFiles(true);

        if (xhr.status === 403) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["h" /* RESPONSE_NOT_ALLOWED */],
            request: request,
            response: new Response('', { status: 403 })
          });
        } else if (xhr.status === 400) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
            request: request,
            response: new Response('', { status: 400 }),
            errors: json.errors
          });
        } else {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1_requests_actionTypes__["g" /* RESPONSE_FAILURE */],
            request: request,
            response: new Response('', { status: xhr.status })
          });
        }
      });

      dropzoneInstance.processQueue();
    }

    return request;
  };
}

function createWorkingSetTypeface(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_TYPEFACE_METHOD_CREATE, request, record, dropzoneInstance);
}

function updateWorkingSetTypeface(request, record, dropzoneInstance) {
  return fromDropzone(WORKING_SET_TYPEFACE_METHOD_UPDATE, request, record, dropzoneInstance);
}

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createImageFromDropzone;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateImageFromDropzone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_requests_actionTypes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_requests_responseHandlers_2xx__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_requests_actions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_requests__ = __webpack_require__(9);





function imageFromDropzone(request, record, dropzoneInstance, requireFile) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0_requests_actionTypes__["a" /* REQUEST_QUEUED */],
      request: request
    });

    if (dropzoneInstance.files.length === 0 && requireFile) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0_requests_actionTypes__["c" /* RESPONSE_BAD_REQUEST */],
        response: new Response('', { status: 400 }),
        request: request,
        errors: { image: ['is required'] }
      });
    } else {
      var dropzoneNeedsProcessing = dropzoneInstance.files.length === 1 && !dropzoneInstance.files[0].complete;

      if (!dropzoneNeedsProcessing) {
        Object(__WEBPACK_IMPORTED_MODULE_2_requests_actions__["a" /* queueRequests */])([request])(dispatch);
      } else {
        dropzoneInstance.on('success', function (file, json) {
          Object(__WEBPACK_IMPORTED_MODULE_2_requests_actions__["a" /* queueRequests */])([request])(dispatch);
        });

        dropzoneInstance.on('error', function (file, json, xhr) {
          dropzoneInstance.removeAllFiles(true);

          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_0_requests_actionTypes__["g" /* RESPONSE_FAILURE */],
            response: new Response('', { status: 500 }),
            request: request
          });
        });

        dropzoneInstance.processQueue();
      }
    }
  };
}

function createImageFromDropzone(request, record, dropzoneInstance) {
  return imageFromDropzone(request, record, dropzoneInstance, true);
}

function updateImageFromDropzone(request, record, dropzoneInstance) {
  return imageFromDropzone(request, record, dropzoneInstance, false);
}

/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEARCH_FOR_ICON_NEW_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_FOR_ICON_EMPTY_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_FOR_ICON_RESULTS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = searchForIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_algolia__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__(69);





var SEARCH_FOR_ICON_NEW_QUERY = 'SEARCH_FOR_ICON_NEW_QUERY';
var SEARCH_FOR_ICON_EMPTY_QUERY = 'SEARCH_FOR_ICON_EMPTY_QUERY';
var SEARCH_FOR_ICON_RESULTS = 'SEARCH_FOR_ICON_RESULTS';

function searchForIcon(query, index) {
  var hitsPerPage = __WEBPACK_IMPORTED_MODULE_3__settings__["a" /* SEARCH_RESULTS_HITS_PER_PAGE */];

  return function (dispatch) {
    dispatch({
      type: SEARCH_FOR_ICON_NEW_QUERY,
      query: query
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_actions__["h" /* locationUpdate */])({
      query: {
        q: query // eslint-disable-line id-length
      }
    }));

    if (query.length > 0) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_algolia__["a" /* client */])().initIndex(index).search(query, {
        hitsPerPage: hitsPerPage,
        attributesToRetrieve: ['id', 'icon_set'],
        facets: ['icon_set.id'],
        highlightPreTag: '<mark>',
        highlightPostTag: '</mark>'
      }).then(function (results) {
        var hits = results.hits;
        var iconSetHits = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedSet"])(hits.map(function (hit) {
          return hit.icon_set.id;
        }));
        var facets = results.facets['icon_set.id'] || {};
        var iconHighlights = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(hits.map(function (hit) {
          return [parseInt(hit.id, 10), hit._highlightResult.name.value];
        }));
        var iconSetCounts = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(Object.keys(facets).map(function (key) {
          return [parseInt(key, 10), facets[key]];
        }));
        var iconHits = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedSet"])(hits.map(function (hit) {
          return hit.id;
        }));

        dispatch({
          type: SEARCH_FOR_ICON_RESULTS,
          query: query,
          iconSetHits: iconSetHits,
          iconSetCounts: iconSetCounts,
          iconHits: iconHits,
          iconHighlights: iconHighlights,
          count: results.nbHits
        });
      });
    } else {
      dispatch({
        type: SEARCH_FOR_ICON_EMPTY_QUERY
      });
    }
  };
}

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_supported__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_env__ = __webpack_require__(88);





if (__WEBPACK_IMPORTED_MODULE_3_utils_env__["a" /* PRODUCTION */] && __WEBPACK_IMPORTED_MODULE_2_utils_supported__["b" /* supported */]) {
  var raven = __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config("https://1f23a42308f74783a1193f7d5da8d74b@app.getsentry.com/24822"); // eslint-disable-line no-undef
  var lastUnhandledErrorSize = 0;

  if (false) {
    // eslint-disable-line no-undef
    raven.install();
  }

  __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].subscribe(function () {
    var unhandledError = __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().unhandledError;

    if (lastUnhandledErrorSize !== unhandledError.size) {
      var lastUnhandledError = unhandledError.last();

      if (typeof lastUnhandledError === 'string') {
        raven.captureMessage(lastUnhandledError);
      } else {
        raven.captureException(lastUnhandledError);
      }

      lastUnhandledErrorSize = unhandledError.size;
    }
  });
}

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_KitController__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NotFoundController__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SummaryController__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MigrateController__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IconsController__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TypefacesController__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ImagesController__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DocumentationController__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_DocumentationSummaryController__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DocumentationIconsController__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_DocumentationTypefacesController__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DocumentationImagesController__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UploadLogoController__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AddIconsController__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_UploadIconController__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_EditIconController__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AddTypefaceController__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_UploadTypefaceController__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_EditTypefaceController__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_UploadImageController__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_EditImageController__ = __webpack_require__(1062);





























var KitIntegrator = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitIntegrator',

  propTypes: {
    iconsSearchIndexName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  childContextTypes: {
    iconsSearchIndexName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  getChildContext: function getChildContext() {
    return {
      iconsSearchIndexName: this.props.iconsSearchIndexName
    };
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */], { store: __WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["d" /* Router */], { history: Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* browserHistory */], __WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */]) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/migrate', component: __WEBPACK_IMPORTED_MODULE_10__components_MigrateController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken', component: __WEBPACK_IMPORTED_MODULE_7__components_KitController__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_9__components_SummaryController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'icons', component: __WEBPACK_IMPORTED_MODULE_11__components_IconsController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'typefaces', component: __WEBPACK_IMPORTED_MODULE_12__components_TypefacesController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'images', component: __WEBPACK_IMPORTED_MODULE_13__components_ImagesController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'docs', component: __WEBPACK_IMPORTED_MODULE_14__components_DocumentationController__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_15__components_DocumentationSummaryController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'icons', component: __WEBPACK_IMPORTED_MODULE_16__components_DocumentationIconsController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'typefaces', component: __WEBPACK_IMPORTED_MODULE_17__components_DocumentationTypefacesController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: 'images', component: __WEBPACK_IMPORTED_MODULE_18__components_DocumentationImagesController__["a" /* default */] }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/logo/upload', component: __WEBPACK_IMPORTED_MODULE_19__components_UploadLogoController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/icons/new', component: __WEBPACK_IMPORTED_MODULE_20__components_AddIconsController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/icons/upload', component: __WEBPACK_IMPORTED_MODULE_21__components_UploadIconController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/icons/:workingSetIconId', component: __WEBPACK_IMPORTED_MODULE_22__components_EditIconController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/typefaces/new', component: __WEBPACK_IMPORTED_MODULE_23__components_AddTypefaceController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/typefaces/upload', component: __WEBPACK_IMPORTED_MODULE_24__components_UploadTypefaceController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/typefaces/:workingSetTypefaceId', component: __WEBPACK_IMPORTED_MODULE_25__components_EditTypefaceController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/images/upload', component: __WEBPACK_IMPORTED_MODULE_26__components_UploadImageController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/images/:workingSetImageId', component: __WEBPACK_IMPORTED_MODULE_27__components_EditImageController__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Route */], { path: '/kits/:kitToken/*', component: __WEBPACK_IMPORTED_MODULE_8__components_NotFoundController__["a" /* default */] })));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  /* eslint-disable react/prop-types */
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KitIntegrator, { iconsSearchIndexName: props.icons_search_index_name });
  /* eslint-enable react/prop-types */
});

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Tooltip__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Alert__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_MainNavMixin__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__KitLogo__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__KitSettings__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PublishButton__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_requests_components_Done__ = __webpack_require__(57);



















var mapStateToProps = function mapStateToProps(state, ownProps) {
  var kitToken = ownProps.params.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var KitController = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitController',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_MainNavMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["g" /* default */], __WEBPACK_IMPORTED_MODULE_5_react_immutable_render_mixin___default.a],

  getInitialState: function getInitialState() {
    var kitToken = this.props.kitToken;

    return {
      showKitSettings: false,
      nameFocused: false,
      embedCodeUrl: 'https://' + "use.fortawesome.com" + '/' + kitToken + '.js',
      embedCodeScriptTag: '<script src="https://' + "use.fortawesome.com" + '/' + kitToken + '.js"></script>'
    };
  },
  componentWillMount: function componentWillMount() {
    this.setRequest({
      kit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken]
      })
    });

    this.setRequest({
      subscription: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'subscriptions']
      })
    });

    this.setRequest({
      workingSetArchives: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-archives']
      })
    });
  },
  transitions: function transitions(register) {
    register({
      request: this.requests.kit,
      to: __WEBPACK_IMPORTED_MODULE_8_requests_RequestsMixin__["d" /* IS_DONE */],
      call: function call(rm) {
        var kit = rm.type(this.requests.kit, 'kits').get();

        if (kit.version < 2) {
          __WEBPACK_IMPORTED_MODULE_6_react_router__["e" /* browserHistory */].push('/kits/' + this.props.kitToken + '/migrate?next=' + encodeURIComponent(window.location.pathname));
        }
      }
    });
  },
  mostRecentWorkingSetArchive: function mostRecentWorkingSetArchive() {
    var rm = this.resourceManager();
    var workingSetArchives = rm.type(this.requests.workingSetArchives, 'working-set-archives').all();

    var value = null;

    if (!workingSetArchives.isEmpty()) {
      value = workingSetArchives.sortBy(function (workingSetArchive) {
        return workingSetArchive.createdAt.unix();
      }).reverse().first();
    }

    return value;
  },
  handleKitSettingsOpened: function handleKitSettingsOpened(event) {
    event.preventDefault();

    this.setState({ showKitSettings: true });
  },
  handleKitSettingsClosed: function handleKitSettingsClosed() {
    this.setState({ showKitSettings: false });
  },
  handleNameFocused: function handleNameFocused() {
    this.setState({ nameFocused: !this.state.nameFocused });
  },
  handleKitPublishing: function handleKitPublishing() {
    this.refreshKitMessages();
  },
  handleKitPublished: function handleKitPublished() {
    this.refreshKitMessages();
    this.refreshKitWorkingSetArchives();
  },
  refreshKitMessages: function refreshKitMessages() {
    this.setRequest({
      refreshKitMessages: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'messages'],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        useCache: false
      })
    });
  },
  refreshKitWorkingSetArchives: function refreshKitWorkingSetArchives() {
    this.setRequest({
      workingSetArchives: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        url: ['api', 'kits', this.props.kitToken, 'working-set-archives'],
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["b" /* GET */],
        useCache: false
      })
    });
  },
  handleKitPublishedFirstTime: function handleKitPublishedFirstTime() {
    this.setState({ showEmbedCode: true });
  },
  renderMain: function renderMain() {
    var _props = this.props,
        dispatch = _props.dispatch,
        children = _props.children,
        kitToken = _props.kitToken;
    var _requests = this.requests,
        kitRequest = _requests.kit,
        subscriptionRequest = _requests.subscription;
    var _state = this.state,
        showKitSettings = _state.showKitSettings,
        nameFocused = _state.nameFocused;

    var rm = this.resourceManager();
    var subscription = rm.type(subscriptionRequest, 'subscriptions').get();
    var kit = rm.type(kitRequest, 'kits').find({ token: kitToken });
    var popover = nameFocused ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Tooltip__["d" /* default */], { icon: 'ficon-pencil', content: 'Edit Kit Name' }) : null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'well bg-white will-fill-page p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-summary gg gg-middle m-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col min-width p-xs-r-md' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__KitLogo__["a" /* default */], { kitToken: kit.token })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'text-3x gg-col kit-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'link-dashed-none', href: '#', onClick: this.handleKitSettingsOpened, onMouseOver: this.handleNameFocused, onMouseOut: this.handleNameFocused }, popover, kit.name))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__KitSettings__["a" /* default */], { kit: kit, showModal: showKitSettings, onClosed: this.handleKitSettingsClosed }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'gg-col text-xs-right text-muted' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PublishButton__["a" /* default */], {
      kit: kit,
      dispatch: dispatch,
      onPublishing: this.handleKitPublishing,
      onPublished: this.handleKitPublished,
      onFirstTimePublished: this.handleKitPublishedFirstTime
    }))), this.renderNav(kit, subscription, { workingSetArchive: this.mostRecentWorkingSetArchive() }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'kit-components' }, children));
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_requests_components_ResourcesMatching__["a" /* default */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_requests_components_Done__["a" /* default */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(KitController));

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jobs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_env__ = __webpack_require__(88);






var initialState = undefined;

var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */], initialState, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a), !__WEBPACK_IMPORTED_MODULE_4_utils_env__["a" /* PRODUCTION */] && window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
}));

Object(__WEBPACK_IMPORTED_MODULE_3__jobs__["b" /* observer */])(store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRODUCTION; });
var PRODUCTION = "production" === 'production';

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Request__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Request__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestsMixin__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__RequestsMixin__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourcesManager__ = __webpack_require__(410);
/* unused harmony reexport ResourcesManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__methods__ = __webpack_require__(52);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__methods__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__methods__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__methods__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__methods__["e"]; });









/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(8);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}






var NavLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'NavLink',

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    activeOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
  },

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      className: 'nav-link',
      activeClassName: 'nav-item active',
      activeOnIndex: false
    };
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeOnIndex = _props.activeOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeOnIndex']);

    var router = this.context.router;

    var activeClass = router.isActive(to, activeOnIndex) ? activeClassName : 'nav-item';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: activeClass }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Link */], _extends({ to: to }, props), this.props.children));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}




var NullPlaceholder = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'NullPlaceholder',
  render: function render() {
    return null;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function (components) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var nextComponents = new (Function.prototype.bind.apply(Array, [null].concat(_toConsumableArray(components))))();

  var optionsWithDefaults = Object.assign({}, { placeholder: NullPlaceholder, multipleOf: 4, minimum: 0, props: {} }, options);

  var Placeholder = optionsWithDefaults.placeholder,
      multipleOf = optionsWithDefaults.multipleOf,
      minimum = optionsWithDefaults.minimum,
      props = optionsWithDefaults.props;

  var neededComponents = Math.ceil(nextComponents.length / multipleOf) * multipleOf;
  var totalComponents = neededComponents >= minimum ? neededComponents : minimum;
  var placeholdersNeeded = totalComponents - nextComponents.length;

  for (var i = 0; i < placeholdersNeeded; i++) {
    nextComponents.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder, _extends({ key: 'placeholder-' + i }, props)));
  }

  return nextComponents;
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_ICONS_PER_KIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_CUSTOM_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_CUSTOM_ICONS_ALLOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_TYPEFACES_PER_KIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NO_CUSTOM_TYPEFACES_ALLOWED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);







var MAX_ICONS_PER_KIT = 'MAX_ICONS_PER_KIT';
var MAX_CUSTOM_ICONS = 'MAX_CUSTOM_ICONS';
var NO_CUSTOM_ICONS_ALLOWED = 'NO_CUSTOM_ICONS_ALLOWED';
var MAX_TYPEFACES_PER_KIT = 'MAX_TYPEFACES_PER_KIT';
var NO_CUSTOM_TYPEFACES_ALLOWED = 'NO_CUSTOM_TYPEFACES_ALLOWED';

var ALL_REASONS = [MAX_ICONS_PER_KIT, MAX_CUSTOM_ICONS, NO_CUSTOM_ICONS_ALLOWED, MAX_TYPEFACES_PER_KIT, NO_CUSTOM_TYPEFACES_ALLOWED];

/* harmony default export */ __webpack_exports__["f"] = (__WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'UpgradeModal',

  propTypes: {
    reason: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(ALL_REASONS),
    subscription: __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.record,
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onOkayClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onUpgradeClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onCloseClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  handleOkayClicked: function handleOkayClicked(event) {
    event.preventDefault();

    this.props.onOkayClicked();
  },
  handleUpgradeClicked: function handleUpgradeClicked(event) {
    event.preventDefault();

    this.props.onUpgradeClicked();
  },
  handleCloseClicked: function handleCloseClicked(event) {
    if (event) {
      event.preventDefault();
    }

    this.props.onCloseClicked();
  },
  render: function render() {
    var title = null;
    var message = null;

    if (this.props.reason === MAX_ICONS_PER_KIT) {
      title = 'Icon Limit Reached';
      message = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Oh noes! It looks like you\u2019ve hit the max number of icons per kit allowed by your plan (', this.props.subscription.iconsPerKitAllowed, '). Feel free to remove icons or upgrade now to keep adding!');
    } else if (this.props.reason === MAX_CUSTOM_ICONS) {
      title = 'Upgrade for more Custom Icons';
      message = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Aw heck! You\u2019re plan is limited to ', this.props.subscription.customIconsAllowed, ' custom icons. Upgrade your account to upload more!');
    } else if (this.props.reason === NO_CUSTOM_ICONS_ALLOWED) {
      title = 'Upgrade for Custom Icons';
      message = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Aw heck! You\u2019re on a plan that doesn\u2019t allow custom icons. Upgrade your account now to start uploading!');
    } else if (this.props.reason === MAX_TYPEFACES_PER_KIT) {
      title = 'Typeface Limit Reached';
      message = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Oh noes! It looks like you\u2019ve hit the max number of typefaces per kit allowed by your plan (', this.props.subscription.workingSetTypefacesAllowed, '). Feel free to remove typefaces or upgrade now to keep adding!');
    } else if (this.props.reason === NO_CUSTOM_TYPEFACES_ALLOWED) {
      title = 'Upgrade for Custom Typefaces';
      message = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'Aw heck! You\u2019re on a plan that doesn\u2019t allow custom typefaces. Upgrade your account now to start uploading!');
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: title || "", isOpen: this.props.isOpen, onRequestClose: this.handleCloseClicked }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-primary dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleCloseClicked, type: 'button', className: 'close close-dangle', 'data-dismiss': 'modal' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'sr-only' }, 'Close')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, title)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text-lg m-xs-b-0 p-xs-a-lg' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'row' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-2' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-level-up-circle ficon-3x text-gray-lighter' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-10 p-xs-l-0' }, message)))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', onClick: this.handleOkayClicked, className: 'btn btn-link btn-secondary', 'data-dismiss': 'modal' }, 'Okay'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '#', onClick: this.handleUpgradeClicked, className: 'btn btn-lg btn-primary' }, 'Upgrade', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-level-up-circle p-xs-l-xs' })))));
  }
}));

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inline":"app-javascript-components-___Tooltip__inline___ume0J","tooltip-top":"app-javascript-components-___Tooltip__tooltip-top___2LAS-","tooltip-right":"app-javascript-components-___Tooltip__tooltip-right___knduM","content":"app-javascript-components-___Tooltip__content___1X-4s"};

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var Alert = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Alert',

  propTypes: {
    message: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      showShow: true
    };
  },
  handleClosed: function handleClosed() {
    this.setState({ showShow: false });
  },
  render: function render() {
    var _props = this.props,
        message = _props.message,
        type = _props.type;

    var alertClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('alert', 'bg-body', 'alert-' + type);

    if (this.state.showShow) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: alertClassName }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'close', 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, message));
    }

    return null;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (Alert);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components_Requesting__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_requests_components_Done__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_WoffEmbeddedIcon__ = __webpack_require__(116);













var mapStateToProps = function mapStateToProps(state, props) {
  var kitToken = props.kitToken;

  return {
    kitToken: kitToken,
    requests: state.requests
  };
};

var KitLogo = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitLogo',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    kitToken: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_requests__["f" /* RequestsMixin */], __WEBPACK_IMPORTED_MODULE_3_react_immutable_render_mixin___default.a],

  componentWillMount: function componentWillMount() {
    this.setRequest({
      workingSetIcons: new __WEBPACK_IMPORTED_MODULE_4_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_4_requests__["b" /* GET */],
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons']
      })
    });
  },
  resources: function resources() {
    var rm = this.resourceManager();

    return {
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      icons: rm.type(this.requests.workingSetIcons, 'icons').all()
    };
  },
  renderSpinner: function renderSpinner() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-blank' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'blank-focus is-loading' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["c" /* default */], { size: __WEBPACK_IMPORTED_MODULE_7_components_Spinner__["a" /* SIZE_BASE */] })))));
  },
  renderBlank: function renderBlank() {
    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/logo/upload', className: 'kit-logo-blank' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'blank-focus' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-plus-circle' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Logo'))));
  },
  renderLogo: function renderLogo(workingSetIcon) {
    var kitToken = this.props.kitToken;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["b" /* Link */], { to: '/kits/' + kitToken + '/icons/' + workingSetIcon.id, className: 'kit-logo' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-inner text-xs-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'kit-logo-rendering' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'logo-default' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_WoffEmbeddedIcon__["a" /* default */], { woff: workingSetIcon.woff })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'logo-focus' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-pencil' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), 'Logo'))));
  },
  renderMain: function renderMain() {
    var _resources = this.resources(),
        workingSetIcons = _resources.workingSetIcons;

    var kitLogo = workingSetIcons.filter(function (record) {
      return record.logo;
    }).first();

    return kitLogo ? this.renderLogo(kitLogo) : this.renderBlank();
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_requests_components_ResourcesMatching__["a" /* default */], { manager: this.resourceManager() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components_Requesting__["a" /* default */], { any: true, render: this.renderSpinner }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_requests_components_Done__["a" /* default */], { all: true, render: this.renderMain }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(KitLogo));

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Modal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_requests_components_ResourcesMatching__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_requests__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_requests_components_HasErrors__ = __webpack_require__(457);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};












var mapStateToProps = function mapStateToProps(state, props) {
  return _extends({}, props, {
    requests: state.requests
  });
};

var KitSettings = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'KitSettings',

  propTypes: {
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    requests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    kit: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.record.isRequired,
    showModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    onClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7_requests__["f" /* RequestsMixin */]],

  getInitialState: function getInitialState() {
    var kit = this.props.kit;

    return {
      kit: kit
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var updateKitRequest = this.requests.updateKit;

    if (this.resourceManager(nextProps).requests.isDone(updateKitRequest)) {
      this.deleteRequest(updateKitRequest);
      this.props.onClosed();
    }
  },
  handleClosed: function handleClosed() {
    this.props.onClosed();
  },
  handleSaved: function handleSaved() {
    var kit = this.state.kit;

    this.setRequest({
      updateKit: new __WEBPACK_IMPORTED_MODULE_7_requests__["e" /* Request */]({
        method: __WEBPACK_IMPORTED_MODULE_7_requests__["d" /* PUT */],
        url: ['api', 'kits', kit.token],
        record: kit
      })
    });
  },
  handleNameChanged: function handleNameChanged(event) {
    var kit = this.state.kit;

    this.setState({
      kit: kit.set(event.target.name, event.target.value)
    });
  },
  render: function render() {
    var kit = this.state.kit;
    var updateKitRequest = this.requests.updateKit;

    var rm = this.resourceManager();
    var hasErrors = rm.requests.hasErrors(updateKitRequest);
    var isSaving = rm.requests.isQueued(updateKitRequest);
    var nameClassNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('form-group', 'm-xs-b-md', { 'has-danger': hasErrors });

    var submitLabel = isSaving ? 'Saving...' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, 'Save Changes ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-check-circle p-xs-l-xs' }));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Modal__["a" /* default */], { contentLabel: 'Kit settings', isOpen: this.props.showModal, onRequestClose: this.handleClosed }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_requests_components_ResourcesMatching__["a" /* default */], { manager: rm }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-dialog modal-md', role: 'document' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'close close-dangle', 'aria-label': 'Close' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'aria-hidden': 'true' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-times' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: 'modal-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ficon ficon-pencil' }), ' Edit Kit Name')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lead m-xs-b-md' }, 'Want to change the name of your Kit?'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: nameClassNames }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'required form-control form-control-lg', type: 'text', value: kit.name, name: 'name', placeholder: 'Kit Name', onChange: this.handleNameChanged }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_requests_components_HasErrors__["a" /* default */], { request: updateKitRequest, errorKey: 'name' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'text-help text-muted p-xs-t-xs' }, rm.requests.errorsFor(updateKitRequest).get('name'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-footer bg-body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleClosed, type: 'button', className: 'btn btn-secondary btn-lg' }, 'Cancel'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: this.handleSaved, type: 'submit', disabled: isSaving, className: 'btn btn-primary btn-lg' }, submitLabel))))));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(KitSettings));

/***/ })

},[486]);


// WEBPACK FOOTER //
// application-7723510a2fe97c487b7b.js